/* KH-FIX 2026-08-07: guard khScatolaPerMq — kh-prezzi-shopify.js carica DOPO il configuratore (defer, ordine layout),
   quindi definiamo qui la STESSA funzione come fallback per evitare 'khScatolaPerMq is not a function' negli step colore/finitura.
   Se kh-prezzi-shopify.js carica dopo, ridefinisce identica: nessun conflitto. */
if (typeof window.khScatolaPerMq !== 'function') {
  window.khScatolaPerMq = function(mqCents, fallback){ /* KH 2026-08-07: il 2° arg = prezzo scatola autorevole del formato/variante corrente -> usalo, evita collisioni €/mq (es. 60x120 e 90x90 stesso €/mq -> box diverso) */ if(fallback!=null) return fallback; try { if(mqCents==null) return fallback; var vs=(window.productData&&window.productData.variants)||[]; for(var i=0;i<vs.length;i++){ if(vs[i].unit_price==mqCents && vs[i].price!=null) return vs[i].price; } } catch(e){} return fallback; };
}

// CONFIGURATORE CERAMICAEURO - VERSIONE UNIVERSALE

// Gestisce dinamicamente i dati del configuratore per TUTTI i prodotti

// Supporta: Supergres, Sinfonie d'Autore, Provence, Outdoor, TERRAE, REBEL, ALCHEMY, RIVER, ecc.






// Evita ridichiarazione se già caricato

(function() {

  if (typeof window.ConfiguratoreDataUniversal !== 'undefined') {

    return;

  }



  if (typeof window.productConfigurator === 'undefined') {

    window.productConfigurator = {

      configuration: {}

    };

  }



  window.ConfiguratoreDataUniversal = {

  // Dati che verranno popolati dinamicamente

  formatOptions: [],

  colorOptions: [],

  thicknessOptions: [],

  finishOptions: [],

  destinationOptions: [

    {

      value: 'INTERNO',

      label: 'Interno',

      description: 'Per ambienti interni',

      image: 'https://cdn.shopify.com/s/files/1/0949/7713/0845/files/INTERNO_SUPERGRES.jpg?v=1762276257'

    },

    {

      value: 'ESTERNO',

      label: 'Esterno',

      description: 'Per spazi esterni',

      image: 'https://cdn.shopify.com/s/files/1/0949/7713/0845/files/ESTERNO_SUPERGRES.jpg?v=1762276259'

    }

  ],



  // Dati delle specifiche tecniche caricate dal JSON

  ceramicaSpecifiche: null,

  ceramicaSpecifichePromise: null,



  // 🆕 Traccia se il prodotto usa il sistema di rating (per applicare filtri intelligenti)

  productHasRatingSystem: false,



  // Helper function per formattare il formato battiscopa per la visualizzazione

  // "6x120-naturale-battiscopa" → "6x120 (Battiscopa)"

  formatBattiscopaForDisplay(formato) {

    if (!formato) return formato;

    if (!formato.toLowerCase().includes('-battiscopa')) return formato;



    // Estrai la parte dimensionale (es: "6x120" da "6x120-naturale-battiscopa")

    const match = formato.match(/^([0-9.,]+x[0-9.,]+)/i);

    if (match) {

      return `${match[1].replace(/\./g, ',')} (Battiscopa)`;

    }

    return formato;

  },



  // Helper function per formattare i prezzi

  formatMoney(cents) {

    const euros = cents / 100;

    return new Intl.NumberFormat('it-IT', {

      style: 'currency',

      currency: 'EUR',

      minimumFractionDigits: 2,

      maximumFractionDigits: 2

    }).format(euros);

  },



  // Helper function per calcolare percentuale sconto (identica ai template Liquid)

  calculateDiscountPercentage(compareAtPrice, price) {

    if (!compareAtPrice || !price || compareAtPrice <= price) {

      return 0;

    }

    // Formula ESATTA di Shopify Liquid:

    // discount_amount = (compare_at_price - price) * 100

    // discount_percentage = round(discount_amount / compare_at_price)

    // NOTA: Shopify usa ROUND (arrotondamento matematico standard)

    const discountAmount = (compareAtPrice - price) * 100;

    const discountPercentage = Math.round(discountAmount / compareAtPrice);



    return discountPercentage;

  },



  // Helper function per verificare se il prodotto corrente è Sensi

  isSensiProduct() {

    if (!this.product || !this.product.title) return false;

    const title = this.product.title.toLowerCase();

    return title.includes('sensi');

  },



  // Helper function per convertire finiture da maschile a femminile e riordinare

  // Usata per mostrare le finiture grammaticalmente corrette con "finitura" (femminile)

  // Riordina anche per mettere "Rettificato" PRIMA della finitura (es: "Rettificato Lucida" invece di "Lucida Rettificato")

  convertFinituraToFemminile(text) {

    if (!text) return text;



    // Mappa delle conversioni maschile → femminile + traduzioni

    // NOTA: Squadrato resta maschile (termine tecnico come Bocciardato)

    const conversioni = {

      'Lucido': 'Lucida',

      'Lux': 'Lucida',  // Lux = Lucida

      'Satinato': 'Satinata', 'velvet': 'Velvet', 'Velvet': 'Velvet',

      'Strutturato': 'Strutturata',

      'Liscio': 'Liscia',

      // 'Squadrato' rimosso - resta maschile come termine tecnico

      'Levigato': 'Levigata',

      'Spazzolato': 'Spazzolata',

      'Naturale': 'Naturale',

      'Matte': 'Opaca',  // Matte = Opaca

      'Matt': 'Opaca',

      'Opaco': 'Opaca'

    };



    // Lista delle finiture (per rilevare e riordinare)

    // NOTA: Squadrato/Squadrata RIMOSSO - non è una finitura, è il tipo di bordo della piastrella

    const finiture = ['Lucido', 'Lucida', 'Lux', 'Satinato', 'Satinata', 'Velvet', 'Strutturato', 'Strutturata',

                      'Liscio', 'Liscia', 'Levigato', 'Levigata',

                      'Spazzolato', 'Spazzolata', 'Naturale', 'Matte', 'Matt', 'Opaco', 'Opaca',

                      'Soft', 'Comfort', 'Fluid', 'PTV', 'Bocciardato'];



    let risultato = text;



    // Prima converti maschile → femminile

    for (const [maschile, femminile] of Object.entries(conversioni)) {

      const regex = new RegExp(`\\b${maschile}\\b`, 'gi');

      risultato = risultato.replace(regex, (match) => {

        if (match[0] === match[0].toUpperCase()) {

          return femminile;

        }

        return femminile.toLowerCase();

      });

    }



    // Poi riordina: metti "Rettificato" prima della finitura

    // Es: "60×120 cm Lucida Rettificato" → "60×120 cm Rettificato Lucida"

    const hasRettificato = /\bRettificato\b/i.test(risultato);

    if (hasRettificato) {

      // Trova quale finitura è presente

      for (const finitura of finiture) {

        const finituraRegex = new RegExp(`\\b(${finitura})\\s+Rettificato\\b`, 'gi');

        if (finituraRegex.test(risultato)) {

          // Scambia l'ordine: "Finitura Rettificato" → "Rettificato Finitura"

          risultato = risultato.replace(finituraRegex, 'Rettificato $1');

          break;

        }

      }

    }



    return risultato;

  },



  // Carica i dati delle specifiche tecniche dal JSON

  loadCeramicaSpecifiche() {

    if (!this.ceramicaSpecifichePromise) {

      this.ceramicaSpecifichePromise = (async () => {

        try {

          let response;



          // PRIORITÀ 1: Usa l'URL passato dal Liquid (più affidabile)

          if (window.specificheTecnicheUrl) {


            response = await fetch(window.specificheTecnicheUrl);

            if (response.ok) {

              this.ceramicaSpecifiche = await response.json();


              return;

            }

          }



          // PRIORITÀ 2: Prova il percorso Shopify assets

          if (window.Shopify?.cdnHost) {

            const shopifyUrl = `${window.Shopify.cdnHost}/assets/specifiche-tecniche.json`;

            response = await fetch(shopifyUrl);

            if (response.ok) {

              this.ceramicaSpecifiche = await response.json();


              return;

            }

          }



          // PRIORITÀ 3: Fallback per ambiente locale/sviluppo

          const localUrl = '/cdn/shop/assets/specifiche-tecniche.json';

          response = await fetch(localUrl);

          if (response.ok) {

            this.ceramicaSpecifiche = await response.json();


          } else {


          }

        } catch (error) {


        }

      })();

    }

    return this.ceramicaSpecifichePromise;

  },



  // Inizializza i dati da Shopify

  initializeFromShopify() {

    // Carica i dati delle specifiche tecniche

    this.loadCeramicaSpecifiche();



    // Aggiungi stili CSS per uniformare lo sfondo glass del modal zoom

    this.injectZoomModalStyles();



    // Inizializza rotazione recensioni nell'header




    // Verifica disponibilità dati

    if (typeof window.productData === 'undefined' || !window.productData) {

      this.loadDefaultData();

      return;

    }



    this.product = window.productData;



    // Recupera product_type via API se non presente nel productData

    const productHandle = this.product.handle || window.location.pathname.split('/products/')[1]?.split('?')[0]?.split('#')[0];


    if (!this.product.product_type && productHandle) {

      fetch('/products/' + productHandle + '.json')

        .then(r => {


          return r.json();

        })

        .then(data => {


          const pType = data?.product?.product_type || data?.product?.type;

          if (pType) {

            this.product.product_type = pType;


            // Aggiorna le card finitura già renderizzate con il product_type

            document.querySelectorAll('.fx-product-type-placeholder').forEach(el => {

              el.textContent = this.product.product_type;

              el.style.display = '';

            });

          }

        })

        .catch(() => {});

    }



    // Salva anche in productConfigurator

    if (window.productConfigurator) {

      window.productConfigurator.product = this.product;
      try { window.__KH_CFG__ = this; } catch(e){} /* KH-DIAG */

    }



    // Estrai dati dalle varianti

    if (this.product.variants && this.product.variants.length > 0) {

      this.extractFormatsFromVariants(this.product.variants);

      this.extractColorsFromVariants(this.product.variants);

      this.extractThicknessFromVariants(this.product.variants);



      // Determina quali destinazioni mostrare basandosi sui rating disponibili

      this.updateAvailableDestinations(this.product.variants);

    }

    

    // Carica finiture di default

    this.loadDefaultFinishes();



    // Se non ci sono formati, carica quelli di default

    if (this.formatOptions.length === 0) {

      this.loadDefaultFormats();

    }

  },



  // Estrai formati dalle varianti

  extractFormatsFromVariants(variants) {

    const formats = new Map();

    const formatRatings = new Map(); // Traccia quali rating ha ogni formato

    const formatHasValidColors = new Map(); // Traccia se il formato ha almeno una variante con colore valido

    const formatVariantDetails = new Map(); // Per debug: traccia dettagli varianti per formato



    // 🆕 PRE-SCANSIONE: Rileva se il prodotto usa il sistema di rating

    // NOTA: controlliamo TUTTE le varianti, anche quelle non disponibili

    let productHasRatingSystem = false;

    for (const variant of variants) {

      const variantText = `${variant.title || ''} ${variant.option1 || ''} ${variant.option2 || ''} ${variant.option3 || ''}`.toLowerCase();

      if (/\br9\b|\br10\b|\br11\b/.test(variantText)) {

        productHasRatingSystem = true;

        break;

      }

    }

    // Salva nell'oggetto per usarlo in altri metodi

    this.productHasRatingSystem = productHasRatingSystem;



    // 🆕 PRE-SCANSIONE: Rileva quali formati hanno ENTRAMBE le versioni (Rettificato e non-Rettificato)

    // Questo serve per distinguerli solo quando necessario

    const formatRettificatoStatus = new Map(); // formatKey -> { hasRettificato: bool, hasNonRettificato: bool }

    for (const variant of variants) {

      const variantFullText = `${variant.title || ''} ${variant.option1 || ''} ${variant.option2 || ''} ${variant.option3 || ''}`.toLowerCase();

      // 🆕 FIX 22-GEN-2026: Usa solo option1 per rilevare finiture (evita confusione con colori come "Naturale")

      const option1Lower = (variant.option1 || '').toLowerCase();

      const formatPattern = /\d+(?:[.,]\d+)?\s*[xX×]\s*\d+(?:[.,]\d+)?/gi;

      const searchTexts = [variant.option1, variant.option2, variant.option3, variant.title].filter(t => t);



      for (const text of searchTexts) {

        const matches = text.match(formatPattern);

        if (matches && matches.length > 0) {

          const format = matches[0].replace(/\s/g, '').toLowerCase().replace('×', 'x').replace(',', '.');



          // Costruisci formatKey base (senza rettificato) per tracking

          let baseKey = format;

          if (variantFullText.includes('ptv')) baseKey += '-ptv';

          if (variantFullText.includes('lucido') || variantFullText.includes('lucida')) baseKey += '-lucido';

          if (variantFullText.includes('comfort')) baseKey += '-comfort';

          if (variantFullText.includes('strutturato') || variantFullText.includes('strutturata')) baseKey += '-strutturato';

          // 🔧 FIX: Soft, Satinata e Matte sono finiture DIVERSE, non sinonimi

          if ((variantFullText.includes('satinato') || variantFullText.includes('satinata')) &&

              !variantFullText.includes('naturale silk') && !variantFullText.includes('lappata satinata') && !variantFullText.includes('lappata-satinata') && !variantFullText.includes('soft')) baseKey += '-satinato';
          if (variantFullText.includes('velvet')) baseKey += '-velvet'; /* KH velvet */

          if (variantFullText.includes('soft') && !variantFullText.includes('naturale silk')) baseKey += '-soft';

          if (/\bmatte?\b/i.test(variantFullText) && !variantFullText.includes('naturale')) baseKey += '-matte';

          if (variantFullText.includes('naturale silk')) baseKey += '-satinatoNaturale';

          if (variantFullText.includes('bocciardato')) baseKey += '-bocciardato';

          if (variantFullText.includes('smooth') || variantFullText.includes('liscio') || variantFullText.includes('liscia')) baseKey += '-liscio';

          // 🆕 FIX 22-GEN-2026: Controlla "naturale" SOLO in option1 (formato), non in option2 (colore)

          // Per prodotti come 4EVER, "Naturale" è un nome colore, non una finitura

          if (option1Lower.includes('naturale') && !option1Lower.includes('bocciardato-naturale') && !option1Lower.includes('naturale leather') && !option1Lower.includes('naturale silk')) baseKey += '-naturale';

          if (option1Lower.includes('naturale leather')) baseKey += '-naturalecuoio';

          if ((variantFullText.includes('lappato') || variantFullText.includes('lappata')) && !variantFullText.includes('lappata satinata') && !variantFullText.includes('lappata-satinata')) baseKey += '-lappata';

          if (variantFullText.includes('levigato') || variantFullText.includes('levigata')) baseKey += '-levigata';
          if (variantFullText.includes('patinato') || variantFullText.includes('patinata')) baseKey += '-patinato';

          if (variantFullText.includes('squadrato') || variantFullText.includes('squadrata')) baseKey += '-squadrato';

          if (variantFullText.includes('cannete') || variantFullText.includes('canneté')) baseKey += '-cannete';

          if (variantFullText.includes('realupstrideup') || variantFullText.includes('realup+strideup')) baseKey += '-realupstrideup';

          else if (variantFullText.includes('realup')) baseKey += '-realup';

          if (variantFullText.includes('grip')) baseKey += '-grip';

          if (/anti[\s_-]?slip/i.test(variantFullText)) baseKey += '-antislip';

          if (variantFullText.includes('battiscopa')) baseKey += '-battiscopa';

          if (variantFullText.includes('fade')) baseKey += '-fade';

          if (variantFullText.includes('lappata satinata') || variantFullText.includes('lappata-satinata')) baseKey += '-lappatasatinata';

          if (variantFullText.includes('parete')) baseKey += '-parete';

          if (variantFullText.includes('lux')) baseKey += '-lux';

          if (variantFullText.includes('fluid')) baseKey += '-fluid';

          // 🆕 Aggiungi -20mm per formati outdoor 20mm (deve corrispondere al formatKey principale)

          if (/\b20\s*mm\b/i.test(variantFullText) || /\b2\s*cm\b/i.test(variantFullText)) baseKey += '-20mm';



          const isRettificato = variantFullText.includes('rettificato') || variantFullText.includes('rettificate') || variantFullText.includes('rectified');



          if (!formatRettificatoStatus.has(baseKey)) {

            formatRettificatoStatus.set(baseKey, { hasRettificato: false, hasNonRettificato: false });

          }

          const status = formatRettificatoStatus.get(baseKey);

          if (isRettificato) {

            status.hasRettificato = true;

          } else {

            status.hasNonRettificato = true;

          }

          break;

        }

      }

    }



    // Identifica quali formati necessitano distinzione Rettificato/non-Rettificato

    const formatsNeedRettificatoDistinction = new Set();

    for (const [key, status] of formatRettificatoStatus) {

      if (status.hasRettificato && status.hasNonRettificato) {

        formatsNeedRettificatoDistinction.add(key);


      }

    }



    variants.forEach((variant, index) => {

      // Traccia se la variante è disponibile (ma non saltiamo più - estraiamo comunque i formati)

      const isVariantAvailable = variant.available !== false;



      // Crea stringa completa per controllo rating

      const variantFullText = `${variant.title || ''} ${variant.option1 || ''} ${variant.option2 || ''} ${variant.option3 || ''}`.toLowerCase();

      // 🆕 FIX 22-GEN-2026: Usa solo option1 per rilevare finiture (evita confusione con colori come "Naturale")

      const option1Lower = (variant.option1 || '').toLowerCase();



      // Verifica se la variante ha ALMENO UN rating valido usando regex più precisi

      const hasR9 = /\br9\b/.test(variantFullText);

      const hasR10 = /\br10\b/.test(variantFullText);

      const hasR11 = /\br11\b/.test(variantFullText);

      const hasR12 = /\br12\b/.test(variantFullText);

      const hasR13 = /\br13\b/.test(variantFullText);

      const hasAnyRating = hasR9 || hasR10 || hasR11 || hasR12 || hasR13;



      // Check if variant has PARETE or special characteristics

      const isPareteVariant = variantFullText.includes('parete');

      const hasSpecialCharacteristics = variantFullText.includes('velvet') || /* KH velvet special */
                                       variantFullText.includes('lucido') ||

                                       variantFullText.includes('lucida') ||

                                       variantFullText.includes('liscio') || variantFullText.includes('liscia') ||

                                       variantFullText.includes('smooth') ||

                                       variantFullText.includes('levigato') ||

                                       variantFullText.includes('levigata') ||

                                       variantFullText.includes('lappato') ||

                                       variantFullText.includes('lappata') ||

                                       variantFullText.includes('comfort') ||

                                       variantFullText.includes('strutturato') ||

                                       variantFullText.includes('strutturata') ||

                                       variantFullText.includes('satinato') ||

                                       variantFullText.includes('satinata') ||

                                       variantFullText.includes('soft') ||

                                       /\bmatte?\b/i.test(variantFullText) ||

                                       variantFullText.includes('silk') ||

                                       variantFullText.includes('bocciardato') ||

                                       variantFullText.includes('naturale') ||

                                       variantFullText.includes('naturale leather') ||

                                       variantFullText.includes('squadrato') ||

                                       variantFullText.includes('squadrata') ||

                                       variantFullText.includes('ptv') ||

                                       variantFullText.includes('lux') ||

                                       variantFullText.includes('fluid') ||

                                       variantFullText.includes('realupstrideup') ||

                                       variantFullText.includes('realup+strideup') ||

                                       variantFullText.includes('realup') ||

                                       variantFullText.includes('grip') ||

                                       variantFullText.includes('fade') ||

                                       variantFullText.includes('lappata satinata') ||

                                       variantFullText.includes('lappata-satinata');



      // FILTRO INTELLIGENTE: applica SOLO se il prodotto ha sistema di rating

      if (productHasRatingSystem) {

        // IMPORTANTE: Processa varianti con rating O varianti PARETE senza rating O varianti con caratteristiche speciali O BATTISCOPA

        const isBattiscopaVariant = variantFullText.includes('battiscopa');

        if (!hasAnyRating && !isPareteVariant && !hasSpecialCharacteristics && !isBattiscopaVariant) {

          return;

        }

      }



      // Verifica se la variante ha un colore valido (non è solo formato, spessore o rating)

      let hasValidColor = false;

      const options = [variant.option1, variant.option2, variant.option3].filter(opt => opt);

      for (const option of options) {

        const optionLower = option.toLowerCase();

        // Escludi: formati, spessori, rating e stringhe vuote

        const isFormat = /\d+\s*[xX×]\s*\d+/i.test(option);

        const isThickness = /\d+\s*mm/i.test(option);

        const isRating = /\br9\b|\br10\b|\br11\b/i.test(optionLower);

        const isEmpty = option.trim() === '';



        if (!isFormat && !isThickness && !isRating && !isEmpty) {

          hasValidColor = true;

          break;

        }

      }



      // Cerca formato in tutte le opzioni

      const searchTexts = [

        variant.option1,

        variant.option2,

        variant.option3,

        variant.title

      ].filter(text => text);



      // Pattern per formati (es: 60x60, 80x80, 120x280, 7.5x30, 26,5x180)

      // Supporta sia punto che virgola come separatore decimale

      const formatPattern = /\d+(?:[.,]\d+)?\s*[xX×]\s*\d+(?:[.,]\d+)?/gi;



      for (const text of searchTexts) {

        const matches = text.match(formatPattern);

        if (matches && matches.length > 0) {

          const formatRaw = matches[0];

          // Normalizza: rimuovi spazi, lowercase, × → x, virgola → punto (per uniformità con chiavi prezzi)

          const format = formatRaw.replace(/\s/g, '').toLowerCase().replace('×', 'x').replace(',', '.');



          // Controlla se questa variante contiene "Rettificato" o "PTV"

          const isRettificato = variantFullText.includes('rettificato') ||

                               variantFullText.includes('rettificate') ||

                               variantFullText.includes('rectified');



          const hasPTV = variantFullText.includes('ptv');



          // Controlla se questa variante contiene "Lucido", "Comfort", "Strutturato", "Satinato", "Bocciardato", "Smooth" (Liscio), "Naturale" (Naturale) o "Naturale"

          const hasLucido = variantFullText.includes('lucido') || variantFullText.includes('lucida') || variantFullText.includes('glossy');

          const hasComfort = variantFullText.includes('comfort');
          const hasTwist = variantFullText.includes('twist');
          const hasStrutturaSign = variantFullText.includes('struttura sign');
          const hasStrutturaNet = variantFullText.includes('struttura net');
          const hasStrutturaMove = variantFullText.includes('struttura move');
          const hasStripe = variantFullText.includes('stripe parete');
          const hasRiga = variantFullText.includes(' riga ');
          const hasPliss = variantFullText.includes('pliss');

          const hasStrutturato = variantFullText.includes('strutturato') ||

                                variantFullText.includes('strutturata');

          const hasNaturaleSilk = variantFullText.includes('naturale silk'); // Naturale Silk = Satinato Naturale

          const hasSilkNotNaturale = variantFullText.includes('silk') && !hasNaturaleSilk; // Silk (non Naturale Silk) = Satinato

          // 🔧 FIX: Soft e Satinato sono finiture DIVERSE

          const hasSatinato = (variantFullText.includes('satinato') ||

                             variantFullText.includes('satinata') ||

                             hasSilkNotNaturale) && !hasNaturaleSilk && !variantFullText.includes('lappata satinata') && !variantFullText.includes('lappata-satinata'); // SILK = Satinato, ma NON Naturale Silk e NON Lappata-Satinata

          const hasVelvet = variantFullText.includes('velvet'); /* KH velvet A */
          const hasSoft = variantFullText.includes('soft'); // Soft è una finitura SEPARATA

          const hasMatte = /\bmatte?\b/i.test(variantFullText); // Matte/Opaca è una finitura SEPARATA (word boundary per non matchare "mattone")

          const hasBocciardato = variantFullText.includes('bocciardato') ||

                                variantFullText.includes('bocciardato-naturale');

          const hasLiscio = variantFullText.includes('smooth') || variantFullText.includes('liscio') || variantFullText.includes('liscia');

          // 🆕 FIX 22-GEN-2026: Controlla "naturale" SOLO in option1 (formato), non in option2 (colore)

          // Per prodotti come 4EVER, "Naturale" è un nome colore, non una finitura

          const hasNaturale = option1Lower.includes('naturale') && !option1Lower.includes('bocciardato-naturale') && !option1Lower.includes('naturale leather') && !option1Lower.includes('naturale silk'); // Rileva Naturale ma non bocciardato-Naturale, Naturale leather e Naturale silk

          const hasNaturaleLeather = option1Lower.includes('naturale leather'); // Rileva Naturale Leather -> Cuoio Naturale

          const hasSquadrato = variantFullText.includes('squadrato') || variantFullText.includes('squadrata');

          const hasCannete = variantFullText.includes('cannete') || variantFullText.includes('canneté') || variantFullText.includes('cannetté') || variantFullText.includes('cannetè');

          const hasLappata = (variantFullText.includes('lappato') || variantFullText.includes('lappata')) && !variantFullText.includes('lappata satinata') && !variantFullText.includes('lappata-satinata');

          const hasLevigata = variantFullText.includes('levigato') || variantFullText.includes('levigata');
          const hasPatinato = variantFullText.includes('patinato') || variantFullText.includes('patinata');

          const hasRealUpStrideUp = variantFullText.includes('realupstrideup') || variantFullText.includes('realup+strideup') || variantFullText.includes('realup-strideup');

          const hasRealUp = variantFullText.includes('realup') && !hasRealUpStrideUp;

          const hasStrideUp = variantFullText.includes('strideup') && !hasRealUpStrideUp;

          const hasGrip = variantFullText.includes('grip');

          // 🔧 FIX: Rileva variazioni di "antislip" (antislip, anti-slip, anti slip)

          const hasAntislip = variantFullText.includes('antislip') || variantFullText.includes('anti-slip') || variantFullText.includes('anti slip');

          const hasBattiscopa = variantFullText.includes('battiscopa');

          const hasFade = variantFullText.includes('fade');

          const hasLappataSatinata = variantFullText.includes('lappata satinata') || variantFullText.includes('lappata-satinata');

          // 🆕 Rileva spessore 20mm (per distinguere formati indoor 9mm da outdoor 20mm)

          const is20mm = /\b20\s*mm\b/i.test(variantFullText) || /\b2\s*cm\b/i.test(variantFullText);



          // Controlla se questa variante contiene "PARETE"

          const isParete = variantFullText.includes('parete');



          // Controlla se questa variante contiene "LUX" o "FLUID"

          const hasLux = variantFullText.includes('lux');

          const hasFluid = variantFullText.includes('fluid');



          // Crea un formato univoco: se ha PARETE, LUX, FLUID, PTV, LUCIDO, COMFORT, STRUTTURATO, SATINATO, BOCCIARDATO, LISCIO, Naturale o NATURALE, aggiungi suffisso al value

          let formatKey = format;

          if (hasPTV) formatKey += '-ptv';

          if (hasLucido) formatKey += '-lucido';

          if (hasComfort) formatKey += '-comfort';

          if (hasStrutturato) formatKey += '-strutturato';
          if (hasTwist) formatKey += '-twist';
          if (hasStrutturaSign) formatKey += '-strutturasign';
          if (hasStrutturaNet) formatKey += '-strutturanet';
          if (hasStrutturaMove) formatKey += '-strutturamove';
          if (hasStripe) formatKey += '-stripe';
          if (hasRiga) formatKey += '-riga';
          if (hasPliss) formatKey += '-pliss';

          if (hasVelvet) formatKey += '-velvet';
          if (hasSatinato) formatKey += '-satinato';

          if (hasSoft) formatKey += '-soft';  // 🔧 FIX: Soft è una finitura SEPARATA

          if (hasMatte) formatKey += '-matte';  // 🔧 FIX: Matte/Opaca è una finitura SEPARATA

          if (hasNaturaleSilk) formatKey += '-satinatoNaturale';

          if (hasBocciardato) formatKey += '-bocciardato';

          if (hasLiscio) formatKey += '-liscio';

          if (hasNaturale) formatKey += '-naturale';

          if (hasNaturaleLeather) formatKey += '-naturalecuoio';

          if (hasLappata) formatKey += '-lappata';

          if (hasLevigata) formatKey += '-levigata';
          if (hasPatinato) formatKey += '-patinato';

          if (hasSquadrato) formatKey += '-squadrato';

          if (hasCannete) formatKey += '-cannete';

          if (hasRealUpStrideUp) formatKey += '-realupstrideup';

          if (hasRealUp) formatKey += '-realup';

          if (hasStrideUp) formatKey += '-strideup';

          if (hasGrip) formatKey += '-grip';

          if (hasAntislip) formatKey += '-antislip';

          if (hasBattiscopa) formatKey += '-battiscopa';

          if (hasFade) formatKey += '-fade';

          if (hasLappataSatinata) formatKey += '-lappatasatinata';

          if (isParete) formatKey += '-parete';

          if (hasLux) formatKey += '-lux';

          if (hasFluid) formatKey += '-fluid';

          // 🆕 Aggiungi -20mm al formatKey per distinguere formati 20mm (outdoor) da altri spessori

          if (is20mm) formatKey += '-20mm';



          // 🆕 DISTINZIONE RETTIFICATO: Aggiungi suffisso SOLO se esistono ENTRAMBE le versioni

          if (formatsNeedRettificatoDistinction.has(formatKey)) {

            if (isRettificato) {

              formatKey += '-rettificato';

            }

            // Non-rettificato rimane senza suffisso aggiuntivo

          }



          // Traccia dettagli per debug

          if (!formatVariantDetails.has(formatKey)) {

            formatVariantDetails.set(formatKey, []);

          }

          formatVariantDetails.get(formatKey).push({

            variant: `${variant.option1} / ${variant.option2} / ${variant.option3}`,

            hasColor: hasValidColor,

            ratings: { R9: hasR9, R10: hasR10, R11: hasR11, R12: hasR12, R13: hasR13 },

            isRettificato: isRettificato,

            hasPTV: hasPTV,

            hasLucido: hasLucido,

            hasComfort: hasComfort,

            hasStrutturato: hasStrutturato,

            hasVelvet: hasVelvet, hasSatinato: hasSatinato,

            hasBocciardato: hasBocciardato,

            hasLiscio: hasLiscio,

            hasNaturale: hasNaturale,

            hasNaturaleLeather: hasNaturaleLeather,

            hasSquadrato: hasSquadrato,

            hasCannete: hasCannete,

            hasRealUpStrideUp: hasRealUpStrideUp,

            hasRealUp: hasRealUp,

            hasStrideUp: hasStrideUp,

            hasGrip: hasGrip,

            hasAntislip: hasAntislip,

            hasBattiscopa: hasBattiscopa,

            hasFade: hasFade,

            hasLappataSatinata: hasLappataSatinata,

            isParete: isParete,

            hasLux: hasLux,

            hasFluid: hasFluid

          });



          // Traccia quali rating ha questo formato

          if (!formatRatings.has(formatKey)) {

            formatRatings.set(formatKey, { R9: false, R10: false, R11: false, R12: false, R13: false, noRating: false });

          }

          const ratings = formatRatings.get(formatKey);

          if (hasR9) ratings.R9 = true;

          if (hasR10) ratings.R10 = true;

          if (hasR11) ratings.R11 = true;

          if (hasR12) ratings.R12 = true;

          if (hasR13) ratings.R13 = true;

          // Traccia se ci sono varianti SENZA rating (non PARETE) per INTERNO

          if (!hasAnyRating && !isPareteVariant) {

            ratings.noRating = true;

          }



          // Traccia se questo formato ha almeno una variante con colore valido

          if (hasValidColor) {

            formatHasValidColors.set(formatKey, true);

          }



          if (!formats.has(formatKey)) {

            // Usa il formato originale per il label, aggiungendo tutte le caratteristiche speciali (PARETE rimosso dal label)

            const baseLabel = formatRaw.replace('x', '×').replace('X', '×').replace(/\./g, ',') + ' cm'; /* KH-FIX virgola */

            let label = baseLabel;

            // NOTA: Non aggiungiamo più ' PARETE' al label, anche se il value ha il suffisso -parete

            if (hasLux) label += ' Lucida';

            if (hasFluid) label += ' FLUID';

            if (hasLucido) label += ' Lucida';

            if (isRettificato && hasPTV) label += ' Rettificato PTV';

            else if (isRettificato) label += ' Rettificato';

            if (hasSquadrato) label += ' Squadrato';  // Squadrato subito dopo Rettificato (prima delle finiture)

            if (hasComfort) label += ' Comfort';

            if (hasStrutturato) label += ' Strutturata';

            if (hasVelvet) label += ' Velvet';
            if (hasSatinato) label += ' Satinata';

            if (hasNaturaleSilk) label += ' Satinata Naturale';

            if (hasBocciardato) label += ' Bocciardato';

            if (hasLiscio) label += ' Liscia';

            if (hasNaturale) label += ' Naturale';  // Naturale aggiunto UNA sola volta

            if (hasNaturaleLeather) label += ' Cuoio Naturale';

            if (hasLappata) label += ' Lappata';

            if (hasLevigata) label += ' Levigata';

            if (hasCannete) label += ' Canneté';

            if (hasRealUpStrideUp) label += ' RealUp+StrideUp';

            if (hasRealUp) label += ' RealUp';

            if (hasStrideUp) label += ' StrideUp';

            if (hasGrip) label += ' Grip';

            if (hasAntislip) label += ' Antislip';

            if (hasBattiscopa) label += ' Battiscopa';


            // NOTA: 20mm NON viene aggiunto alla label (lo spessore si seleziona separatamente)



            // 🎯 Cerca il prezzo fisso usando il comparePrice della variante

            let displayPrice = variant.price;

            let displayComparePrice = variant.compare_at_price;

            if (typeof window.getPrezzoByComparePrice === 'function' && variant.compare_at_price) {

              // Determina la finitura per match preciso

              let finituraForPrice = 'base';

              if (hasLucido) finituraForPrice = 'lucido';

              else if (hasVelvet) finituraForPrice = 'velvet';
              else if (hasSatinato) finituraForPrice = 'satinato';

              else if (hasStrutturato) finituraForPrice = 'strutturato';

              else if (hasBocciardato) finituraForPrice = 'bocciardato';

              else if (hasLiscio) finituraForPrice = 'liscio';

              else if (hasComfort) finituraForPrice = 'comfort';

              else if (hasNaturale) finituraForPrice = 'naturale';

              else if (hasNaturaleSilk) finituraForPrice = 'soft';

              else if (hasCannete) finituraForPrice = 'cannete';

              else if (hasLappata) finituraForPrice = 'lappata';

              else if (hasLevigata) finituraForPrice = 'levigata';

              else if (hasRealUpStrideUp) finituraForPrice = 'realupstrideup';

              else if (hasRealUp) finituraForPrice = 'realup';

              else if (hasGrip) finituraForPrice = 'grip';

              else if (hasAntislip) finituraForPrice = 'antislip';



              const prezzoFisso = window.getPrezzoByComparePrice(variant.compare_at_price, this.product.title, finituraForPrice, format);


              if (prezzoFisso) {

                // Moltiplica per 100 per convertire in centesimi

                displayPrice = prezzoFisso.prezzo * 100;

                displayComparePrice = prezzoFisso.comparePrice * 100;

              }

            }



            formats.set(formatKey, {

              value: formatKey,

              label: (variantFullText.includes('composizione') ? label + ' Composizione' : label),  /* KH-FILATI */

              description: variantFullText.includes('composizione') ? '4 lastre 60×120 · pannello 120×240' : this.getFormatDescription(format),  /* KH-FILATI */

              price: variant.price,

              compareAtPrice: variant.compare_at_price,

              displayPrice: displayPrice,

              displayComparePrice: displayComparePrice,

              variantId: variant.id,

              isRettificato: isRettificato,

              hasPTV: hasPTV,

              hasLucido: hasLucido,

              hasComfort: hasComfort,

              hasStrutturato: hasStrutturato,

              hasVelvet: hasVelvet, hasSatinato: hasSatinato,

              hasNaturaleSilk: hasNaturaleSilk,

              hasBocciardato: hasBocciardato,

              hasLiscio: hasLiscio,

              hasNaturale: hasNaturale,

              hasNaturaleLeather: hasNaturaleLeather,

              hasNaturale: hasNaturale,

              hasSquadrato: hasSquadrato,

              hasCannete: hasCannete,

              hasRealUp: hasRealUp,

              hasGrip: hasGrip,

              hasAntislip: hasAntislip,

              isBattiscopa: hasBattiscopa,

              isParete: isParete,

              hasLux: hasLux,

              hasFluid: hasFluid,

              is20mm: is20mm  // 🆕 Flag per formati outdoor 20mm

            });

          } else {

            // Se il formato esiste già, aggiorna solo i rating se necessario

            const existingFormat = formats.get(formatKey);

            const ratings = formatRatings.get(formatKey);

            if (hasR9) ratings.R9 = true;

            if (hasR10) ratings.R10 = true;

            if (hasR11) ratings.R11 = true;

            if (hasR12) ratings.R12 = true;

            if (hasR13) ratings.R13 = true;

            // Traccia se ci sono varianti SENZA rating (non PARETE) per INTERNO

            if (!hasAnyRating && !isPareteVariant) {

              ratings.noRating = true;

            }

            // Aggiorna anche lo stato LUX se questa variante lo ha

            if (hasLux && !existingFormat.hasLux) {

              existingFormat.hasLux = true;

              if (!existingFormat.label.includes('LUX')) {

                existingFormat.label += ' LUX';

              }

            }

            // Aggiorna anche lo stato FLUID se questa variante lo ha

            if (hasFluid && !existingFormat.hasFluid) {

              existingFormat.hasFluid = true;

              if (!existingFormat.label.includes('FLUID')) {

                existingFormat.label += ' FLUID';

              }

            }

            // Aggiorna anche lo stato Lucido se questa variante lo ha (PRIMA di Rettificato per ordine corretto)

            if (hasLucido && !existingFormat.hasLucido) {

              existingFormat.hasLucido = true;

              if (!existingFormat.label.includes('Lucida')) {

                existingFormat.label += ' Lucida';

              }

            }

            // Aggiorna anche lo stato rettificato se questa variante lo ha

            if (isRettificato && !existingFormat.isRettificato) {

              existingFormat.isRettificato = true;

              if (!existingFormat.label.includes('Rettificato')) {

                if (hasPTV) {

                  existingFormat.label += ' Rettificato PTV';

                } else {

                  existingFormat.label += ' Rettificato';

                }

              }

            }

            // Aggiorna anche lo stato Comfort se questa variante lo ha

            if (hasComfort && !existingFormat.hasComfort) {

              existingFormat.hasComfort = true;

              if (!existingFormat.label.includes('Comfort')) {

                existingFormat.label += ' Comfort';

              }

            }

            // Aggiorna anche lo stato Strutturato se questa variante lo ha

            if (hasStrutturato && !existingFormat.hasStrutturato) {

              existingFormat.hasStrutturato = true;

              if (!existingFormat.label.includes('Strutturata')) {

                existingFormat.label += ' Strutturata';

              }

            }

            // Aggiorna anche lo stato Satinato se questa variante lo ha

            if (hasVelvet && !existingFormat.hasVelvet) { existingFormat.hasVelvet = true; }
            if (hasSatinato && !existingFormat.hasSatinato) {

              existingFormat.hasSatinato = true;

              if (!existingFormat.label.includes('Satinata')) {

                existingFormat.label += ' Satinata';

              }

            }

            // Aggiorna anche lo stato Naturale Silk (Satinato Naturale) se questa variante lo ha

            if (hasNaturaleSilk && !existingFormat.hasNaturaleSilk) {

              existingFormat.hasNaturaleSilk = true;

              if (!existingFormat.label.includes('Satinata Naturale')) {

                existingFormat.label += ' Satinata Naturale';

              }

            }

            // Aggiorna anche lo stato Bocciardato se questa variante lo ha

            if (hasBocciardato && !existingFormat.hasBocciardato) {

              existingFormat.hasBocciardato = true;

              if (!existingFormat.label.includes('Bocciardato')) {

                existingFormat.label += ' Bocciardato';

              }

            }

            // Aggiorna anche lo stato Liscio se questa variante lo ha

            if (hasLiscio && !existingFormat.hasLiscio) {

              existingFormat.hasLiscio = true;

              if (!existingFormat.label.includes('Liscia')) {

                existingFormat.label += ' Liscia';

              }

            }

            // Aggiorna anche lo stato Naturale (Naturale) se questa variante lo ha

            if (hasNaturale && !existingFormat.hasNaturale) {

              existingFormat.hasNaturale = true;

              if (!existingFormat.label.includes('Naturale')) {

                existingFormat.label += ' Naturale';

              }

            }

            // Aggiorna anche lo stato Naturale Leather (Cuoio Naturale) se questa variante lo ha

            if (hasNaturaleLeather && !existingFormat.hasNaturaleLeather) {

              existingFormat.hasNaturaleLeather = true;

              if (!existingFormat.label.includes('Cuoio Naturale')) {

                existingFormat.label += ' Cuoio Naturale';

              }

            }

            // Aggiorna anche lo stato Naturale se questa variante lo ha

            if (hasNaturale && !existingFormat.hasNaturale) {

              existingFormat.hasNaturale = true;

              if (!existingFormat.label.includes('Naturale')) {

                existingFormat.label += ' Naturale';

              }

            }

            // Aggiorna anche lo stato Squadrato se questa variante lo ha

            if (hasSquadrato && !existingFormat.hasSquadrato) {

              existingFormat.hasSquadrato = true;

              if (!existingFormat.label.includes('Squadrato')) {

                existingFormat.label += ' Squadrato';

              }

            }

            // Aggiorna anche lo stato Canneté se questa variante lo ha

            if (hasCannete && !existingFormat.hasCannete) {

              existingFormat.hasCannete = true;

              if (!existingFormat.label.includes('Canneté')) {

                existingFormat.label += ' Canneté';

              }

            }

            // Aggiorna anche lo stato RealUp se questa variante lo ha

            if (hasRealUp && !existingFormat.hasRealUp) {

              existingFormat.hasRealUp = true;

              if (!existingFormat.label.includes('RealUp')) {

                existingFormat.label += ' RealUp';

              }

            }

            // Aggiorna anche lo stato Grip se questa variante lo ha

            if (hasGrip && !existingFormat.hasGrip) {

              existingFormat.hasGrip = true;

              if (!existingFormat.label.includes('Grip')) {

                existingFormat.label += ' Grip';

              }

            }

            // Aggiorna anche lo stato Antislip se questa variante lo ha

            if (hasAntislip && !existingFormat.hasAntislip) {

              existingFormat.hasAntislip = true;

              if (!existingFormat.label.includes('Antislip')) {

                existingFormat.label += ' Antislip';

              }

            }

            // Aggiorna anche lo stato Lux/Satinata se questa variante lo ha

            if (hasLux && !existingFormat.label.includes('Satinata')) {

              existingFormat.label += ' Satinata';

            }

          }

          break;

        }

      }

    });

    

    // Se non trova formati con pattern, prova a cercare nelle opzioni

    if (formats.size === 0) {

      // Se il prodotto ha opzioni definite

      if (this.product.options) {

        // Cerca l'opzione "Formato" o "Size"

        const formatOption = this.product.options.find(opt =>

          opt.name && (

            opt.name.toLowerCase().includes('formato') ||

            opt.name.toLowerCase().includes('format') ||

            opt.name.toLowerCase().includes('size') ||

            opt.name.toLowerCase().includes('dimensione')

          )

        );



        if (formatOption && formatOption.values) {

          formatOption.values.forEach(value => {

            // Se il valore sembra un formato

            if (/\d+/.test(value)) {

              const format = value.toLowerCase().replace(/\s/g, '').replace('×', 'x');

              formats.set(format, {

                value: format,

                label: value,

                description: this.getFormatDescription(format),

                price: 0

              });

            }

          });

        }

      }

    }



    // Filtra solo formati che hanno sia rating che varianti con colori validi

    const validFormats = new Map();

    formats.forEach((format, key) => {

      const hasRatings = formatRatings.has(key);

      const hasColors = formatHasValidColors.has(key);

      const ratings = formatRatings.get(key) || { R9: false, R10: false, R11: false, noRating: false };

      const isPareteFormat = format.isParete === true;

      const hasActualRating = ratings.R9 || ratings.R10 || ratings.R11 || ratings.R12 || ratings.R13;

      const hasNoRatingVariants = ratings.noRating === true;



      // Includi se:

      // - Ha ratings E colori (formati normali)

      // - OPPURE è formato PARETE con colori (anche senza rating)

      // - OPPURE ha varianti senza rating (non PARETE) con colori (per INTERNO)

      const shouldInclude = (hasRatings && hasColors) || (isPareteFormat && hasColors) || (hasNoRatingVariants && hasColors && !isPareteFormat);



      if (shouldInclude) {

        format.availableRatings = ratings;

        validFormats.set(key, format);

      }

    });



    this.formatOptions = Array.from(validFormats.values());
    /* KH-ROOTSYNC: ripristina price/compare di ogni formato dalla variante vera (estrazione corrompe il price su finiture non-base) */
    try { var _pp=this; (this.formatOptions||[]).forEach(function(f){ var vv=(_pp.product&&_pp.product.variants||[]).find(function(x){return String(x.id)===String(f.variantId);}); if(vv){ if(vv.price!=null) f.price=parseInt(vv.price); if(vv.compare_at_price!=null) f.compareAtPrice=parseInt(vv.compare_at_price); f.displayPrice=window.khMQ(f.variantId, vv.unit_price); } }); } catch(e){}



    // Aggiungi prezzi fissi per la visualizzazione (se disponibili)

    if (typeof window.getPrezzoFissoM2 === 'function' && ({})) {







      // 🎯 Identifica il prodotto dal titolo - AUTOMATICO

      // Solo prodotti con naming speciale (normalizzazione diversa dal nome)

      const SPECIAL_NAMING = {

        'colovers+': 'coloversplus',

        'colovers plus': 'coloversplus',

        'h.24': 'h24',

        'h 24': 'h24',

        "sinfonie d'autore": 'sinfonie',

        'natural appeal': 'naturalappeal',

        'purity of marble': 'purityofmarble',

        'your match palette': 'yourmatchpaletten2',

        'your match': 'yourmatch'

      };



      let prodottoSpecifico = null;
      /* Escludi vendor IMEX dal sistema prezzi piastrelle */
      if (this.product.vendor && this.product.vendor.toLowerCase() === 'imex') return;

      const titleToCheck = this.product.title.toLowerCase();



      // 1. Cerca prima nella lista prodotti con naming speciale

      for (const [nome, chiave] of Object.entries(SPECIAL_NAMING).sort((a, b) => b[0].length - a[0].length)) {

        if (titleToCheck.includes(nome)) {

          prodottoSpecifico = chiave;

          break;

        }

      }



      // 2. Se non trovato, prova con normalizzazione automatica del titolo

      if (!prodottoSpecifico) {

        // Estrai parole significative del titolo (salta articoli e parole brevi)

        const words = titleToCheck.split(/\s+/).filter(w => w.length > 2 && !['the', 'del', 'della', 'dei', 'and'].includes(w));



        if (words.length > 0) {

          // STRATEGIA 1: Prova con titolo completo normalizzato

          const fullNormalized = words.join('').replace(/[^a-z0-9]/g, '');

          const hasFullProduct = Object.keys(({})).some(key =>

            key.includes('-' + fullNormalized + '-') || key.endsWith('-' + fullNormalized)

          );



          if (hasFullProduct) {

            prodottoSpecifico = fullNormalized;

          }



          // STRATEGIA 2: Se non trovato e ci sono almeno 2 parole, prova con prime 2 parole

          if (!prodottoSpecifico && words.length >= 2) {

            const twoWordsNormalized = words.slice(0, 2).join('').replace(/[^a-z0-9]/g, '');

            const hasTwoWordsProduct = Object.keys(({})).some(key =>

              key.includes('-' + twoWordsNormalized + '-') || key.endsWith('-' + twoWordsNormalized)

            );



            if (hasTwoWordsProduct) {

              prodottoSpecifico = twoWordsNormalized;

            }

          }



          // STRATEGIA 3: Fallback con prima parola

          if (!prodottoSpecifico) {

            const normalized = words[0].replace(/[^a-z0-9]/g, '');

            const hasProduct = Object.keys(({})).some(key =>

              key.includes('-' + normalized + '-') || key.endsWith('-' + normalized)

            );



            if (hasProduct) {

              prodottoSpecifico = normalized;

            }

          }

        }

      }







      this.formatOptions.forEach(format => {

        let formatBase = format.value;

        // Rimuovi TUTTI i suffissi delle caratteristiche speciali per ottenere il formato puro

        formatBase = formatBase

          .replace('-parete', '')

          .replace('-lux', '')

          .replace('-fluid', '')

          .replace('-ptv', '')

          .replace('-lucido', '').replace('-stripe', '').replace('-riga', '').replace('-pliss', '').replace('-twist', '').replace('-strutturasign', '').replace('-strutturanet', '').replace('-strutturamove', '')

          .replace('-comfort', '')

          .replace('-strutturato', '')

          .replace('-satinatoNaturale', '')  // DEVE essere prima di -satinato!

          .replace('-satinato', '').replace('-velvet', '')

          .replace('-liscio', '')

          .replace('-Naturalecuoio', '')

          .replace('-Naturale', '')

          .replace('-naturale', '')

          .replace('-soft', '')

          .replace('-matte', '')

          .replace('-bocciardato', '')

          .replace('-squadrato', '')

          .replace('-squadrata', '')

          .replace('-cannete', '')

          .replace('-realupstrideup', '')

          .replace('-realup', '')

          .replace('-strideup', '')

          .replace('-grip', '')

          .replace('-antislip', '')

          .replace('-fade', '')

          .replace('-20mm', '')

          .replace(/-+/g, '-').replace(/^-|-$/g, '');



        // Salva i suffissi rimossi per ricostruire la chiave corretta dopo

        const hasPTV = format.value.includes('-ptv');

        let hasLucido = format.value.includes('-lucido');

        const hasComfort = format.value.includes('-comfort');

        const hasStrutturato = format.value.includes('-strutturato');

        const hasSatinatoNaturale = format.value.includes('-satinatoNaturale');

        const hasSatinato = format.value.includes('-satinato') && !hasSatinatoNaturale;
        const hasVelvet = format.value.includes('-velvet'); /* KH velvet B */

        let hasLiscio = format.value.includes('-liscio');

        const hasNaturalecuoio = format.value.includes('-Naturalecuoio') || format.value.includes('-naturalecuoio');

        const hasFade = format.value.includes('-fade');

        const hasNaturale = (format.value.includes('-Naturale') && !hasNaturalecuoio) || format.value.includes('-naturale');

        const hasSoft = format.value.includes('-soft');

        const hasLux = format.value.includes('-lux');

        const hasBocciardato = format.value.includes('-bocciardato');

        const hasCannete = format.value.includes('-cannete');

        const hasRealUp = format.value.includes('-realup');

        const hasStrideUp = format.value.includes('-strideup');

        const hasGrip = format.value.includes('-grip');

        const hasAntislip = format.value.includes('-antislip');



        // 🎯 MAPPING FINITURA PER STONES&MORE: "liscio" → "smooth", "lucido" → "glossy"

        let finituraPerStones = null;

        if (prodottoSpecifico === 'stonesmore') {

          if (hasLiscio) {

            finituraPerStones = 'smooth';

            hasLiscio = false; // Non usare più "liscio"

          } else if (hasLucido) {

            finituraPerStones = 'glossy';

            hasLucido = false; // Non usare più "lucido"

          }

        }



        // 🎯 TROVA IL PREZZO MINIMO tra tutti i colori per questo formato DEL PRODOTTO SPECIFICO

        const allPricesForFormat = [];



        // 🎯 Determina la destinazione corrente per scegliere i prezzi corretti

        const currentDestination = window.productConfigurator?.configuration?.destination || this.selectedDestination;

        const isEsterno = currentDestination === 'ESTERNO';



        // Costruisci la chiave con le caratteristiche speciali

        let searchKey = formatBase;

        if (prodottoSpecifico) {

          searchKey = formatBase + '-' + prodottoSpecifico;

          // Aggiungi suffissi nell'ordine corretto: formato-prodotto-caratteristica (es: 60x120-essentialmood-ptv)

          if (hasPTV) searchKey += '-ptv';

          if (hasLucido) searchKey += '-lucido';

          if (hasComfort) searchKey += '-comfort';

          if (hasStrutturato) searchKey += '-strutturato';

          if (hasSatinatoNaturale) searchKey += '-satinatoNaturale';

          if (hasVelvet) searchKey += '-velvet';
          if (hasSatinato) searchKey += '-satinato';

          if (hasLiscio) searchKey += '-liscio';

          if (hasNaturalecuoio) searchKey += '-Naturalecuoio';

          if (hasNaturale) searchKey += '-Naturale';

          if (hasNaturale) searchKey += '-naturale';

          if (hasSoft) searchKey += '-soft';

          if (hasLux) searchKey += '-lux';

          if (hasBocciardato) searchKey += '-bocciardato';

          if (hasCannete) searchKey += '-cannete';

          if (hasRealUp) searchKey += '-realup';

          if (hasStrideUp) searchKey += '-strideup';

          if (hasGrip) searchKey += '-grip';

          if (hasFade) searchKey += '-fade';

          // NOTA: Antislip è una FINITURA, non va nel searchKey per formato


          // Per STONES&MORE usa la finitura mappata

          if (finituraPerStones) searchKey += '-' + finituraPerStones;

        } else {

          // Per prodotti generici, aggiungi le caratteristiche al formato

          if (hasPTV) searchKey += '-ptv';

          if (hasLucido) searchKey += '-lucido';

          if (hasComfort) searchKey += '-comfort';

          if (hasStrutturato) searchKey += '-strutturato';

          if (hasSatinatoNaturale) searchKey += '-satinatoNaturale';

          if (hasVelvet) searchKey += '-velvet';
          if (hasSatinato) searchKey += '-satinato';

          if (hasLiscio) searchKey += '-liscio';

          if (hasNaturalecuoio) searchKey += '-Naturalecuoio';

          if (hasNaturale) searchKey += '-Naturale';

          if (hasNaturale) searchKey += '-naturale';

          if (hasSoft) searchKey += '-soft';

          if (hasLux) searchKey += '-lux';

          if (hasBocciardato) searchKey += '-bocciardato';

          if (hasCannete) searchKey += '-cannete';

          if (hasRealUp) searchKey += '-realup';

          if (hasStrideUp) searchKey += '-strideup';

          if (hasGrip) searchKey += '-grip';

          if (hasFade) searchKey += '-fade';

          // NOTA: Antislip è una FINITURA, non va nel searchKey per formato


        }



        // 🎯 Per ESTERNO: cerca prima chiavi con spessore 20mm, poi r11

        // Per prodotti con prezzi diversi per spessore (es: APOGEO 9mm vs 20mm)

        const spessoriEsterno = ['20mm', 'r11', '9mmr11'];

        let searchKeyWithThickness = searchKey;



        if (isEsterno && prodottoSpecifico) {

          // Prova con ogni spessore per vedere quale esiste

          for (const spessore of spessoriEsterno) {

            const testKey = searchKey + '-' + spessore;

            const hasThicknessPrice = Object.keys(({})).some(k =>

              k === testKey || k.startsWith(testKey + '-')

            );

            if (hasThicknessPrice) {

              searchKeyWithThickness = testKey;

              break;

            }

          }

        }



        for (const [key, value] of Object.entries(({}))) {

          // Se è un prodotto specifico (Supergres, Sinfonie, Provence, Outdoor), cerca solo le chiavi di quel prodotto

          if (prodottoSpecifico) {

            // 🎯 STONES&MORE: cerca formato-prodotto-[COLORE]-finitura (ordine colore-finitura)

            if (prodottoSpecifico === 'stonesmore' && finituraPerStones) {

              // Cerca chiavi che contengono formato+prodotto+finitura (es: "80x180-stonesmore-XXX-smooth")

              const basePattern = formatBase + '-' + prodottoSpecifico;

              if (key.startsWith(basePattern + '-') && key.endsWith('-' + finituraPerStones)) {

                allPricesForFormat.push(value);

              }

            } else if (isEsterno && searchKeyWithThickness !== searchKey) {

              // 🎯 ESTERNO con spessore specifico: cerca SOLO chiavi con lo spessore corretto

              // Es: per 90x90-apogeo-20mm cerca solo chiavi che contengono "-20mm"

              if (key.startsWith(searchKeyWithThickness + '-') || key === searchKeyWithThickness ||

                  key.startsWith(formatBase + '-' + prodottoSpecifico + '-') && key.includes('-' + searchKeyWithThickness.split('-').pop())) {

                allPricesForFormat.push(value);

              }

            } else {

              // Altri prodotti: ordine standard

              // 🎯 Se c'è una finitura specifica (cannete, lucido, satinato, etc.), cerca SOLO quella finitura

              const hasSpecificFinitura = hasCannete || hasLucido || hasVelvet || hasSatinato || hasSoft || hasLux || hasBocciardato || hasStrutturato || hasComfort || hasLiscio || hasRealUp || hasStrideUp || hasGrip || hasAntislip;



              if (hasSpecificFinitura) {

                // Cerca SOLO chiavi che matchano esattamente la searchKey (con finitura)

                if (key.startsWith(searchKey + '-') || key === searchKey) {

                  allPricesForFormat.push(value);

                }

              } else {

                // Nessuna finitura specifica: cerca tutte le varianti per mostrare prezzo minimo

                // Cerca chiavi formato-prodotto-caratteristica-colore (es: "60x120-essentialmood-ptv-polverefresca01")

                // OPPURE formato-prodotto-caratteristica (es: "60x120-essentialmood-ptv")

                // OPPURE formato-prodotto-colore (es: "60x120-essentialmood-polverefresca01")

                // OPPURE formato-prodotto (es: "60x120-essentialmood")

                if (key.startsWith(searchKey + '-') || key === searchKey ||

                    key.startsWith(formatBase + '-' + prodottoSpecifico + '-') || key === formatBase + '-' + prodottoSpecifico) {



                  // 🎯 FIX 21-GEN-2026: Filtra chiavi per destinazione INTERNO/ESTERNO

                  // Per STONEWORK e prodotti con varianti R9/R11 separate

                  // Le chiavi -r9 sono per INTERNO, le chiavi senza -r9 sono per ESTERNO (R11)

                  const hasR9Key = key.includes('-r9');



                  if (currentDestination === 'ESTERNO') {

                    // ESTERNO: escludi chiavi -r9 (quelle sono per INTERNO)

                    if (!hasR9Key) {

                      allPricesForFormat.push(value);

                    }

                  } else if (currentDestination === 'INTERNO') {

                    // INTERNO: raccogli separatamente R9 e non-R9

                    // Memorizziamo con flag per filtrare dopo

                    allPricesForFormat.push({ ...value, _isR9: hasR9Key, _key: key });

                  } else {

                    // Nessuna destinazione: includi tutto

                    allPricesForFormat.push(value);

                  }

                }

              }

            }

          } else {

            // Per prodotti generici (TERRAE, REBEL, ALCHEMY, ecc.), usa il formato con caratteristiche

            if (key === searchKey || key === formatBase) {

              allPricesForFormat.push(value);

            }

          }

        }



        if (allPricesForFormat.length > 0) {

          // 🎯 FIX 21-GEN-2026: Per INTERNO, se ci sono prezzi R9, usa SOLO quelli

          let pricesToUse = allPricesForFormat;

          if (currentDestination === 'INTERNO') {

            const r9Prices = allPricesForFormat.filter(p => p._isR9);

            if (r9Prices.length > 0) {

              pricesToUse = r9Prices;

            } else {

              // Priorità: usa chiavi con finitura indoor specifica
              const indoorFinishes = ['-realup', '-naturale', '-natural', '-lappata', '-lappato', '-fade', '-ptv', '-lucido', '-comfort', '-satinata', '-satinato', '-matt', '-levigato', '-stripe', '-strideup'];
              const indoorFinishPrices = allPricesForFormat.filter(p => {
                const k = (p._key || '').toLowerCase();
                return indoorFinishes.some(f => k.includes(f));
              });

              if (indoorFinishPrices.length > 0) {
                pricesToUse = indoorFinishPrices;
              } else {
                // Fallback: escludi chiavi outdoor ovvie
                const nonOutdoorPrices = allPricesForFormat.filter(p => {
                  const k = (p._key || '').toLowerCase();
                  return !k.includes('-antislip') && !k.includes('-anti-slip') && !k.includes('-20mm');
                });
                if (nonOutdoorPrices.length > 0) {
                  pricesToUse = nonOutdoorPrices;
                }
              }

            }

          }



          // 🆕 PRIORITÀ 1B: Per INTERNO_SOLO_PARETE cerca prezzo basato su comparePrice varianti PARETE

          // Approccio intelligente: trova le varianti con "PARETE" nel colore, prendi il loro comparePrice,

          // poi cerca in unit_price Shopify chiavi con quel comparePrice

          if (currentDestination === 'INTERNO_SOLO_PARETE' && format.value.toLowerCase().includes('-parete')) {

            // 1. Trova varianti con "PARETE" nel colore per questo formato

            const pareteVariants = this.product.variants.filter(v => {

              const opt1 = (v.option1 || '').toLowerCase();

              const opt2 = (v.option2 || '').toLowerCase();

              const matchFormat = opt1.includes(formatBase.replace(/-/g, ''));

              const hasParete = opt2.includes('parete');

              return matchFormat && hasParete;

            });



            if (pareteVariants.length > 0) {

              // 2. Prendi il comparePrice delle varianti PARETE

              const pareteComparePrice = pareteVariants[0].compare_at_price / 100; // converti da centesimi



              // 3. Cerca chiavi in unit_price Shopify con quel comparePrice

              const paretePrices = [];

              for (const [key, value] of Object.entries(({}))) {

                const keyLower = key.toLowerCase();

                if (keyLower.includes(formatBase) && keyLower.includes(prodottoSpecifico)) {

                  if (value.comparePrice === pareteComparePrice) {

                    paretePrices.push(value);

                  }

                }

              }



              if (paretePrices.length > 0) {

                pricesToUse = paretePrices;


              } else {


              }

            }

          }



          // Trova il prezzo minimo tra i prezzi filtrati

          const minPrice = Math.min(...pricesToUse.map(p => p.prezzo));

          const minPriceObj = pricesToUse.find(p => p.prezzo === minPrice);



          // IMPORTANTE: Moltiplica per 100 perché i prezzi in unit_price Shopify sono in EURO, non in centesimi

          format.displayPrice = window.khMQ(format.variantId, (minPriceObj.prezzo * 100)) /* KH unitprice */; // converti in cents

          format.displayComparePrice = minPriceObj.comparePrice * 100; // converti in cents

          format.hasMultiplePrices = pricesToUse.length > 1; // Flag per badge "A PARTIRE DA"




        } else {

          // Fallback: prova senza colore

          const prezziFissi = window.getPrezzoFissoM2(formatBase, this.product.title);

          if (prezziFissi) {

            // Moltiplica per 100 per convertire in centesimi

            format.displayPrice = window.khMQ(format.variantId, (prezziFissi.prezzo * 100)) /* KH unitprice */;

            format.displayComparePrice = prezziFissi.comparePrice * 100;

            format.hasMultiplePrices = false;


          } else {


          }

        }

      });



      // Ordina i formati per prezzo: raggruppa formati simili e ordina per prezzo più basso

      this.formatOptions.sort((a, b) => {

        // Funzione per estrarre formato base (rimuove tutti i suffissi)

        const getFormatBase = (value) => {

          return value

            .replace('-parete', '')

            .replace('-lux', '')

            .replace('-fluid', '')

            .replace('-ptv', '')

            .replace('-glossy', '')

            .replace('-glossybright', '')

            .replace('-lucido', '').replace('-stripe', '').replace('-riga', '').replace('-pliss', '').replace('-twist', '').replace('-strutturasign', '').replace('-strutturanet', '').replace('-strutturamove', '')

            .replace('-lucida', '')

            .replace('-satinatoNaturale', '')  // DEVE essere prima di -satinato!

            .replace('-satinato', '').replace('-velvet', '')

            .replace('-satinata', '')

            .replace('-strutturato', '')

            .replace('-strutturata', '')

            .replace('-strutturato20mm', '')

            .replace('-comfort', '')

            .replace('-liscio', '')

            .replace('-Naturalecuoio', '')

            .replace('-Naturale', '')

            .replace('-naturale', '')

            .replace('-soft', '')

            .replace('-matte', '')

            .replace('-bocciardato', '')

            .replace('-squadrato', '')

            .replace('-squadrata', '')

            .replace('-cannete', '')

            .replace('-grip', '')

            .replace('-antislip', '')

            .replace('-fade', '')

            .replace('-20mm', '')

            .replace(/-+/g, '-').replace(/^-|-$/g, '');

        };



        const baseA = getFormatBase(a.value);

        const baseB = getFormatBase(b.value);



        // Funzione per estrarre dimensioni

        const getDimensions = (format) => {

          const match = format.match(/(\d+(?:\.\d+)?)x(\d+(?:\.\d+)?)/i);

          return match ? [parseFloat(match[1]), parseFloat(match[2])] : [0, 0];

        };



        // Se formati base diversi, ordina PRIMA per dimensione (area CRESCENTE - dal più piccolo), poi per prezzo

        if (baseA !== baseB) {

          const dimsA = getDimensions(baseA);

          const dimsB = getDimensions(baseB);

          const areaA = dimsA[0] * dimsA[1];

          const areaB = dimsB[0] * dimsB[1];



          // Prima ordina per area CRESCENTE (dal più piccolo al più grande)

          if (areaA !== areaB) {

            return areaA - areaB;  // Dal più piccolo al più grande

          }



          // Se stessa area ma formato diverso (es: 60x120 vs 80x90), ordina per prezzo minimo del gruppo

          const getMinPriceForBase = (base, allFormats) => {

            const formatsWithSameBase = allFormats.filter(f => getFormatBase(f.value) === base);

            const prices = formatsWithSameBase

              .map(f => f.displayPrice || f.price || Infinity)

              .filter(p => p !== Infinity);

            return prices.length > 0 ? Math.min(...prices) : Infinity;

          };

          const minPriceA = getMinPriceForBase(baseA, this.formatOptions);

          const minPriceB = getMinPriceForBase(baseB, this.formatOptions);

          return minPriceA - minPriceB;

        }



        // Stesso formato base: ordina per displayPrice, poi per price effettivo

        const displayPriceA = a.displayPrice || Infinity;

        const displayPriceB = b.displayPrice || Infinity;



        if (displayPriceA !== displayPriceB) {

          return displayPriceA - displayPriceB;

        }



        // Se stesso displayPrice, usa il price effettivo (prezzo Shopify calcolato)

        const actualPriceA = a.price || Infinity;

        const actualPriceB = b.price || Infinity;



        if (actualPriceA !== actualPriceB) {

          return actualPriceA - actualPriceB;

        }



        // Se stesso prezzo effettivo, ordina per tipo (naturale prima perché solitamente più economico)

        const getTypeOrder = (value) => {

          if (value.includes('-naturale')) return 1;  // Naturale prima (più economico)

          if (value.includes('-Naturale')) return 2;

          if (value.includes('-soft')) return 3;

          if (value.includes('-liscio')) return 4;

          if (value.includes('-satinato') || value.includes('-satinata')) return 5;

          if (value.includes('-satinatoNaturale')) return 6;

          if (value.includes('-Naturalecuoio') || value.includes('-naturalecuoio')) return 7;

          if (value.includes('-strutturato') || value.includes('-strutturata')) return 8;

          if (value.includes('-strutturato20mm')) return 9;

          if (value.includes('-comfort')) return 10;

          if (value.includes('-bocciardato')) return 11;

          if (value.includes('-grip')) return 12;

          if (value.includes('-lucido') || value.includes('-lucida')) return 13;  // Lucido dopo (più costoso)

          if (value.includes('-ptv')) return 14;

          if (value.includes('-lux')) return 15;

          if (value.includes('-fluid')) return 16;

          if (value.includes('-parete')) return 17;

          return 0; // standard (Naturale base)

        };



        return getTypeOrder(a.value) - getTypeOrder(b.value);

      });

    } else {

      // Se i prezzi non sono disponibili, ordina per dimensione area DECRESCENTE

      this.formatOptions.sort((a, b) => {

        const getFormatBase = (value) => {

          return value.replace('-parete', '').replace('-lux', '').replace('-fluid', '')

            .replace('-ptv', '').replace('-glossy', '').replace('-glossybright', '').replace('-lucido', '').replace('-stripe', '').replace('-riga', '').replace('-pliss', '').replace('-twist', '').replace('-strutturasign', '').replace('-strutturanet', '').replace('-strutturamove', '').replace('-satinatoNaturale', '').replace('-satinato', '').replace('-velvet', '')

            .replace('-strutturato', '').replace('-strutturato20mm', '').replace('-comfort', '')

            .replace('-Naturalecuoio', '').replace('-Naturale', '').replace('-naturale', '').replace('-soft', '').replace('-matte', '')

            .replace('-bocciardato', '').replace('-liscio', '').replace('-levigato', '').replace('-levigata', '').replace('-patinato', '').replace('-patinata', '').replace('-squadrato', '').replace('-squadrata', '').replace('-cannete', '').replace('-grip', '').replace('-antislip', '').replace('-fade', '').replace('-20mm', '').replace(/-+/g, '-').replace(/^-|-$/g, '');

        };



        const baseA = getFormatBase(a.value);

        const baseB = getFormatBase(b.value);



        const getDimensions = (format) => {

          const match = format.match(/(\d+(?:\.\d+)?)x(\d+(?:\.\d+)?)/i);

          return match ? [parseFloat(match[1]), parseFloat(match[2])] : [0, 0];

        };



        const dimsA = getDimensions(baseA);

        const dimsB = getDimensions(baseB);

        const areaA = dimsA[0] * dimsA[1];

        const areaB = dimsB[0] * dimsB[1];



        if (areaA !== areaB) return areaA - areaB;  // Dal più piccolo al più grande

        if (baseA !== baseB) return baseA.localeCompare(baseB);



        const getTypeOrder = (value) => {

          if (value.includes('-lux')) return 1;

          if (value.includes('-fluid')) return 2;

          if (value.includes('-parete')) return 3;

          return 0;

        };



        return getTypeOrder(a.value) - getTypeOrder(b.value);

      });

    }

  },



  // 🟢 Sovrascrive i prezzi dei formati col min unit_price (€/m²) preso da Shopify. No Worker, no prezzi fissi.
  applyUnitPrices() {
    const U = window.__KH_UNIT__;
    if (!U || !this.formatOptions || !this.product || !this.product.variants) return;
    const variants = this.product.variants;
    const dimOf = s => { const m = (s||'').toLowerCase().match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)/); return m ? (m[1]+'x'+m[2]).replace(/,/g,'.') : null; };
    const FIN = ['lappatasatinata','lappata','lappato','levigata','levigato','naturale','matte','satinato','soft','silk','lucido','lux','glossy','liscio','smooth','bocciardato','comfort','strutturato','grip','antislip','realup','cannete','fade'];
    this.formatOptions.forEach(format => {
      const fdim = dimOf(format.value);
      if (!fdim) return;
      const fv = (format.value || '').toLowerCase();
      const is20 = /(20mm|t_20)/.test(fv);
      const finInValue = FIN.filter(f => fv.includes('-' + f));
      let minP = null, minC = null, minBox = null;
      let fbP = null, fbC = null, fbBox = null;
      const _destU = (this.selectedDestination || '').toUpperCase();
      const _isEsternoDest = _destU === 'ESTERNO';
      const _isInternoDest = _destU.indexOf('INTERNO') !== -1;
      variants.forEach(v => {
        if (dimOf(v.option1) !== fdim) return;
        const vtext = ((v.option1||'') + ' ' + (v.option2||'') + ' ' + (v.option3||'')).toLowerCase();
        const v20 = /(20\s*mm|t_20)/.test(vtext);
        if (is20 !== v20) return;
        if (finInValue.length && !finInValue.some(f => vtext.includes(f))) return;
        const u = U[v.id];
        if (!(u && u.p != null)) return;
        if (fbP === null || u.p < fbP) { fbP = u.p; fbC = u.c; fbBox = parseInt(v.price, 10); }
        /* KH-FIX 2026-08-07: filtro destinazione — INTERNO esclude R11/R12/R13 e 20mm (esterno); ESTERNO tiene solo quelli. Evita che la card formato mostri il prezzo Esterno sotto Interno. */
        const vEst = /r1[123]/.test(vtext) || /(20\s*mm|t_?20|2\s*cm)/.test(vtext);
        if (_isEsternoDest && !vEst) return;
        if (_isInternoDest && vEst) return;
        if (minP === null || u.p < minP) { minP = u.p; minC = u.c; minBox = parseInt(v.price, 10); }
      });
      if (minP === null) { minP = fbP; minC = fbC; minBox = fbBox; }
      if (minP !== null) {
        format.displayPrice = minP;                                   // €/mq (unit_price)
        if (!isNaN(minBox)) format.price = minBox;                    // €/scatola (prezzo scatola)
        format.compareAtPrice = (minC !== null && minC > minP) ? minC : null;
      }
    });
  },

  // 🎯 KH 2026-08-07 — FONTE UNICA DI VERITÀ prezzo card formato.
  // Problema risolto: prezzi Interno/Esterno mischiati (la card mostrava il prezzo R11/Esterno sotto Interno).
  // Regola pulita: il prezzo mostrato = ESATTAMENTE la variante Shopify già assegnata al formato (format.variantId,
  // che le regole esistenti scelgono correttamente per destinazione). displayPrice=€/mq unit_price, price=€/scatola.
  khEnforceFormatPricesFromVariant() {
    const U = window.__KH_UNIT__ || {};
    const prod = this.product || window.productData;
    if (!prod || !prod.variants || !this.formatOptions) return;
    const dest = (this.selectedDestination || '').toUpperCase();
    const isEst = dest === 'ESTERNO';
    const isInt = dest.indexOf('INTERNO') !== -1;
    const dimOf = s => { const m = (s || '').toLowerCase().match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)/); return m ? (m[1] + 'x' + m[2]).replace(/,/g, '.') : null; };
    this.formatOptions.forEach(format => {
      const fdim = dimOf(format.value);
      if (!fdim) return;
      let best = null;
      prod.variants.forEach(v => {
        if (dimOf(v.option1) !== fdim) return;
        const vtext = ((v.option1 || '') + ' ' + (v.option2 || '') + ' ' + (v.option3 || '')).toLowerCase();
        const vEst = /\br1[123]\b/.test(vtext) || /(20\s*mm|t_?20|2\s*cm)/.test(vtext);
        if (isEst && !vEst) return;   // ESTERNO: solo varianti esterno (R11/20mm)
        if (isInt && vEst) return;    // INTERNO: escludi esterno (R11/20mm)
        const u = U[v.id];
        const p = (u && u.p != null) ? u.p : null;
        if (p == null) return;
        if (best === null || p < best.p) best = { p: p, c: (u.c != null ? u.c : null), box: parseInt(v.price, 10), id: v.id };
      });
      if (best) {
        format.displayPrice = best.p;                          // €/mq esatto Shopify (destinazione-corretto)
        if (!isNaN(best.box)) format.price = best.box;         // €/scatola esatto Shopify
        format.compareAtPrice = (best.c != null && best.c > best.p) ? best.c : null;
        format.variantId = best.id;                            // allinea variantId alla destinazione
      }
    });
  },

  // Riapplica prezzi di visualizzazione prima del rendering

  applyDisplayPrices() {

    if (typeof window.getPrezzoFissoM2 !== 'function' || !({})) return;






    // Controlla se è selezionata la destinazione ESTERNO (implica 20mm o R11)

    const savedDestination = window.productConfigurator?.configuration?.destination || this.selectedDestination;

    const isEsterno = savedDestination === 'ESTERNO';




    // Identifica il prodotto - USA LISTA GLOBALE CONDIVISA CON Shopify (unit_price)

    // 🎯 window.SUPERGRES_PRODUCTS contiene tutti i mapping nome->chiave

    // Per aggiungere nuovi prodotti, modificare SOLO Shopify (unit_price) (window.SUPERGRES_PRODUCTS)



    let prodottoSpecifico = null;

    const titleToCheck = this.product.title.toLowerCase();

    // 1. Cerca nella lista globale SUPERGRES_PRODUCTS (se disponibile)

    if (window.SUPERGRES_PRODUCTS) {

      for (const [nome, chiave] of Object.entries(window.SUPERGRES_PRODUCTS).sort((a, b) => b[0].length - a[0].length)) {

        if (titleToCheck.includes(nome)) {

          prodottoSpecifico = chiave;

          break;

        }

      }

    }



    // 2. Se non trovato, prova con normalizzazione automatica del titolo

    if (!prodottoSpecifico) {

      // Estrai parole significative del titolo (salta articoli e parole brevi)

      const words = titleToCheck.split(/\s+/).filter(w => w.length > 2 && !['the', 'del', 'della', 'dei', 'and'].includes(w));



      if (words.length > 0) {

        // STRATEGIA 1: Prova con titolo completo normalizzato (es: "Essential Mood" → "essentialmood")

        // 🎯 FIX: Rimuovi anche apostrofi per nomi come "Pierre d'Avignon"

        const fullNormalized = words.join('').replace(/[^a-z0-9]/g, '').replace(/[''`]/g, '');

        const hasFullProduct = Object.keys(({})).some(key =>

          key.includes('-' + fullNormalized + '-') || key.endsWith('-' + fullNormalized)

        );



        if (hasFullProduct) {

          prodottoSpecifico = fullNormalized;

        }



        // STRATEGIA 2: Se non trovato e ci sono almeno 2 parole, prova con prime 2 parole

        if (!prodottoSpecifico && words.length >= 2) {

          const twoWordsNormalized = words.slice(0, 2).join('').replace(/[^a-z0-9]/g, '').replace(/[''`]/g, '');

          const hasTwoWordsProduct = Object.keys(({})).some(key =>

            key.includes('-' + twoWordsNormalized + '-') || key.endsWith('-' + twoWordsNormalized)

          );



          if (hasTwoWordsProduct) {

            prodottoSpecifico = twoWordsNormalized;

          }

        }



        // STRATEGIA 3: Fallback con prima parola (es: "Terrae" → "terrae")

        if (!prodottoSpecifico) {

          const normalized = words[0].replace(/[^a-z0-9]/g, '').replace(/[''`]/g, '');

          const hasProduct = Object.keys(({})).some(key =>

            key.includes('-' + normalized + '-') || key.endsWith('-' + normalized)

          );



          if (hasProduct) {

            prodottoSpecifico = normalized;

          }

        }

      }

    }



    this.formatOptions.forEach(format => {
      let formatBase = format.value;

      // 🔧 FIX PURITY of MARBLE: NON rimuovere -lux - è una finitura separata con prezzi diversi!

      // -parete e -fluid sono indicatori di destinazione, -lux è una FINITURA (Lucida)

      formatBase = formatBase.replace('-parete', '').replace('-fluid', '');

      // 🔧 FIX ORIGINS ESTERNO: Strip -20mm prima di estrarre la finitura, poi ripristina
      let has20mmSuffix = false;
      let formatBaseForFinitura = formatBase;
      if (formatBase.endsWith('-20mm')) {
        has20mmSuffix = true;
        formatBaseForFinitura = formatBase.replace(/-20mm$/, '');
      }

      // 🎯 Estrai finitura dal formato (es: "90x90-naturale" → formato="90x90", finitura="naturale")

      let formatoDimensionale = formatBaseForFinitura;

      let finitura = null;

      // 🔧 FIX PURITY of MARBLE: Aggiunto 'lux' alla lista finiture per riconoscerlo come finitura Lucida

      const finiture = ['cannete', 'naturale', 'lucido', 'lux', 'Naturale', 'strutturato', 'comfort', 'satinato', 'bocciardato', 'liscio', 'realupstrideup', 'realup', 'strideup', 'grip', 'antislip', 'lappato', 'lappata', 'levigato', 'levigata', 'patinato', 'patinata'];

      for (const fin of finiture) {

        if (formatBaseForFinitura.endsWith('-' + fin)) {

          finitura = fin;

          formatoDimensionale = formatBaseForFinitura.replace('-' + fin, '');

          break;

        }

      }



      // 🔍 DEBUG: Log per capire cosa sta succedendo con cannete

      if (format.value.includes('cannete')) {


      }



      // Trova il prezzo minimo tra tutti i colori DEL PRODOTTO SPECIFICO

      const allPricesForFormat = [];

      for (const [key, value] of Object.entries(({}))) {

        if (prodottoSpecifico) {

          // 🎯 Se ESTERNO, cerca chiavi con -20mm O con R11 O con -grip

          if (isEsterno) {

            // Costruisci le chiavi possibili nel formato corretto

            // Es: 90x90-pierredavignon-naturale-20mm, 90x90-pierredavignon-20mm

            // 🎯 FIX PIETRA REGALE: Includi anche chiavi R11 per ESTERNO

            // 🎯 FIX AUTHENTIC LUXE: Includi anche chiavi -grip per ESTERNO

            const keyPatterns20mm = [

              `${formatoDimensionale}-${prodottoSpecifico}-20mm`,

              `${formatoDimensionale}-${prodottoSpecifico}-${finitura}-20mm`,

              `${formatoDimensionale}-${prodottoSpecifico}-naturale-20mm`

            ];

            const keyPatternsR11 = [

              `${formatoDimensionale}-${prodottoSpecifico}-9mmr11`,

              `${formatoDimensionale}-${prodottoSpecifico}-r11`,

              `${formatoDimensionale}-${prodottoSpecifico}-20mmr11`,

              `${formatoDimensionale}-${prodottoSpecifico}-${finitura}-9mmr11`,

              `${formatoDimensionale}-${prodottoSpecifico}-${finitura}-20mmr11`,

              `${formatoDimensionale}-${prodottoSpecifico}-${finitura}-r11`,

              `${formatoDimensionale}-${prodottoSpecifico}-naturale-9mmr11`,

              `${formatoDimensionale}-${prodottoSpecifico}-naturale-20mmr11`,

              `${formatoDimensionale}-${prodottoSpecifico}-naturale-r11`

            ];

            // 🎯 Pattern per prodotti con finitura "grip" per ESTERNO (es: Authentic Luxe)

            const keyPatternsGrip = [

              `${formatoDimensionale}-${prodottoSpecifico}-grip`,

              `${formatoDimensionale}-${prodottoSpecifico}-grip-`

            ];

            // 🎯 Pattern per prodotti con finitura "strutturato" per ESTERNO (es: La Roche 40x80 Strutturato 9mm R11)

            const keyPatternsStrutturato = [

              `${formatoDimensionale}-${prodottoSpecifico}-strutturato`,

              `${formatoDimensionale}-${prodottoSpecifico}-strutturato-`

            ];



            // Se il formato selezionato è 20mm, cerca SOLO chiavi con -20mm
            if (has20mmSuffix) {
              if (key.includes('-20mm') && keyPatterns20mm.some(pattern => key.startsWith(pattern) || key === pattern)) {
                allPricesForFormat.push(value);
              }
            } else {
              // Formato NON 20mm: cerca R11, grip, strutturato (per prodotti con outdoor 9mm)
              if (key.includes('-20mm') && keyPatterns20mm.some(pattern => key.startsWith(pattern) || key === pattern)) {
                allPricesForFormat.push(value);
              }
              else if ((key.includes('r11') || key.includes('R11')) && keyPatternsR11.some(pattern => key.startsWith(pattern) || key === pattern)) {
                allPricesForFormat.push(value);
              }
              else if (key.includes('-grip') && keyPatternsGrip.some(pattern => key.startsWith(pattern) || key === pattern)) {
                allPricesForFormat.push(value);
              }
              else if (key.includes('-strutturato') && !key.includes('20mm') && keyPatternsStrutturato.some(pattern => key.startsWith(pattern) || key === pattern)) {
                allPricesForFormat.push(value);
              }
            }

          } else {

            // INTERNO: cerca formato-prodotto-finitura - TROVA PREZZO MINIMO

            // 🎯 FIX 21-GEN-2026: Non filtrare per R9, accetta TUTTI i prezzi per trovare il minimo

            const formatHas20mm = formatoDimensionale.includes('20mm');

            const keyHas20mm = key.includes('-20mm') || key.includes('20mm-');

            const keyHasGrip = key.includes('-grip');



            // Per INTERNO: accetta tutte le chiavi tranne grip (che è solo ESTERNO)

            // Se formato 20mm: accetta chiavi 20mm

            // Se formato normale: escludi chiavi 20mm

            let shouldProcess = false;

            if (formatHas20mm) {

              // Formato 20mm: accetta chiavi 20mm (sia R9 che R11)

              if (keyHas20mm && !keyHasGrip) {

                shouldProcess = true;

              }

            } else {

              // Formato normale: escludi 20mm e grip

              if (!keyHas20mm && !keyHasGrip) {

                shouldProcess = true;

              }

            }



            if (shouldProcess) {

              let matchFound = false;



              // PRIORITÀ 1: Se c'è finitura, cerca SOLO quella finitura specifica

              if (finitura) {

                const patternConFinitura = `${formatoDimensionale}-${prodottoSpecifico}-${finitura}`;

                if (key === patternConFinitura || key.startsWith(patternConFinitura + '-')) {

                  matchFound = true;

                }

              } else {

                // PRIORITÀ 2: Senza finitura, cerca TUTTE le varianti del formato

                const patternBase = `${formatoDimensionale}-${prodottoSpecifico}-`;

                const patternExact = `${formatoDimensionale}-${prodottoSpecifico}`;

                // 🔧 FIX PURITY of MARBLE: Aggiunto 'lux' per escludere prezzi LUX quando si cerca il base

                const finiturasSpeciali = ['lucido', 'glossy', 'cannete', 'strutturato', 'soft', 'rusticedge', 'grip', 'lux'];

                if (!formatHas20mm) {

                  finiturasSpeciali.push('20mm');

                }

                if (key === patternExact || key.startsWith(patternBase)) {

                  const restoDopo = key.replace(patternBase, '');

                  const isFinituraSpeciale = finiturasSpeciali.some(fs => restoDopo.startsWith(fs));

                  if (!isFinituraSpeciale) {

                    matchFound = true;

                  }

                }

              }



              if (matchFound) {

                allPricesForFormat.push(value);

              }

            }

          }

        } else {

          // Prodotto generico: cerca solo formato base

          if (key === formatBase || key === formatoDimensionale) {

            allPricesForFormat.push(value);

          }

        }

      }



      // Se ESTERNO e non trovato prezzi 20mm/R11/grip/strutturato, prova fallback con spessore esplicito

      if (isEsterno && allPricesForFormat.length === 0 && prodottoSpecifico) {

        // Fallback: cerca qualsiasi chiave del prodotto che contenga 20mm O R11 O grip O strutturato

        for (const [key, value] of Object.entries(({}))) {

          if (key.includes(prodottoSpecifico) && key.startsWith(formatoDimensionale)) {

            if (key.includes('20mm') || key.includes('r11') || key.includes('R11') || key.includes('-grip') || key.includes('-strutturato')) {

              allPricesForFormat.push(value);

            }

          }

        }

      }



      // 🎯 FIX 21-GEN-2026: Per INTERNO con formato 20mm, cerca TUTTI i prezzi (R9 e R11)

      // Il cliente può scegliere sia R9 che R11 per interno, quindi mostriamo il prezzo minimo

      const formatHas20mmGlobal = formatoDimensionale.includes('20mm');

      if (!isEsterno && allPricesForFormat.length === 0 && prodottoSpecifico && formatHas20mmGlobal) {


        for (const [key, value] of Object.entries(({}))) {

          if (key.includes(prodottoSpecifico) && key.startsWith(formatoDimensionale)) {

            // Per INTERNO accetta tutti i prezzi (sia R9 che R11) - mostrerà il minimo


            allPricesForFormat.push(value);

          }

        }

      }



      // 🔍 DEBUG: Log per cannete

      if (format.value.includes('cannete')) {


      }



      if (allPricesForFormat.length > 0) {

        let pricesToUse = allPricesForFormat;



        // 🆕 PRIORITÀ INTERNO_SOLO_PARETE: cerca prezzo basato su comparePrice varianti PARETE

        // Approccio intelligente: trova le varianti con "PARETE" nel colore, prendi il loro comparePrice,

        // poi cerca in unit_price Shopify chiavi con quel comparePrice

        if (savedDestination === 'INTERNO_SOLO_PARETE' && format.value.includes('-parete') && prodottoSpecifico) {

          // 1. Trova varianti con "PARETE" nel colore per questo formato

          const pareteVariants = this.product.variants.filter(v => {

            const opt1 = (v.option1 || '').toLowerCase();

            const opt2 = (v.option2 || '').toLowerCase();

            const matchFormat = opt1.includes(formatoDimensionale.toLowerCase().replace(/-/g, ''));

            const hasParete = opt2.includes('parete');

            return matchFormat && hasParete;

          });



          if (pareteVariants.length > 0) {

            // 2. Prendi il comparePrice delle varianti PARETE

            const pareteComparePrice = pareteVariants[0].compare_at_price / 100; // converti da centesimi



            // 3. Cerca chiavi in unit_price Shopify con quel comparePrice

            const paretePrices = [];

            for (const [key, value] of Object.entries(({}))) {

              const keyLower = key.toLowerCase();

              if (keyLower.includes(formatoDimensionale.toLowerCase()) && keyLower.includes(prodottoSpecifico)) {

                if (value.comparePrice === pareteComparePrice) {

                  paretePrices.push(value);

                }

              }

            }



            if (paretePrices.length > 0) {

              pricesToUse = paretePrices;


            }

          }

        }



        const minPrice = Math.min(...pricesToUse.map(p => p.prezzo));

        const minPriceObj = pricesToUse.find(p => p.prezzo === minPrice);

        // Moltiplica per 100 per convertire in centesimi

        format.displayPrice = window.khMQ(format.variantId, (minPriceObj.prezzo * 100)) /* KH unitprice */;

        format.displayComparePrice = minPriceObj.comparePrice * 100;

        format.hasMultiplePrices = pricesToUse.length > 1;

        // 🔴 DEBUG: Log per TUTTI i formati per vedere assegnazione prezzo


      } else {
        // Fallback usando getPrezzoFissoM2 con spessore

        // Per ESTERNO prova vari spessori (20mm, 9mmr11, r11) finché non trova

        let prezziFissi = null;

        if (isEsterno) {

          const spessoriEsterno = ['20mm', '9mmr11', 'r11', '20mmr11'];

          for (const sp of spessoriEsterno) {

            prezziFissi = window.getPrezzoFissoM2(formatBase, this.product.title, null, sp);

            if (prezziFissi) {

              break;

            }

          }

          // Se ancora non trova, prova senza spessore (la ricerca intelligente proverà tutto)

          if (!prezziFissi) {

            prezziFissi = window.getPrezzoFissoM2(formatBase, this.product.title, null, null);

          }

        } else {

          prezziFissi = window.getPrezzoFissoM2(formatBase, this.product.title, null, null);

        }

        if (prezziFissi) {

          // Moltiplica per 100 per convertire in centesimi (come allPricesForFormat)

          format.displayPrice = window.khMQ(format.variantId, (prezziFissi.prezzo * 100)) /* KH unitprice */;

          format.displayComparePrice = prezziFissi.comparePrice * 100;

          format.hasMultiplePrices = false;



          // 🔴 DEBUG: Log per TUTTI i formati per vedere assegnazione prezzo


        } else {

          // 🔴 DEBUG: Nessun prezzo trovato!


        }

      }

    });

  },



  // Estrai colori dalle varianti e metaobject

  extractColorsFromVariants(variants) {

    const colors = new Map();



    // Controlla metaobjects

    if (this.product.metaobjects) {

      // Prova TUTTE le chiavi, non solo quelle con "color"

      for (const key in this.product.metaobjects) {

        const metaobj = this.product.metaobjects[key];

        // Estrai sempre, poi vediamo cosa c'è

        if (metaobj) {

          this.extractColorsFromMetaobject(metaobj, colors);

        }

      }

    }



    // Controlla anche metafields.custom

    if (this.product.metafields?.custom) {

      for (const key in this.product.metafields.custom) {

        // Se sembra contenere dati colore

        if (key.toLowerCase().includes('color') ||

            key.toLowerCase().includes('colore') ||

            key.toLowerCase().includes('colour')) {

          const field = this.product.metafields.custom[key];

          if (field) {

            this.extractColorsFromMetaobject(field, colors);

          }

        }

      }

    }



    // Se non trova nei metaobjects/metafields, estrai dalle varianti

    if (colors.size === 0) {

      variants.forEach((variant, index) => {

        // Cerca il colore nelle opzioni

        const options = [

          variant.option1,

          variant.option2,

          variant.option3

        ].filter(opt => opt);



        for (const option of options) {

          // Salta formati e spessori

          if (!/\d+x\d+/i.test(option) && !/\d+mm/i.test(option)) {

            // Ottieni l'immagine della variante

            let imageUrl = '';



            // Prova diversi modi per ottenere l'immagine

            if (variant.featured_image) {

              imageUrl = variant.featured_image.src || variant.featured_image;

            } else if (variant.image) {

              imageUrl = variant.image.src || variant.image;

            } else if (variant.featured_media) {

              imageUrl = variant.featured_media.preview_image?.src || '';

            }



            // Se l'immagine non ha protocollo, aggiungi https:

            if (imageUrl && !imageUrl.startsWith('http')) {

              imageUrl = 'https:' + imageUrl;

            }

            

            if (!colors.has(option)) {

              // 🎯 Cerca il prezzo fisso usando il comparePrice della variante

              let displayPrice = variant.price;

              let displayComparePrice = variant.compare_at_price;

              if (typeof window.getPrezzoByComparePrice === 'function' && variant.compare_at_price) {

                const prezzoFisso = window.getPrezzoByComparePrice(variant.compare_at_price, this.product.title);

                if (prezzoFisso) {

                  // Moltiplica per 100 per convertire in centesimi

                  displayPrice = prezzoFisso.prezzo * 100;

                  displayComparePrice = prezzoFisso.comparePrice * 100;

                }

              }



              colors.set(option, {

                value: option,

                label: option,

                code: this.getColorCode(option),

                image: imageUrl,

                variantId: variant.id,

                price: variant.price,

                compareAtPrice: variant.compare_at_price,

                displayPrice: displayPrice,

                displayComparePrice: displayComparePrice

              });

            }

            break;

          }

        }

      });

    }



    this.colorOptions = Array.from(colors.values());

  },



  // Helper per estrarre colori dai metaobject

  extractColorsFromMetaobject(metaobj, colorsMap) {

    if (!metaobj) return;



    // Se è un array diretto

    if (Array.isArray(metaobj)) {

      metaobj.forEach(item => {

        // Gestisci oggetti con riferimenti

        if (item.value) {

          this.extractColorFromItem(item.value, colorsMap);

        } else {

          this.extractColorFromItem(item, colorsMap);

        }

      });

    }

    // Se ha fields

    else if (metaobj.fields) {

      // Cerca campi colore

      for (const key in metaobj.fields) {

        if (key.toLowerCase().includes('color') || key.toLowerCase().includes('colore')) {

          const field = metaobj.fields[key];

          if (Array.isArray(field)) {

            field.forEach(color => this.extractColorFromItem(color, colorsMap));

          } else {

            this.extractColorFromItem(field, colorsMap);

          }

        }

      }

    }

    // Se ha value (stringa JSON o oggetto)

    else if (metaobj.value) {

      try {

        const parsed = typeof metaobj.value === 'string' ?

          JSON.parse(metaobj.value) : metaobj.value;



        if (Array.isArray(parsed)) {

          parsed.forEach(item => this.extractColorFromItem(item, colorsMap));

        } else {

          this.extractColorFromItem(parsed, colorsMap);

        }

      } catch (e) {

        // Errore silenzioso nel parsing metaobject

      }

    }

    // Se è un oggetto diretto

    else if (typeof metaobj === 'object') {

      this.extractColorFromItem(metaobj, colorsMap);

    }

  },

  

  // Helper per estrarre un singolo colore

  extractColorFromItem(item, colorsMap) {

    if (!item) return;

    

    // Estrai nome

    const name = item.name || item.nome || item.title || item.label || item.color_name;

    

    if (name) {

      // Estrai immagine - cerca in vari campi possibili

      let imageUrl = '';

      

      // Cerca l'immagine in diversi campi possibili

      if (item.image) {

        // Se image è un oggetto con src

        if (typeof item.image === 'object' && item.image.src) {

          imageUrl = item.image.src;

        } 

        // Se image è un URL diretto

        else if (typeof item.image === 'string') {

          imageUrl = item.image;

        }

      } 

      // Altri campi possibili per l'immagine

      else if (item.immagine) {

        imageUrl = typeof item.immagine === 'object' ? item.immagine.src : item.immagine;

      }

      else if (item.color_image) {

        imageUrl = typeof item.color_image === 'object' ? item.color_image.src : item.color_image;

      }

      else if (item.photo) {

        imageUrl = typeof item.photo === 'object' ? item.photo.src : item.photo;

      }

      else if (item.picture) {

        imageUrl = typeof item.picture === 'object' ? item.picture.src : item.picture;

      }

      

      // Se l'URL non ha protocollo, aggiungi https:

      if (imageUrl && !imageUrl.startsWith('http')) {

        imageUrl = imageUrl.startsWith('//') ? 'https:' + imageUrl : 'https://' + imageUrl;

      }

      

      // Estrai codice colore

      const code = item.code || item.codice || item.hex || item.color_code || this.getColorCode(name);



      colorsMap.set(name, {

        value: name,

        label: name,

        code: code,

        image: imageUrl

      });

    }

  },



  // Estrai spessori dalle varianti

  extractThicknessFromVariants(variants) {

    const thicknesses = new Map();



    // Trova quale opzione contiene gli spessori

    let thicknessOptionIndex = -1;

    let thicknessOptionName = null;



    if (this.product && this.product.options) {

      this.product.options.forEach((opt, idx) => {

        // Se l'opzione si chiama "Spessore" o contiene "mm" nel nome

        if (opt.name && (

          opt.name.toLowerCase().includes('spess') ||

          opt.name.toLowerCase().includes('thick') ||

          opt.name.toLowerCase() === 'mm' ||

          opt.name.toLowerCase().includes('millimetri')

        )) {

          thicknessOptionIndex = idx + 1; // option1 = idx 0, option2 = idx 1, etc.

          thicknessOptionName = opt.name;

        }

      });

    }



    variants.forEach((variant, index) => {

      // Non filtriamo per available - estraiamo spessori da tutte le varianti



      // Pattern per estrarre spessori SOLO quando c'è esplicitamente "mm" o "cm"

      const thicknessPattern = /(\d+(?:[.,]\d+)?)\s*mm/i;

      const thicknessCmPattern = /(\d+(?:[.,]\d+)?)\s*cm/i;

      const thicknessWithRatingPattern = /(\d+(?:[.,]\d+)?)\s*mm\s+(r\d+)/i;



      // Se abbiamo identificato quale opzione contiene lo spessore

      if (thicknessOptionIndex > 0) {

        // Prendi solo l'opzione corretta

        const thicknessOption = variant[`option${thicknessOptionIndex}`];



        if (thicknessOption) {

          // Controlla se la variante è Lucida

          const variantFullText = `${variant.title || ''} ${variant.option1 || ''} ${variant.option2 || ''} ${variant.option3 || ''}`.toLowerCase();

          const isLucido = variantFullText.includes('lucido') || variantFullText.includes('lucida') || variantFullText.includes('glossy');



          // Cerca spessore con rating

          const matchWithRating = thicknessOption.match(thicknessWithRatingPattern);

          if (matchWithRating) {

            const thickness = matchWithRating[1].replace(',', '.') + 'mm';

            const rating = matchWithRating[2].toUpperCase();



            // Mantieni sempre il rating nella chiave e nella label per ogni combinazione

            const thicknessKey = `${thickness} ${rating}`;

            if (!thicknesses.has(thicknessKey)) {

              thicknesses.set(thicknessKey, {

                value: thicknessKey,

                label: `${thickness} ${rating}`,  // Include il rating nella label

                description: this.getThicknessDescription(thickness),

                rating: rating

              });

            }

          } else {

            // Cerca spessore semplice con "mm"

            const match = thicknessOption.match(thicknessPattern);

            if (match) {

              const thickness = match[1].replace(',', '.') + 'mm';



              // Controlla se l'opzione contiene "PARETE" per distinguere spessori parete

              const hasParete = thicknessOption.toLowerCase().includes('parete');

              const thicknessKey = hasParete ? `${thickness}-parete` : thickness;



              if (!thicknesses.has(thicknessKey)) {

                thicknesses.set(thicknessKey, {

                  value: thicknessKey,

                  label: thickness,  // Label pulito senza "PARETE"

                  description: this.getThicknessDescription(thickness),

                  isParete: hasParete

                });

              }

            } else {

              // Cerca spessore in centimetri (es: "2cm" diventa "20mm")

              const matchCm = thicknessOption.match(thicknessCmPattern);

              if (matchCm) {

                const thicknessValue = parseFloat(matchCm[1].replace(',', '.')) * 10;

                const thickness = thicknessValue + 'mm';

                if (!thicknesses.has(thickness)) {

                  thicknesses.set(thickness, {

                    value: thickness,

                    label: thickness,

                    description: this.getThicknessDescription(thickness)

                  });

                }

              }

            }

          }

        }

      } else {

        // Fallback: cerca "mm" o "cm" in tutte le opzioni

        const options = [variant.option1, variant.option2, variant.option3].filter(opt => opt);



        // Controlla se la variante è Lucida

        const variantFullText = `${variant.title || ''} ${variant.option1 || ''} ${variant.option2 || ''} ${variant.option3 || ''}`.toLowerCase();

        const isLucido = variantFullText.includes('lucido') || variantFullText.includes('lucida') || variantFullText.includes('glossy');



        for (const option of options) {

          // IMPORTANTE: Cerca SOLO se l'opzione contiene esplicitamente "mm" o "cm"

          if (option && (option.toLowerCase().includes('mm') || option.toLowerCase().includes('cm'))) {

            // Cerca spessore con rating

            const matchWithRating = option.match(thicknessWithRatingPattern);

            if (matchWithRating) {

              const thickness = matchWithRating[1].replace(',', '.') + 'mm';

              const rating = matchWithRating[2].toUpperCase();



              // Mantieni sempre il rating nella chiave e nella label per ogni combinazione

              const thicknessKey = `${thickness} ${rating}`;

              if (!thicknesses.has(thicknessKey)) {

                thicknesses.set(thicknessKey, {

                  value: thicknessKey,

                  label: `${thickness} ${rating}`,  // Include il rating nella label

                  description: this.getThicknessDescription(thickness),

                  rating: rating

                });

              }

            } else {

              // Cerca spessore semplice in mm

              const match = option.match(thicknessPattern);

              if (match) {

                const thickness = match[1].replace(',', '.') + 'mm';



                // Verifica se c'è un rating separato nella stessa opzione

                const ratingMatch = option.match(/r\d+/i);

                if (ratingMatch) {

                  const rating = ratingMatch[0].toUpperCase();



                  // Mantieni sempre il rating nella chiave e nella label

                  const thicknessKey = `${thickness} ${rating}`;

                  if (!thicknesses.has(thicknessKey)) {

                    thicknesses.set(thicknessKey, {

                      value: thicknessKey,

                      label: `${thickness} ${rating}`,

                      description: this.getThicknessDescription(thickness),

                      rating: rating

                    });

                  }

                } else {

                  // 🆕 Controlla se l'opzione contiene "PARETE"

                  const hasParete = option.toLowerCase().includes('parete');

                  const thicknessKey = hasParete ? `${thickness}-parete` : thickness;



                  if (!thicknesses.has(thicknessKey)) {

                    thicknesses.set(thicknessKey, {

                      value: thicknessKey,

                      label: thickness,  // Label pulito senza "PARETE"

                      description: this.getThicknessDescription(thickness),

                      isParete: hasParete

                    });

                  }

                }

              } else {

                // Cerca spessore in centimetri (es: "2cm" diventa "20mm")

                const matchCm = option.match(thicknessCmPattern);

                if (matchCm) {

                  const thicknessValue = parseFloat(matchCm[1].replace(',', '.')) * 10;

                  const thickness = thicknessValue + 'mm';



                  // Verifica se c'è un rating separato nella stessa opzione

                  const ratingMatch = option.match(/r\d+/i);

                  if (ratingMatch) {

                    const rating = ratingMatch[0].toUpperCase();



                    // Mantieni sempre il rating nella chiave e nella label

                    const thicknessKey = `${thickness} ${rating}`;

                    if (!thicknesses.has(thicknessKey)) {

                      thicknesses.set(thicknessKey, {

                        value: thicknessKey,

                        label: `${thickness} ${rating}`,

                        description: this.getThicknessDescription(thickness),

                        rating: rating

                      });

                    }

                  } else {

                    if (!thicknesses.has(thickness)) {

                      thicknesses.set(thickness, {

                        value: thickness,

                        label: thickness,

                        description: this.getThicknessDescription(thickness)

                      });

                    }

                  }

                }

              }

            }

          }

        }

      }

    });

    

    this.thicknessOptions = Array.from(thicknesses.values());



    // Ordina gli spessori numericamente e per rating (R9 prima di R10, R10 prima di R11, etc.)

    this.thicknessOptions.sort((a, b) => {

      // Estrai numero dello spessore

      const numA = parseFloat(a.value.match(/\d+(?:[.,]\d+)?/)?.[0]?.replace(',', '.') || 0);

      const numB = parseFloat(b.value.match(/\d+(?:[.,]\d+)?/)?.[0]?.replace(',', '.') || 0);



      // Prima ordina per numero

      if (numA !== numB) {

        return numA - numB;

      }



      // Se lo spessore è uguale, ordina per rating (R9, R10, R11, R12, R13)

      const ratingA = a.rating ? parseInt(a.rating.replace('R', '')) : 999;

      const ratingB = b.rating ? parseInt(b.rating.replace('R', '')) : 999;

      return ratingA - ratingB;

    });



    // Se non trova spessori, array vuoto

    if (this.thicknessOptions.length === 0) {

      this.thicknessOptions = [];

    }

  },



  // Determina quali destinazioni mostrare basandosi sui rating disponibili nelle varianti

  updateAvailableDestinations(variants) {

    let hasR9 = false;

    let hasR10 = false;

    let hasR11 = false;

    let hasR12 = false;

    let hasR13 = false;



    // Cerca R9, R10, R11, R12, R13 per INTERNO (esclude varianti PARETE)

    let internoHasR9 = false;

    let internoHasR10 = false;

    let internoHasNoRating = false; // Varianti senza rating (non PARETE, non 20mm) vanno in INTERNO

    let has20mmNoRating = false; // 🆕 Varianti 20mm senza rating vanno in ESTERNO



    // 🆕 Prima controlla se ci sono 20mm senza rating (va in ESTERNO anche senza rating system)

    variants.forEach(variant => {

      const variantText = `${variant.title} ${variant.option1} ${variant.option2} ${variant.option3}`;

      const variantLower = variantText.toLowerCase();

      const is20mm = /\b20\s*mm\b/.test(variantLower) || /\b2\s*cm\b/.test(variantLower);

      const hasAnyRating = /\br9\b|\br10\b|\br11\b|\br12\b|\br13\b/i.test(variantLower);

      if (is20mm && !hasAnyRating && !variantText.toUpperCase().includes('PARETE')) {

        has20mmNoRating = true;

      }

    });



    // Se il prodotto non ha sistema di rating E non ha 20mm senza rating, mostra SOLO INTERNO

    if (!this.productHasRatingSystem && !has20mmNoRating) {

      this.destinationOptions = [

        {

          value: 'INTERNO',

          label: 'Interno',

          description: 'Per ambienti interni',

          image: 'https://cdn.shopify.com/s/files/1/0949/7713/0845/files/INTERNO_SUPERGRES.jpg?v=1762276257'

        }

      ];

      return;

    }



    variants.forEach(variant => {

      // Non filtriamo per available - controlliamo tutte le varianti per determinare le destinazioni

      const variantText = `${variant.title} ${variant.option1} ${variant.option2} ${variant.option3}`;

      const variantLower = variantText.toLowerCase();



      // Verifica se ha un rating

      const variantHasR9 = /\br9\b/.test(variantLower);

      const variantHasR10 = /\br10\b/.test(variantLower);

      const variantHasR11 = /\br11\b/.test(variantLower);

      const variantHasR12 = /\br12\b/.test(variantLower);

      const variantHasR13 = /\br13\b/.test(variantLower);

      const variantHasAnyRating = variantHasR9 || variantHasR10 || variantHasR11 || variantHasR12 || variantHasR13;



      // 🆕 Verifica se è 20mm (cerca "20mm", "20 mm", "2cm")

      const is20mm = /\b20\s*mm\b/.test(variantLower) || /\b2\s*cm\b/.test(variantLower);



      // Solo varianti NON PARETE per INTERNO

      if (!variantText.toUpperCase().includes('PARETE')) {

        if (variantHasR9) internoHasR9 = true;

        if (variantHasR10) internoHasR10 = true;

        // Se la variante NON ha nessun rating

        if (!variantHasAnyRating) {

          // 🆕 Se è 20mm senza rating → va in ESTERNO

          if (is20mm) {

            has20mmNoRating = true;

          } else if (!variantLower.includes('battiscopa')) {

            // Se NON è 20mm, NON è battiscopa e non ha rating → va in INTERNO

            // 🆕 FIX 22-GEN-2026: Escludi battiscopa dal conteggio INTERNO

            internoHasNoRating = true;

          }

        }

      }



      // Per tutti i rating (per ESTERNO e controllo generale)

      if (variantHasR9) hasR9 = true;

      if (variantHasR10) hasR10 = true;

      if (variantHasR11) hasR11 = true;

      if (variantHasR12) hasR12 = true;

      if (variantHasR13) hasR13 = true;

    });



    const hasR9orR10 = hasR9 || hasR10;

    const hasR11orR12orR13 = hasR11 || hasR12 || hasR13;



    // Costruisci array destinazioni basandosi sui rating trovati

    const newDestinations = [];



    // INTERNO: mostrato se ci sono varianti con R9, R10, oppure SENZA rating (esclude PARETE)

    if (internoHasR9 || internoHasR10 || internoHasNoRating) {

      // Costruisci la lista dei rating trovati per INTERNO (solo NON PARETE)

      const internoRatings = [];

      if (internoHasR9) internoRatings.push('R9');

      if (internoHasR10) internoRatings.push('R10');

      // Se ci sono varianti senza rating, non mostriamo nulla come resistenza

      const resistenzaText = internoRatings.length > 0 ? internoRatings.join(' / ') : '';



      newDestinations.push({

        value: 'INTERNO',

        label: 'Interno',

        description: 'Per ambienti interni',

        resistenza: resistenzaText,

        image: 'https://cdn.shopify.com/s/files/1/0949/7713/0845/files/INTERNO_SUPERGRES.jpg?v=1762276257'

      });

    }



    // ESTERNO: mostrato se ci sono varianti con R11, R12, R13 OPPURE 20mm senza rating

    if (hasR11orR12orR13 || has20mmNoRating) {

      // Costruisci la lista dei rating trovati

      const externoRatings = [];

      if (hasR11) externoRatings.push('R11');

      if (hasR12) externoRatings.push('R12');

      if (hasR13) externoRatings.push('R13');

      // 🆕 Se ci sono 20mm senza rating E il prodotto ha rating system, aggiungi indicazione

      // Se il prodotto NON ha rating system, non mostrare nulla come resistenza

      if (has20mmNoRating && externoRatings.length === 0 && this.productHasRatingSystem) {

        externoRatings.push('20mm Outdoor');

      }

      const resistenzaText = externoRatings.join(' / ');



      newDestinations.push({

        value: 'ESTERNO',

        label: 'Esterno',

        description: 'Per spazi esterni',

        resistenza: resistenzaText,

        image: 'https://cdn.shopify.com/s/files/1/0949/7713/0845/files/ESTERNO_SUPERGRES.jpg?v=1762276259'

      });

    }



    // NOTA: "INTERNO SOLO A PARETE" viene gestito separatamente nel rendering

    // e non passa attraverso questa funzione



    this.destinationOptions = newDestinations;

  },



  // Crea una rappresentazione visiva dello spessore con piastrelle 3D

  createThicknessVisual(thicknessValue) {

    // Calcola l'altezza proporzionale (6mm = 15px, 20mm = 50px)

    const height = Math.min(50, Math.max(15, thicknessValue * 2.5));

    const width = 100;

    const depth = 40;

    

    // Colori per l'effetto 3D

    const topColor = '#2D5A3D';

    const frontColor = '#1B4332';

    const sideColor = '#1B4332';

    

    // Crea vista isometrica di piastrelle impilate per mostrare lo spessore

    return `

      <svg width="120" height="120" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">

        <!-- Piastrella di sfondo per confronto -->

        <g transform="translate(10, 70)">

          <!-- Lato superiore sfondo -->

          <path d="M 0 -10 L 40 -30 L 100 -10 L 60 10 Z" 

                fill="#D9D2C5" opacity="0.3"/>

          <!-- Lato frontale sfondo -->

          <path d="M 0 -10 L 0 5 L 60 25 L 60 10 Z" 

                fill="#d0d0d0" opacity="0.3"/>

          <!-- Lato destro sfondo -->

          <path d="M 60 10 L 60 25 L 100 5 L 100 -10 Z" 

                fill="#c0c0c0" opacity="0.3"/>

        </g>

        

        <!-- Piastrella principale che mostra lo spessore -->

        <g transform="translate(10, ${70 - height/2})">

          <!-- Lato superiore -->

          <path d="M 0 -10 L 40 -30 L 100 -10 L 60 10 Z" 

                fill="${topColor}" stroke="#fff" stroke-width="0.5"/>

          

          <!-- Lato frontale (questo mostra lo spessore) -->

          <path d="M 0 -10 L 0 ${height - 10} L 60 ${height + 10} L 60 10 Z" 

                fill="${frontColor}" stroke="#fff" stroke-width="0.5"/>

          

          <!-- Lato destro (questo mostra lo spessore) -->

          <path d="M 60 10 L 60 ${height + 10} L 100 ${height - 10} L 100 -10 Z" 

                fill="${sideColor}" stroke="#fff" stroke-width="0.5"/>

          

          <!-- Linee di misura per enfatizzare lo spessore -->

          <line x1="-10" y1="-10" x2="-10" y2="${height - 10}" 

                stroke="#333" stroke-width="1" stroke-dasharray="2,2" opacity="0.5"/>

          <line x1="-15" y1="-10" x2="-5" y2="-10" 

                stroke="#333" stroke-width="1" opacity="0.5"/>

          <line x1="-15" y1="${height - 10}" x2="-5" y2="${height - 10}" 

                stroke="#333" stroke-width="1" opacity="0.5"/>

        </g>

        

        <!-- Testo spessore -->

        <text x="60" y="110" text-anchor="middle" 

              font-family="Arial, sans-serif" font-size="10" fill="#666">

          ${thicknessValue} mm

        </text>

      </svg>

    `;

  },

  

  // Genera SVG della piastrella con colore/immagine applicato sulla superficie

  generateTileSVG(format, colorCode, imageUrl = null) {

    // Gestisci sia oggetti formato che stringhe

    const formatValue = typeof format === 'object' ? format.value : format;



    // Se c'è un'immagine, crea un pattern, altrimenti usa il colore

    if (imageUrl) {

      return this.generateFormatSVGWithImage(formatValue, imageUrl);

    } else {

      return this.generateFormatSVGWithColor(formatValue, colorCode);

    }

  },

  

  // Genera SVG con colore solido (identico allo step 2 ma con colore custom)

  generateFormatSVGWithColor(format, colorCode) {

    // Normalizza formato battiscopa (es: "Battiscopa 7.2x80" -> "7.2x80")

    let formatForDimensions = format;

    if (format.toLowerCase().includes('battiscopa')) {

      const match = format.match(/(\d+(?:[.,]\d+)?)\s*[xX]\s*(\d+(?:[.,]\d+)?)/);

      if (match) {

        formatForDimensions = `${match[1]}x${match[2]}`.replace(',', '.');

      }

    }



    // Estrai dimensioni dal formato (es: "60x60" -> [60, 60])

    let [width, height] = formatForDimensions.split('x').map(n => parseFloat(n));



    // Fallback se le dimensioni non sono valide

    if (isNaN(width) || isNaN(height)) {

      width = 60;

      height = 60;

    }



    // Mantieni le proporzioni originali per visualizzazione accurata

    const originalWidth = width;

    const originalHeight = height;



    // Determina dimensione contenitore in base al viewport

    const isMobile = window.innerWidth <= 768;



    // Calcola containerSize in base al formato - dimensioni proporzionali su mobile e desktop

    // Su mobile dimensioni ridotte per stare dentro la card (max ~100px per non uscire dai lati)

    let containerSize = isMobile ? 85 : 160;

    if (format.startsWith('160x320')) containerSize = isMobile ? 100 : 280;

    else if (format.startsWith('150x300')) containerSize = isMobile ? 98 : 270;

    else if (format.startsWith('120x280') || format.startsWith('120x278') || format.startsWith('120x260')) containerSize = isMobile ? 95 : 260;

    else if (format.startsWith('120x240')) containerSize = isMobile ? 95 : 240;

    else if (format.startsWith('150x150')) containerSize = isMobile ? 92 : 220;

    else if (format.startsWith('120x120')) containerSize = isMobile ? 90 : 200;

    else if (format.startsWith('80x180')) containerSize = isMobile ? 90 : 210;

    else if (format.startsWith('80x160')) containerSize = isMobile ? 90 : 215;

    else if (format.startsWith('75x150')) containerSize = isMobile ? 88 : 200;

    else if (format.startsWith('26.5x180') || format.startsWith('20x180')) containerSize = isMobile ? 95 : 210;

    else if (format.startsWith('26.5x160')) containerSize = isMobile ? 95 : 220;  // Listello largo

    else if (format.startsWith('20x150')) containerSize = isMobile ? 92 : 200;

    else if (format.startsWith('60x120')) containerSize = isMobile ? 85 : 190;

    else if (format.startsWith('60x90')) containerSize = isMobile ? 85 : 180;

    else if (format.startsWith('30x120') || format.startsWith('20x120')) containerSize = isMobile ? 95 : 200;

    else if (format.startsWith('20x60')) containerSize = isMobile ? 80 : 170;

    // Formati battiscopa - strisce sottili e lunghe (usa formatForDimensions per match corretto)

    else if (formatForDimensions.startsWith('6.5x120') || formatForDimensions.startsWith('6.3x120') || formatForDimensions.startsWith('6x120')) containerSize = isMobile ? 110 : 250;

    else if (formatForDimensions.startsWith('26.5x160')) containerSize = isMobile ? 95 : 220;  // Listello largo

    else if (formatForDimensions.startsWith('7.2x90') || formatForDimensions.startsWith('7x90')) containerSize = isMobile ? 105 : 230;

    else if (formatForDimensions.startsWith('7.2x80') || formatForDimensions.startsWith('7x80')) containerSize = isMobile ? 100 : 210;

    else if (formatForDimensions.startsWith('7.2x60') || formatForDimensions.startsWith('7x60')) containerSize = isMobile ? 90 : 180;



    const maxDim = Math.max(width, height);



    // Base scale adattata al contenitore

    const baseScale = isMobile ? 65 : 80;

    let scale = baseScale / maxDim;



    // Aumenta la scala per i formati specifici

    // Usa startsWith per intercettare formati con suffissi (es: "120x120-comfort-squadrato")

    const scaleFactor = isMobile ? 0.85 : 1; // Scala maggiore su mobile



    // Formati grandi

    if (format.startsWith('160x320')) {

      scale = scale * 2.7 * scaleFactor;  // Lastra maxi

    } else if (format.startsWith('150x300')) {

      scale = scale * 2.6 * scaleFactor;  // Lastra grande

    } else if (format.startsWith('120x280') || format.startsWith('120x278') || format.startsWith('120x260')) {

      scale = scale * 2.4 * scaleFactor;

    } else if (format.startsWith('120x240')) {

      scale = scale * 2.2 * scaleFactor;

    } else if (format.startsWith('150x150')) {

      scale = scale * 1.8 * scaleFactor;  // Quadratone grande

    } else if (format.startsWith('120x120')) {

      scale = scale * 1.6 * scaleFactor;

    } else if (format.startsWith('75x150')) {

      scale = scale * 1.5 * scaleFactor;  // Rettangolo medio

    } else if (format.startsWith('90x90')) {

      scale = scale * 1.25 * scaleFactor;

    } else if (format.startsWith('80x80')) {

      scale = scale * 1.2 * scaleFactor;

    } else if (format.startsWith('80x180')) {

      scale = scale * 1.8 * scaleFactor;

    } else if (format.startsWith('80x160')) {

      scale = scale * 1.7 * scaleFactor;  // Rettangolo grande 1:2

    } else if (format.startsWith('26.5x180')) {

      scale = scale * 1.8 * scaleFactor;  // Formato listello lungo

    } else if (format.startsWith('20x180')) {

      scale = scale * 1.8 * scaleFactor;  // Formato listello lungo

    } else if (format.startsWith('26.5x160')) {

      scale = scale * 1.75 * scaleFactor;  // Listello largo

    } else if (format.startsWith('20x150')) {

      scale = scale * 1.7 * scaleFactor;  // Formato listello lungo

    // Formati medi

    } else if (format.startsWith('60x120')) {

      scale = scale * 1.5 * scaleFactor;

    } else if (format.startsWith('60x90')) {

      scale = scale * 1.4 * scaleFactor;

    } else if (format.startsWith('60x60')) {

      scale = scale * 1.2 * scaleFactor;

    } else if (format.startsWith('40x80')) {

      scale = scale * 1.4 * scaleFactor;

    } else if (format.startsWith('40x60')) {

      scale = scale * 1.3 * scaleFactor;

    } else if (format.startsWith('40x40')) {

      scale = scale * 0.75 * scaleFactor;  // Proporzionale - 2/3 di 60x60

    // Formati piccoli-medi

    } else if (format.startsWith('30x120')) {

      scale = scale * 1.6 * scaleFactor;

    } else if (format.startsWith('30x90')) {

      scale = scale * 1.5 * scaleFactor;

    } else if (format.startsWith('30x60')) {

      scale = scale * 1.4 * scaleFactor;

    } else if (format.startsWith('20x60')) {

      scale = scale * 1.4 * scaleFactor;

    } else if (format.startsWith('30x30')) {

      scale = scale * 0.65 * scaleFactor;  // Proporzionale a 60x60

    } else if (format.startsWith('29x25')) {

      scale = scale * 0.58 * scaleFactor;

    } else if (format.startsWith('25x50')) {

      scale = scale * 0.85 * scaleFactor;

    } else if (format.startsWith('25x25')) {

      scale = scale * 0.55 * scaleFactor;

    // Formati piccoli - ridotti per proporzione corretta

    } else if (format.startsWith('20x120')) {

      scale = scale * 1.2 * scaleFactor;

    } else if (format.startsWith('20x40')) {

      scale = scale * 0.75 * scaleFactor;

    } else if (format.startsWith('20x20')) {

      scale = scale * 0.45 * scaleFactor;  // Piccolo - proporzionale

    } else if (format.startsWith('10x60')) {

      scale = scale * 0.75 * scaleFactor;

    } else if (format.startsWith('10x30')) {

      scale = scale * 0.58 * scaleFactor;

    // Formati battiscopa - scale proporzionate alla lunghezza (usa formatForDimensions per match corretto)

    } else if (formatForDimensions.startsWith('6.5x120') || formatForDimensions.startsWith('6.3x120') || formatForDimensions.startsWith('6x120')) {

      scale = scale * 1.8 * scaleFactor;  // Battiscopa 120cm - il più grande

    } else if (formatForDimensions.startsWith('26.5x160')) {

      scale = scale * 1.9 * scaleFactor;  // Listello largo 160cm

    } else if (formatForDimensions.startsWith('7.2x90') || formatForDimensions.startsWith('7x90')) {

      scale = scale * 1.5 * scaleFactor;  // Battiscopa 90cm

    } else if (formatForDimensions.startsWith('7.2x80') || formatForDimensions.startsWith('7x80')) {

      scale = scale * 1.35 * scaleFactor;  // Battiscopa 80cm

    } else if (formatForDimensions.startsWith('7.2x60') || formatForDimensions.startsWith('7x60')) {

      scale = scale * 1.2 * scaleFactor;  // Battiscopa 60cm

    } else {

      scale = scale * scaleFactor;

    }



    // Dimensioni scalate per la visualizzazione 3D

    const scaledWidth = width * scale;

    const scaledHeight = height * scale;



    // Offset per centrare la piastrella

    const centerX = containerSize / 2;

    const centerY = containerSize / 2;



    // Angolo isometrico standard per prospettiva corretta

    const skewAngle = 30; // Angolo isometrico standard

    const depth = 3; // Profondità ulteriormente ridotta per piastrelle più sottili



    // Schema colori basato sul colore fornito

    const topColor = colorCode || '#faf7f3';

    const topColorLight = this.lightenColor(topColor, 20);

    const topColorDark = this.darkenColor(topColor, 10);

    const sideColorRight = this.darkenColor(topColor, 20);

    const sideColorLeft = this.darkenColor(topColor, 30);

    const bottomColor = this.darkenColor(topColor, 40);

    const accentColor = '#2D5A3D';

    

    // Calcola i punti per la vista isometrica

    const cos = Math.cos(skewAngle * Math.PI / 180);

    const sin = Math.sin(skewAngle * Math.PI / 180);

    

    // Punti della piastrella in prospettiva isometrica

    const x1 = centerX - scaledWidth/2 * cos + scaledHeight/2 * cos;

    const y1 = centerY - scaledWidth/2 * sin - scaledHeight/2 * sin - depth;

    const x2 = centerX + scaledWidth/2 * cos + scaledHeight/2 * cos;

    const y2 = centerY + scaledWidth/2 * sin - scaledHeight/2 * sin - depth;

    const x3 = centerX + scaledWidth/2 * cos - scaledHeight/2 * cos;

    const y3 = centerY + scaledWidth/2 * sin + scaledHeight/2 * sin - depth;

    const x4 = centerX - scaledWidth/2 * cos - scaledHeight/2 * cos;

    const y4 = centerY - scaledWidth/2 * sin + scaledHeight/2 * sin - depth;



    // Calcola viewBox dinamico che contiene tutti i punti (inclusi i lati con depth)

    const padding = 15;

    const allX = [x1, x2, x3, x4];

    const allY = [y1, y2, y3, y4, y3 + depth, y4 + depth];

    const minX = Math.min(...allX) - padding;

    const minY = Math.min(...allY) - padding;

    const maxX = Math.max(...allX) + padding;

    const maxY = Math.max(...allY) + padding + 22;

    const viewWidth = maxX - minX;

    const viewHeight = maxY - minY;



    // Calcola max-width percentuale per mantenere scala relativa su mobile

    let maxWidthPercent = '100%';

    if (isMobile) {

      const area = originalWidth * originalHeight;

      if (area >= 50000) maxWidthPercent = '100%';

      else if (area >= 40000) maxWidthPercent = '98%';

      else if (area >= 30000) maxWidthPercent = '95%';

      else if (area >= 20000) maxWidthPercent = '92%';

      else if (area >= 14000) maxWidthPercent = '90%';

      else if (area >= 10000) maxWidthPercent = '88%';

      else if (area >= 7000) maxWidthPercent = '85%';

      else if (area >= 3500) maxWidthPercent = '80%';

      else maxWidthPercent = '75%';

    }



    return `

      <svg width="${viewWidth}" height="${viewHeight}" viewBox="${minX} ${minY} ${viewWidth} ${viewHeight}" xmlns="http://www.w3.org/2000/svg" style="max-width: ${maxWidthPercent}; height: auto; display: block; margin: 0 auto;">

        <defs>

          <!-- Ombra realistica con blur multipli -->

          <filter id="shadow_${format}_color" x="-50%" y="-50%" width="200%" height="200%">

            <feGaussianBlur in="SourceAlpha" stdDeviation="5"/>

            <feOffset dx="0" dy="6" result="offsetblur"/>

            <feFlood flood-color="#000000" flood-opacity="0.38"/>

            <feComposite in2="offsetblur" operator="in"/>

            <feMerge>

              <feMergeNode/>

              

            </feMerge>

          </filter>

          

          <!-- Colore solido per superficie senza effetto luce -->

          <!-- Mantengo il gradiente ma con colore uniforme -->

          <radialGradient id="topGrad_${format}_color" cx="40%" cy="30%">

            <stop offset="0%" style="stop-color:${topColor};stop-opacity:1" />

            <stop offset="100%" style="stop-color:${topColor};stop-opacity:1" />

          </radialGradient>

          

          <!-- Gradiente metallico per bordi -->

          <linearGradient id="edgeGrad_${format}_color" x1="0%" y1="0%" x2="100%" y2="100%">

            <stop offset="0%" style="stop-color:#ffffff;stop-opacity:0.8" />

            <stop offset="50%" style="stop-color:${topColor};stop-opacity:0.4" />

            <stop offset="100%" style="stop-color:${sideColorLeft};stop-opacity:0.6" />

          </linearGradient>

        </defs>

        

        <!-- Ombra isometrica allineata esattamente con la piastrella -->

        <g transform="translate(4, 6)">

          <path d="M ${x1} ${y1 + depth} 

                   L ${x2} ${y2 + depth} 

                   L ${x3} ${y3 + depth} 

                   L ${x4} ${y4 + depth} Z" 

                fill="rgba(0,0,0,1)" 

                filter="url(#shadow_${format}_color)"

                transform="scale(1.05, 1.05) translate(-${centerX * 0.05}, -${centerY * 0.05})"/>

        </g>

        

        <!-- Gruppo principale piastrella -->

        <g>

          <!-- Lato destro (profondità) -->

          <path d="M ${x2} ${y2} L ${x2} ${y2 + depth} L ${x3} ${y3 + depth} L ${x3} ${y3} Z" 

                fill="${sideColorRight}"

                stroke="${bottomColor}" 

                stroke-width="0.3"

                opacity="0.95"/>

          

          <!-- Lato sinistro (profondità) -->

          <path d="M ${x3} ${y3} L ${x3} ${y3 + depth} L ${x4} ${y4 + depth} L ${x4} ${y4} Z" 

                fill="${sideColorLeft}"

                stroke="${bottomColor}" 

                stroke-width="0.3"

                opacity="0.95"/>

          

          <!-- Superficie superiore principale -->

          <path d="M ${x1} ${y1} L ${x2} ${y2} L ${x3} ${y3} L ${x4} ${y4} Z" 

                fill="url(#topGrad_${format}_color)" 

                stroke="url(#edgeGrad_${format}_color)" 

                stroke-width="1.5" 

                stroke-linejoin="round"

                opacity="1"/>

          

          <!-- Bordo superiore luminoso -->

          <line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}" 

                stroke="rgba(255,255,255,0.6)" 

                stroke-width="1"/>

          <line x1="${x2}" y1="${y2}" x2="${x3}" y2="${y3}" 

                stroke="rgba(255,255,255,0.4)" 

                stroke-width="1"/>

        </g>

        

        <!-- Effetto glow sul hover (preparato per CSS) -->

        <rect x="0" y="0" width="${containerSize}" height="${containerSize}" 

              fill="transparent" 

              class="tile-hover-area"/>

      </svg>

    `;

  },

  

  // Genera SVG con immagine sulla superficie (solo sulla parte superiore)

  generateFormatSVGWithImage(format, imageUrl) {

    // Normalizza formato battiscopa (es: "Battiscopa 7.2x80" -> "7.2x80")

    let formatForDimensions = format;

    if (format.toLowerCase().includes('battiscopa')) {

      const match = format.match(/(\d+(?:[.,]\d+)?)\s*[xX]\s*(\d+(?:[.,]\d+)?)/);

      if (match) {

        formatForDimensions = `${match[1]}x${match[2]}`.replace(',', '.');

      }

    }



    // Calcola le stesse dimensioni e punti della piastrella isometrica

    let [width, height] = formatForDimensions.split('x').map(n => parseFloat(n));



    // Fallback se le dimensioni non sono valide

    if (isNaN(width) || isNaN(height)) {

      width = 60;

      height = 60;

    }



    const originalWidth = width;

    const originalHeight = height;



    const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768;



    // Calcola containerSize in base al formato - dimensioni proporzionali su mobile e desktop

    // Su mobile dimensioni ridotte per stare dentro la card (max ~100px per non uscire dai lati)

    let containerSize = isMobile ? 85 : 160;

    if (format.startsWith('160x320')) containerSize = isMobile ? 100 : 280;

    else if (format.startsWith('150x300')) containerSize = isMobile ? 98 : 270;

    else if (format.startsWith('120x280') || format.startsWith('120x278') || format.startsWith('120x260')) containerSize = isMobile ? 95 : 260;

    else if (format.startsWith('120x240')) containerSize = isMobile ? 95 : 240;

    else if (format.startsWith('150x150')) containerSize = isMobile ? 92 : 220;

    else if (format.startsWith('120x120')) containerSize = isMobile ? 90 : 200;

    else if (format.startsWith('80x180')) containerSize = isMobile ? 90 : 210;

    else if (format.startsWith('80x160')) containerSize = isMobile ? 90 : 215;

    else if (format.startsWith('75x150')) containerSize = isMobile ? 88 : 200;

    else if (format.startsWith('26.5x180') || format.startsWith('20x180')) containerSize = isMobile ? 95 : 210;

    else if (format.startsWith('26.5x160')) containerSize = isMobile ? 95 : 220;  // Listello largo

    else if (format.startsWith('20x150')) containerSize = isMobile ? 92 : 200;

    else if (format.startsWith('60x120')) containerSize = isMobile ? 85 : 190;

    else if (format.startsWith('60x90')) containerSize = isMobile ? 85 : 180;

    else if (format.startsWith('30x120') || format.startsWith('20x120')) containerSize = isMobile ? 95 : 200;

    else if (format.startsWith('20x60')) containerSize = isMobile ? 80 : 170;

    // Formati battiscopa - strisce sottili e lunghe (usa formatForDimensions per match corretto)

    else if (formatForDimensions.startsWith('6.5x120') || formatForDimensions.startsWith('6.3x120') || formatForDimensions.startsWith('6x120')) containerSize = isMobile ? 110 : 250;

    else if (formatForDimensions.startsWith('26.5x160')) containerSize = isMobile ? 95 : 220;  // Listello largo

    else if (formatForDimensions.startsWith('7.2x90') || formatForDimensions.startsWith('7x90')) containerSize = isMobile ? 105 : 230;

    else if (formatForDimensions.startsWith('7.2x80') || formatForDimensions.startsWith('7x80')) containerSize = isMobile ? 100 : 210;

    else if (formatForDimensions.startsWith('7.2x60') || formatForDimensions.startsWith('7x60')) containerSize = isMobile ? 90 : 180;



    const maxDim = Math.max(width, height);

    const baseScale = isMobile ? 65 : 80;

    let scale = baseScale / maxDim;

    const scaleFactor = isMobile ? 0.85 : 1;



    // Applica le stesse scale per formato (scale originali ripristinate)

    if (format.startsWith('160x320')) scale = scale * 2.7 * scaleFactor;

    else if (format.startsWith('150x300')) scale = scale * 2.6 * scaleFactor;

    else if (format.startsWith('120x280') || format.startsWith('120x278') || format.startsWith('120x260')) scale = scale * 2.4 * scaleFactor;

    else if (format.startsWith('120x240')) scale = scale * 2.2 * scaleFactor;

    else if (format.startsWith('150x150')) scale = scale * 1.8 * scaleFactor;

    else if (format.startsWith('120x120')) scale = scale * 1.6 * scaleFactor;

    else if (format.startsWith('75x150')) scale = scale * 1.5 * scaleFactor;

    else if (format.startsWith('90x90')) scale = scale * 1.25 * scaleFactor;

    else if (format.startsWith('80x80')) scale = scale * 1.2 * scaleFactor;

    else if (format.startsWith('80x180')) scale = scale * 1.8 * scaleFactor;

    else if (format.startsWith('80x160')) scale = scale * 1.7 * scaleFactor;

    else if (format.startsWith('26.5x180')) scale = scale * 1.8 * scaleFactor;

    else if (format.startsWith('20x180')) scale = scale * 1.8 * scaleFactor;

    else if (format.startsWith('26.5x160')) scale = scale * 1.75 * scaleFactor;  // Listello largo

    else if (format.startsWith('20x150')) scale = scale * 1.7 * scaleFactor;

    else if (format.startsWith('60x120')) scale = scale * 1.5 * scaleFactor;

    else if (format.startsWith('60x90')) scale = scale * 1.4 * scaleFactor;

    else if (format.startsWith('60x60')) scale = scale * 1.2 * scaleFactor;

    else if (format.startsWith('40x80')) scale = scale * 1.4 * scaleFactor;

    else if (format.startsWith('40x60')) scale = scale * 1.3 * scaleFactor;

    else if (format.startsWith('40x40')) scale = scale * 0.75 * scaleFactor;

    else if (format.startsWith('30x120')) scale = scale * 1.6 * scaleFactor;

    else if (format.startsWith('30x90')) scale = scale * 1.5 * scaleFactor;

    else if (format.startsWith('30x60')) scale = scale * 1.4 * scaleFactor;

    else if (format.startsWith('20x60')) scale = scale * 1.4 * scaleFactor;

    else if (format.startsWith('30x30')) scale = scale * 0.65 * scaleFactor;

    else if (format.startsWith('29x25')) scale = scale * 0.58 * scaleFactor;

    else if (format.startsWith('25x50')) scale = scale * 0.85 * scaleFactor;

    else if (format.startsWith('25x25')) scale = scale * 0.55 * scaleFactor;

    else if (format.startsWith('20x120')) scale = scale * 1.2 * scaleFactor;

    else if (format.startsWith('20x40')) scale = scale * 0.75 * scaleFactor;

    else if (format.startsWith('20x20')) scale = scale * 0.45 * scaleFactor;

    else if (format.startsWith('10x60')) scale = scale * 0.75 * scaleFactor;

    else if (format.startsWith('10x30')) scale = scale * 0.58 * scaleFactor;

    // Formati battiscopa - scale proporzionate alla lunghezza (usa formatForDimensions per match corretto)

    else if (formatForDimensions.startsWith('6.5x120') || formatForDimensions.startsWith('6.3x120') || formatForDimensions.startsWith('6x120')) scale = scale * 1.8 * scaleFactor;  // Battiscopa 120cm - il più grande

    else if (formatForDimensions.startsWith('26.5x160')) scale = scale * 1.9 * scaleFactor;  // Listello largo 160cm

    else if (formatForDimensions.startsWith('7.2x90') || formatForDimensions.startsWith('7x90')) scale = scale * 1.5 * scaleFactor;  // Battiscopa 90cm

    else if (formatForDimensions.startsWith('7.2x80') || formatForDimensions.startsWith('7x80')) scale = scale * 1.35 * scaleFactor;  // Battiscopa 80cm

    else if (formatForDimensions.startsWith('7.2x60') || formatForDimensions.startsWith('7x60')) scale = scale * 1.2 * scaleFactor;  // Battiscopa 60cm

    else scale = scale * scaleFactor;



    const scaledWidth = width * scale;

    const scaledHeight = height * scale;

    const centerX = containerSize / 2;

    const centerY = containerSize / 2;

    const skewAngle = 30;

    const depth = 3;



    const cos = Math.cos(skewAngle * Math.PI / 180);

    const sin = Math.sin(skewAngle * Math.PI / 180);



    // Punti della piastrella in prospettiva isometrica

    const x1 = centerX - scaledWidth/2 * cos + scaledHeight/2 * cos;

    const y1 = centerY - scaledWidth/2 * sin - scaledHeight/2 * sin - depth;

    const x2 = centerX + scaledWidth/2 * cos + scaledHeight/2 * cos;

    const y2 = centerY + scaledWidth/2 * sin - scaledHeight/2 * sin - depth;

    const x3 = centerX + scaledWidth/2 * cos - scaledHeight/2 * cos;

    const y3 = centerY + scaledWidth/2 * sin + scaledHeight/2 * sin - depth;

    const x4 = centerX - scaledWidth/2 * cos - scaledHeight/2 * cos;

    const y4 = centerY - scaledWidth/2 * sin + scaledHeight/2 * sin - depth;



    const randomId = Math.random().toString(36).substring(2, 9);

    const uniqueId = `img_${format.replace(/[^a-z0-9]/gi, '_')}_${Date.now()}_${randomId}`;



    // Colori per i lati

    const sideColorRight = '#d0d0d0';

    const sideColorLeft = '#b8b8b8';

    const bottomColor = '#a0a0a0';



    // Calcola viewBox dinamico che contiene tutti i punti (inclusi i lati con depth)

    const padding = 15;

    const allX = [x1, x2, x3, x4];

    const allY = [y1, y2, y3, y4, y3 + depth, y4 + depth];

    const minX = Math.min(...allX) - padding;

    const minY = Math.min(...allY) - padding;

    const maxX = Math.max(...allX) + padding;

    const maxY = Math.max(...allY) + padding + 22;

    const viewWidth = maxX - minX;

    const viewHeight = maxY - minY;



    // Calcola max-width percentuale per mantenere scala relativa su mobile

    let maxWidthPercent = '100%';

    if (isMobile) {

      const area = originalWidth * originalHeight;

      if (area >= 50000) maxWidthPercent = '100%';

      else if (area >= 40000) maxWidthPercent = '98%';

      else if (area >= 30000) maxWidthPercent = '95%';

      else if (area >= 20000) maxWidthPercent = '92%';

      else if (area >= 14000) maxWidthPercent = '90%';

      else if (area >= 10000) maxWidthPercent = '88%';

      else if (area >= 7000) maxWidthPercent = '85%';

      else if (area >= 3500) maxWidthPercent = '80%';

      else maxWidthPercent = '75%';

    }



    return `

      <svg width="${viewWidth}" height="${viewHeight}" viewBox="${minX} ${minY} ${viewWidth} ${viewHeight}" xmlns="http://www.w3.org/2000/svg" style="max-width: ${maxWidthPercent}; height: auto; display: block; margin: 0 auto;">

        <defs>

          <filter id="shadow_${uniqueId}" x="-50%" y="-50%" width="200%" height="200%">

            <feGaussianBlur in="SourceAlpha" stdDeviation="5"/>

            <feOffset dx="0" dy="6" result="offsetblur"/>

            <feFlood flood-color="#000000" flood-opacity="0.38"/>

            <feComposite in2="offsetblur" operator="in"/>

            <feMerge>

              <feMergeNode/>

              

            </feMerge>

          </filter>



          <!-- ClipPath per la superficie superiore (coordinate isometriche finali) -->

          <clipPath id="clip_${uniqueId}">

            <path d="M ${x1} ${y1} L ${x2} ${y2} L ${x3} ${y3} L ${x4} ${y4} Z"/>

          </clipPath>

          <!-- ClipPath in coordinate locali (rettangolo prima della trasformazione isometrica) -->

          <clipPath id="clipLocal_${uniqueId}">

            <rect x="0" y="0" width="${scaledWidth}" height="${scaledHeight}"/>

          </clipPath>



          <!-- Gradiente per bordi -->

          <linearGradient id="edgeGrad_${uniqueId}" x1="0%" y1="0%" x2="100%" y2="100%">

            <stop offset="0%" style="stop-color:#ffffff;stop-opacity:0.8" />

            <stop offset="50%" style="stop-color:#D9D2C5;stop-opacity:0.4" />

            <stop offset="100%" style="stop-color:${sideColorLeft};stop-opacity:0.6" />

          </linearGradient>

        </defs>



        <!-- Ombra isometrica -->

        <g transform="translate(4, 6)">

          <path d="M ${x1} ${y1 + depth} L ${x2} ${y2 + depth} L ${x3} ${y3 + depth} L ${x4} ${y4 + depth} Z"

                fill="rgba(0,0,0,1)"

                filter="url(#shadow_${uniqueId})"

                transform="scale(1.05, 1.05) translate(-${centerX * 0.05}, -${centerY * 0.05})"/>

        </g>



        <!-- Gruppo principale piastrella -->

        <g>

          <!-- Lato destro (profondità) -->

          <path d="M ${x2} ${y2} L ${x2} ${y2 + depth} L ${x3} ${y3 + depth} L ${x3} ${y3} Z"

                fill="${sideColorRight}" stroke="${bottomColor}" stroke-width="0.3" opacity="0.95"/>



          <!-- Lato sinistro (profondità) -->

          <path d="M ${x3} ${y3} L ${x3} ${y3 + depth} L ${x4} ${y4 + depth} L ${x4} ${y4} Z"

                fill="${sideColorLeft}" stroke="${bottomColor}" stroke-width="0.3" opacity="0.95"/>



          <!-- Superficie superiore con immagine in prospettiva isometrica -->

          <!-- Clip esterno sulla forma isometrica finale -->

          <g clip-path="url(#clip_${uniqueId})">

            <!-- Trasformazione isometrica -->

            <g transform="matrix(${cos}, ${sin}, ${-cos}, ${sin}, ${x1}, ${y1})">

              <!-- Clip interno sul rettangolo locale -->

              <g clip-path="url(#clipLocal_${uniqueId})">

                <!-- Immagine ruotata di -90° per orientarla orizzontalmente -->

                <!-- L'immagine sorgente è verticale, ruotiamo -90° per renderla orizzontale -->

                <!-- Impostiamo dimensioni che DOPO la rotazione diano scaledWidth x scaledHeight -->

                <!-- Pre-rotazione: width=scaledHeight, height=scaledWidth -->

                <!-- Post-rotazione -90°: diventa scaledWidth (larghezza) x scaledHeight (altezza) -->

                <g transform="translate(${scaledWidth/2}, ${scaledHeight/2}) rotate(-90) translate(${-scaledHeight/2}, ${-scaledWidth/2})">

                  <image href="${imageUrl}"

                         x="0" y="0"

                         width="${scaledHeight}" height="${scaledWidth}"

                         preserveAspectRatio="xMidYMid slice"/>

                </g>

              </g>

            </g>

          </g>



          <!-- Bordo superiore della piastrella -->

          <path d="M ${x1} ${y1} L ${x2} ${y2} L ${x3} ${y3} L ${x4} ${y4} Z"

                fill="none"

                stroke="url(#edgeGrad_${uniqueId})"

                stroke-width="1.5"

                stroke-linejoin="round"/>



          <!-- Bordi luminosi -->

          <line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}" stroke="rgba(255,255,255,0.6)" stroke-width="1"/>

          <line x1="${x2}" y1="${y2}" x2="${x3}" y2="${y3}" stroke="rgba(255,255,255,0.3)" stroke-width="0.5"/>

        </g>

      </svg>`;

  },

  

  // Helper per schiarire un colore

  lightenColor(color, percent) {

    if (!color) return '#ffffff';

    const num = parseInt(color.replace("#",""), 16);

    const amt = Math.round(2.55 * percent);

    const R = (num >> 16) + amt;

    const G = (num >> 8 & 0x00FF) + amt;

    const B = (num & 0x0000FF) + amt;

    return "#" + (0x1000000 + (R<255?R<1?0:R:255)*0x10000 + (G<255?G<1?0:G:255)*0x100 + (B<255?B<1?0:B:255)).toString(16).slice(1);

  },

  

  // Helper per scurire un colore

  darkenColor(color, percent) {

    if (!color) return '#000000';

    const num = parseInt(color.replace("#",""), 16);

    const amt = Math.round(2.55 * percent);

    const R = (num >> 16) - amt;

    const G = (num >> 8 & 0x00FF) - amt;

    const B = (num & 0x0000FF) - amt;

    return "#" + (0x1000000 + (R>0?R:0)*0x10000 + (G>0?G:0)*0x100 + (B>0?B:0)).toString(16).slice(1);

  },

  

  // Genera SVG 3D per visualizzare il formato della piastrella - NUOVO STILE MODERNO

  generateFormatSVG(format, uniqueId = null) {

    // Normalizza formato battiscopa (es: "Battiscopa 7.2x80" -> "7.2x80")

    let formatForDimensions = format;

    if (format.toLowerCase().includes('battiscopa')) {

      const match = format.match(/(\d+(?:[.,]\d+)?)\s*[xX]\s*(\d+(?:[.,]\d+)?)/);

      if (match) {

        formatForDimensions = `${match[1]}x${match[2]}`.replace(',', '.');

      }

    }



    // Estrai dimensioni dal formato (es: "60x60" -> [60, 60])

    let [width, height] = formatForDimensions.split('x').map(n => parseFloat(n));



    // Fallback se le dimensioni non sono valide

    if (isNaN(width) || isNaN(height)) {

      width = 60;

      height = 60;

    }



    // Genera un ID unico per evitare conflitti tra SVG multipli con stesso formato

    const svgId = uniqueId || `${format}_${Date.now()}_${Math.random().toString(36).substr(2, 5)}`;



    // Mantieni le proporzioni originali per visualizzazione accurata

    const originalWidth = width;

    const originalHeight = height;



    // Determina dimensione contenitore in base al viewport

    const isMobile = window.innerWidth <= 768;



    // Calcola containerSize in base al formato - dimensioni proporzionali su mobile e desktop

    // Su mobile dimensioni ridotte per stare dentro la card (max ~100px per non uscire dai lati)

    let containerSize = isMobile ? 85 : 160;

    if (format.startsWith('160x320')) containerSize = isMobile ? 100 : 280;

    else if (format.startsWith('150x300')) containerSize = isMobile ? 98 : 270;

    else if (format.startsWith('120x280') || format.startsWith('120x278') || format.startsWith('120x260')) containerSize = isMobile ? 95 : 260;

    else if (format.startsWith('120x240')) containerSize = isMobile ? 95 : 240;

    else if (format.startsWith('150x150')) containerSize = isMobile ? 92 : 220;

    else if (format.startsWith('120x120')) containerSize = isMobile ? 90 : 200;

    else if (format.startsWith('80x180')) containerSize = isMobile ? 90 : 210;

    else if (format.startsWith('80x160')) containerSize = isMobile ? 90 : 215;

    else if (format.startsWith('75x150')) containerSize = isMobile ? 88 : 200;

    else if (format.startsWith('26.5x180') || format.startsWith('20x180')) containerSize = isMobile ? 95 : 210;

    else if (format.startsWith('26.5x160')) containerSize = isMobile ? 95 : 220;  // Listello largo

    else if (format.startsWith('20x150')) containerSize = isMobile ? 92 : 200;

    else if (format.startsWith('60x120')) containerSize = isMobile ? 85 : 190;

    else if (format.startsWith('60x90')) containerSize = isMobile ? 85 : 180;

    else if (format.startsWith('30x120') || format.startsWith('20x120')) containerSize = isMobile ? 95 : 200;

    else if (format.startsWith('20x60')) containerSize = isMobile ? 80 : 170;

    // Formati battiscopa - strisce sottili e lunghe (usa formatForDimensions per match corretto)

    else if (formatForDimensions.startsWith('6.5x120') || formatForDimensions.startsWith('6.3x120') || formatForDimensions.startsWith('6x120')) containerSize = isMobile ? 110 : 250;

    else if (formatForDimensions.startsWith('26.5x160')) containerSize = isMobile ? 95 : 220;  // Listello largo

    else if (formatForDimensions.startsWith('7.2x90') || formatForDimensions.startsWith('7x90')) containerSize = isMobile ? 105 : 230;

    else if (formatForDimensions.startsWith('7.2x80') || formatForDimensions.startsWith('7x80')) containerSize = isMobile ? 100 : 210;

    else if (formatForDimensions.startsWith('7.2x60') || formatForDimensions.startsWith('7x60')) containerSize = isMobile ? 90 : 180;



    const maxDim = Math.max(width, height);



    // Base scale adattata al contenitore

    const baseScale = isMobile ? 65 : 80;

    let scale = baseScale / maxDim;



    // Aumenta la scala per i formati specifici

    // Usa startsWith per intercettare formati con suffissi (es: "120x120-comfort-squadrato")

    const scaleFactor = isMobile ? 0.85 : 1; // Scala maggiore su mobile



    // Formati grandi

    if (format.startsWith('160x320')) {

      scale = scale * 2.7 * scaleFactor;  // Lastra maxi

    } else if (format.startsWith('150x300')) {

      scale = scale * 2.6 * scaleFactor;  // Lastra grande

    } else if (format.startsWith('120x280') || format.startsWith('120x278') || format.startsWith('120x260')) {

      scale = scale * 2.4 * scaleFactor;

    } else if (format.startsWith('120x240')) {

      scale = scale * 2.2 * scaleFactor;

    } else if (format.startsWith('150x150')) {

      scale = scale * 1.8 * scaleFactor;  // Quadratone grande

    } else if (format.startsWith('120x120')) {

      scale = scale * 1.6 * scaleFactor;

    } else if (format.startsWith('75x150')) {

      scale = scale * 1.5 * scaleFactor;  // Rettangolo medio

    } else if (format.startsWith('90x90')) {

      scale = scale * 1.25 * scaleFactor;

    } else if (format.startsWith('80x80')) {

      scale = scale * 1.2 * scaleFactor;

    } else if (format.startsWith('80x180')) {

      scale = scale * 1.8 * scaleFactor;

    } else if (format.startsWith('80x160')) {

      scale = scale * 1.7 * scaleFactor;  // Rettangolo grande 1:2

    } else if (format.startsWith('26.5x180')) {

      scale = scale * 1.8 * scaleFactor;  // Formato listello lungo

    } else if (format.startsWith('20x180')) {

      scale = scale * 1.8 * scaleFactor;  // Formato listello lungo

    } else if (format.startsWith('26.5x160')) {

      scale = scale * 1.75 * scaleFactor;  // Listello largo

    } else if (format.startsWith('20x150')) {

      scale = scale * 1.7 * scaleFactor;  // Formato listello lungo

    // Formati medi

    } else if (format.startsWith('60x120')) {

      scale = scale * 1.5 * scaleFactor;

    } else if (format.startsWith('60x90')) {

      scale = scale * 1.4 * scaleFactor;

    } else if (format.startsWith('60x60')) {

      scale = scale * 1.2 * scaleFactor;

    } else if (format.startsWith('40x80')) {

      scale = scale * 1.4 * scaleFactor;

    } else if (format.startsWith('40x60')) {

      scale = scale * 1.3 * scaleFactor;

    } else if (format.startsWith('40x40')) {

      scale = scale * 0.75 * scaleFactor;  // Proporzionale - 2/3 di 60x60

    // Formati piccoli-medi

    } else if (format.startsWith('30x120')) {

      scale = scale * 1.6 * scaleFactor;

    } else if (format.startsWith('30x90')) {

      scale = scale * 1.5 * scaleFactor;

    } else if (format.startsWith('30x60')) {

      scale = scale * 1.4 * scaleFactor;

    } else if (format.startsWith('20x60')) {

      scale = scale * 1.4 * scaleFactor;

    } else if (format.startsWith('30x30')) {

      scale = scale * 0.65 * scaleFactor;  // Proporzionale a 60x60

    } else if (format.startsWith('29x25')) {

      scale = scale * 0.58 * scaleFactor;

    } else if (format.startsWith('25x50')) {

      scale = scale * 0.85 * scaleFactor;

    } else if (format.startsWith('25x25')) {

      scale = scale * 0.55 * scaleFactor;

    // Formati piccoli - ridotti per proporzione corretta

    } else if (format.startsWith('20x120')) {

      scale = scale * 1.2 * scaleFactor;

    } else if (format.startsWith('20x40')) {

      scale = scale * 0.75 * scaleFactor;

    } else if (format.startsWith('20x20')) {

      scale = scale * 0.45 * scaleFactor;  // Piccolo - proporzionale

    } else if (format.startsWith('10x60')) {

      scale = scale * 0.75 * scaleFactor;

    } else if (format.startsWith('10x30')) {

      scale = scale * 0.58 * scaleFactor;

    // Formati battiscopa - scale proporzionate alla lunghezza (usa formatForDimensions per match corretto)

    } else if (formatForDimensions.startsWith('6.5x120') || formatForDimensions.startsWith('6.3x120') || formatForDimensions.startsWith('6x120')) {

      scale = scale * 1.8 * scaleFactor;  // Battiscopa 120cm - il più grande

    } else if (formatForDimensions.startsWith('26.5x160')) {

      scale = scale * 1.9 * scaleFactor;  // Listello largo 160cm

    } else if (formatForDimensions.startsWith('7.2x90') || formatForDimensions.startsWith('7x90')) {

      scale = scale * 1.5 * scaleFactor;  // Battiscopa 90cm

    } else if (formatForDimensions.startsWith('7.2x80') || formatForDimensions.startsWith('7x80')) {

      scale = scale * 1.35 * scaleFactor;  // Battiscopa 80cm

    } else if (formatForDimensions.startsWith('7.2x60') || formatForDimensions.startsWith('7x60')) {

      scale = scale * 1.2 * scaleFactor;  // Battiscopa 60cm

    } else {

      scale = scale * scaleFactor;

    }



    // Dimensioni scalate per la visualizzazione 3D

    const scaledWidth = width * scale;

    const scaledHeight = height * scale;



    // Offset per centrare la piastrella

    const centerX = containerSize / 2;

    const centerY = containerSize / 2;



    // Angolo isometrico standard per prospettiva corretta

    const skewAngle = 30; // Angolo isometrico standard

    const depth = 3; // Profondità ulteriormente ridotta per piastrelle più sottili



    // Schema colori moderno con gradienti realistici per ceramica

    const topColor = '#faf7f3';  // Bianco caldo ceramica

    const topColorLight = '#fffefb';  // Bianco luminoso caldo

    const topColorDark = '#f5ede4';  // Beige chiaro

    const sideColorRight = '#e8d7c6';  // Sabbia chiaro

    const sideColorLeft = '#d4bfaa';  // Sabbia scuro

    const bottomColor = '#b39d88';  // Marrone chiaro caldo

    const accentColor = '#2D5A3D';

    

    // Calcola i punti per la vista isometrica

    const cos = Math.cos(skewAngle * Math.PI / 180);

    const sin = Math.sin(skewAngle * Math.PI / 180);

    

    // Punti della piastrella in prospettiva isometrica

    const x1 = centerX - scaledWidth/2 * cos + scaledHeight/2 * cos;

    const y1 = centerY - scaledWidth/2 * sin - scaledHeight/2 * sin - depth;

    const x2 = centerX + scaledWidth/2 * cos + scaledHeight/2 * cos;

    const y2 = centerY + scaledWidth/2 * sin - scaledHeight/2 * sin - depth;

    const x3 = centerX + scaledWidth/2 * cos - scaledHeight/2 * cos;

    const y3 = centerY + scaledWidth/2 * sin + scaledHeight/2 * sin - depth;

    const x4 = centerX - scaledWidth/2 * cos - scaledHeight/2 * cos;

    const y4 = centerY - scaledWidth/2 * sin + scaledHeight/2 * sin - depth;



    // Calcola viewBox dinamico che contiene tutti i punti (inclusi i lati con depth)

    const padding = 15;

    const allX = [x1, x2, x3, x4];

    const allY = [y1, y2, y3, y4, y3 + depth, y4 + depth];

    const minX = Math.min(...allX) - padding;

    const minY = Math.min(...allY) - padding;

    const maxX = Math.max(...allX) + padding;

    const maxY = Math.max(...allY) + padding + 22;

    const viewWidth = maxX - minX;

    const viewHeight = maxY - minY;



    // Calcola max-width percentuale per mantenere scala relativa su mobile

    // Formati più grandi = 100%, formati più piccoli = percentuali inferiori

    let maxWidthPercent = '100%';

    if (isMobile) {

      const area = originalWidth * originalHeight;

      if (area >= 50000) maxWidthPercent = '100%';        // 160x320 = 51200

      else if (area >= 40000) maxWidthPercent = '98%';    // 150x300 = 45000

      else if (area >= 30000) maxWidthPercent = '95%';    // 120x280 = 33600

      else if (area >= 20000) maxWidthPercent = '92%';    // 150x150 = 22500, 120x240 = 28800

      else if (area >= 14000) maxWidthPercent = '90%';    // 120x120 = 14400, 80x180 = 14400

      else if (area >= 10000) maxWidthPercent = '88%';    // 75x150 = 11250

      else if (area >= 7000) maxWidthPercent = '85%';     // 60x120 = 7200, 90x90 = 8100

      else if (area >= 3500) maxWidthPercent = '80%';     // 60x60 = 3600

      else maxWidthPercent = '75%';                        // Formati piccoli

    }



    return `

      <svg width="${viewWidth}" height="${viewHeight}" viewBox="${minX} ${minY} ${viewWidth} ${viewHeight}" xmlns="http://www.w3.org/2000/svg" style="max-width: ${maxWidthPercent}; height: auto; display: block; margin: 0 auto;">

        <defs>

          <!-- Ombra realistica con blur multipli -->

          <filter id="shadow_${svgId}" x="-50%" y="-50%" width="200%" height="200%">

            <feGaussianBlur in="SourceAlpha" stdDeviation="5"/>

            <feOffset dx="0" dy="6" result="offsetblur"/>

            <feFlood flood-color="#000000" flood-opacity="0.38"/>

            <feComposite in2="offsetblur" operator="in"/>

            <feMerge>

              <feMergeNode/>

              

            </feMerge>

          </filter>



          <!-- Colore solido per superficie senza effetto luce -->

          <!-- Mantengo il gradiente ma con colore uniforme -->

          <radialGradient id="topGrad_${svgId}" cx="40%" cy="30%">

            <stop offset="0%" style="stop-color:${topColor};stop-opacity:1" />

            <stop offset="100%" style="stop-color:${topColor};stop-opacity:1" />

          </radialGradient>



          <!-- Gradiente metallico per bordi -->

          <linearGradient id="edgeGrad_${svgId}" x1="0%" y1="0%" x2="100%" y2="100%">

            <stop offset="0%" style="stop-color:#ffffff;stop-opacity:0.8" />

            <stop offset="50%" style="stop-color:#f0e6dc;stop-opacity:0.4" />

            <stop offset="100%" style="stop-color:#d4bfaa;stop-opacity:0.6" />

          </linearGradient>



          <!-- Pattern texture ceramica realistica -->

          <pattern id="ceramic_${svgId}" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">

            <circle cx="2" cy="2" r="0.5" fill="rgba(255,255,255,0.3)"/>

            <circle cx="10" cy="10" r="0.5" fill="rgba(255,255,255,0.2)"/>

            <circle cx="18" cy="6" r="0.5" fill="rgba(255,255,255,0.25)"/>

            <circle cx="6" cy="18" r="0.5" fill="rgba(255,255,255,0.15)"/>

          </pattern>



          <!-- Riflesso luce speculare -->

          <radialGradient id="specular_${svgId}">

            <stop offset="0%" style="stop-color:#ffffff;stop-opacity:0.7" />

            <stop offset="40%" style="stop-color:#ffffff;stop-opacity:0.3" />

            <stop offset="100%" style="stop-color:#ffffff;stop-opacity:0" />

          </radialGradient>



          <!-- Gradiente per lato destro con ombreggiatura -->

          <linearGradient id="rightGrad_${svgId}" x1="0%" y1="0%" x2="100%" y2="100%">

            <stop offset="0%" style="stop-color:${sideColorRight};stop-opacity:1" />

            <stop offset="50%" style="stop-color:#dcc9b6;stop-opacity:1" />

            <stop offset="100%" style="stop-color:#c7b099;stop-opacity:1" />

          </linearGradient>



          <!-- Gradiente per lato sinistro -->

          <linearGradient id="leftGrad_${svgId}" x1="0%" y1="0%" x2="100%" y2="100%">

            <stop offset="0%" style="stop-color:${sideColorLeft};stop-opacity:1" />

            <stop offset="50%" style="stop-color:#c7b099;stop-opacity:1" />

            <stop offset="100%" style="stop-color:#a89177;stop-opacity:1" />

          </linearGradient>

        </defs>



        <!-- Ombra isometrica allineata esattamente con la piastrella -->

        <g transform="translate(4, 6)">

          <path d="M ${x1} ${y1 + depth}

                   L ${x2} ${y2 + depth}

                   L ${x3} ${y3 + depth}

                   L ${x4} ${y4 + depth} Z"

                fill="rgba(0,0,0,1)"

                filter="url(#shadow_${svgId})"

                transform="scale(1.05, 1.05) translate(-${centerX * 0.05}, -${centerY * 0.05})"/>

        </g>



        <!-- Gruppo principale piastrella -->

        <g>

          <!-- Lato destro (profondità) con gradiente -->

          <path d="M ${x2} ${y2} L ${x2} ${y2 + depth} L ${x3} ${y3 + depth} L ${x3} ${y3} Z"

                fill="url(#rightGrad_${svgId})"

                stroke="${bottomColor}"

                stroke-width="0.3"

                opacity="0.95"/>



          <!-- Lato sinistro (profondità) con gradiente -->

          <path d="M ${x3} ${y3} L ${x3} ${y3 + depth} L ${x4} ${y4 + depth} L ${x4} ${y4} Z"

                fill="url(#leftGrad_${svgId})"

                stroke="${bottomColor}"

                stroke-width="0.3"

                opacity="0.95"/>



          <!-- Superficie superiore principale -->

          <path d="M ${x1} ${y1} L ${x2} ${y2} L ${x3} ${y3} L ${x4} ${y4} Z"

                fill="url(#topGrad_${svgId})"

                stroke="url(#edgeGrad_${svgId})"

                stroke-width="1.5"

                stroke-linejoin="round"

                opacity="1"/>



          <!-- Texture ceramica sulla superficie -->

          <path d="M ${x1} ${y1} L ${x2} ${y2} L ${x3} ${y3} L ${x4} ${y4} Z"

                fill="url(#ceramic_${svgId})"

                opacity="0.4"/>



          <!-- Bordo superiore luminoso -->

          <line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}"

                stroke="rgba(255,255,255,0.6)"

                stroke-width="1"/>

          <line x1="${x2}" y1="${y2}" x2="${x3}" y2="${y3}"

                stroke="rgba(255,255,255,0.4)"

                stroke-width="1"/>



          <!-- Linee di fuga per effetto prospettiva -->

          <line x1="${x4}" y1="${y4}" x2="${x4}" y2="${y4 + depth}"

                stroke="${bottomColor}"

                stroke-width="0.5"

                opacity="0.5"/>

          <line x1="${x1}" y1="${y1}" x2="${x1}" y2="${y1 + depth * 0.3}"

                stroke="${bottomColor}"

                stroke-width="0.3"

                opacity="0.3"/>

        </g>





        <!-- Effetto glow sul hover (preparato per CSS) -->

        <rect x="0" y="0" width="${containerSize}" height="${containerSize}"

              fill="transparent"

              class="tile-hover-area"/>

      </svg>

    `;

  },

  

  // Funzione per zoommare l'immagine del colore

  zoomColorImage(imageUrl, colorName, colorCode) {

    // Se non c'è immagine, usa il colore di fallback

    if (!imageUrl) {

      this.showColorZoomWithSwatch(colorName, colorCode);

      return;

    }

    

    // Ottieni URL ad alta risoluzione per lo zoom fullscreen

    let highResUrl = imageUrl;

    if (imageUrl.includes('cdn.shopify.com')) {

      // Rimuovi qualsiasi parametro di dimensione esistente

      highResUrl = imageUrl.split('?')[0];

      // Usa risoluzione massima per zoom nitido su schermi retina/4K

      highResUrl = highResUrl + '?v=' + Date.now() + '&width=4000&height=4000&crop=center&format=png&quality=100';

    }

    

    // Crea o riusa il modal di zoom (stesso stile del carosello)

    let zoomModal = document.getElementById('fxColorZoomModal');

    if (!zoomModal) {

      zoomModal = document.createElement('div');

      zoomModal.id = 'fxColorZoomModal';

      zoomModal.className = 'fx-image-zoom-modal active';

      document.body.appendChild(zoomModal);

    } else {

      zoomModal.className = 'fx-image-zoom-modal active';

    }

    

    // Determina se siamo su mobile

    const isMobile = window.innerWidth <= 768;

    

    // Verifica se l'immagine è già nel formato 399x200 (o proporzioni 2:1)

    const isOptimalRatio = imageUrl && imageUrl.includes('399') && imageUrl.includes('200');

    

    // Dimensioni uniformi e fisse per tutte le immagini - nessuno sfondo bianco

    const imageStyle = isMobile 

      ? `width: ${isOptimalRatio ? '85vw' : '200vw'} !important; 

         height: ${isOptimalRatio ? '85vw' : '200vw'} !important; 

         max-width: ${isOptimalRatio ? '400px' : '950px'} !important; 

         max-height: ${isOptimalRatio ? '400px' : '950px'} !important;

         object-fit: cover !important; object-position: center center !important;

         border-radius: 0 !important;

         padding: 0 !important; border: none !important;

         margin: 0 !important; display: block !important;`

      : `width: 60vw !important; height: 60vh !important; max-width: 1250px !important; max-height: 700px !important; 

         object-fit: cover !important; border-radius: 0 !important;

         box-shadow: 0 25px 70px rgba(0, 0, 0, 0.2), 0 10px 25px rgba(0, 0, 0, 0.1) !important;

         padding: 0 !important; border: none !important;`;

    

    // Crea HTML con onclick inline per massima compatibilità - stesso stile del carosello

    const closeButtonHTML = `

      <div class="fx-zoom-close" id="fxColorZoomClose"

           onclick="window.ConfiguratoreDataUniversal.closeColorZoom(); return false;"

           ontouchend="window.ConfiguratoreDataUniversal.closeColorZoom(); return false;"

           style="position: absolute;

                  top: 30px;

                  right: 30px;

                  font-size: 36px;

                  color: #999;

                  cursor: pointer;

                  z-index: 100001;

                  width: 50px;

                  height: 50px;

                  display: flex;

                  align-items: center;

                  justify-content: center;

                  background: rgba(255, 255, 255, 0.8);

                  border: 1px solid rgba(255, 255, 255, 0.5);

                  border-radius: 50%;

                  transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);

                  font-weight: 300;

                  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1), inset 0 0 0 1px rgba(255, 255, 255, 0.2);

                  overflow: hidden;

                  -webkit-tap-highlight-color: transparent;

                  touch-action: manipulation;

                  user-select: none;"

           onmouseover="this.style.border='1px solid #E12D2D'; this.style.background='rgba(255, 255, 255, 0.7)'; this.style.color='#E12D2D'; this.style.transform='rotate(90deg) scale(1.1)';"

           onmouseout="this.style.border='1px solid rgba(255, 255, 255, 0.5)'; this.style.background='rgba(255, 255, 255, 0.5)'; this.style.color='#999'; this.style.transform='rotate(0) scale(1)';">&times;</div>

    `;

    

    const containerStyle = isMobile 

      ? `position: relative; width: 85vw; height: 85vw; max-width: 400px; max-height: 400px; 

         overflow: hidden; display: flex; align-items: center; justify-content: center;`

      : `position: relative; display: flex; align-items: center; justify-content: center;`;

    

    zoomModal.innerHTML = closeButtonHTML + `

      <div class="fx-zoom-content" style="${containerStyle}">

        <img class="fx-zoomed-image" 

             src="${highResUrl}" 

             alt="${colorName}"

             style="${imageStyle}"

             loading="eager"

             decoding="sync">

      </div>

    `;

    

    zoomModal.style.display = 'flex';

    

    // Aggiungi solo evento per chiudere cliccando fuori (il pulsante ha già onclick inline)

    zoomModal.onclick = (e) => {

      if (e.target === zoomModal || e.target.classList.contains('fx-zoom-content')) {

        this.closeColorZoom();

      }

    };

  },

  

  // Funzione per chiudere lo zoom

  closeColorZoom() {

    const zoomModal = document.getElementById('fxColorZoomModal');

    if (zoomModal) {

      zoomModal.style.display = 'none';

      zoomModal.classList.remove('active');

      // Rimuovi il modal dal DOM per pulizia completa

      setTimeout(() => {

        if (zoomModal && zoomModal.parentNode) {

          zoomModal.parentNode.removeChild(zoomModal);

        }

      }, 300);

    }

  },



  // Mostra informazioni sul formato

  // context: 'formato' (Step 2) mostra caratteristiche bordo, 'finitura' (Step 3) mostra solo finiture

  // Su desktop (hover): mostra tooltip leggero vicino al pulsante

  // Su mobile (click): mostra popup completo centrato

  showFormatInfo(formatValue, formatLabel, context = 'finitura', finituraLabelParam = '', event = null) {

    const isDesktop = window.innerWidth > 768;



    // Su desktop usa tooltip leggero

    if (isDesktop) {

      this.showFormatInfoTooltip(formatValue, formatLabel, context, finituraLabelParam, event);

      return;

    }



    // Su mobile usa popup completo (codice esistente sotto)

    // Determina quali caratteristiche ha questo formato

    // Controlla sia formatValue che formatLabel per caratteristiche come "rettificato" che non sono nel value

    const formatLower = formatValue.toLowerCase();

    const labelLower = (formatLabel || '').toLowerCase();

    // 🔧 Usa finituraLabelParam se passato, altrimenti prova dalla configurazione

    const finituraLabelConfig = (finituraLabelParam || window.productConfigurator?.configuration?.finituraLabel || '').toLowerCase();

    const characteristics = [];



    // === CARATTERISTICHE DEL BORDO (solo nello Step 2 - context='formato') ===

    if (context === 'formato') {

      if (formatLower.includes('rettificato') || labelLower.includes('rettificato')) {

        characteristics.push({

          title: 'Rettificato',

          icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="3" width="18" height="18" stroke="#2D5A3D" stroke-width="2" stroke-linejoin="miter"/><path d="M3 3L21 21M21 3L3 21" stroke="#2D5A3D" stroke-width="1" opacity="0.3"/></svg>',

          description: 'Bordi perfettamente squadrati e tagliati con precisione. Permette una posa con fughe minime (2mm) per un effetto continuo e moderno.'

        });

      }



      if (formatLower.includes('squadrato') || formatLower.includes('squadrata') || labelLower.includes('squadrato') || labelLower.includes('squadrata')) {

        characteristics.push({

          title: 'Squadrato',

          icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="3" width="18" height="18" stroke="#2D5A3D" stroke-width="2" stroke-linejoin="miter"/><path d="M3 3L7 7M21 3L17 7M3 21L7 17M21 21L17 17" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round"/></svg>',

          description: 'Bordi tagliati a 90° con estrema precisione. Permette accostamenti perfetti tra le piastrelle con fughe sottilissime, creando superfici continue ed eleganti.'

        });

      }

    }



    // === FINITURE (caratteristiche della superficie) - SOLO nello Step 3 (context='finitura') ===

    if (context === 'finitura') {

    if (formatLower.includes('lucido')) {

      characteristics.push({

        title: 'Lucida',

        icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="8" stroke="#2D5A3D" stroke-width="2"/><path d="M8 12l3 3 5-6" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M15 7L17 5M17 5L19 7M17 5V9" stroke="#2D5A3D" stroke-width="1.5" stroke-linecap="round"/></svg>',

        description: 'Finitura lucida e brillante che riflette la luce. Ideale per ambienti eleganti e sofisticati. Richiede maggiore manutenzione ma offre un effetto estetico di grande impatto.'

      });

    }



// Velvet (effetto vellutato soft-touch) - KH velvet desc

    if (formatLower.includes('velvet')) {

      characteristics.push({

        title: 'Velvet',

        icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="4" width="16" height="16" rx="3" stroke="#2D5A3D" stroke-width="2"/><path d="M7 10c2-2 3-2 5 0s3 2 5 0M7 14c2-2 3-2 5 0s3 2 5 0" stroke="#2D5A3D" stroke-width="1.3" stroke-linecap="round"/></svg>',

        description: 'Finitura opaca con effetto vellutato e soft-touch: superficie morbida al tatto, antiriflesso ed elegante, che dona al materiale un aspetto contemporaneo e raffinato.'

      });

    }



        // Satinata normale (escludi satinatoNaturale che è Naturale Silk)

    if (formatLower.includes('satinato') && !formatLower.includes('satinatoNaturale')) {

      characteristics.push({

        title: 'Satinata',

        icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="8" stroke="#2D5A3D" stroke-width="2"/><circle cx="12" cy="12" r="4" fill="#2D5A3D" opacity="0.3"/><path d="M12 4V8M12 16V20M20 12H16M8 12H4" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round"/></svg>',

        description: 'Finitura semi-opaca con una leggera brillantezza. Combina eleganza e praticità, nascondendo meglio impronte e graffi rispetto alla lucida.'

      });

    }



    if (formatLower.includes('bocciardato') || formatLower.includes('lithos')) {

      characteristics.push({

        title: 'Bocciardato',

        icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="8" width="4" height="12" stroke="#2D5A3D" stroke-width="2"/><path d="M6 8L12 4L18 8" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="12" cy="14" r="1" fill="#2D5A3D"/><circle cx="15" cy="12" r="1" fill="#2D5A3D"/><circle cx="9" cy="12" r="1" fill="#2D5A3D"/><circle cx="13" cy="17" r="1" fill="#2D5A3D"/><circle cx="11" cy="17" r="1" fill="#2D5A3D"/></svg>',

        description: 'Superficie lavorata con texture irregolare ottenuta tramite bocciardatura. Offre eccellente resistenza allo scivolamento (antiscivolo) ed è ideale per esterni e ambienti umidi.'

      });

    }



    if (formatLower.includes('strutturato')) {

      characteristics.push({

        title: 'Strutturata',

        icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 20L8 14L12 18L21 7" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M3 12L8 8L12 12L21 3" stroke="#2D5A3D" stroke-width="2" opacity="0.4" stroke-linecap="round" stroke-linejoin="round"/></svg>',

        description: 'Superficie con texture tridimensionale che riproduce l\'aspetto naturale della pietra. Antiscivolo e perfetta per esterni e zone con forte passaggio.'

      });

    }



    if (formatLower.includes('liscio') || formatLower.includes('smooth')) {

      characteristics.push({

        title: 'Liscia',

        icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="4" width="16" height="16" rx="2" stroke="#2D5A3D" stroke-width="2"/><path d="M4 10H20M4 14H20" stroke="#2D5A3D" stroke-width="2" opacity="0.3"/></svg>',

        description: 'Superficie perfettamente liscia e uniforme. Facile da pulire e mantenere, ideale per ambienti interni con traffico moderato.'

      });

    }



    if (formatLower.includes('levigato') || formatLower.includes('levigata') || labelLower.includes('levigat') || finituraLabelConfig.includes('levigat')) {

      characteristics.push({

        title: 'Levigata',

        icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="4" width="16" height="16" rx="2" stroke="#2D5A3D" stroke-width="2"/><path d="M4 8H20M4 12H20M4 16H20" stroke="#2D5A3D" stroke-width="1.5" opacity="0.4"/><circle cx="12" cy="12" r="3" fill="#2D5A3D" opacity="0.3"/><path d="M15 7L17 5M17 5L19 7M17 5V9" stroke="#2D5A3D" stroke-width="1.5" stroke-linecap="round"/></svg>',

        description: 'Finitura levigata lucida ottenuta mediante lavorazione meccanica della superficie. Offre un aspetto brillante e riflettente, ideale per ambienti eleganti e raffinati.'

      });

    }



    // Mostra "Lappata" solo se NON è "Lappata-Satinata" (altrimenti mostrerebbe entrambe)

    const isLappataSatinata = formatLower.includes('lappatasatinata') || formatLower.includes('lappata-satinata') ||

                              finituraLabelConfig.includes('lappatasatinata') || finituraLabelConfig.includes('lappata-satinata');

    if ((formatLower.includes('lappato') || formatLower.includes('lappata') || labelLower.includes('lappat') || finituraLabelConfig.includes('lappat')) && !isLappataSatinata) {

      characteristics.push({

        title: 'Lappata',

        icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="4" width="16" height="16" rx="2" stroke="#2D5A3D" stroke-width="2"/><path d="M4 9H20M4 14H20" stroke="#2D5A3D" stroke-width="1.5" opacity="0.5"/><ellipse cx="12" cy="12" rx="4" ry="2" fill="#2D5A3D" opacity="0.25"/><path d="M8 6L10 8M14 6L16 8" stroke="#2D5A3D" stroke-width="1.5" stroke-linecap="round" opacity="0.6"/></svg>',

        description: 'Finitura lappata semi-lucida ottenuta mediante lavorazione parziale della superficie. Offre un aspetto satinato elegante, meno riflettente della levigata ma più luminoso del naturale.'

      });

    }



    if (formatLower.includes('comfort')) {

      characteristics.push({

        title: 'Comfort',

        icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 3C7.58 3 4 6.58 4 11C4 15.42 7.58 19 12 19C16.42 19 20 15.42 20 11C20 6.58 16.42 3 12 3Z" stroke="#2D5A3D" stroke-width="2"/><path d="M9 11C9 11 10 13 12 13C14 13 15 11 15 11" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round"/><circle cx="9" cy="9" r="1" fill="#2D5A3D"/><circle cx="15" cy="9" r="1" fill="#2D5A3D"/></svg>',

        description: 'Finitura speciale che offre comfort al tatto e migliore grip. Combina estetica e funzionalità per un\'esperienza di camminata piacevole.'

      });

    }



    if (formatLower.includes('parete') && characteristics.length === 0) { // KH-FIX 30-06 parete-no-doppio: card Parete solo se non c'è già una finitura (es. Bocciardato)

      characteristics.push({

        title: 'Parete',

        icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="3" width="7" height="4" stroke="#2D5A3D" stroke-width="1.5"/><rect x="3" y="9" width="7" height="4" stroke="#2D5A3D" stroke-width="1.5"/><rect x="3" y="15" width="7" height="4" stroke="#2D5A3D" stroke-width="1.5"/><rect x="12" y="3" width="9" height="4" stroke="#2D5A3D" stroke-width="1.5"/><rect x="12" y="9" width="9" height="4" stroke="#2D5A3D" stroke-width="1.5"/><rect x="12" y="15" width="9" height="4" stroke="#2D5A3D" stroke-width="1.5"/></svg>',

        description: 'Formato specificamente progettato per rivestimenti murali. Ottimizzato per installazione verticale con caratteristiche tecniche adatte alle pareti.'

      });

    }



    if (formatLower.includes('ptv')) {

      characteristics.push({

        title: 'PTV',

        icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><ellipse cx="12" cy="18" rx="6" ry="3" stroke="#2D5A3D" stroke-width="2"/><path d="M12 18V6M12 6L8 10M12 6L16 10" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="12" cy="4" r="2" fill="#2D5A3D"/></svg>',

        description: 'Pendulum Test Value - Certificazione di resistenza allo scivolamento. Indica il livello di sicurezza della superficie in condizioni bagnate.'

      });

    }



    if (formatLower.includes('lux')) {

      characteristics.push({

        title: 'Lucida',

        icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="4" stroke="#2D5A3D" stroke-width="2"/><path d="M12 2V6M12 18V22M22 12H18M6 12H2M19.07 4.93L16.24 7.76M7.76 16.24L4.93 19.07M19.07 19.07L16.24 16.24M7.76 7.76L4.93 4.93" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round"/></svg>',

        description: 'Finitura premium con effetto luminoso e sofisticato. Combina eleganza estetica con caratteristiche tecniche avanzate.'

      });

    }



    if (formatLower.includes('fluid')) {

      characteristics.push({

        title: 'Fluid',

        icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 12C3 12 5 8 9 8C13 8 13 12 17 12C21 12 21 8 21 8" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round"/><path d="M3 18C3 18 5 14 9 14C13 14 13 18 17 18C21 18 21 14 21 14" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round"/><path d="M3 6C3 6 5 2 9 2C13 2 13 6 17 6C21 6 21 2 21 2" stroke="#2D5A3D" stroke-width="2" opacity="0.3" stroke-linecap="round"/></svg>',

        description: 'Design fluido e dinamico con venature naturali che creano continuità visiva. Perfetto per ambienti contemporanei e minimalisti.'

      });

    }



    if (formatLower.includes('naturale')) {

      characteristics.push({

        title: 'Naturale',

        icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C12 2 4 8 4 14C4 18.42 7.58 22 12 22C16.42 22 20 18.42 20 14C20 8 12 2 12 2Z" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 22V12M12 12L8 16M12 12L16 16" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',

        description: 'Finitura naturale che riproduce fedelmente l\'aspetto della pietra o del materiale originale. Superficie Naturale con texture autentica, ideale per chi cerca un effetto elegante e non riflettente.'

      });

    }



    if (formatLower.includes('cannete') || formatLower.includes('canneté') || formatLower.includes('cannetté') || formatLower.includes('cannetè')) {

      characteristics.push({

        title: 'Canneté',

        icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 4V20" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round"/><path d="M8 4V20" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round"/><path d="M12 4V20" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round"/><path d="M16 4V20" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round"/><path d="M20 4V20" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round"/></svg>',

        description: 'Superficie con scanalature verticali parallele che creano un elegante effetto tridimensionale. Ideale per rivestimenti decorativi e pareti d\'accento, dona profondità e movimento agli ambienti.'

      });

    }



    // Satinata Naturale (Naturale Silk) - voce specifica

    if (formatLower.includes('satinatoNaturale') || formatLower.includes('Naturale silk') || formatLower.includes('satinato Naturale')) {

      characteristics.push({

        title: 'Satinata Naturale',

        icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="3" width="18" height="18" rx="2" stroke="#2D5A3D" stroke-width="2"/><path d="M3 12h18" stroke="#2D5A3D" stroke-width="1" opacity="0.3"/><path d="M7 7l10 10M7 17l10-10" stroke="#2D5A3D" stroke-width="1" opacity="0.2"/><circle cx="12" cy="12" r="3" fill="#2D5A3D" opacity="0.15"/></svg>',

        description: 'Finitura satinata con effetto naturale. Superficie morbida e vellutata al tatto, combina l\'eleganza della satinata con la praticità della finitura naturale.'

      });

    }



    // Soft (solo se non è già satinatoNaturale)

    if ((formatLower.includes('-soft') || formatLower.includes('soft')) && !formatLower.includes('satinatoNaturale')) {

      characteristics.push({

        title: 'Soft',

        icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="3" width="18" height="18" rx="2" stroke="#2D5A3D" stroke-width="2"/><path d="M3 12h18" stroke="#2D5A3D" stroke-width="1" opacity="0.3"/><path d="M7 7l10 10M7 17l10-10" stroke="#2D5A3D" stroke-width="1" opacity="0.2"/><circle cx="12" cy="12" r="3" fill="#2D5A3D" opacity="0.15"/></svg>',

        description: 'Finitura soft con effetto setoso e delicato. Superficie morbida al tatto con riflessi attenuati. Elegante e raffinata, ideale per ambienti moderni.'

      });

    }



    if (formatLower.includes('-lux')) {

      characteristics.push({

        title: 'Satinata',

        icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="3" width="18" height="18" rx="2" stroke="#2D5A3D" stroke-width="2"/><path d="M3 12h18" stroke="#2D5A3D" stroke-width="1" opacity="0.3"/><path d="M7 7l10 10M7 17l10-10" stroke="#2D5A3D" stroke-width="1" opacity="0.2"/><circle cx="12" cy="12" r="3" fill="#2D5A3D" opacity="0.15"/></svg>',

        description: 'Finitura Satinata semi-lucida ottenuta mediante levigatura superficiale. Offre un aspetto elegante e setoso con riflessi delicati. Resistente e facile da pulire.'

      });

    }



    // Naturale (escludi satinatoNaturale, Naturalecuoio, Naturale leather, Naturale silk)

    if ((formatLower.includes('Naturale') || formatLower.includes('Naturale')) &&

        !formatLower.includes('satinatoNaturale') && !formatLower.includes('Naturalecuoio') &&

        !formatLower.includes('Naturale leather') && !formatLower.includes('Naturale silk') &&

        !formatLower.includes('cuoio Naturale') && !formatLower.includes('satinato Naturale')) {

      characteristics.push({

        title: 'Naturale',

        icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="4" width="16" height="16" rx="2" stroke="#2D5A3D" stroke-width="2"/><rect x="7" y="7" width="10" height="10" fill="#2D5A3D" opacity="0.2"/></svg>',

        description: 'Finitura completamente Naturale senza riflessi. Non trattiene impronte e macchie, ideale per ambienti ad alto traffico. Aspetto contemporaneo e sofisticato.'

      });

    }



    if (formatLower.includes('Naturalecuoio') || formatLower.includes('Naturale leather') || formatLower.includes('cuoio Naturale')) {

      characteristics.push({

        title: 'Cuoio Naturale',

        icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="4" width="16" height="16" rx="2" stroke="#8B4513" stroke-width="2"/><rect x="7" y="7" width="10" height="10" fill="#8B4513" opacity="0.3"/><path d="M7 10h10M7 14h10" stroke="#8B4513" stroke-width="1" opacity="0.5"/></svg>',

        description: 'Finitura Naturale con texture effetto cuoio. Superficie tattile che riproduce la morbidezza e le venature del cuoio naturale. Elegante e contemporanea.'

      });

    }



    // Grip - Finitura antiscivolo per esterni

    if (formatLower.includes('grip') || finituraLabelConfig.includes('grip')) {

      characteristics.push({

        title: 'Grip',

        icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="4" width="16" height="16" rx="2" stroke="#2D5A3D" stroke-width="2"/><circle cx="8" cy="8" r="1.5" fill="#2D5A3D"/><circle cx="12" cy="8" r="1.5" fill="#2D5A3D"/><circle cx="16" cy="8" r="1.5" fill="#2D5A3D"/><circle cx="8" cy="12" r="1.5" fill="#2D5A3D"/><circle cx="12" cy="12" r="1.5" fill="#2D5A3D"/><circle cx="16" cy="12" r="1.5" fill="#2D5A3D"/><circle cx="8" cy="16" r="1.5" fill="#2D5A3D"/><circle cx="12" cy="16" r="1.5" fill="#2D5A3D"/><circle cx="16" cy="16" r="1.5" fill="#2D5A3D"/></svg>',

        description: 'Superficie antiscivolo certificata, ideale per esterni e zone soggette a umidità. Texture speciale che garantisce sicurezza e aderenza anche in condizioni bagnate.'

      });

    }



    // Antislip - Finitura antiscivolo

    if (formatLower.includes('antislip') || finituraLabelConfig.includes('antislip')) {

      characteristics.push({

        title: 'Antislip',

        icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="4" width="16" height="16" rx="2" stroke="#2D5A3D" stroke-width="2"/><path d="M7 17L17 7" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round"/><path d="M7 12L12 7" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round"/><path d="M12 17L17 12" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round"/></svg>',

        description: 'Superficie antiscivolo certificata per ambienti umidi e bagnati. Ideale per bagni, cucine, aree piscina e zone esterne. Garantisce sicurezza e aderenza anche in presenza di acqua.'

      });

    }



    // RealUp+StrideUp - Finitura 3D con rilievi strutturati

    if (formatLower.includes('realupstrideup') || finituraLabelConfig.includes('realupstrideup') || finituraLabelConfig.includes('realup+strideup')) {

      characteristics.push({

        title: 'RealUp+StrideUp',

        icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="4" width="16" height="16" rx="2" stroke="#2D5A3D" stroke-width="2"/><path d="M4 12h16" stroke="#2D5A3D" stroke-width="1.5" opacity="0.4"/><path d="M8 8l4 4-4 4" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M14 8l4 4-4 4" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" opacity="0.5"/><path d="M4 8h16" stroke="#2D5A3D" stroke-width="1" opacity="0.3"/><path d="M4 16h16" stroke="#2D5A3D" stroke-width="1" opacity="0.3"/></svg>',

        description: 'Tecnologia avanzata che combina la tridimensionalità RealUp con rilievi strutturati StrideUp. Superficie materica con texture accentuate, perfetta per ambienti che richiedono grip e carattere estetico.'

      });

    }



    // RealUp - Finitura 3D materica (solo se non è RealUp+StrideUp)

    if ((formatLower.includes('realup') && !formatLower.includes('realupstrideup')) ||

        (finituraLabelConfig.includes('realup') && !finituraLabelConfig.includes('realupstrideup') && !finituraLabelConfig.includes('realup+strideup'))) {

      characteristics.push({

        title: 'RealUp',

        icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="4" width="16" height="16" rx="2" stroke="#2D5A3D" stroke-width="2"/><path d="M4 12h16" stroke="#2D5A3D" stroke-width="1.5" opacity="0.4"/><path d="M8 8l4 4-4 4" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M14 8l4 4-4 4" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" opacity="0.5"/></svg>',

        description: 'Tecnologia esclusiva che riproduce la tridimensionalità della pietra naturale. Superficie materica ad alta definizione con texture realistiche, perfetta per interni ed esterni.'

      });

    }



    // StrideUp - Finitura con rilievi strutturati antiscivolo (solo se non è RealUp+StrideUp)

    if ((formatLower.includes('strideup') && !formatLower.includes('realupstrideup')) ||

        (finituraLabelConfig.includes('strideup') && !finituraLabelConfig.includes('realupstrideup') && !finituraLabelConfig.includes('realup+strideup'))) {

      characteristics.push({

        title: 'StrideUp',

        icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="4" width="16" height="16" rx="2" stroke="#2D5A3D" stroke-width="2"/><path d="M6 8h12" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round"/><path d="M6 12h12" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round"/><path d="M6 16h12" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round"/><path d="M9 6v12" stroke="#2D5A3D" stroke-width="1" opacity="0.4"/><path d="M15 6v12" stroke="#2D5A3D" stroke-width="1" opacity="0.4"/></svg>',

        description: 'Tecnologia esclusiva con rilievi strutturati che garantiscono eccellente resistenza allo scivolamento. Superficie con texture accentuate che offre grip superiore, ideale per ambienti che richiedono sicurezza e carattere estetico.'

      });

    }



    // Fade - Finitura con effetto sfumato

    if (formatLower.includes('fade') || finituraLabelConfig.includes('fade')) {

      characteristics.push({

        title: 'Fade',

        icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="4" width="16" height="16" rx="2" stroke="#2D5A3D" stroke-width="2"/><defs><linearGradient id="fadeGrad" x1="0%" y1="0%" x2="100%" y2="0%"><stop offset="0%" style="stop-color:#2D5A3D;stop-opacity:0.1"/><stop offset="100%" style="stop-color:#2D5A3D;stop-opacity:0.8"/></linearGradient></defs><rect x="7" y="7" width="10" height="10" fill="url(#fadeGrad)"/></svg>',

        description: 'Superficie con effetto sfumato che crea transizioni di colore delicate e naturali. Design contemporaneo che aggiunge profondità e movimento agli ambienti.'

      });

    }



    // Lappata-Satinata - Finitura semi-lucida con tocco satinato

    if (formatLower.includes('lappatasatinata') || formatLower.includes('lappata-satinata') ||

        finituraLabelConfig.includes('lappatasatinata') || finituraLabelConfig.includes('lappata-satinata')) {

      characteristics.push({

        title: 'Lappata-Satinata',

        icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="4" width="16" height="16" rx="2" stroke="#2D5A3D" stroke-width="2"/><rect x="7" y="7" width="10" height="5" fill="#2D5A3D" opacity="0.5"/><rect x="7" y="12" width="10" height="5" fill="#2D5A3D" opacity="0.25"/></svg>',

        description: 'Finitura che combina la luminosità della lappatura con la morbidezza del satinato. Superficie elegante con riflessi delicati, perfetta per ambienti raffinati.'

      });

    }



    // T_20 / 20mm - Spessore maggiorato per esterni

    if (formatLower.includes('20mm') || formatLower.includes('t_20') || formatLower.includes('t20') ||

        finituraLabelConfig.includes('20mm') || finituraLabelConfig.includes('t_20') || finituraLabelConfig.includes('t20')) {

      const hasT20Label = formatLower.includes('t_20') || formatLower.includes('t20') || finituraLabelConfig.includes('t_20') || finituraLabelConfig.includes('t20');

      characteristics.push({

        title: hasT20Label ? 'T_20' : '20mm',

        icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="6" width="18" height="12" rx="2" stroke="#2D5A3D" stroke-width="2"/><path d="M3 10h18M3 14h18" stroke="#2D5A3D" stroke-width="1.5" opacity="0.4"/><text x="12" y="13" font-size="6" fill="#2D5A3D" text-anchor="middle" font-weight="bold">20</text></svg>',

        description: 'Spessore maggiorato 20mm per esterni e applicazioni speciali. Ideale per posa su ghiaia, piedini, erba o sabbia. Resistente a carichi pesanti, cicli gelo/disgelo e agenti atmosferici.'

      });

    }

    } // Fine blocco if (context === 'finitura') - finiture solo in Step 3



    // Se non ci sono caratteristiche specifiche, mostra info appropriate in base al context

    if (characteristics.length === 0) {

      if (context === 'formato') {

        // Step 2: info sul formato/dimensione

        characteristics.push({

          title: 'Formato Standard',

          icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="3" width="18" height="18" stroke="#2D5A3D" stroke-width="2" rx="2"/><path d="M3 9H21M9 3V21" stroke="#2D5A3D" stroke-width="2" opacity="0.5"/></svg>',

          description: 'Formato con bordi tradizionali. La posa avviene con fughe standard (3-5mm) che garantiscono la corretta dilatazione del materiale.'

        });

      } else {

        // Step 3: info sulla finitura - usa la finitura reale dalla variante

        const finituraReale = finituraLabelParam || window.productConfigurator?.configuration?.finituraLabel || 'Naturale';

        characteristics.push({

          title: finituraReale,

          icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="4" width="16" height="16" rx="2" stroke="#2D5A3D" stroke-width="2"/><rect x="7" y="7" width="10" height="10" fill="#2D5A3D" opacity="0.2"/></svg>',

          description: 'Finitura naturale opaca che riproduce fedelmente l\'aspetto del materiale originale. Superficie versatile, facile da pulire e adatta a tutti gli ambienti.'

        });

      }

    }



    // Crea il modal

    let infoModal = document.getElementById('fxFormatInfoModal');

    if (!infoModal) {

      infoModal = document.createElement('div');

      infoModal.id = 'fxFormatInfoModal';

      document.body.appendChild(infoModal);

    }



    // 🔧 Costruisci titolo - SOLO formato, MAI finitura (la finitura è mostrata nello step separato)

    let displayTitle = formatLabel;

    // Rimuovi eventuali finiture già presenti nel formatLabel per mostrare solo dimensioni + bordo

    const finitureToRemove = ['lappata-satinata', 'lappatasatinata', 'naturale', 'lappata', 'lappato', 'satinata', 'satinato', 'lucida', 'lucido', 'strutturata', 'strutturato', 'bocciardato', 'levigata', 'levigato', 'liscia', 'liscio', 'comfort', 'soft', 'matte', 'matt', 'grip', 'antislip', 'realup', 'strideup', 'fade', 't_20', '20mm'];

    for (const fin of finitureToRemove) {

      const regex = new RegExp(`\\s+${fin}\\b`, 'gi');

      displayTitle = displayTitle.replace(regex, '').trim();

    }



    // 🆕 Costruisci HTML delle caratteristiche - stile compatto simile al tooltip desktop

    const characteristicsHTML = characteristics.map(char => `

      <div style="display: flex; align-items: flex-start; gap: 12px; padding: 12px; background: #F5F2EB; border-radius: 12px; margin-bottom: 10px;">

        <div style="flex-shrink: 0; width: 40px; height: 40px; display: flex; align-items: center; justify-content: center; background: white; border-radius: 10px; box-shadow: 0 2px 6px rgba(0,0,0,0.08);">

          ${char.icon.replace(/width="32" height="32"/g, 'width="24" height="24"')}

        </div>

        <div style="flex: 1; min-width: 0;">

          <h4 style="margin: 0 0 4px 0; font-size: 0.95rem; font-weight: 600; color: #2d3436;">${char.title}</h4>

          <p style="margin: 0; font-size: 0.8rem; color: #636e72; line-height: 1.45;">${char.description}</p>

        </div>

      </div>

    `).join('');



    // 🆕 Mobile: Bottom sheet compatto e moderno

    infoModal.innerHTML = `

      <div id="fxModalOverlay"

           onclick="window.ConfiguratoreDataUniversal.closeFormatInfo();"

           ontouchend="window.ConfiguratoreDataUniversal.closeFormatInfo();"

           style="position: fixed; top: 0; left: 0; right: 0; bottom: 0;

                  background: rgba(0, 0, 0, 0.4);

                  backdrop-filter: blur(4px);

                  -webkit-backdrop-filter: blur(4px);

                  z-index: 100000;

                  animation: fxFadeIn 0.2s ease;">

        <div onclick="event.stopPropagation();"

             ontouchend="event.stopPropagation();"

             style="position: fixed; bottom: 0; left: 0; right: 0;

                    background: white;

                    border-radius: 20px 20px 0 0;

                    max-height: 75vh;

                    overflow-y: auto;

                    box-shadow: 0 -4px 24px rgba(0, 0, 0, 0.15);

                    padding: 0;

                    animation: fxSlideUp 0.3s cubic-bezier(0.32, 0.72, 0, 1);">



          <!-- Handle bar per drag -->

          <div style="padding: 12px 0 8px; text-align: center; position: sticky; top: 0; background: white; z-index: 2; border-radius: 20px 20px 0 0;">

            <div style="width: 36px; height: 4px; background: #ddd; border-radius: 2px; margin: 0 auto;"></div>

          </div>



          <div style="padding: 0 20px 24px;">

            <!-- Caratteristiche -->

            <div>

              ${characteristicsHTML}

            </div>



            <!-- Footer compatto -->

            <div style="background: linear-gradient(135deg, #2D5A3D 0%, #1B4332 100%);

                        color: white; padding: 12px 16px; border-radius: 12px;

                        margin-top: 8px; text-align: center;">

              <p style="margin: 0; font-size: 0.8rem; font-weight: 500;">

                Scegli la finitura più adatta alle tue esigenze di stile e funzionalità

              </p>

            </div>

          </div>

        </div>

      </div>

      <style>

        @keyframes fxFadeIn { from { opacity: 0; } to { opacity: 1; } }

        @keyframes fxSlideUp { from { transform: translateY(100%); } to { transform: translateY(0); } }

      </style>

    `;



    infoModal.style.display = 'block';



    // Previeni scroll del body quando il modal è aperto

    document.body.style.overflow = 'hidden';



    // Chiudi cliccando sullo sfondo

    const overlay = infoModal.querySelector('#fxModalOverlay');

    if (overlay) {

      overlay.onclick = (e) => {

        if (e.target === overlay) {

          this.closeFormatInfo();

        }

      };

    }

  },



  closeFormatInfo() {

    const infoModal = document.getElementById('fxFormatInfoModal');

    if (infoModal) {

      infoModal.style.display = 'none';

      document.body.style.overflow = '';

      // Rimuovi il modal dal DOM per pulizia

      setTimeout(() => {

        if (infoModal && infoModal.parentNode) {

          infoModal.parentNode.removeChild(infoModal);

        }

      }, 300);

    }

  },



  // 🆕 Tooltip leggero per desktop (hover)

  showFormatInfoTooltip(formatValue, formatLabel, context = 'finitura', finituraLabelParam = '', event = null) {

    // Chiudi eventuali tooltip esistenti

    this.closeFormatInfoTooltip();



    const formatLower = formatValue.toLowerCase();

    const labelLower = (formatLabel || '').toLowerCase();

    const finituraLabelConfig = (finituraLabelParam || '').toLowerCase();



    // Trova la caratteristica principale da mostrare

    let title = '';

    let description = '';



    // Determina il titolo e descrizione in base al context e alle caratteristiche

    if (context === 'formato') {

      if (formatLower.includes('rettificato') || labelLower.includes('rettificato')) {

        title = 'Rettificato';

        description = 'Bordi perfettamente squadrati grazie a lavorazione meccanica di precisione. Permette una posa con fughe minime (2mm) per un effetto visivo continuo e moderno.';

      } else if (formatLower.includes('squadrato') || labelLower.includes('squadrato')) {

        title = 'Squadrato';

        description = 'Bordi tagliati a 90° con estrema precisione per una posa omogenea e pulita.';

      } else {

        title = 'Formato Standard';

        description = 'Posa tradizionale con fughe standard (3-5mm) che facilitano l\'installazione.';

      }

    } else {

      // Finiture - cerca la finitura specifica

      if (formatLower.includes('lucido') || finituraLabelConfig.includes('lucid')) {

        title = 'Lucida';

        description = 'Superficie brillante e riflettente ottenuta tramite lucidatura meccanica. Ideale per ambienti eleganti come soggiorni e ingressi. Richiede maggiore manutenzione per mantenere la lucentezza.';

      } else if (formatLower.includes('lappata') && !formatLower.includes('lappatasatinata')) {

        title = 'Lappata';

        description = 'Finitura semi-lucida ottenuta con lappatura parziale della superficie. Offre un equilibrio tra eleganza e praticità: riflette la luce senza essere troppo brillante e resiste meglio a graffi e impronte.';

      } else if (formatLower.includes('lappatasatinata') || finituraLabelConfig.includes('lappata-satinata')) {

        title = 'Lappata-Satinata';

        description = 'Finitura ibrida che combina la luminosità della lappatura con la morbidezza del satinato. Effetto sofisticato con ottima resistenza alle impronte.';

      } else if (formatLower.includes('satinato') || finituraLabelConfig.includes('satinat')) {

        title = 'Satinata';

        description = 'Superficie semi-opaca con aspetto setoso e vellutato. Nasconde efficacemente impronte e piccoli graffi, rendendola perfetta per zone ad alto traffico.';

      } else if (formatLower.includes('naturale') || finituraLabelConfig.includes('naturale')) {

        title = 'Naturale';

        description = 'Finitura opaca che riproduce fedelmente l\'aspetto della pietra naturale. Antiscivolo di base (R9), facile da pulire e adatta a tutti gli ambienti interni.';

      } else if (formatLower.includes('twist') || finituraLabelConfig.includes('twist')) {

        title = 'Twist';

        description = 'Superficie con texture tridimensionale dal motivo intrecciato, che crea un raffinato gioco di luci e ombre. Ideale per rivestimenti a parete di forte carattere decorativo.';

      } else if (formatLower.includes('strutturamove') || finituraLabelConfig.includes('struttura move')) {

        title = 'Struttura Move';

        description = 'Superficie strutturata con rilievo dal movimento morbido e dinamico. Pensata per rivestimenti a parete dal forte impatto materico e decorativo.';

      } else if (formatLower.includes('strutturasign') || finituraLabelConfig.includes('struttura sign')) {

        title = 'Struttura Sign';

        description = 'Superficie strutturata con rilievo dal segno grafico marcato e geometrico. Pensata per rivestimenti a parete dal forte impatto decorativo.';

      } else if (formatLower.includes('strutturanet') || finituraLabelConfig.includes('struttura net')) {

        title = 'Struttura Net';

        description = 'Superficie strutturata con rilievo a trama reticolare. Pensata per rivestimenti a parete dal forte impatto materico e decorativo.';

      } else if (formatLower.includes('stripe') || finituraLabelConfig.includes('stripe')) {

        title = 'Stripe';

        description = 'Superficie con struttura a righe tridimensionali (stripe) che crea texture materiche e giochi di luce. Ideale per rivestimenti a parete di forte carattere.';

      } else if (formatLower.includes('-riga') || finituraLabelConfig.includes('riga')) {

        title = 'Riga';

        description = 'Superficie con struttura a righe verticali che crea un raffinato effetto materico e tridimensionale, ideale per pavimenti e rivestimenti di design.';

      } else if (formatLower.includes('pliss') || finituraLabelConfig.includes('pliss')) {

        title = 'Plissé';

        description = 'Superficie con struttura plissé dalle pieghe morbide e regolari, che crea un elegante gioco di luci e ombre. Ideale per rivestimenti a parete di grande raffinatezza.';

      } else if (formatLower.includes('strutturato') || finituraLabelConfig.includes('struttur')) {

        title = 'Strutturata';

        description = 'Superficie con texture tridimensionale che garantisce elevata aderenza. Classificazione antiscivolo R10/R11, ideale per esterni, terrazze e bordi piscina.';

      } else if (formatLower.includes('grip') || finituraLabelConfig.includes('grip')) {

        title = 'Grip';

        description = 'Superficie con trattamento antiscivolo certificato (R10/R11). Sicura per esterni, zone umide, bagni e aree intorno a piscine. Mantiene l\'estetica del prodotto naturale.';

      } else if (formatLower.includes('antislip') || finituraLabelConfig.includes('antislip')) {

        title = 'Antislip';

        description = 'Finitura con elevata resistenza allo scivolamento certificata. Pensata per ambienti bagnati, docce, piscine e spazi esterni esposti alle intemperie.';

      } else if (formatLower.includes('realupstrideup') || finituraLabelConfig.includes('realup+strideup')) {

        title = 'RealUp+StrideUp';

        description = 'Tecnologia esclusiva che combina texture tridimensionale (RealUp) con rilievi strutturati (StrideUp). Offre massimo realismo tattile e visivo con eccellente resistenza allo scivolamento.';

      } else if (formatLower.includes('realup') || finituraLabelConfig.includes('realup')) {

        title = 'RealUp';

        description = 'Tecnologia innovativa che riproduce la tridimensionalità e le micro-texture della pietra naturale. Al tatto si percepisce la stessa sensazione del materiale originale.';

      } else if (formatLower.includes('strideup') || finituraLabelConfig.includes('strideup')) {

        title = 'StrideUp';

        description = 'Tecnologia con rilievi strutturati che garantisce eccellente resistenza allo scivolamento. Ideale per esterni e zone ad alto traffico dove la sicurezza è prioritaria.';

      } else if (formatLower.includes('bocciardato') || formatLower.includes('lithos')) {

        title = 'Bocciardato';

        description = 'Superficie lavorata che riproduce l\'effetto della pietra bocciarda tradizionale. Elevata aderenza antiscivolo, perfetta per pavimentazioni esterne e percorsi pedonali.';

      } else if (formatLower.includes('levigat') || finituraLabelConfig.includes('levigat')) {

        title = 'Levigata';

        description = 'Superficie resa lucida tramite processo di levigatura meccanica. Effetto specchiante che esalta la profondità delle venature e dei colori.';

      } else if (formatLower.includes('fade') || finituraLabelConfig.includes('fade')) {

        title = 'Fade';

        description = 'Finitura caratterizzata da delicate sfumature e transizioni di colore naturali. Crea effetti visivi unici che variano in base alla luce e all\'angolazione.';

      } else if (formatLower.includes('comfort') || finituraLabelConfig.includes('comfort')) {

        title = 'Comfort';

        description = 'Superficie studiata per il massimo comfort al tatto e al calpestio. Offre una piacevole sensazione sotto i piedi nudi con un grip naturale migliorato.';

      } else if (formatLower.includes('soft') || finituraLabelConfig.includes('soft')) {

        title = 'Soft';

        description = 'Finitura con superficie morbida al tatto e riflessi delicatamente attenuati. Elegante e raffinata, ideale per ambienti residenziali contemporanei.';

      } else if (formatLower.includes('cannete') || finituraLabelConfig.includes('cannete')) {

        title = 'Canneté';

        description = 'Decoro tridimensionale con eleganti scanalature verticali. Perfetto per creare pareti d\'accento, rivestimenti bagno e superfici di design con giochi di luce e ombre.';

      } else if (formatLower.includes('velvet') || finituraLabelConfig.includes('velvet')) {

        title = 'Velvet';

        description = 'Finitura opaca con effetto vellutato e soft-touch: superficie morbida al tatto, antiriflesso ed elegante, che dona al materiale un aspetto contemporaneo e raffinato.';

      } else {

        title = finituraLabelParam || 'Finitura';

        description = 'Superficie di alta qualità prodotta con tecnologie avanzate per garantire durabilità e resistenza nel tempo.';

      }

    }



    // Crea il tooltip

    const tooltip = document.createElement('div');

    tooltip.id = 'fxFormatInfoTooltip';

        var _finA = {
      'Rettificato': { icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="3" width="18" height="18" stroke="#2D5A3D" stroke-width="2" stroke-linejoin="miter"/><path d="M3 3L21 21M21 3L3 21" stroke="#2D5A3D" stroke-width="1" opacity="0.3"/></svg>', description: 'Bordi perfettamente squadrati e tagliati con precisione. Permette una posa con fughe minime (2mm) per un effetto continuo e moderno.' },
      'Squadrato': { icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="3" width="18" height="18" stroke="#2D5A3D" stroke-width="2" stroke-linejoin="miter"/><path d="M3 3L7 7M21 3L17 7M3 21L7 17M21 21L17 17" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round"/></svg>', description: 'Bordi tagliati a 90° con estrema precisione. Permette accostamenti perfetti tra le piastrelle con fughe sottilissime, creando superfici continue ed eleganti.' },
      'Lucida': { icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="8" stroke="#2D5A3D" stroke-width="2"/><path d="M8 12l3 3 5-6" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M15 7L17 5M17 5L19 7M17 5V9" stroke="#2D5A3D" stroke-width="1.5" stroke-linecap="round"/></svg>', description: 'Finitura lucida e brillante che riflette la luce. Ideale per ambienti eleganti e sofisticati. Richiede maggiore manutenzione ma offre un effetto estetico di grande impatto.' },
      'Velvet': { icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="4" width="16" height="16" rx="3" stroke="#2D5A3D" stroke-width="2"/><path d="M7 10c2-2 3-2 5 0s3 2 5 0M7 14c2-2 3-2 5 0s3 2 5 0" stroke="#2D5A3D" stroke-width="1.3" stroke-linecap="round"/></svg>', description: 'Finitura opaca con effetto vellutato e soft-touch: superficie morbida al tatto, antiriflesso ed elegante, che dona al materiale un aspetto contemporaneo e raffinato.' },
      'Satinata': { icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="8" stroke="#2D5A3D" stroke-width="2"/><circle cx="12" cy="12" r="4" fill="#2D5A3D" opacity="0.3"/><path d="M12 4V8M12 16V20M20 12H16M8 12H4" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round"/></svg>', description: 'Finitura semi-opaca con una leggera brillantezza. Combina eleganza e praticità, nascondendo meglio impronte e graffi rispetto alla lucida.' },
      'Bocciardato': { icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="8" width="4" height="12" stroke="#2D5A3D" stroke-width="2"/><path d="M6 8L12 4L18 8" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="12" cy="14" r="1" fill="#2D5A3D"/><circle cx="15" cy="12" r="1" fill="#2D5A3D"/><circle cx="9" cy="12" r="1" fill="#2D5A3D"/><circle cx="13" cy="17" r="1" fill="#2D5A3D"/><circle cx="11" cy="17" r="1" fill="#2D5A3D"/></svg>', description: 'Superficie lavorata con texture irregolare ottenuta tramite bocciardatura. Offre eccellente resistenza allo scivolamento (antiscivolo) ed è ideale per esterni e ambienti umidi.' },
      'Strutturata': { icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 20L8 14L12 18L21 7" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M3 12L8 8L12 12L21 3" stroke="#2D5A3D" stroke-width="2" opacity="0.4" stroke-linecap="round" stroke-linejoin="round"/></svg>', description: 'Superficie con texture tridimensionale che riproduce l\'aspetto naturale della pietra. Antiscivolo e perfetta per esterni e zone con forte passaggio.' },
      'Liscia': { icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="4" width="16" height="16" rx="2" stroke="#2D5A3D" stroke-width="2"/><path d="M4 10H20M4 14H20" stroke="#2D5A3D" stroke-width="2" opacity="0.3"/></svg>', description: 'Superficie perfettamente liscia e uniforme. Facile da pulire e mantenere, ideale per ambienti interni con traffico moderato.' },
      'Levigata': { icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="4" width="16" height="16" rx="2" stroke="#2D5A3D" stroke-width="2"/><path d="M4 8H20M4 12H20M4 16H20" stroke="#2D5A3D" stroke-width="1.5" opacity="0.4"/><circle cx="12" cy="12" r="3" fill="#2D5A3D" opacity="0.3"/><path d="M15 7L17 5M17 5L19 7M17 5V9" stroke="#2D5A3D" stroke-width="1.5" stroke-linecap="round"/></svg>', description: 'Finitura levigata lucida ottenuta mediante lavorazione meccanica della superficie. Offre un aspetto brillante e riflettente, ideale per ambienti eleganti e raffinati.' },
      'Lappata': { icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="4" width="16" height="16" rx="2" stroke="#2D5A3D" stroke-width="2"/><path d="M4 9H20M4 14H20" stroke="#2D5A3D" stroke-width="1.5" opacity="0.5"/><ellipse cx="12" cy="12" rx="4" ry="2" fill="#2D5A3D" opacity="0.25"/><path d="M8 6L10 8M14 6L16 8" stroke="#2D5A3D" stroke-width="1.5" stroke-linecap="round" opacity="0.6"/></svg>', description: 'Finitura lappata semi-lucida ottenuta mediante lavorazione parziale della superficie. Offre un aspetto satinato elegante, meno riflettente della levigata ma più luminoso del naturale.' },
      'Comfort': { icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 3C7.58 3 4 6.58 4 11C4 15.42 7.58 19 12 19C16.42 19 20 15.42 20 11C20 6.58 16.42 3 12 3Z" stroke="#2D5A3D" stroke-width="2"/><path d="M9 11C9 11 10 13 12 13C14 13 15 11 15 11" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round"/><circle cx="9" cy="9" r="1" fill="#2D5A3D"/><circle cx="15" cy="9" r="1" fill="#2D5A3D"/></svg>', description: 'Finitura speciale che offre comfort al tatto e migliore grip. Combina estetica e funzionalità per un\'esperienza di camminata piacevole.' },
      'Parete': { icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="3" width="7" height="4" stroke="#2D5A3D" stroke-width="1.5"/><rect x="3" y="9" width="7" height="4" stroke="#2D5A3D" stroke-width="1.5"/><rect x="3" y="15" width="7" height="4" stroke="#2D5A3D" stroke-width="1.5"/><rect x="12" y="3" width="9" height="4" stroke="#2D5A3D" stroke-width="1.5"/><rect x="12" y="9" width="9" height="4" stroke="#2D5A3D" stroke-width="1.5"/><rect x="12" y="15" width="9" height="4" stroke="#2D5A3D" stroke-width="1.5"/></svg>', description: 'Formato specificamente progettato per rivestimenti murali. Ottimizzato per installazione verticale con caratteristiche tecniche adatte alle pareti.' },
      'PTV': { icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><ellipse cx="12" cy="18" rx="6" ry="3" stroke="#2D5A3D" stroke-width="2"/><path d="M12 18V6M12 6L8 10M12 6L16 10" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="12" cy="4" r="2" fill="#2D5A3D"/></svg>', description: 'Pendulum Test Value - Certificazione di resistenza allo scivolamento. Indica il livello di sicurezza della superficie in condizioni bagnate.' },
      'Fluid': { icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 12C3 12 5 8 9 8C13 8 13 12 17 12C21 12 21 8 21 8" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round"/><path d="M3 18C3 18 5 14 9 14C13 14 13 18 17 18C21 18 21 14 21 14" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round"/><path d="M3 6C3 6 5 2 9 2C13 2 13 6 17 6C21 6 21 2 21 2" stroke="#2D5A3D" stroke-width="2" opacity="0.3" stroke-linecap="round"/></svg>', description: 'Design fluido e dinamico con venature naturali che creano continuità visiva. Perfetto per ambienti contemporanei e minimalisti.' },
      'Naturale': { icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C12 2 4 8 4 14C4 18.42 7.58 22 12 22C16.42 22 20 18.42 20 14C20 8 12 2 12 2Z" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 22V12M12 12L8 16M12 12L16 16" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>', description: 'Finitura naturale che riproduce fedelmente l\'aspetto della pietra o del materiale originale. Superficie Naturale con texture autentica, ideale per chi cerca un effetto elegante e non riflettente.' },
      'Canneté': { icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 4V20" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round"/><path d="M8 4V20" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round"/><path d="M12 4V20" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round"/><path d="M16 4V20" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round"/><path d="M20 4V20" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round"/></svg>', description: 'Superficie con scanalature verticali parallele che creano un elegante effetto tridimensionale. Ideale per rivestimenti decorativi e pareti d\'accento, dona profondità e movimento agli ambienti.' },
      'Satinata Naturale': { icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="3" width="18" height="18" rx="2" stroke="#2D5A3D" stroke-width="2"/><path d="M3 12h18" stroke="#2D5A3D" stroke-width="1" opacity="0.3"/><path d="M7 7l10 10M7 17l10-10" stroke="#2D5A3D" stroke-width="1" opacity="0.2"/><circle cx="12" cy="12" r="3" fill="#2D5A3D" opacity="0.15"/></svg>', description: 'Finitura satinata con effetto naturale. Superficie morbida e vellutata al tatto, combina l\'eleganza della satinata con la praticità della finitura naturale.' },
      'Soft': { icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="3" width="18" height="18" rx="2" stroke="#2D5A3D" stroke-width="2"/><path d="M3 12h18" stroke="#2D5A3D" stroke-width="1" opacity="0.3"/><path d="M7 7l10 10M7 17l10-10" stroke="#2D5A3D" stroke-width="1" opacity="0.2"/><circle cx="12" cy="12" r="3" fill="#2D5A3D" opacity="0.15"/></svg>', description: 'Finitura soft con effetto setoso e delicato. Superficie morbida al tatto con riflessi attenuati. Elegante e raffinata, ideale per ambienti moderni.' },
      'Cuoio Naturale': { icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="4" width="16" height="16" rx="2" stroke="#8B4513" stroke-width="2"/><rect x="7" y="7" width="10" height="10" fill="#8B4513" opacity="0.3"/><path d="M7 10h10M7 14h10" stroke="#8B4513" stroke-width="1" opacity="0.5"/></svg>', description: 'Finitura Naturale con texture effetto cuoio. Superficie tattile che riproduce la morbidezza e le venature del cuoio naturale. Elegante e contemporanea.' },
      'Grip': { icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="4" width="16" height="16" rx="2" stroke="#2D5A3D" stroke-width="2"/><circle cx="8" cy="8" r="1.5" fill="#2D5A3D"/><circle cx="12" cy="8" r="1.5" fill="#2D5A3D"/><circle cx="16" cy="8" r="1.5" fill="#2D5A3D"/><circle cx="8" cy="12" r="1.5" fill="#2D5A3D"/><circle cx="12" cy="12" r="1.5" fill="#2D5A3D"/><circle cx="16" cy="12" r="1.5" fill="#2D5A3D"/><circle cx="8" cy="16" r="1.5" fill="#2D5A3D"/><circle cx="12" cy="16" r="1.5" fill="#2D5A3D"/><circle cx="16" cy="16" r="1.5" fill="#2D5A3D"/></svg>', description: 'Superficie antiscivolo certificata, ideale per esterni e zone soggette a umidità. Texture speciale che garantisce sicurezza e aderenza anche in condizioni bagnate.' },
      'Antislip': { icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="4" width="16" height="16" rx="2" stroke="#2D5A3D" stroke-width="2"/><path d="M7 17L17 7" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round"/><path d="M7 12L12 7" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round"/><path d="M12 17L17 12" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round"/></svg>', description: 'Superficie antiscivolo certificata per ambienti umidi e bagnati. Ideale per bagni, cucine, aree piscina e zone esterne. Garantisce sicurezza e aderenza anche in presenza di acqua.' },
      'RealUp+StrideUp': { icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="4" width="16" height="16" rx="2" stroke="#2D5A3D" stroke-width="2"/><path d="M4 12h16" stroke="#2D5A3D" stroke-width="1.5" opacity="0.4"/><path d="M8 8l4 4-4 4" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M14 8l4 4-4 4" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" opacity="0.5"/><path d="M4 8h16" stroke="#2D5A3D" stroke-width="1" opacity="0.3"/><path d="M4 16h16" stroke="#2D5A3D" stroke-width="1" opacity="0.3"/></svg>', description: 'Tecnologia avanzata che combina la tridimensionalità RealUp con rilievi strutturati StrideUp. Superficie materica con texture accentuate, perfetta per ambienti che richiedono grip e carattere estetico.' },
      'RealUp': { icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="4" width="16" height="16" rx="2" stroke="#2D5A3D" stroke-width="2"/><path d="M4 12h16" stroke="#2D5A3D" stroke-width="1.5" opacity="0.4"/><path d="M8 8l4 4-4 4" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M14 8l4 4-4 4" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" opacity="0.5"/></svg>', description: 'Tecnologia esclusiva che riproduce la tridimensionalità della pietra naturale. Superficie materica ad alta definizione con texture realistiche, perfetta per interni ed esterni.' },
      'StrideUp': { icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="4" width="16" height="16" rx="2" stroke="#2D5A3D" stroke-width="2"/><path d="M6 8h12" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round"/><path d="M6 12h12" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round"/><path d="M6 16h12" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round"/><path d="M9 6v12" stroke="#2D5A3D" stroke-width="1" opacity="0.4"/><path d="M15 6v12" stroke="#2D5A3D" stroke-width="1" opacity="0.4"/></svg>', description: 'Tecnologia esclusiva con rilievi strutturati che garantiscono eccellente resistenza allo scivolamento. Superficie con texture accentuate che offre grip superiore, ideale per ambienti che richiedono sicurezza e carattere estetico.' },
      'Fade': { icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="4" width="16" height="16" rx="2" stroke="#2D5A3D" stroke-width="2"/><defs><linearGradient id="fadeGrad" x1="0%" y1="0%" x2="100%" y2="0%"><stop offset="0%" style="stop-color:#2D5A3D;stop-opacity:0.1"/><stop offset="100%" style="stop-color:#2D5A3D;stop-opacity:0.8"/></linearGradient></defs><rect x="7" y="7" width="10" height="10" fill="url(#fadeGrad)"/></svg>', description: 'Superficie con effetto sfumato che crea transizioni di colore delicate e naturali. Design contemporaneo che aggiunge profondità e movimento agli ambienti.' },
      'Lappata-Satinata': { icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="4" width="16" height="16" rx="2" stroke="#2D5A3D" stroke-width="2"/><rect x="7" y="7" width="10" height="5" fill="#2D5A3D" opacity="0.5"/><rect x="7" y="12" width="10" height="5" fill="#2D5A3D" opacity="0.25"/></svg>', description: 'Finitura che combina la luminosità della lappatura con la morbidezza del satinato. Superficie elegante con riflessi delicati, perfetta per ambienti raffinati.' },
      'T_20': { icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="6" width="18" height="12" rx="2" stroke="#2D5A3D" stroke-width="2"/><path d="M3 10h18M3 14h18" stroke="#2D5A3D" stroke-width="1.5" opacity="0.4"/><text x="12" y="13" font-size="6" fill="#2D5A3D" text-anchor="middle" font-weight="bold">20</text></svg>', description: 'Spessore maggiorato 20mm per esterni e applicazioni speciali. Ideale per posa su ghiaia, piedini, erba o sabbia. Resistente a carichi pesanti, cicli gelo/disgelo e agenti atmosferici.' },
      'Formato Standard': { icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="3" width="18" height="18" stroke="#2D5A3D" stroke-width="2" rx="2"/><path d="M3 9H21M9 3V21" stroke="#2D5A3D" stroke-width="2" opacity="0.5"/></svg>', description: 'Formato con bordi tradizionali. La posa avviene con fughe standard (3-5mm) che garantiscono la corretta dilatazione del materiale.' },
      '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="4" width="16" height="16" rx="2" stroke="#2D5A3D" stroke-width="2"/><rect x="7" y="7" width="10" height="10" fill="#2D5A3D" opacity="0.2"/></svg>': { icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="4" width="16" height="16" rx="2" stroke="#2D5A3D" stroke-width="2"/><rect x="7" y="7" width="10" height="10" fill="#2D5A3D" opacity="0.2"/></svg>', description: 'Finitura naturale opaca che riproduce fedelmente l\'aspetto del materiale originale. Superficie versatile, facile da pulire e adatta a tutti gli ambienti.' },
      'Twist': { icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 8C8 4 12 12 16 8" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round"/><path d="M4 16C8 12 12 20 16 16" stroke="#2D5A3D" stroke-width="2" opacity="0.4" stroke-linecap="round"/></svg>', description: 'Superficie con texture tridimensionale dal motivo intrecciato, che crea un raffinato gioco di luci e ombre. Ideale per rivestimenti a parete di forte carattere decorativo.' },
      'Struttura Move': { icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 7C7 3 11 11 15 7C17 5 19 5 21 7" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round"/><path d="M3 13C7 9 11 17 15 13C17 11 19 11 21 13" stroke="#2D5A3D" stroke-width="2" opacity="0.5" stroke-linecap="round"/><path d="M3 19C7 15 11 23 15 19C17 17 19 17 21 19" stroke="#2D5A3D" stroke-width="2" opacity="0.3" stroke-linecap="round"/></svg>', description: 'Superficie strutturata con rilievo dal movimento morbido e dinamico. Pensata per rivestimenti a parete dal forte impatto materico e decorativo.' },
      'Struttura Sign': { icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 20L20 4" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round"/><path d="M4 13L13 4" stroke="#2D5A3D" stroke-width="2" opacity="0.5" stroke-linecap="round"/><path d="M11 20L20 11" stroke="#2D5A3D" stroke-width="2" opacity="0.5" stroke-linecap="round"/></svg>', description: 'Superficie strutturata con rilievo dal segno grafico marcato e geometrico. Pensata per rivestimenti a parete dal forte impatto decorativo.' },
      'Plissé': { icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 4V20M8 4V20M12 4V20M16 4V20M20 4V20" stroke="#2D5A3D" stroke-width="1.6" stroke-linecap="round"/></svg>', description: 'Superficie con struttura plissé dalle pieghe morbide e regolari, un elegante gioco di luci e ombre per rivestimenti raffinati.' },
      'Riga': { icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 4V20M12 4V20M18 4V20" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round"/></svg>', description: 'Superficie con struttura a righe verticali dall\'effetto materico e tridimensionale, per pavimenti e rivestimenti di design.' },
      'Stripe': { icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 6H20M4 12H20M4 18H20" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round"/></svg>', description: 'Superficie con struttura a righe tridimensionali che crea texture materiche e giochi di luce, per rivestimenti a parete di forte carattere.' },
      'Struttura Net': { icon: '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="4" width="16" height="16" stroke="#2D5A3D" stroke-width="2"/><path d="M4 4L20 20M20 4L4 20" stroke="#2D5A3D" stroke-width="1.5" opacity="0.5" stroke-linecap="round"/></svg>', description: 'Superficie strutturata con rilievo a trama reticolare. Pensata per rivestimenti a parete dal forte impatto materico e decorativo.' },
    };

    const _kvC = (typeof _finA !== 'undefined' && _finA[title]) ? _finA[title] : null;

    const _kvIcon = (_kvC && _kvC.icon) ? _kvC.icon : '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="10" stroke="#2D5A3D" stroke-width="2"/><path d="M12 16v-4M12 8h.01" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round"/></svg>';

    const _kvTitle = (_kvC && _kvC.title) ? _kvC.title : title;

    const _kvDesc = (_kvC && _kvC.description) ? _kvC.description : description;

    tooltip.innerHTML = `

      <div style="display: flex; align-items: flex-start; gap: 0.6rem;">

        <div style="flex-shrink: 0; display: flex; align-items: center; justify-content: center; width: 34px; height: 34px;">${_kvIcon}</div>

        <div>

          <div style="font-weight: 700; color: #2d3436; font-size: 0.9rem; margin-bottom: 0.25rem;">${_kvTitle}</div>

          <div style="color: #636e72; font-size: 0.8rem; line-height: 1.4;">${_kvDesc}</div>

        </div>

      </div>

    `;



    // Stile del tooltip

    tooltip.style.cssText = `

      position: fixed;

      background: white;

      border-radius: 12px;

      padding: 0.75rem 1rem;

      box-shadow: 0 4px 20px rgba(0,0,0,0.15), 0 0 0 1px rgba(0,0,0,0.05);

      z-index: 100001;

      max-width: 340px;

      animation: tooltipFadeIn 0.15s ease;

      pointer-events: none;

    `;



    // Aggiungi animazione CSS se non esiste

    if (!document.getElementById('fxTooltipStyles')) {

      const style = document.createElement('style');

      style.id = 'fxTooltipStyles';

      style.textContent = `

        @keyframes tooltipFadeIn {

          from { opacity: 0; transform: translateY(5px); }

          to { opacity: 1; transform: translateY(0); }

        }

      `;

      document.head.appendChild(style);

    }



    document.body.appendChild(tooltip);



    // Posiziona il tooltip vicino al pulsante info

    // Cerca il pulsante info attivo

    const infoButtons = document.querySelectorAll('.fx-format-info-btn');

    let targetButton = null;



    // Trova il pulsante su cui è il mouse

    infoButtons.forEach(btn => {

      if (btn.matches(':hover')) {

        targetButton = btn;

      }

    });



    if (targetButton) {

      const btnRect = targetButton.getBoundingClientRect();

      const tooltipRect = tooltip.getBoundingClientRect();



      // Posiziona a sinistra del pulsante

      let left = btnRect.left - tooltipRect.width - 10;

      let top = btnRect.top + (btnRect.height / 2) - (tooltipRect.height / 2);



      // Se non c'è spazio a sinistra, metti sotto

      if (left < 10) {

        left = btnRect.left + (btnRect.width / 2) - (tooltipRect.width / 2);

        top = btnRect.bottom + 10;

      }



      // Assicurati che non esca dallo schermo

      if (left + tooltipRect.width > window.innerWidth - 10) {

        left = window.innerWidth - tooltipRect.width - 10;

      }

      if (left < 10) left = 10;

      if (top < 10) top = 10;

      if (top + tooltipRect.height > window.innerHeight - 10) {

        top = btnRect.top - tooltipRect.height - 10;

      }



      tooltip.style.left = `${left}px`;

      tooltip.style.top = `${top}px`;

    } else {

      // Fallback: posiziona al centro-alto

      tooltip.style.top = '100px';

      tooltip.style.left = '50%';

      tooltip.style.transform = 'translateX(-50%)';

    }



    // Chiudi il tooltip quando il mouse esce dal pulsante

    const closeTooltip = () => {

      const tt = document.getElementById('fxFormatInfoTooltip');

      if (tt) {

        tt.style.opacity = '0';

        tt.style.transform = 'translateY(5px)';

        setTimeout(() => {

          if (tt && tt.parentNode) {

            tt.parentNode.removeChild(tt);

          }

        }, 150);

      }

    };



    infoButtons.forEach(btn => {

      btn.addEventListener('mouseleave', closeTooltip, { once: true });

    });

  },



  // Chiudi tooltip desktop (chiamata esterna)

  closeFormatInfoTooltip() {

    const tooltip = document.getElementById('fxFormatInfoTooltip');

    if (tooltip) {

      tooltip.style.opacity = '0';

      tooltip.style.transform = 'translateY(5px)';

      setTimeout(() => {

        if (tooltip && tooltip.parentNode) {

          tooltip.parentNode.removeChild(tooltip);

        }

      }, 150);

    }

  },



  // Inietta stili CSS per uniformare lo sfondo glass del modal zoom

  injectZoomModalStyles() {

    // Verifica se gli stili sono già stati iniettati

    if (document.getElementById('fx-zoom-modal-styles')) return;

    

    const style = document.createElement('style');

    style.id = 'fx-zoom-modal-styles';

    style.textContent = `

      /* IMPORTANTE: Rimuovi bordo verde di default su tutte le carte */

      .fx-style-card {

        border: 1px solid #e8e8e3 !important;

        border-radius: 12px !important;

        box-shadow: 0 1px 3px rgba(0,0,0,0.05) !important;

        transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.15s ease !important;

        overflow: visible !important; /* Assicura che il contenuto non sia tagliato */

        position: relative !important;

        z-index: 1 !important;

      }

      

      /* Z-index più alto per le card al hover o selezionate */

      .fx-style-card:hover {

        z-index: 10 !important;

        transform: translateY(-3px) !important;

        box-shadow: 0 4px 14px rgba(0,0,0,0.08) !important;

        border-color: #d0cfc9 !important;

      }



      .fx-style-card.selected {

        z-index: 5 !important;

        transform: translateY(-1px) !important;

        box-shadow: 0 2px 8px rgba(0,0,0,0.07) !important;

      }

      /* Check badge gestito via JS DOM (più affidabile di ::after con flex) */

      

      /* RIMUOVI COMPLETAMENTE IL CLIPPING per Step 2 */

      #fxStep2 {

        overflow: visible !important;

        clip-path: none !important;

        contain: none !important;

      }

      

      #fxStep2 .fx-style-card {

        border-radius: var(--fx-radius) !important;

        overflow: visible !important;

        clip-path: none !important;

        -webkit-clip-path: none !important;

        contain: none !important;

        isolation: auto !important;

        padding: 0 !important;

      }

      

      /* Assicura che il contenuto interno possa uscire dai bordi */

      #fxStep2 .fx-style-card > *:not(.fx-format-info-btn):not(.fx-check-badge-dom) {

        overflow: visible !important;

        position: relative !important;

        z-index: 1 !important;

      }

      

      /* Aggiungi margine negativo per compensare il padding e permettere overflow */

      #fxStep2 .fx-style-card > div:first-child {

        margin: 0 !important;

      }

      

      /* Classe speciale per card formato che bypassa TUTTI gli stili limitanti */

      .fx-format-card {

        overflow: visible !important;

        clip-path: none !important;

        -webkit-clip-path: none !important;

        contain: none !important;

        transform-style: preserve-3d !important;

        isolation: auto !important;

      }

      

      .fx-format-card::before,

      .fx-format-card::after {

        display: none !important; /* Rimuovi pseudo-elementi che potrebbero interferire */

      }

      

      /* Assicura che NIENTE nel formato card possa essere tagliato */

      .fx-format-card * {

        overflow: visible !important;

        clip-path: none !important;

        contain: none !important;

      }



      /* Step 3 (colori) deve avere overflow visible come Step 2 */

      #fxStep3 .fx-style-card {

        overflow: visible !important;

        clip-path: none !important;

        -webkit-clip-path: none !important;

        contain: none !important;

        padding: 0 !important;

        border-radius: var(--fx-radius) !important;

      }



      #fxStep3 .fx-style-card > *:not(.fx-format-info-btn):not(.fx-check-badge-dom) {

        overflow: visible !important;

        position: relative !important;

        z-index: 1 !important;

      }



      #fxStep3 .fx-style-card > div:first-child {

        margin: 0 !important;

      }



      /* Step 4 (spessore) deve avere lo stesso padding dello Step 3 */

      #fxStep4 .fx-style-card {

        overflow: visible !important;

        clip-path: none !important;

        -webkit-clip-path: none !important;

        contain: none !important;

        padding: 0 !important;

        border-radius: var(--fx-radius) !important;

      }



      #fxStep4 .fx-style-card > *:not(.fx-format-info-btn):not(.fx-color-zoom-btn):not(.fx-check-badge-dom) {

        overflow: visible !important;

        position: relative !important;

        z-index: 1 !important;

      }



      #fxStep4 .fx-style-card > div:first-child {

        margin: 0 !important;

      }



      /* Prezzo barrato per gli step del configuratore */

      .fx-step-price-was {

        color: var(--fx-text-dim, #b2bec3);

        text-decoration: line-through;

        font-size: 1rem;

        font-weight: 500;

        font-family: var(--fx-font, 'Jost', -apple-system, BlinkMacSystemFont, sans-serif);

        line-height: 1;

      }



      /* Stile globale per pulsanti - border radius uniforme */

      .fx-btn {

        border-radius: 6px !important;

      }



      /* Badge di sconto - mantieni border radius arrotondato */

      .fx-discount-badge {

        clip-path: polygon(8px 0, 100% 0, 100% 100%, 8px 100%, 0 50%) !important;

        border-radius: 0 3px 3px 0 !important;

        font-size: 0.62rem !important;

        padding: 0.2rem 0.4rem 0.2rem 0.8rem !important;

        display: inline-flex !important;

        align-items: center !important;

        white-space: nowrap !important;

      }



      /* Badge sconto overlay nelle card del configuratore */

      .fx-overlay-badge {

        background: #E12D2D !important;

        color: #fff !important;

        font-family: 'Jost', sans-serif !important;

        font-size: 0.62rem !important;

        font-weight: 700 !important;

        padding: 0.2rem 0.4rem 0.2rem 0.8rem !important;

        clip-path: polygon(8px 0, 100% 0, 100% 100%, 8px 100%, 0 50%) !important;

        -webkit-clip-path: polygon(8px 0, 100% 0, 100% 100%, 8px 100%, 0 50%) !important;

        border-radius: 0 3px 3px 0 !important;

        white-space: nowrap !important;

        line-height: 1 !important;

        display: inline-flex !important;

        align-items: center !important;

        letter-spacing: 0.02em !important;

        align-self: center !important;

        flex-shrink: 0 !important;

      }



      /* Step 6 - Selettore quantità - Stili minimali aggiuntivi */

      #fxStep6 .fx-variants-grid {

        max-height: none !important;

        overflow: visible !important;

      }





      #fxStep6 .fx-quantity-btn:hover {

        transform: translateY(-2px);

        box-shadow: 0 5px 15px rgba(45, 90, 61, 0.2);

      }



      #fxStep6 .fx-quantity-btn:disabled {

        opacity: 0.4;

        cursor: not-allowed;

        transform: none !important;

      }



      /* Stile compatto per i pulsanti quantità su mobile */

      @media (max-width: 768px) {



        /* Layout a 3 righe per i pulsanti su mobile */

        #fxStep6 .fx-quantity-controls {

          display: grid !important;

          grid-template-columns: 1fr 1fr !important;

          gap: 0.4rem !important;

          margin: 1rem 0 !important;

          padding: 0 !important;

        }



        /* Prima riga: -1 e +1 */

        #fxBtnMinus1 {

          grid-column: 1 / 2 !important;

          grid-row: 1 !important;

        }



        #fxBtnPlus1 {

          grid-column: 2 / 3 !important;

          grid-row: 1 !important;

        }



        /* Seconda riga: -10 e +10 */

        #fxBtnMinus10 {

          grid-column: 1 / 2 !important;

          grid-row: 2 !important;

        }



        #fxBtnPlus10 {

          grid-column: 2 / 3 !important;

          grid-row: 2 !important;

        }



        /* Terza riga: - BANCALE e + BANCALE */

        #fxBtnPalletMinus {

          grid-column: 1 / 2 !important;

          grid-row: 3 !important;

        }



        #fxBtnPalletPlus {

          grid-column: 2 / 3 !important;

          grid-row: 3 !important;

        }



        /* Riduci padding e margin dello step 5 su mobile */

        #fxStep6 .fx-style-card {

          padding: 0.75rem !important;

          margin-bottom: 0.5rem !important;

        }



        /* Riduci dimensione numeri mq */

        #fxStep6 #fxMqNumber {

          font-size: 2.5rem !important;

        }



        /* Riduci spacing interno */

        #fxStep6 .fx-style-card > div {

          padding: 0.5rem !important;

        }



        /* Riduci margin del display principale */

        #fxStep6 .fx-quantity-display {

          margin: 1rem 0 !important;

        }



        /* Riduci margin tra MQ e pulsanti */

        #fxStep6 .fx-quantity-display > div:first-child {

          margin-bottom: 1rem !important;

        }



        /* Riduci spacing info inferiori */

        #fxStep6 .fx-quantity-info {

          gap: 1rem !important;

        }



        /* Nascondi separatore prima del prezzo su mobile */

        #fxStep6 .fx-price-separator {

          display: none !important;

        }

      }



      /* Su desktop mantieni layout orizzontale originale */

      @media (min-width: 769px) {

        #fxStep6 .fx-quantity-controls {

          display: flex !important;

          flex-direction: row !important;

          justify-content: center !important;

          gap: 0.5rem !important;

        }



        #fxStep6 .fx-btn {

          width: auto !important;

          border-radius: 6px !important;

        }

      }



      .fx-style-card:not(.selected) {

        border-color: #e8e8e3 !important;

        background: var(--fx-bg) !important;

      }



      .fx-style-card.selected {

        border-color: #2D5A3D !important;

        border-width: 1.5px !important;

        background: var(--fx-bg);

      }

      /* Step 6: niente bordo verde sulla card prodotto */
      #fxStep6 .fx-style-card.selected {
        border-color: #e8e8e3 !important;
        border-width: 1px !important;
      }



      /* Stili unificati per lo sfondo glass del modal zoom - Desktop e Mobile */

      .fx-image-zoom-modal {

        display: none;

        position: fixed;

        top: 0;

        left: 0;

        width: 100%;

        height: 100%;

        /* Sfondo glass uniforme per desktop e mobile */

        background: linear-gradient(

          135deg,

          rgba(255, 255, 255, 0.1) 0%,

          rgba(255, 255, 255, 0.05) 100%

        );

        backdrop-filter: blur(20px) saturate(180%);

        -webkit-backdrop-filter: blur(20px) saturate(180%);

        z-index: 100000;

        align-items: center;

        justify-content: center;

      }

      

      .fx-image-zoom-modal::before {

        content: '';

        position: absolute;

        top: 0;

        left: 0;

        right: 0;

        bottom: 0;

        background: radial-gradient(

          circle at center,

          rgba(255, 255, 255, 0.1) 0%,

          rgba(0, 0, 0, 0.1) 100%

        );

        pointer-events: none;

      }

      

      .fx-image-zoom-modal.active {

        display: flex;

      }

      

      /* Contenitore colori senza limiti di altezza */

      #fxVariantsContainer {

        max-height: none !important;

        overflow-y: visible !important;

        overflow-x: hidden !important;

        padding-top: 6px !important;

        padding-right: 0.5rem !important;

      }



      /* Layout desktop - uniforma tutti i contenitori */

      @media (min-width: 769px) {

        .fx-style-grid,

        #fxDestinationContainer,

        #fxVariantsContainer,

        #fxFinishContainer {

          display: grid !important;

          grid-template-columns: repeat(auto-fit, minmax(280px, 350px)) !important;

          gap: 1.5rem !important;

          justify-content: center !important;

        }



        #fxVariantsContainer {

          overflow-y: visible !important;

          overflow-x: hidden !important;

          padding-top: 6px !important;

        }

        

        /* Assicura che Step 1 abbia lo stesso layout dello Step 3 */

        #fxStep1 .fx-style-grid {

          display: grid !important;

          grid-template-columns: repeat(auto-fit, minmax(280px, 350px)) !important;

          gap: 1.5rem !important;

          justify-content: center !important;

          overflow: visible !important;

        }

        

        /* Specifico per Step 2 - assicura nessun taglio e rimuove il contenitore quadrato */

        #fxStep2 .fx-style-grid {

          overflow: visible !important;

        }

        

        #fxStep2 .fx-style-grid .fx-style-card {

          overflow: visible !important;

        }

        

        /* Override del contenitore visual per Step 2 - elimina il quadrato */

        #fxStep2 .fx-style-visual {

          width: auto !important;

          height: auto !important;

          margin: 0 !important;

          border-radius: 0 !important;

          background: transparent !important;

          box-shadow: none !important;

        }

        

        #fxStep2 .fx-style-color {

          width: auto !important;

          height: auto !important;

          border-radius: 0 !important;

          background: transparent !important;

        }

        

        #fxStep2 .fx-style-shine {

          display: none !important;

        }

      }

      

      /* 2 colonne su mobile — overflow rimosso per permettere scroll della griglia */

      @media (max-width: 768px) {

        .fx-style-grid,

        #fxDestinationContainer,

        #fxVariantsContainer,

        #fxFinishContainer {

          display: grid !important;

          grid-template-columns: repeat(2, 1fr) !important;

          gap: 0.75rem !important;

          justify-items: stretch !important;

        }

      }

      

      /* Badge bancale responsive */

      @media (max-width: 768px) {

        .fx-bancale-badge-desktop {

          position: static !important;

          transform: none !important;

          margin-top: 1rem !important;

          margin-left: auto !important;

          margin-right: auto !important;

          animation: pulse-elegant-mobile 2.5s ease-in-out infinite !important;

        }



        @keyframes pulse-elegant-mobile {

          0%, 100% {

            transform: scale(1);

          }

          50% {

            transform: scale(1.02);

          }

        }



        .fx-price-wrapper {

          display: flex !important;

          flex-direction: column !important;

          align-items: center !important;

        }

      }



      /* Override per mobile - mantieni lo stesso sfondo glass del desktop */

      @media (max-width: 768px) {

        .fx-image-zoom-modal {

          /* Stesso sfondo glass del desktop con blur */

          background: linear-gradient(

            135deg,

            rgba(255, 255, 255, 0.1) 0%,

            rgba(255, 255, 255, 0.05) 100%

          ) !important;

          backdrop-filter: blur(20px) saturate(180%) !important;

          -webkit-backdrop-filter: blur(20px) saturate(180%) !important;

        }

        

        .fx-image-zoom-modal.active {

          display: flex !important;

          opacity: 1 !important;

          visibility: visible !important;

        }

        

        /* Uniforma tutte le carte su mobile con le stesse dimensioni */

        .fx-style-card {

          padding: 0.75rem !important;

          gap: 0.5rem !important;

        }



        /* Quando c'è una singola carta negli step 1, 2, 3, 4, occupa tutta la larghezza come lo step 5 */

        #fxDestinationContainer:has(.fx-style-card:only-child),

        #fxVariantsContainer:has(.fx-style-card:only-child),

        #fxFinishContainer:has(.fx-style-card:only-child),

        .fx-style-grid:has(.fx-style-card:only-child) {

          grid-template-columns: 1fr !important;

          justify-items: stretch !important;

        }



        #fxDestinationContainer .fx-style-card:only-child,

        #fxVariantsContainer .fx-style-card:only-child,

        #fxFinishContainer .fx-style-card:only-child,

        .fx-style-grid .fx-style-card:only-child {

          grid-column: 1 !important;

          max-width: 100% !important;

          width: 100% !important;

        }

        

        .fx-style-card .fx-style-image {

          height: 150px !important; /* Dimensione ottimale su mobile */

          margin-bottom: 0.5rem !important;

          overflow: hidden !important; /* Evita che le piastrelle escano fuori */

        }

        

        .fx-style-card .fx-style-info {

          padding: 0.5rem 0 !important;

        }

        

        .fx-style-card .fx-style-info h4 {

          font-size: 1rem !important;

          margin: 0 0 0.25rem 0 !important;

          line-height: 1.3 !important;

        }

        

        .fx-style-card .fx-style-info p {

          font-size: 0.85rem !important;

          margin: 0 !important;

          color: #666 !important;

        }

        

        /* Mantieni pulsante zoom della dimensione precedente */

        .fx-style-card .fx-color-zoom-btn {

          width: 32px !important;

          height: 32px !important;

          top: 8px !important;

          right: 8px !important;

        }

        

        .fx-style-card .fx-color-zoom-btn svg {

          width: 16px !important;

          height: 16px !important;

        }



        /* DISABILITA HOVER SU MOBILE - inutile su touch screens */

        .fx-style-card:hover {

          z-index: 1 !important;

        }



        #fxStep6 .fx-quantity-btn:hover {

          transform: none !important;

          box-shadow: none !important;

        }



        .fx-style-card:hover .fx-price-container {

          transform: none !important;

        }

      }



      /* Animazione pulse per badge sconto */

      @keyframes pulse {

        0% {

          transform: scale(1);

          box-shadow: 0 3px 8px rgba(225, 45, 45, 0.3);

        }

        50% {

          transform: scale(1.05);

          box-shadow: 0 5px 15px rgba(225, 45, 45, 0.5);

        }

        100% {

          transform: scale(1);

          box-shadow: 0 3px 8px rgba(225, 45, 45, 0.3);

        }

      }



      /* Animazione pulse per i numeri che cambiano */

      @keyframes numberPulse {

        0% {

          transform: scale(1);

        }

        50% {

          transform: scale(1.1);

        }

        100% {

          transform: scale(1);

        }

      }



      /* Animazione pulse elegante per badge bancale */

      @keyframes pulse-elegant {

        0%, 100% {

          transform: translateY(-50%) scale(1);

        }

        50% {

          transform: translateY(-50%) scale(1.02);

        }

      }



      .fx-pulse {

        animation: numberPulse 0.3s ease;

        display: inline-block;

      }



      /* Hover effect per i contenitori prezzi nelle card */

      .fx-style-card:hover .fx-price-container {

        transform: none !important;

      }



      /* Check badge gestito via JS - vedi MutationObserver in injectZoomModalStyles */



      /* ===== CARD UNIFORMI - stessa struttura e dimensione in tutti gli step ===== */

      .fx-style-card {

        display: flex !important;

        flex-direction: column !important;

      }

      .fx-style-info {

        flex: 1 !important;

        display: flex !important;

        flex-direction: column !important;

        justify-content: center !important;

      }

      /* Area visiva (immagine o piastrella 3D) stessa altezza in tutti gli step */

      @media (min-width: 769px) {

        .fx-variant-image,

        #fxStep2 .fx-style-card > div:first-child,

        #fxStep3 .fx-style-card > div:first-child,

        #fxStep4 .fx-style-card > div:first-child {

          height: 190px !important;

          min-height: 190px !important;

          flex-shrink: 0 !important;

        }

        .fx-style-card {

          min-height: 290px !important;

        }

      }

      @media (max-width: 768px) {

        /* Immagine scalata per mobile (stesso schema desktop: 190px → 120px) */

        .fx-variant-image,

        #fxStep2 .fx-style-card > div:first-child,

        #fxStep3 .fx-style-card > div:first-child,

        #fxStep4 .fx-style-card > div:first-child {

          height: 120px !important;

          min-height: 120px !important;

          flex-shrink: 0 !important;

        }

        /* Carta mobile: stessa logica desktop (min-height + flex:1 su info) */

        #fxStep1 .fx-style-card,

        #fxStep2 .fx-style-card,

        #fxStep3 .fx-style-card,

        #fxStep4 .fx-style-card,

        #fxStep5 .fx-style-card {

          min-height: 310px !important;

          overflow: visible !important;

          height: auto !important;

        }

        /* KH-FIX info: flex-basis auto = card cresce col contenuto (no testo tagliato/sovrapposto) */

        #fxStep1 .fx-style-card .fx-style-info,

        #fxStep2 .fx-style-card .fx-style-info,

        #fxStep3 .fx-style-card .fx-style-info,

        #fxStep4 .fx-style-card .fx-style-info,

        #fxStep5 .fx-style-card .fx-style-info {

          flex: 1 1 auto !important;

          min-height: auto !important;

        }

        /* KH-FIX price-container: era min-height:0+flex:1 (si comprimeva e sforava). Ora cresce col contenuto */

        #fxStep1 .fx-style-card .fx-price-container,

        #fxStep2 .fx-style-card .fx-price-container,

        #fxStep3 .fx-style-card .fx-price-container,

        #fxStep4 .fx-style-card .fx-price-container,

        #fxStep5 .fx-style-card .fx-price-container {

          flex: 1 1 auto !important;

          min-height: auto !important;

          height: auto !important;

          justify-content: space-evenly !important;

          gap: 0.3rem !important;

        }

      }

      /* KH-DESKTOP: stesso layout del mobile (card cresce + distribuzione uniforme) */
      @media (min-width: 769px) {
        #fxStep1 .fx-style-card,
        #fxStep2 .fx-style-card,
        #fxStep3 .fx-style-card,
        #fxStep4 .fx-style-card,
        #fxStep5 .fx-style-card {
          min-height: 410px !important;
          overflow: visible !important;
          height: auto !important;
        }
        #fxStep1 .fx-style-card .fx-style-info,
        #fxStep2 .fx-style-card .fx-style-info,
        #fxStep3 .fx-style-card .fx-style-info,
        #fxStep4 .fx-style-card .fx-style-info,
        #fxStep5 .fx-style-card .fx-style-info {
          flex: 1 1 auto !important;
          min-height: auto !important;
        }
        #fxStep1 .fx-style-card .fx-price-container,
        #fxStep2 .fx-style-card .fx-price-container,
        #fxStep3 .fx-style-card .fx-price-container,
        #fxStep4 .fx-style-card .fx-price-container,
        #fxStep5 .fx-style-card .fx-price-container {
          flex: 1 1 auto !important;
          min-height: auto !important;
          height: auto !important;
          justify-content: space-evenly !important;
          gap: 0.4rem !important;
        }
      }

    `;

    document.head.appendChild(style);
    // ===== DEBUG: log stili computati carte su mobile =====

    // ===== CHECK BADGE via DOM (più affidabile di ::after su flex container) =====
    const BADGE_STYLE = 'position:absolute;top:8px;right:8px;width:32px;height:32px;background:white;color:#2D5A3D;border:1px solid #ddd;border-radius:50%;font-size:15px;font-weight:700;align-items:center;justify-content:center;z-index:30;box-shadow:0 2px 8px rgba(0,0,0,0.1);pointer-events:none;line-height:1;';

    function syncBadge(card) {
      if (card.closest('#fxStep6')) return;
      let badge = card.querySelector('.fx-check-badge-dom');
      if (!badge) {
        badge = document.createElement('div');
        badge.className = 'fx-check-badge-dom';
        badge.textContent = '✓';
        badge.style.cssText = BADGE_STYLE + 'display:none;';
        card.appendChild(badge);
      }
      badge.style.display = card.classList.contains('selected') ? 'flex' : 'none';
    }

    const badgeObserver = new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        if (m.attributeName === 'class' && m.target.classList && m.target.classList.contains('fx-style-card')) {
          syncBadge(m.target);
        }
      });
    });

    function startBadgeObserver() {
      badgeObserver.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['class'] });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startBadgeObserver);
    } else {
      startBadgeObserver();
    }

  },



  // Mostra zoom con colore solido se non c'è immagine

  showColorZoomWithSwatch(colorName, colorCode) {

    let zoomModal = document.getElementById('fxColorZoomModal');

    if (!zoomModal) {

      zoomModal = document.createElement('div');

      zoomModal.id = 'fxColorZoomModal';

      zoomModal.className = 'fx-image-zoom-modal active';

      document.body.appendChild(zoomModal);

    } else {

      zoomModal.className = 'fx-image-zoom-modal active';

    }

    

    // Determina se siamo su mobile

    const isMobile = window.innerWidth <= 768;

    const swatchSize = isMobile ? '70vw' : '450px';

    const swatchStyle = isMobile

      ? `width: ${swatchSize} !important; height: ${swatchSize} !important; max-width: 350px !important; max-height: 350px !important;

         background: ${colorCode} !important; 

         border-radius: 0 !important;

         box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3) !important;`

      : `width: ${swatchSize} !important; height: ${swatchSize} !important; 

         background: ${colorCode} !important; 

         border-radius: 0 !important;

         box-shadow: 0 25px 70px rgba(0, 0, 0, 0.2), 0 10px 25px rgba(0, 0, 0, 0.1) !important;`;

    

    // Crea HTML con onclick inline per massima compatibilità - stesso stile del carosello

    const closeButtonHTML = `

      <div class="fx-zoom-close" id="fxColorZoomClose"

           onclick="window.ConfiguratoreDataUniversal.closeColorZoom(); return false;"

           ontouchend="window.ConfiguratoreDataUniversal.closeColorZoom(); return false;"

           style="position: absolute;

                  top: 30px;

                  right: 30px;

                  font-size: 36px;

                  color: #999;

                  cursor: pointer;

                  z-index: 100001;

                  width: 50px;

                  height: 50px;

                  display: flex;

                  align-items: center;

                  justify-content: center;

                  background: rgba(255, 255, 255, 0.8);

                  border: 1px solid rgba(255, 255, 255, 0.5);

                  border-radius: 50%;

                  transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);

                  font-weight: 300;

                  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1), inset 0 0 0 1px rgba(255, 255, 255, 0.2);

                  overflow: hidden;

                  -webkit-tap-highlight-color: transparent;

                  touch-action: manipulation;

                  user-select: none;"

           onmouseover="this.style.border='1px solid #E12D2D'; this.style.background='rgba(255, 255, 255, 0.7)'; this.style.color='#E12D2D'; this.style.transform='rotate(90deg) scale(1.1)';"

           onmouseout="this.style.border='1px solid rgba(255, 255, 255, 0.5)'; this.style.background='rgba(255, 255, 255, 0.5)'; this.style.color='#999'; this.style.transform='rotate(0) scale(1)';">&times;</div>

    `;

    

    zoomModal.innerHTML = closeButtonHTML + `

      <div class="fx-zoom-content" style="position: relative; display: flex; align-items: center; justify-content: center;">

        <div style="${swatchStyle}"></div>

      </div>

    `;

    

    zoomModal.style.display = 'flex';

    

    // Event listeners multipli per garantire funzionamento

    setTimeout(() => {

      const closeBtn = document.getElementById('fxColorZoomClose');

      if (closeBtn) {

        closeBtn.addEventListener('click', (e) => {

          e.stopPropagation();

          this.closeColorZoom();

        });

        closeBtn.addEventListener('touchstart', (e) => {

          e.stopPropagation();

          e.preventDefault();

          this.closeColorZoom();

        });

      }

      

      // Chiudi cliccando fuori

      zoomModal.addEventListener('click', (e) => {

        if (e.target === zoomModal || e.target.classList.contains('fx-zoom-content')) {

          this.closeColorZoom();

        }

      });

    }, 10);

  },

  

  // Helper functions

  getFormatDescription(format) {

    const descriptions = {

      '60x60': 'Formato standard versatile',

      '80x80': 'Ideale per spazi ampi',

      '120x120': 'Formato maxi, effetto continuità',

      '30x60': 'Perfetto per rivestimenti',

      '60x120': 'Moderno ed elegante',

      '90x90': 'Extra large, minime fughe'

    };

    return descriptions[format] || 'Formato ceramica';

  },

  

  getColorCode(colorName) {

    const lowerName = colorName.toLowerCase();

    const colorMap = {

      'bianco': '#FFFFFF',

      'white': '#FFFFFF',

      'grigio': '#808080',

      'grey': '#808080',

      'gray': '#808080',

      'nero': '#000000',

      'black': '#000000',

      'beige': '#F5E6D3',

      'tortora': '#C4B5A0',

      'antracite': '#4A4A4A',

      'sabbia': '#E6D4B1',

      'avorio': '#FFFFF0',

      'crema': '#FFFDD0',

      'marrone': '#964B00'

    };

    

    for (const [key, value] of Object.entries(colorMap)) {

      if (lowerName.includes(key)) {

        return value;

      }

    }

    

    return '#CCCCCC';

  },

  

  getThicknessDescription(thickness) {

    const descriptions = {

      '6mm': 'Ultraleggero per rivestimenti',

      '9mm': 'Standard per uso residenziale',

      '12mm': 'Alta resistenza',

      '20mm': 'Per esterni e carrabili'

    };

    return descriptions[thickness] || 'Spessore ceramica';

  },

  

  // Carica formati di default

  loadDefaultFormats() {

    this.formatOptions = [

      {

        value: '60x60',

        label: '60×60 cm',

        description: 'Formato standard versatile',

        price: 45

      },

      {

        value: '80x80',

        label: '80×80 cm',

        description: 'Ideale per spazi ampi',

        price: 55

      },

      {

        value: '120x120',

        label: '120×120 cm',

        description: 'Formato maxi, effetto continuità',

        price: 75

      },

      {

        value: '120x280',

        label: '120×280 cm',

        description: 'Lastra extra large',

        price: 125

      },

      {

        value: '30x60',

        label: '30×60 cm',

        description: 'Perfetto per rivestimenti',

        price: 40

      },

      {

        value: '60x120',

        label: '60×120 cm',

        description: 'Moderno ed elegante',

        price: 65

      },

      {

        value: '90x90',

        label: '90×90 cm',

        description: 'Grande formato',

        price: 60

      },

      {

        value: '20x20',

        label: '20×20 cm',

        description: 'Piccolo formato decorativo',

        price: 35

      }

    ];

  },

  

  // Carica finiture di default

  loadDefaultFinishes() {

    this.finishOptions = [

      {

        value: 'lucida',

        label: 'Lucida',

        description: 'Superficie brillante',

        icon: '✨'

      },

      {

        value: 'Naturale',

        label: 'Naturale',

        description: 'Superficie matt',

        icon: '🔲'

      }

    ];

  },

  

  // Carica tutti i dati di default

  loadDefaultData() {

    this.loadDefaultFormats();

    

    this.colorOptions = [

      { value: 'Bianco', label: 'Bianco', code: '#FFFFFF' },

      { value: 'Grigio', label: 'Grigio', code: '#808080' },

      { value: 'Beige', label: 'Beige', code: '#F5E6D3' }

    ];

    

    this.thicknessOptions = [];

    

    this.loadDefaultFinishes();

  },

  

  // FUNZIONI DI POPOLAMENTO DOM

  

  // Popola le destinazioni nello step 1

  populateDestinations() {

    // Cerca prima il container con ID specifico, altrimenti usa fx-style-grid

    let container = document.getElementById('fxDestinationContainer');

    if (!container) {

      container = document.querySelector('#fxStep1 .fx-style-grid');

    }

    if (!container) {

      return;

    }



    container.innerHTML = '';



    // Disabilita il pulsante Continua inizialmente

    const nextBtn = document.getElementById('fxNext2'); // Step 1 usa fxNext2

    if (nextBtn) nextBtn.disabled = true;



    // Assicurati che nessuna carta sia selezionata di default

    setTimeout(() => {

      container.querySelectorAll('.fx-style-card').forEach(card => {

        card.classList.remove('selected');

      });

    }, 10);



    // Controlla se esistono varianti DISPONIBILI con "PARETE" nel nome

    let hasPareteVariant = false;

    let allVariantsAreParete = false;

    if (this.product && this.product.variants) {

      const availableVariants = this.product.variants.filter(v => v.available !== false);

      hasPareteVariant = availableVariants.some(variant => {

        const variantFullText = `${variant.title || ''} ${variant.option1 || ''} ${variant.option2 || ''} ${variant.option3 || ''}`.toUpperCase();

        return variantFullText.includes('PARETE');

      });



      // Controlla se TUTTE le varianti disponibili sono PARETE

      allVariantsAreParete = availableVariants.length > 0 && availableVariants.every(variant => {

        const variantFullText = `${variant.title || ''} ${variant.option1 || ''} ${variant.option2 || ''} ${variant.option3 || ''}`.toUpperCase();

        return variantFullText.includes('PARETE');

      });

    }



    // Crea array di destinazioni da utilizzare

    // Se TUTTE le varianti sono PARETE, non includere INTERNO/ESTERNO di base

    const destinationsToShow = allVariantsAreParete ? [] : [...this.destinationOptions];



    // Se c'è una variante con PARETE, aggiungi la terza carta

    if (hasPareteVariant) {

      // Calcola i rating disponibili per INTERNO SOLO A PARETE

      let pareteHasR9 = false;

      let pareteHasR10 = false;

      let pareteHasR11 = false;

      let pareteHasR12 = false;

      let pareteHasR13 = false;



      this.product.variants.forEach(variant => {

        // Non filtriamo per available - controlliamo tutte le varianti per determinare PARETE

        const variantFullText = `${variant.title || ''} ${variant.option1 || ''} ${variant.option2 || ''} ${variant.option3 || ''}`.toUpperCase();



        // Controlla se è una variante PARETE o se è Bocciardato (per TUTTI i prodotti)

        const isParete = variantFullText.includes('PARETE');

        const isBocciardato = variantFullText.includes('LITHOS') || variantFullText.includes('BOCCIARDATO');



        if (isParete || isBocciardato) {

          // SPECIAL RULE PER SENSI: escludi R11 dalle varianti bocciardato

          const hasR11 = /\bR11\b/i.test(variantFullText);

          if (this.isSensiProduct() && isBocciardato && hasR11) {

            // Skip R11 per bocciardato Sensi (solo LITHOS R10 ammessi)

            return;

          }



          // Cerca i rating con word boundary

          if (/\bR9\b/i.test(variantFullText)) pareteHasR9 = true;

          if (/\bR10\b/i.test(variantFullText)) pareteHasR10 = true;

          if (/\bR11\b/i.test(variantFullText)) pareteHasR11 = true;

          if (/\bR12\b/i.test(variantFullText)) pareteHasR12 = true;

          if (/\bR13\b/i.test(variantFullText)) pareteHasR13 = true;

        }

      });



      // Costruisci la lista dei rating trovati (tutti i rating disponibili)

      const pareteRatings = [];

      if (pareteHasR9) pareteRatings.push('R9');

      if (pareteHasR10) pareteRatings.push('R10');

      if (pareteHasR11) pareteRatings.push('R11');

      if (pareteHasR12) pareteRatings.push('R12');

      if (pareteHasR13) pareteRatings.push('R13');

      const resistenzaText = pareteRatings.length > 0 ? pareteRatings.join(' / ') : '';



      destinationsToShow.push({

        value: 'INTERNO_SOLO_PARETE',

        label: 'Interno Solo a Parete',

        description: 'Per rivestimenti a parete',

        resistenza: resistenzaText,

        image: 'https://cdn.shopify.com/s/files/1/0949/7713/0845/files/INTERNO_SOLO_A_PARETE_SUPERGRES.jpg?v=1762276257'

      });

    }



    // Controlla se esistono varianti con "BATTISCOPA" nel nome

    let hasBattiscopaVariant = false;

    if (this.product && this.product.variants) {

      const availableVariants = this.product.variants.filter(v => v.available !== false);

      hasBattiscopaVariant = availableVariants.some(variant => {

        const variantFullText = `${variant.title || ''} ${variant.option1 || ''} ${variant.option2 || ''} ${variant.option3 || ''}`.toUpperCase();

        return variantFullText.includes('BATTISCOPA');

      });

    }



    // Se c'è una variante con BATTISCOPA, aggiungi la carta BATTISCOPA

    if (hasBattiscopaVariant) {

      destinationsToShow.push({

        value: 'BATTISCOPA',

        label: 'Battiscopa',

        description: 'Battiscopa coordinati',

        resistenza: '',

        image: 'https://cdn.shopify.com/s/files/1/0949/7713/0845/files/amb-rodapie-concret.jpg?v=1767605650'

      });

    }



    destinationsToShow.forEach((destination, index) => {

      const card = document.createElement('div');

      card.className = 'fx-style-card'; // Non aggiungere 'selected'

      card.dataset.style = destination.value;

      card.style.animationDelay = `${index * 0.02}s`;

      card.style.borderColor = 'transparent'; // Forza bordo trasparente inizialmente

      

      // Determina lo stile del visual

      let visualStyle = '';

      if (destination.image) {

        visualStyle = `background-image: url('${destination.image}'); background-size: cover; background-position: center;`;

      } else if (destination.gradient) {

        visualStyle = `background: ${destination.gradient};`;

      }

      

      // Determina l'altezza in base al dispositivo per immagini più quadrate su desktop

      const isMobile = window.innerWidth <= 768;

      

      // Determina il badge di resistenza da mostrare (solo se presente nelle varianti)

      let resistenzaBadge = '';

      if (destination.value === 'INTERNO') {

        // Mostra rating solo se effettivamente trovato nelle varianti

        if (destination.resistenza) {

          resistenzaBadge = `<small style="color: #2D5A3D; font-weight: 600; display: block; margin-bottom: 0.25rem;">Resistenza: ${destination.resistenza}</small>`;

        }

      } else if (destination.value === 'ESTERNO') {

        // Mostra rating solo se effettivamente trovato nelle varianti

        if (destination.resistenza) {

          resistenzaBadge = `<small style="color: #2D5A3D; font-weight: 600; display: block; margin-bottom: 0.25rem;">Resistenza: ${destination.resistenza}</small>`;

        }

      } else if (destination.value === 'INTERNO_SOLO_PARETE') {

        // Mostra rating solo se effettivamente trovato nelle varianti

        if (destination.resistenza) {

          resistenzaBadge = `<small style="color: #2D5A3D; font-weight: 600; display: block; margin-bottom: 0.25rem;">Resistenza: ${destination.resistenza}</small>`;

        }

      } else if (destination.value === 'BATTISCOPA') {

        // BATTISCOPA: nessun badge di resistenza (già vuoto di default)

        resistenzaBadge = '';

      }



      if (isMobile) {

        // Mobile: dimensione ottimale con overflow nascosto

        const imageHeight = '150px';

        card.innerHTML = `

          ${destination.image ? `<div class="fx-style-image" style="background-image: url('${destination.image}'); background-size: cover; background-position: center; width: 100%; height: ${imageHeight}; margin-bottom: 0; border-radius: 12px 12px 0 0; overflow: hidden;"></div>` : ''}

          <div class="fx-style-info">

            <div class="fx-price-container" style="width: 100%; text-align: center; background: rgba(248,249,250,0.95); border-radius: 12px; padding: 0.75rem 0.5rem; min-height: 112px; border: none; border-top: 1px solid #ebebeb; position: relative; overflow: visible; transition: var(--fx-transition, all 0.3s cubic-bezier(0.4, 0, 0.2, 1)); margin: 0; box-sizing: border-box;">

              <h4 style="margin: 0 0 0.25rem 0; color: var(--fx-text, #2d3436); font-size: 1.1rem; font-weight: 700; letter-spacing: -0.02em; font-family: var(--fx-font, 'Jost', -apple-system, BlinkMacSystemFont, sans-serif);">${destination.label}</h4>

              <p style="margin: 0 0 0.5rem 0; color: var(--fx-text-muted, #636e72); font-size: 0.85rem; font-family: var(--fx-font, 'Jost', -apple-system, BlinkMacSystemFont, sans-serif);">${destination.description}</p>

              ${resistenzaBadge}

            </div>

          </div>

        `;

      } else {

        // Desktop: usa esattamente la stessa struttura dello Step 3

        // Verifica se l'immagine è già ottimizzata (399x200 o simile)

        // Controlla vari pattern possibili nell'URL

        const isOptimizedImage = destination.image && 

          (destination.image.includes('399x200') || 

           destination.image.includes('400x200') ||

           destination.image.includes('398x200') ||

           destination.image.includes('_399x200') ||

           destination.image.includes('_400x200') ||

           destination.image.includes('-399x200') ||

           destination.image.includes('-400x200') ||

           destination.image.match(/399\s*x\s*200/i) ||

           destination.image.match(/400\s*x\s*200/i));

        

        const imageStyle = isOptimizedImage 

          ? `position: absolute !important;

             top: 50% !important; 

             left: 50% !important;

             transform: translate(-50%, -50%) !important;

             width: 100% !important;

             height: 100% !important;

             object-fit: cover !important; 

             object-position: center center !important;

             border-radius: 0 !important; 

             display: block !important; 

             margin: 0 !important;

             padding: 0 !important;

             background: #f5f4f2;`

          : `position: absolute !important;

             top: 50% !important; 

             left: 50% !important;

             transform: translate(-50%, -50%) scale(1.5) !important;

             min-width: 150% !important; 

             min-height: 150% !important; 

             width: auto !important;

             height: auto !important;

             object-fit: cover !important; 

             object-position: center center !important;

             border-radius: 0 !important; 

             display: block !important; 

             margin: 0 !important;

             padding: 0 !important;

             background: #f5f4f2;`;

        

        card.innerHTML = `

          <div class="fx-variant-image" style="position: relative; width: 100%; height: 200px; margin-bottom: 0; overflow: hidden; border-radius: 12px 12px 0 0;">

            <img src="${destination.image}"

                 alt="${destination.label}"

                 style="${imageStyle}">

          </div>

          <div class="fx-style-info">

            <div class="fx-price-container" style="width: 100%; text-align: center; background: rgba(248,249,250,0.95); border-radius: 12px; padding: 0.75rem 0.5rem; min-height: 112px; border: none; border-top: 1px solid #ebebeb; position: relative; overflow: visible; transition: var(--fx-transition, all 0.3s cubic-bezier(0.4, 0, 0.2, 1)); margin: 0; box-sizing: border-box;">

              <h4 style="margin: 0 0 0.25rem 0; color: var(--fx-text, #2d3436); font-size: 1.1rem; font-weight: 700; letter-spacing: -0.02em; font-family: var(--fx-font, 'Jost', -apple-system, BlinkMacSystemFont, sans-serif);">${destination.label}</h4>

              <p style="margin: 0 0 0.5rem 0; color: var(--fx-text-muted, #636e72); font-size: 0.85rem; font-family: var(--fx-font, 'Jost', -apple-system, BlinkMacSystemFont, sans-serif);">${destination.description}</p>

              ${resistenzaBadge}

            </div>

          </div>

        `;

      }

      

      // Gestione click singolo e doppio (desktop e mobile)

      let cardLastTapTime = 0;

      const DOUBLE_TAP_DELAY = 300;



      const handleSelection = () => {

        document.querySelectorAll('#fxStep1 .fx-style-card').forEach(c => {

          c.classList.remove('selected');

        });

        card.classList.add('selected');

        

        const nextBtn = document.getElementById('fxNext2'); // Step 1 usa fxNext2

        if (nextBtn) nextBtn.disabled = false;

        

        if (window.productConfigurator) {

          window.productConfigurator.configuration.destination = destination.value;

        }

        

        // Filtra le varianti basandosi sulla destinazione selezionata

        this.filterVariantsByDestination(destination.value);



        // Filtra anche i formati basandosi sulla destinazione

        this.filterFormatsByDestination(destination.value);



        // IMPORTANTE: Ripopola i formati nello step 2 se è già visibile

        const step2Container = document.querySelector('#fxStep2 .fx-style-grid');

        if (step2Container && step2Container.children.length > 0) {

          this.populateFormats();

        }

      };



      const proceedToNext = () => {

        handleSelection();

        const nextBtn = document.getElementById('fxNext2'); // Step 1 usa fxNext2

        if (nextBtn) {

          nextBtn.disabled = false;

          setTimeout(() => nextBtn.click(), 50);

        }

      };



      // Gestione touch per mobile

      card.addEventListener('touchend', function(e) {

        e.preventDefault();

        const currentTime = e.timeStamp; // timestamp reale del browser, non del processing JS

        const tapLength = currentTime - cardLastTapTime;

        if (tapLength < DOUBLE_TAP_DELAY && tapLength > 0) {

          // Doppio tap

          proceedToNext();

          cardLastTapTime = 0;

        } else {

          // Singolo tap

          handleSelection();

          cardLastTapTime = currentTime;

        }

      });



      // Gestione click per desktop

      card.addEventListener('click', function(e) {

        if (!('ontouchstart' in window)) {

          const currentTime = e.timeStamp; // timestamp reale del browser

          const clickLength = currentTime - cardLastTapTime;

          if (clickLength < DOUBLE_TAP_DELAY && clickLength > 0) {

            // Doppio click

            proceedToNext();

            cardLastTapTime = 0;

          } else {

            // Singolo click

            handleSelection();

            cardLastTapTime = currentTime;

          }

        }

      });

      

      // Previeni doppio tap zoom su iOS e comportamenti indesiderati

      card.addEventListener('touchstart', function(e) {

        if (e.touches.length > 1) {

          e.preventDefault();

        }

      });

      

      container.appendChild(card);

    });



    this.addDiscountBadgesToStep(container);



  },



  // Popola i formati nello step 2

  populateFormats() {

    this.applyDisplayPrices();
    this.applyUnitPrices();
    this.khEnforceFormatPricesFromVariant();

    // Se i prezzi Worker non sono pronti, riprova quando arrivano
    if (!window._prezziFormatListenerAdded) {
      window._prezziFormatListenerAdded = true;
      const self = window.ConfiguratoreDataUniversal;
      window.addEventListener('prezzi-m2-updated', () => {
        self.applyDisplayPrices();
        self.applyUnitPrices();
        self.khEnforceFormatPricesFromVariant();
        self.populateFormats();
      }, { once: true });
    }



    const container = document.querySelector('#fxStep2 .fx-style-grid');


    if (!container) {

      return;

    }



    container.innerHTML = '';



    // Se c'è una destinazione selezionata, filtra i formati

    const savedDestination = window.productConfigurator?.configuration?.destination || this.selectedDestination;

    let formatsToShow;



    if (savedDestination) {

      this.filterFormatsByDestination(savedDestination);

      // Assicurati che sia salvata anche localmente

      this.selectedDestination = savedDestination;

      formatsToShow = this.filteredFormatOptions || [];

    } else {

      // IMPORTANTE: Anche senza destinazione, mostra solo formati con almeno un rating valido

      formatsToShow = this.formatOptions.filter(format => {

        if (!format.availableRatings) {

          return false;

        }

        // Mostra solo se ha almeno un rating valido

        const hasValidRating = format.availableRatings.R9 || format.availableRatings.R10 || format.availableRatings.R11;

        if (!hasValidRating) {

          return false;

        }

        return true;

      });

    }



    // 🚫 ESCLUDI BATTISCOPA dal configuratore (sono prodotti speciali, non piastrelle)

    // MA se la destinazione è BATTISCOPA, mostra SOLO i battiscopa

    const selectedDestination = this.selectedDestination;

    formatsToShow = formatsToShow.filter(format => {

      const valueLower = (format.value || '').toLowerCase();

      const labelLower = (format.label || '').toLowerCase();

      const isBattiscopaFormat = valueLower.includes('battiscopa') || labelLower.includes('battiscopa') || format.isBattiscopa === true;



      if (selectedDestination === 'BATTISCOPA') {

        // Se destinazione BATTISCOPA, mostra SOLO i battiscopa

        if (!isBattiscopaFormat) {

          return false;

        }

        return true;

      } else {

        // Per altre destinazioni, escludi i battiscopa

        if (isBattiscopaFormat) {


          return false;

        }

        return true;

      }

    });



    // 🆕 AGGREGAZIONE: Raggruppa formati per dimensioni (senza finitura)

    // Es: 60x60-naturale, 60x60-lucido → mostro solo 60x60

    // NOTA: '-satinatoNaturale' deve venire PRIMA di '-satinato' per essere rimosso correttamente

    // IMPORTANTE: ordine suffissi - i più lunghi/specifici PRIMA dei più corti (es. -realupstrideup PRIMA di -realup)

    const suffissiDaRimuovere = ['-parete', '-lux', '-fluid', '-ptv', '-comfort', '-lucido', '-satinatoNaturale', '-satinato', '-velvet',

                                  '-strutturato', '-strutturamove', '-strutturasign', '-strutturanet', '-twist', '-stripe', '-riga', '-pliss', '-strutturato20mm', '-bocciardato', '-liscio', '-levigato', '-levigata', '-patinato', '-patinata', '-lappatasatinata', '-Lappata-Satinata', '-lappato', '-lappata',

                                  '-Naturale', '-naturale', '-squadrato', '-squadrata', '-cannete', '-soft', '-matte', '-Naturalecuoio', '-grip',

                                  '-realupstrideup', '-RealUp+StrideUp', '-antislip', '-realup', '-RealUp', '-strideup', '-StrideUp', '-battiscopa', '-fade', '-Fade'];



    const formatiPerDimensione = new Map(); // Map<dimensione, formato[]>



    formatsToShow.forEach(format => {

      let dimensione = format.value;

      // Rimuovi tutti i suffissi di finitura per ottenere solo la dimensione

      suffissiDaRimuovere.forEach(suffix => {

        dimensione = dimensione.replace(suffix, '');

      });

      // Rimuovi anche suffissi spessore

      dimensione = dimensione.replace(/-20mm$/, '').replace(/-9mm$/, '');



      if (!formatiPerDimensione.has(dimensione)) {

        formatiPerDimensione.set(dimensione, []);

      }

      formatiPerDimensione.get(dimensione).push(format);

    });



    // Crea array di formati aggregati (un formato per dimensione)

    const formatiAggregati = [];

    formatiPerDimensione.forEach((formati, dimensione) => {

      // 🔴 DEBUG: Mostra tutti i formati e i loro prezzi per questa dimensione


      formati.forEach(f => {

        // Converti in euro per leggibilità

        const dispPriceEuro = f.displayPrice ? (f.displayPrice / 100).toFixed(2) : 'N/A';

        const priceEuro = f.price ? (f.price / 100).toFixed(2) : 'N/A';


      });



      // 🎯 Usa il formato con displayPrice più BASSO (il prezzo base "da X€")

      // Per AUTHENTIC LUXE: MATTE=37.9€, SATINATO=41.9€, LUCIDO=46.9€ - vogliamo mostrare 37.9€

      // Ordina per displayPrice crescente e prendi il primo

      const formatiOrdinati = [...formati].sort((a, b) => {

        const priceA = a.displayPrice || a.price || Infinity;

        const priceB = b.displayPrice || b.price || Infinity;

        return priceA - priceB; // Crescente (prezzo minimo prima)

      });

      const formatoBase = formatiOrdinati[0];



      const prezzoFinale = formatoBase.displayPrice || formatoBase.price;




      const formatoRappresentativo = { ...formatoBase };

      formatoRappresentativo.value = dimensione;



      // Controlla se almeno un formato originale ha "rettificato"

      const isRettificato = formati.some(f =>

        (f.label && f.label.toLowerCase().includes('rettificato')) ||

        (f.value && f.value.toLowerCase().includes('rettificato'))

      );

      // Controlla se almeno un formato originale ha "squadrato"

      const isSquadrato = formati.some(f =>

        (f.label && (f.label.toLowerCase().includes('squadrato') || f.label.toLowerCase().includes('squadrata'))) ||

        (f.value && (f.value.toLowerCase().includes('squadrato') || f.value.toLowerCase().includes('squadrata')))

      );

      let label = dimensione.replace('x', '×').replace(/\./g, ',') + ' cm'; /* KH-FIX virgola */

      if (isRettificato) label += ' Rettificato';

      if (isSquadrato) label += ' Squadrato';

      formatoRappresentativo.label = label; // Es: "60×60 cm" o "60×60 cm Rettificato" o "60×60 cm Squadrato"



      formatoRappresentativo._formatiOriginali = formati; // Salva tutti i formati originali per lo step finitura

      formatiAggregati.push(formatoRappresentativo);

    });



    // Usa i formati aggregati invece di formatsToShow

    const formatsToDisplay = formatiAggregati;



    // Disabilita il pulsante Continua inizialmente

    const nextBtn2Colore = document.getElementById('fxNext2Finitura');

    if (nextBtn2Colore) nextBtn2Colore.disabled = true;



    // Assicurati che nessuna carta sia selezionata di default

    setTimeout(() => {

      container.querySelectorAll('.fx-style-card').forEach(card => {

        card.classList.remove('selected');

      });

    }, 10);




    if (formatsToDisplay.length === 0) {

      container.innerHTML = '<p style="color: var(--fx-text-muted); text-align: center; padding: 2rem;">Nessun formato disponibile per questa destinazione</p>';

      return;

    }



    // Variabile per tracciare l'ultimo tap (fuori dal loop)

    let lastTapTime = 0;



    // 🆕 Usa formatsToDisplay (formati aggregati per dimensione)

    formatsToDisplay.forEach((format, index) => {

      const card = document.createElement('div');

      card.className = 'fx-style-card fx-format-card'; // Aggiungi classe speciale per formati

      card.dataset.format = format.value;

      card.style.animationDelay = `${index * 0.02}s`;

      card.style.borderColor = 'transparent'; // Forza bordo trasparente inizialmente

      // Override inline per garantire overflow visible (solo desktop — su mobile causa fuoriuscita contenuto)
      if (window.innerWidth > 768) {
        card.style.cssText += 'overflow: visible !important; clip-path: none !important; contain: none !important;';
      }



      // 🎯 Cerca il prezzo fisso usando il comparePrice della variante CORRETTA

      const currentDestination = window.productConfigurator?.configuration?.destination || this.selectedDestination;

      const priceUnitFormat = currentDestination === 'BATTISCOPA' ? '/box' : '/mq';

      let finalDisplayPrice = format.displayPrice || format.price;

      let finalDisplayComparePrice = format.displayComparePrice || format.compareAtPrice;



      // 🔧 NON sovrascrivere il prezzo - usa quello già calcolato da applyDisplayPrices

      // Il prezzo è già stato impostato correttamente per tutti i formati inclusi quelli con finiture speciali

      // La ricerca variante qui sotto causava problemi perché trovava la variante MATTE invece di CANNETE



      // 🔴 DEBUG

      if (format._formatiOriginali && format._formatiOriginali.some(f => f.value.includes('cannete'))) {


      }



      // SKIP: Non cercare più la variante qui - usa il prezzo già assegnato da applyDisplayPrices

// KH: blocco if(false) morto rimosso




      // Genera SVG per il formato

      const svgTile = this.generateFormatSVG(format.value);



      // Su mobile mantieni uniformità, su desktop usa layout originale
      try { var _pcS = window.productData || (window.ConfiguratoreDataUniversal&&window.ConfiguratoreDataUniversal.product); if (_pcS && _pcS.variants && typeof currentPrice !== 'undefined' && currentPrice != null && typeof displayPrice !== 'undefined') { var _mvS = _pcS.variants.find(function(v){ return Math.abs(parseInt(v.price,10) - currentPrice) < 1; }); if (_mvS) { var _kuS = window.__KH_UNIT__ && window.__KH_UNIT__[_mvS.id]; if (_kuS && _kuS.p != null) displayPrice = _kuS.p; } } } catch(e){} /* KH sync €/mq */

      const isMobile = window.innerWidth <= 768;



      // Escape dei caratteri speciali per evitare problemi con apostrofi negli attributi HTML

      const safeFormatValue = (format.value || '').replace(/'/g, "\\'");

      const safeFormatLabel = (format.label || '').replace(/'/g, "\\'");



      // Rimuovi contenitore quadrato - mostra solo la piastrella SVG con info button

      // Su mobile: altezza auto per adattarsi all'SVG. Su desktop: altezza fissa per allineamento

      const heightStyle = isMobile ? 'min-height: 120px' : 'height: 240px';

      card.innerHTML = `

        <div style="display: flex; align-items: center; justify-content: center; padding: 1rem 0; ${heightStyle}; width: 100%; overflow: visible !important; clip-path: none !important;">

          ${svgTile}

        </div>

        <button class="fx-format-info-btn"

                onclick="event.stopPropagation(); event.preventDefault();

        if (window.innerWidth <= 768) { window.ConfiguratoreDataUniversal.showFormatInfo('${safeFormatValue}', '${safeFormatLabel}', 'formato'); } return false;"

                ontouchstart="event.stopPropagation(); event.preventDefault();

        window.ConfiguratoreDataUniversal.showFormatInfo('${safeFormatValue}', '${safeFormatLabel}', 'formato'); return false;"

                onmouseenter="event.stopPropagation();

        if (window.innerWidth > 768) { window.ConfiguratoreDataUniversal.showFormatInfo('${safeFormatValue}', '${safeFormatLabel}', 'formato'); }"

                style="position: absolute; top: 8px; left: 8px; width: 32px; height: 32px;

                       background: white; border: 1px solid #ddd; border-radius: 50%;

                       display: flex; align-items: center; justify-content: center;

                       cursor: pointer; box-shadow: 0 2px 8px rgba(0,0,0,0.1);

                       z-index: 10;">

          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">

            <circle cx="12" cy="12" r="10" stroke="#2D5A3D" stroke-width="2"/>

            <path d="M12 16v-4M12 8h.01" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round"/>

          </svg>

        </button>

      `;



      card.innerHTML += `

        <div class="fx-style-info">

          <div class="fx-price-container" style="width: 100%; text-align: center; background: rgba(248,249,250,0.95); border-radius: 12px; padding: 0.75rem 0.5rem; min-height: 112px; border: none; border-top: 1px solid #ebebeb; position: relative; overflow: visible; transition: var(--fx-transition, all 0.3s cubic-bezier(0.4, 0, 0.2, 1)); margin: 0; box-sizing: border-box;">

            <h4 style="margin: 0 0 0.25rem 0; color: var(--fx-text, #2d3436); font-size: 1.1rem; font-weight: 700; letter-spacing: -0.02em; font-family: var(--fx-font, 'Jost', -apple-system, BlinkMacSystemFont, sans-serif);">${format.label}</h4>

            <p style="margin: 0 0 0.5rem 0; color: var(--fx-text-muted, #636e72); font-size: 0.85rem; font-family: var(--fx-font, 'Jost', -apple-system, BlinkMacSystemFont, sans-serif);">${format.description}</p>

            ${format.price ? `

              <div class="fx-price-row" style="display: flex; align-items: center; justify-content: center; gap: 0.5rem; flex-wrap: wrap;">

                <span class="fx-price" style="font-weight: 800; color: var(--fx-primary, #2D5A3D); font-size: 1.3rem; line-height: 1; font-family: var(--fx-font, 'Jost', -apple-system, BlinkMacSystemFont, sans-serif); letter-spacing: -0.02em;">

                  ${currentDestination === 'BATTISCOPA' ? this.formatMoney(format.price) : this.formatMoney(format.displayPrice || format.price)}<span style="font-size: 0.8em; font-weight: inherit;">${currentDestination === 'BATTISCOPA' ? '/scatola' : priceUnitFormat}</span>

                </span>

                ${currentDestination === 'BATTISCOPA' ? (format.compareAtPrice && format.compareAtPrice > format.price ? `
                  <span class="fx-step-price-was">
                    ${this.formatMoney(format.compareAtPrice)}
                  </span>
                ` : '') : (format.displayComparePrice ? `

                  <span class="fx-step-price-was">

                    ${this.formatMoney(format.displayComparePrice)}

                  </span>

                ` : format.compareAtPrice && format.compareAtPrice > format.price ? `

                  <span class="fx-step-price-was">

                    ${this.formatMoney(format.compareAtPrice)}

                  </span>

                ` : '')}

              </div>

              ${currentDestination === 'BATTISCOPA' ? (format.compareAtPrice && format.compareAtPrice > format.price ? `
                
              ` : '') : (format.displayComparePrice ? `

                

              ` : format.compareAtPrice && format.compareAtPrice > format.price ? `

                

              ` : '')}

              ${currentDestination === 'BATTISCOPA' ? `<span class="fx-box-price" style="display:block;font-size:0.75rem;color:#b2bec3;font-weight:700;margin-top:0.25rem;text-align:center;font-family:var(--fx-font,Jost,sans-serif);">IVA incl.</span>` : `<span class="fx-box-price" style="display:block;font-size:0.75rem;color:#b2bec3;font-weight:700;margin-top:0.25rem;text-align:center;font-family:var(--fx-font,Jost,sans-serif);">${this.formatMoney(window.khScatolaPerMq(format.displayPrice||format.price, format.price))}/scatola · IVA incl.</span>`}

            ` : ''}

          </div>

        </div>

      `;

      

      // Gestione click singolo e doppio (desktop e mobile)

      let clickCount = 0;

      let clickTimer = null;

      

      const handleSelection = () => {

        document.querySelectorAll('#fxStep2 .fx-style-card').forEach(c => {

          c.classList.remove('selected');

        });

        card.classList.add('selected');



        const nextBtn = document.getElementById('fxNext2Finitura');

        if (nextBtn) nextBtn.disabled = false;



        // 🆕 Salva le DIMENSIONI selezionate (senza finitura)

        this.selectedFormatoDimensionale = format.value; // Es: "60x60"

        this.selectedFormat = format.value; // Per compatibilità



        // 🆕 Salva i formati originali (con finiture) per lo step finitura

        this.formatiOriginaliPerDimensione = format._formatiOriginali || [format];

        if (window.productConfigurator) {

          window.productConfigurator.configuration.format = format.value;

          window.productConfigurator.configuration.formatoDimensionale = format.value;

        }



        // NON aggiornare step colori qui - verrà fatto dopo la selezione della finitura

      };

      

      const proceedToNext = () => {

        handleSelection();

        const nextBtn = document.getElementById('fxNext2Finitura');

        if (nextBtn) {

          nextBtn.disabled = false;

          setTimeout(() => nextBtn.click(), 50);

        }

      };

      

      // Gestione unificata per click e tap

      card.addEventListener('click', function(e) {

        clickCount++;

        

        if (clickCount === 1) {

          // Primo click/tap

          clickTimer = setTimeout(() => {

            // Click singolo

            handleSelection();

            clickCount = 0;

          }, 250);

        } else if (clickCount === 2) {

          // Doppio click/tap

          clearTimeout(clickTimer);

          proceedToNext();

          clickCount = 0;

        }

      });

      

      // Previeni doppio tap zoom su iOS

      card.addEventListener('touchstart', function(e) {

        if (e.touches.length > 1) {

          e.preventDefault();

        }

      });

      

      container.appendChild(card);

    });


    this.addDiscountBadgesToStep(container);

  },



  // 🆕 STEP 3: Popola le finiture disponibili per il formato selezionato

  // Mostra le varianti complete (es. 60x60-naturale, 60x60-lucido) con le stesse card dello step Formato

  populateFiniture() {

    const container = document.getElementById('fxFinitureContainer');

    if (!container) {

      return;

    }



    container.innerHTML = '';



    // Disabilita il pulsante Continua inizialmente

    const nextBtn3 = document.getElementById('fxNext3Colore');

    if (nextBtn3) nextBtn3.disabled = true;



    // 🆕 Usa i formati originali salvati durante la selezione del formato

    let formatiOriginali = this.formatiOriginaliPerDimensione || [];
    /* KH-SYNC: ripristina prezzo per-variante (displayPrice/price/compare corrotti in estrazione) */
    try { var _self0=this; (formatiOriginali||[]).forEach(function(f){ var u=window.__KH_UNIT__&&window.__KH_UNIT__[f.variantId]; f.displayPrice=window.khMQ(f.variantId, (u&&u.p)?u.p:f.displayPrice); var vv=(_self0.product&&_self0.product.variants||[]).find(function(x){return String(x.id)===String(f.variantId);}); if(vv){ if(vv.price!=null) f.price=parseInt(vv.price)||f.price; if(vv.compare_at_price!=null) f.compareAtPrice=parseInt(vv.compare_at_price)||f.compareAtPrice; } }); } catch(e){}
    // FIX 2026-06-10: se la finitura e' solo un rating (R9..R13), traducila in finitura reale: R9/R10=Naturale, R11/R12/R13=Grip (antislip)
    formatiOriginali = (formatiOriginali||[]).map(function(f){
      var rv = ((f.value||'')+' '+(f.label||'')).toLowerCase();
      var hasRealFinish = /(grip|antislip|natural|lappat|satinat|velvet|strutturat|opac|lucid|soft|matt|levigat|patinat|spazzolat|bocciard|liscia|fluid|cannet)/.test(rv);
      if (hasRealFinish) return f;
      if (/\br(9|10)\b/.test(rv)) return Object.assign({}, f, { label: 'Naturale' });
      if (/\br(11|12|13)\b/.test(rv)) return Object.assign({}, f, { label: 'Grip' });
      return f;
    });

    // 🎯 FIX 2026-06-05: Filtra finiture in base a destinazione
    // INTERNO → escludi Grip/Antislip (sono finiture solo per esterno)
    // ESTERNO → mostra solo finiture esterne (Grip/Antislip/StrideUp/20mm)
    const currentDestFiltro = window.productConfigurator?.configuration?.destination || this.configuration?.destination;
    if (currentDestFiltro === 'INTERNO' || currentDestFiltro === 'INTERNO_SOLO_PARETE') {
      formatiOriginali = formatiOriginali.filter(f => {
        const v = (f.value || '').toLowerCase();
        const l = (f.label || '').toLowerCase();
        var _vrI = (this.product && this.product.variants || []).find(function(x){return x.id == f.variantId;});
        var _o3I = (_vrI && (_vrI.option3||'')).toLowerCase();
        var _txtI = v + ' ' + l + ' ' + _o3I;
        var _estI = /(r11|r12|r13)/i.test(_txtI) || /(20\s*mm|t_?20)/i.test(_txtI) || /(strideup|stride-up)/i.test(_txtI);
        return !_estI; /* REGOLA 25-06 GENERALE: interno = NON esterno (qualsiasi finitura senza R11/R12/R13/20mm/strideup) */
      });
    } else if (currentDestFiltro === 'ESTERNO') {
      // Per ESTERNO: tieni SOLO finiture per esterno (Grip/Antislip/StrideUp/20mm)
      formatiOriginali = formatiOriginali.filter(f => {
        const v = (f.value || '').toLowerCase();
        const l = (f.label || '').toLowerCase();
        var _vrE = (this.product && this.product.variants || []).find(function(x){return x.id == f.variantId;});
        var _o3E = (_vrE && (_vrE.option3||'')).toLowerCase();
        var _txtE = v + ' ' + l + ' ' + _o3E;
        return /(r11|r12|r13)/i.test(_txtE) || /(20\s*mm|t_?20)/i.test(_txtE) || /(strideup|stride-up)/i.test(_txtE); /* REGOLA 25-06 GENERALE: esterno = qualsiasi finitura R11+/20mm/strideup */
      });
    }




    if (formatiOriginali.length === 0) { var _natSrc = this.formatiOriginaliPerDimensione || []; if (_natSrc.length > 0) { formatiOriginali = [Object.assign({}, _natSrc[0], { label: 'Naturale', value: (_natSrc[0].value||'naturale') })]; } else { container.innerHTML = '<p style="color: var(--fx-text-muted); text-align: center; padding: 2rem;">Nessuna variante disponibile</p>'; return; } }



    // 🎯 Ordina per prezzo crescente (il prezzo più basso prima)

    // I displayPrice sono già stati calcolati correttamente in applyDisplayPrices()

    formatiOriginali = [...formatiOriginali].sort((a, b) => {

      const priceA = a.displayPrice || a.price || Infinity;

      const priceB = b.displayPrice || b.price || Infinity;


      return priceA - priceB; // Crescente

    });




    // 🔧 Definisci finitureNames qui per usarlo nell'auto-selezione

    // NOTA: 'lux' cercato SOLO nel format.value, NON nel label (può essere nome colore come STATUARIO LUX)

    // 🔧 FIX: Soft, Satinata e Matte sono finiture DIVERSE

    const finitureNamesLocal = {

      'naturale': 'Naturale', 'Naturale': 'Naturale',

      'matte': 'Opaca', 'matt': 'Opaca', 'opaco': 'Opaca', 'opaca': 'Opaca',

      'soft': 'Soft', 'comfort': 'Comfort', 'lux': 'Lucida', 'fluid': 'Fluid', 'ptv': 'PTV', 'cannete': 'Canneté',

      'lucido': 'Lucida', 'lucida': 'Lucida',

      // IMPORTANTE: lappatasatinata PRIMA di satinato/satinata per match corretto (contiene "satinata")

      'lappatasatinata': 'Lappata-Satinata', 'Lappata-Satinata': 'Lappata-Satinata', 'lappata-satinata': 'Lappata-Satinata',

      'satinato': 'Satinata', 'velvet': 'Velvet', 'Velvet': 'Velvet', 'satinata': 'Satinata',

      'strutturato': 'Strutturata', 'strutturata': 'Strutturata',

      'bocciardato': 'Bocciardato',

      'liscio': 'Liscia', 'liscia': 'Liscia',

      'levigato': 'Levigata', 'levigata': 'Levigata', 'patinato': 'Patinata', 'patinata': 'Patinata',

      // lappato/lappata DOPO lappatasatinata

      'lappato': 'Lappata', 'lappata': 'Lappata',

      'spazzolato': 'Spazzolata', 'spazzolata': 'Spazzolata',

      'Naturalecuoio': 'Naturale Cuoio', 'naturalecuoio': 'Naturale Cuoio',

      'realupstrideup': 'RealUp+StrideUp', 'RealUp+StrideUp': 'RealUp+StrideUp', 'realup-strideup': 'RealUp+StrideUp', 'RealUp-StrideUp': 'RealUp+StrideUp',

      'realup': 'RealUp', 'RealUp': 'RealUp',

      'strideup': 'StrideUp', 'StrideUp': 'StrideUp',

      'grip': 'Grip', 'Grip': 'Grip',

      'antislip': 'Antislip', 'Antislip': 'Antislip',

      'fade': 'Fade', 'Fade': 'Fade'

    };



    // Se c'è solo una variante, selezionala automaticamente

    if (formatiOriginali.length === 1) {

      const format = formatiOriginali[0];

      this.selectedFormat = format.value;

      this.selectedFinitura = format.value;



      // 🔧 Calcola finituraLabel per auto-selezione

      let autoFinituraLabel = 'Naturale';

      const formatValue = format.value.toLowerCase().replace(/-parete/g, '').replace(/-squadrato/g, '');

      for (const [key, label] of Object.entries(finitureNamesLocal)) {

        if (formatValue.includes('-' + key) || formatValue.endsWith(key)) {

          autoFinituraLabel = label;

          break;

        }

      }

      // Se non trova nel value, cerca anche nel label del formato

      // NOTA: 'lux' e 'fluid' NON vengono cercati nel label (possono essere nomi colore)

      if (autoFinituraLabel === 'Naturale' && format.label) {

        const labelLower = format.label.toLowerCase();

        const finitureEscluseInLabel = ['lux', 'fluid']; // Queste possono essere nomi colore

        for (const [key, label] of Object.entries(finitureNamesLocal)) {

          if (finitureEscluseInLabel.includes(key.toLowerCase())) continue;

          const keyRegex = new RegExp('\\b' + key + '\\b', 'i');

          if (keyRegex.test(labelLower)) {

            autoFinituraLabel = label;

            break;

          }

        }

      }



      if (window.productConfigurator?.configuration) {

        window.productConfigurator.configuration.format = format.value;

        window.productConfigurator.configuration.finitura = format.value;

        window.productConfigurator.configuration.finituraLabel = autoFinituraLabel;

      }

      // 🎯 FILTRA I COLORI anche per auto-selezione

      this.filterColorsByFormat(format.value);

      if (nextBtn3) nextBtn3.disabled = false;

    }



    const isMobile = window.innerWidth <= 768;



    // Determina l'unità di prezzo: /box per BATTISCOPA, /mq per il resto

    const currentDestinationFiniture = window.productConfigurator?.configuration?.destination || this.selectedDestination;

    const priceUnitFiniture = currentDestinationFiniture === 'BATTISCOPA' ? '/box' : '/mq';



    // 🔧 FIX 22-GEN-2026: Per prodotti con rating system, filtra i formati in base alla destinazione

    // NOTA: -antislip può essere R9 (INTERNO) o R11 (ESTERNO) - NON usare come indicatore automatico

    // Grip = tipicamente R11 (ESTERNO), 20mm = ESTERNO


    const has20mmFormats = formatiOriginali.some(f => f.value.toLowerCase().includes('-20mm'));

    // REGOLA ASSOLUTA: 20mm va SEMPRE e SOLO in ESTERNO
    // Si applica PRIMA di qualsiasi altra logica di filtraggio
    if (has20mmFormats) {
      if (currentDestinationFiniture === 'INTERNO' || currentDestinationFiniture === 'INTERNO_SOLO_PARETE') {
        formatiOriginali = formatiOriginali.filter(f => !f.value.toLowerCase().includes('-20mm'));
      } else if (currentDestinationFiniture === 'ESTERNO') {
        // In ESTERNO, i 20mm vengono mantenuti (filtro sotto gestisce il resto)
      }
    }

    if (this.productHasRatingSystem) {

      const isOnlyHighRating = (f) => {
        const r = f.availableRatings || {};
        const hasLow = r.R9 || r.R10 || r.noRating; /* KH-FIX 29-06: 9mm senza rating = INTERNO */
        const hasHigh = r.R11 || r.R12 || r.R13;
        return hasHigh && !hasLow;
      };

      if (currentDestinationFiniture === 'INTERNO' || currentDestinationFiniture === 'INTERNO_SOLO_PARETE') {

        // Per INTERNO: escludi formati con SOLO rating alto (R11+) senza R9/R10
        formatiOriginali = formatiOriginali.filter(f => !isOnlyHighRating(f));

      } else if (currentDestinationFiniture === 'ESTERNO') {

        // Per ESTERNO: mostra formati outdoor (20mm) E formati con R11+ (anche se hanno anche R10/R9)
        // Fix: prodotti come DOCKS hanno stesso formato in R10 (interno) e R11 (esterno)
        const hasHighRating = (f) => { const r = f.availableRatings || {}; return r.R11 || r.R12 || r.R13; };
        formatiOriginali = formatiOriginali.filter(f => f.value.toLowerCase().includes('-20mm') || hasHighRating(f));

      }

    } else if (has20mmFormats && currentDestinationFiniture === 'ESTERNO') {
      // Prodotti SENZA rating system: ESTERNO = solo 20mm
      formatiOriginali = formatiOriginali.filter(f => f.value.toLowerCase().includes('-20mm'));
    }

    // 🆕 AGGREGAZIONE FINITURE: Raggruppa formati che differiscono solo per -parete/-fluid

    // Es: 60x120-naturale e 60x120-naturale-parete → mostra solo una card "Naturale"

    // NOTA: -lux NON viene aggregato perché è una FINITURA diversa (Lucida vs Naturale)

    const finitureViste = new Map(); // Map<finituraBase, format>

    const formatiAggregatiPerFinitura = [];






    formatiOriginali.forEach(format => {

      // Calcola la finitura base (senza -parete, -fluid) - NOTA: -lux NON rimosso (è finitura separata)

      const finituraBase = format.value.replace(/-parete/g, '').replace(/-fluid/g, '');



      if (!finitureViste.has(finituraBase)) {

        // Prima volta che vediamo questa finitura

        finitureViste.set(finituraBase, format);

        formatiAggregatiPerFinitura.push(format);

      } else {

        // Già vista, usa il formato con displayPrice più basso

        const existing = finitureViste.get(finituraBase);

        const existingPrice = existing.displayPrice || existing.price || Infinity;

        const newPrice = format.displayPrice || format.price || Infinity;

        if (newPrice < existingPrice) {

          // Sostituisci con il formato più economico

          const index = formatiAggregatiPerFinitura.indexOf(existing);

          if (index !== -1) {

            formatiAggregatiPerFinitura[index] = format;

          }

          finitureViste.set(finituraBase, format);

        }

      }

    });



    // 🔧 FIX: Deduplicazione aggiuntiva per finituraLabel identica
    // Se due formati diversi (es: 60x120-naturale e 60x120-naturale-grip) producono lo stesso label,
    // mostra solo quello con il prezzo più basso
    const finitureNamesDedup = {
      'naturale': 'Naturale', 'Naturale': 'Naturale', 'matte': 'Opaca', 'matt': 'Opaca',
      'twist': 'Twist', 'stripe': 'Stripe', 'riga': 'Riga', 'pliss': 'Plissé', 'strutturasign': 'Struttura Sign', 'strutturanet': 'Struttura Net', 'strutturamove': 'Struttura Move',
      'soft': 'Soft', 'comfort': 'Comfort', 'lux': 'Lucida', 'fluid': 'Fluid', 'ptv': 'PTV', 'cannete': 'Canneté',
      'lucido': 'Lucida', 'lucida': 'Lucida',
      'lappatasatinata': 'Lappata-Satinata', 'satinato': 'Satinata', 'velvet': 'Velvet', 'Velvet': 'Velvet', 'satinata': 'Satinata',
      'strutturato': 'Strutturata', 'strutturata': 'Strutturata', 'bocciardato': 'Bocciardato',
      'liscio': 'Liscia', 'liscia': 'Liscia', 'levigato': 'Levigata', 'levigata': 'Levigata', 'patinato': 'Patinata', 'patinata': 'Patinata',
      'lappato': 'Lappata', 'lappata': 'Lappata', 'naturalecuoio': 'Naturale Cuoio',
      'realupstrideup': 'RealUp+StrideUp', 'realup': 'RealUp', 'strideup': 'StrideUp',
      'grip': 'Grip', 'antislip': 'Antislip', 'fade': 'Fade', '20mm': '20mm', 't_20': 'T_20', 't20': 'T_20'
    };
    function getFinituraLabelForDedup(fValue, format) {
      let fv = fValue.toLowerCase().replace(/-parete/g, '').replace(/-squadrato/g, '');
      let lbl = '';
      for (const [k, v] of Object.entries(finitureNamesDedup)) {
        if (fv.includes('-' + k) || fv.endsWith(k)) {
          lbl = v;
          if (k !== 'naturale' && k !== 'Naturale') break;
        }
      }
      lbl = lbl || 'Naturale';
      // ESTERNO: tutti gli spessori R11+ (anche 20mm) → raggruppati in un'unica card "Grip"
      if (currentDestinationFiniture === 'ESTERNO' &&
          format && (format.availableRatings?.R11 || format.availableRatings?.R12 || format.availableRatings?.R13) &&
          (lbl === 'Naturale' || lbl === '20mm' || lbl === 'T_20')) {
        lbl = 'Grip';
      }
      return lbl;
    }
    const dedupMap = new Map();
    const formatiDeduplicated = [];
    formatiAggregatiPerFinitura.forEach(format => {
      const lbl = getFinituraLabelForDedup(format.value, format);
      if (!dedupMap.has(lbl)) {
        dedupMap.set(lbl, format);
        formatiDeduplicated.push(format);
      } else {
        const existing = dedupMap.get(lbl);
        const ep = existing.displayPrice || existing.price || Infinity;
        const np = format.displayPrice || format.price || Infinity;
        if (np < ep) {
          const idx = formatiDeduplicated.indexOf(existing);
          if (idx !== -1) formatiDeduplicated[idx] = format;
          dedupMap.set(lbl, format);
        }
      }
    });

    // Usa formatiDeduplicated al posto di formatiAggregatiPerFinitura
    formatiAggregatiPerFinitura.length = 0;
    formatiDeduplicated.forEach(f => formatiAggregatiPerFinitura.push(f));





    // Crea le card per ogni finitura aggregata

    formatiAggregatiPerFinitura.forEach((format, index) => {
      try { var _pcF = window.productData || (window.ConfiguratoreDataUniversal&&window.ConfiguratoreDataUniversal.product); if (_pcF && _pcF.variants && format && format.price != null) { var _mvF = _pcF.variants.find(function(v){ return Math.abs(parseInt(v.price,10) - format.price) < 1; }); if (_mvF) { var _kuF2 = window.__KH_UNIT__ && window.__KH_UNIT__[_mvF.id]; if (_kuF2 && _kuF2.p != null) format.displayPrice = _kuF2.p; } } } catch(e){} /* KH sync €/mq finitura */

      const card = document.createElement('div');

      card.className = 'fx-style-card fx-format-card';

      card.dataset.format = format.value;

      card.dataset.finitura = format.value;

      card.style.animationDelay = `${index * 0.02}s`;

      card.style.borderColor = 'transparent';

      card.style.cssText += 'overflow: visible !important; clip-path: none !important; contain: none !important;';



      // Se c'è solo una variante, selezionala logicamente ma NON visivamente

      // (evita sfondo verde che rende la piastrella chiara quasi invisibile)

      // La selezione visiva avverrà al click dell'utente



      // Genera SVG per il formato - USA LA DIMENSIONE SELEZIONATA (come nello step 2)

      // per garantire che l'SVG sia IDENTICO a quello dello step Formato

      const dimensionePerSVG = this.selectedFormatoDimensionale || format.value;

      const svgTile = this.generateFormatSVG(dimensionePerSVG);



      // Escape dei caratteri speciali

      const safeFormatValue = (format.value || '').replace(/'/g, "\\'");

      const safeFormatLabel = (format.label || format.value || '').replace(/'/g, "\\'");



      const heightStyle = isMobile ? 'min-height: 120px' : 'height: 240px';



      // 🆕 Estrai solo il nome della finitura dal format.value (es: "60x60-naturale" → "Naturale")

      // Converte automaticamente dal maschile (Shopify) al femminile (grammaticalmente corretto con "finitura")

      // NOTA: "-parete" NON è una finitura ma un indicatore di destinazione (solo pareti interne)

      const finitureNames = {

        // Invariabili (stessa forma maschile/femminile)

        'naturale': 'Naturale',

        'Naturale': 'Naturale',

        'soft': 'Soft',

        'matte': 'Opaca',

        'matt': 'Opaca',

        'opaco': 'Opaca',

        'opaca': 'Opaca',

        'comfort': 'Comfort',

        'lux': 'Lucida', // Finitura valida nel format.value, ma NON cercare nel label (può essere nome colore)

        'fluid': 'Fluid',

        'ptv': 'PTV',

        'cannete': 'Canneté',

        // 'parete' RIMOSSO - non è una finitura, è un indicatore di destinazione

        // Convertiti al femminile (accetta sia maschile che femminile da Shopify)

        'lucido': 'Lucida',

        'lucida': 'Lucida',

        // IMPORTANTE: lappatasatinata PRIMA di satinato/satinata per match corretto (contiene "satinata")

        'lappatasatinata': 'Lappata-Satinata',

        'Lappata-Satinata': 'Lappata-Satinata',

        'lappata-satinata': 'Lappata-Satinata',

        'satinato': 'Satinata', 'velvet': 'Velvet', 'Velvet': 'Velvet',

        'satinata': 'Satinata',

        'strutturato': 'Strutturata',

        'strutturata': 'Strutturata',

        'strutturamove': 'Struttura Move',

        'strutturasign': 'Struttura Sign',

        'strutturanet': 'Struttura Net',

        'twist': 'Twist', 'stripe': 'Stripe', 'riga': 'Riga', 'pliss': 'Plissé',

        'bocciardato': 'Bocciardato',  // Eccezione: termine tecnico, resta maschile

        'liscio': 'Liscia',

        'liscia': 'Liscia',

        // 'squadrato' RIMOSSO - non è una finitura, è il tipo di bordo della piastrella

        'levigato': 'Levigata',

        'patinato': 'Patinata',

        'patinata': 'Patinata',

        'levigata': 'Levigata',

        // lappato/lappata DOPO lappatasatinata

        'lappato': 'Lappata',

        'lappata': 'Lappata',

        'spazzolato': 'Spazzolata',

        'spazzolata': 'Spazzolata',

        'Naturalecuoio': 'Naturale Cuoio',

        'naturalecuoio': 'Naturale Cuoio',

        'realupstrideup': 'RealUp+StrideUp',

        'RealUp+StrideUp': 'RealUp+StrideUp',

        'realup': 'RealUp',

        'RealUp': 'RealUp',

        'strideup': 'StrideUp',

        'StrideUp': 'StrideUp',

        'grip': 'Grip',

        'Grip': 'Grip',

        'antislip': 'Antislip',

        'Antislip': 'Antislip',

        'anti slip': 'Antislip',

        'anti-slip': 'Antislip',

        'fade': 'Fade',

        'Fade': 'Fade',

        // T_20 solo se la variante ha effettivamente T_20 nel nome, altrimenti 20mm

        't_20': 'T_20',

        't20': 'T_20',

        '20mm': '20mm'

      };



      // 🎨 Descrizioni per le finiture

      const finitureDescriptions = {

        'Naturale': 'Superficie opaca, non riflettente',

        'Velvet': 'Superficie opaca vellutata, soft-touch',

        'Lucida': 'Superficie brillante e riflettente',

        'Levigata': 'Superficie lucida lavorata',

        'Lappata': 'Superficie semi-lucida satinata',

        'Patinata': 'Superficie patinata, effetto consumato opaco',

        'Satinata': 'Superficie semi-opaca setosa',

        'Strutturata': 'Superficie con texture 3D',

        'Liscia': 'Superficie liscia e uniforme',

        'Bocciardato': 'Superficie antiscivolo lavorata',

        'Soft': 'Superficie morbida al tatto',

        'Opaca': 'Superficie opaca naturale',

        'Comfort': 'Superficie confortevole e sicura',

        'Fluid': 'Design fluido e dinamico',

        'PTV': 'Resistenza allo scivolamento',

        'Canneté': 'Superficie con scanalature',

        'Spazzolata': 'Superficie spazzolata elegante',

        'Naturale Cuoio': 'Texture effetto cuoio',

        'RealUp+StrideUp': 'Superficie 3D con rilievi strutturati',

        'RealUp': 'Superficie 3D materica ad alta definizione',

        'StrideUp': 'Superficie con rilievi strutturati antiscivolo',

        'Grip': 'Superficie antiscivolo per esterni',

        'Antislip': 'Superficie antiscivolo',

        'Fade': 'Superficie con effetto sfumato',

        'Lappata-Satinata': 'Superficie semi-lucida con tocco satinato',

        'T_20': 'Spessore 20mm per esterni, carichi pesanti e posa su ghiaia o piedini',

        '20mm': 'Spessore 20mm per esterni, carichi pesanti e posa su ghiaia o piedini',

        'Standard': 'Finitura classica versatile'

      };



      // Rimuovi suffissi che NON sono finiture prima di cercare la finitura

      // "-parete" indica solo che il prodotto è per pareti interne, non è una finitura

      // "-squadrato" indica il tipo di bordo della piastrella, non è una finitura

      // NOTA: "-lux" È una finitura (Lucida) e NON va rimosso!

      let formatValue = format.value.toLowerCase();

      formatValue = formatValue.replace(/-parete/g, ''); // Rimuovi -parete ovunque (non è una finitura)

      formatValue = formatValue.replace(/-squadrato/g, ''); // Rimuovi -squadrato ovunque (non è una finitura, è il tipo di bordo)

      // NOTA: -lux NON va rimosso perché È una finitura (Lucida)



      let finituraLabel = '';

      for (const [key, label] of Object.entries(finitureNames)) {

        if (formatValue.includes('-' + key) || formatValue.endsWith(key)) {

          finituraLabel = label;

          // Non fermarti su 'naturale' - continua a cercare finiture piu' specifiche (grip, antislip, etc.)
          if (key !== 'naturale' && key !== 'Naturale') break;

        }

      }

      // Se non trova nel value, cerca anche nel label del formato (es: "60x60 24"x24" Levigata Rettificato")

      // NOTA: 'lux' e 'fluid' NON vengono cercati nel label perché possono essere parte del nome colore (es: STATUARIO LUX)

      if (!finituraLabel && format.label) {

        const labelLower = format.label.toLowerCase();

        const finitureEscluseInLabel = ['lux', 'fluid']; // Queste possono essere nomi colore

        for (const [key, label] of Object.entries(finitureNames)) {

          // Salta lux/fluid nella ricerca del label (potrebbero essere nomi colore)

          if (finitureEscluseInLabel.includes(key.toLowerCase())) continue;

          // Cerca la finitura come parola nel label (es: "levigata" in "60x60 24"x24" Levigata Rettificato")

          const keyRegex = new RegExp('\\b' + key + '\\b', 'i');

          if (keyRegex.test(labelLower)) {

            finituraLabel = label;

            break;

          }

        }

      }

      // Se non trova finitura specifica, usa "Naturale" come default

      if (!finituraLabel) finituraLabel = 'Naturale';

      // 🎯 Per ESTERNO con R11+: tutti gli spessori (incluso 20mm/T_20) → unica card "Grip"
      if (currentDestinationFiniture === 'ESTERNO' &&
          format && (format.availableRatings?.R11 || format.availableRatings?.R12 || format.availableRatings?.R13) &&
          (finituraLabel === 'Naturale' || finituraLabel === '20mm' || finituraLabel === 'T_20')) {
        finituraLabel = 'Grip';
      }

      // 🎯 STEP FINITURA: Cerca il prezzo fisso usando il comparePrice della variante CORRETTA

      const currentDestination = window.productConfigurator?.configuration?.destination || this.selectedDestination;

      let finalDisplayPrice = format.displayPrice || format.price;

      let finalDisplayComparePrice = format.displayComparePrice || format.compareAtPrice;



      if (this.product.variants && typeof window.getPrezzoByComparePrice === 'function') {

        const formatBase = format.value.replace(/(?:-naturale|-lucido|-velvet|-satinato|-soft|-matte|-strutturato|-strutturasign|-strutturanet|-strutturamove|-twist|-bocciardato|-liscio|-levigato|-levigata|-patinato|-patinata|-lappato|-lappata|-comfort|-ptv|-parete|-lux|-fluid|-realupstrideup|-realup|-strideup|-grip|-antislip|-fade)+$/g, '');

        const formatDim = formatBase.split('-')[0]; // es: "60x60"



        // 🎯 Estrai la finitura dal format.value (es: "80x80-lucido-parete" → "lucido")

        // IMPORTANTE: lappatasatinata PRIMA di lappata/satinata per match corretto, realupstrideup PRIMA di realup e strideup

        // 🆕 FIX: Aggiunto 'lux' per PURITY of MARBLE (LUX = Lucida)

        const finitureToMatch = ['lappatasatinata', 'lappata-satinata', 'lappata satinata', 'cannete', 'velvet', 'lucido', 'lucida', 'lux', 'naturale', 'satinato', 'satinata', 'strutturato', 'strutturata', 'bocciardato', 'liscio', 'liscia', 'levigato', 'levigata', 'patinato', 'patinata', 'lappato', 'lappata', 'comfort', 'soft', 'matte', 'grip', 'antislip', 'anti slip', 'anti-slip', 'glossy', 'realupstrideup', 'realup', 'strideup', 'battiscopa', 'fade', 't_20', 't20'];

        let finituraFromFormat = null;

        const formatLower = format.value.toLowerCase();

        for (const fin of finitureToMatch) {

          if (formatLower.includes('-' + fin)) {

            finituraFromFormat = fin;

            break;

          }

        }

        // 🎯 Se non trovato nel value, cerca anche nel label (es: "60x60 24"x24" Levigata Rettificato")

        if (!finituraFromFormat && format.label) {

          const labelLower = format.label.toLowerCase();

          for (const fin of finitureToMatch) {

            const finRegex = new RegExp('\\b' + fin + '\\b', 'i');

            if (finRegex.test(labelLower)) {

              finituraFromFormat = fin;

              break;

            }

          }

        }



        // 🎯 Mapping sinonimi finiture (formato → possibili nomi in variante Shopify)

        // 🔧 FIX: Soft, Satinata e Matte sono finiture DIVERSE, non sinonimi

        // 🆕 FIX: LUX è una finitura specifica per PURITY of MARBLE (varianti contengono "lux")

        const finituraSinonimi = {

          'lucido': ['lucido', 'lucida', 'glossy', 'glossybright'],

          'lucida': ['lucido', 'lucida', 'glossy', 'glossybright'],

          'glossy': ['lucido', 'lucida', 'glossy', 'glossybright'],

          'lux': ['lux'],  // 🆕 PURITY of MARBLE - LUX è finitura separata

          'satinato': ['satinato', 'satinata'],

          'satinata': ['satinato', 'satinata'],

          'soft': ['soft'],

          'naturale': ['naturale', 'natural'],

          'matte': ['matte', 'matt', 'opaco', 'opaca'],

          'strutturato': ['strutturato', 'strutturata', 'structured', 'textured'],

          'strutturata': ['strutturato', 'strutturata', 'structured', 'textured'],

          'grip': ['grip', 'r11', 'antiscivolo'],

          'comfort': ['comfort'],

          'bocciardato': ['bocciardato', 'bush-hammered'],

          'liscio': ['liscio', 'liscia', 'smooth'],

          'liscia': ['liscio', 'liscia', 'smooth'],

          'levigato': ['levigato', 'levigata', 'polished'],

          'levigata': ['levigato', 'levigata', 'polished'],
          'patinato': ['patinato', 'patinata'],
          'patinata': ['patinato', 'patinata'],
          'lappato': ['lappato', 'lappata'],
          'lappata': ['lappato', 'lappata'],

          'cannete': ['cannete', 'canneté', 'cannette'],

          'realupstrideup': ['realupstrideup', 'realup+strideup', 'RealUp+StrideUp', 'realup-strideup', 'RealUp-StrideUp'],

          'realup': ['realup', 'RealUp'],

          'strideup': ['strideup', 'StrideUp'],

          // 🎯 Finiture composte - DEVONO essere cercate con sinonimi corretti

          'lappatasatinata': ['lappata satinata', 'lappata-satinata', 'lappatasatinata'],

          'lappata-satinata': ['lappata satinata', 'lappata-satinata', 'lappatasatinata'],

          'lappata satinata': ['lappata satinata', 'lappata-satinata', 'lappatasatinata']

        };



        // Funzione helper per verificare se la variante matcha la finitura

        const matchesFinitura = (opt1, opt3, finitura) => {

          if (!finitura) return true; // Se non c'è finitura, qualsiasi variante va bene

          const sinonimi = finituraSinonimi[finitura] || [finitura];

          const combined = (opt1 + ' ' + opt3).toLowerCase().replace(/[\s_-]+/g, '');

          return sinonimi.some(sin => combined.includes(sin.toLowerCase().replace(/[\s_-]+/g, '')));

        };



        let targetVariant = null;



        // 🎯 PRIORITÀ 1: Per ESTERNO cerca variante appropriata

        // Se il formato contiene -20mm, cerca SPECIFICAMENTE varianti 20mm

        // Altrimenti cerca varianti R11 (come Grip)

        if (currentDestination === 'ESTERNO') {

          const formatIs20mm = format.value.toLowerCase().includes('-20mm');



          targetVariant = this.product.variants.find(v => {

            const opt1 = (v.option1 || '').toLowerCase();

            const opt3 = (v.option3 || '').toLowerCase();

            const matchFormat = opt1.includes(formatDim);

            const variantIs20mm = opt3.includes('20mm') || opt3.includes('20 mm') || opt1.includes('20mm') || opt1.includes('20 mm') || opt1.includes('t_20') || opt1.includes('t20');

            const isR11 = opt3.includes('r11') || opt1.includes('r11');



            // 🔧 FIX: Se il formato è specificamente -20mm, cerca SOLO varianti 20mm

            if (formatIs20mm) {

              if (finituraFromFormat) {

                return matchFormat && matchesFinitura(opt1, opt3, finituraFromFormat) && variantIs20mm;

              }

              return matchFormat && variantIs20mm;

            }



            // Se il formato NON è 20mm (es: -grip), cerca varianti R11 ma NON 20mm

            if (finituraFromFormat) {

              return matchFormat && matchesFinitura(opt1, opt3, finituraFromFormat) && isR11 && !variantIs20mm;

            }

            return matchFormat && isR11 && !variantIs20mm;

          });

        }



        // 🆕 PRIORITÀ 1B: Per INTERNO_SOLO_PARETE cerca variante con PARETE nel colore

        // Questo assicura che il prezzo mostrato sia quello dei colori PARETE (es. Kaleido)

        if (!targetVariant && currentDestination === 'INTERNO_SOLO_PARETE') {

          const isPareteFormat = format.value.toLowerCase().includes('-parete');

          if (isPareteFormat) {

            targetVariant = this.product.variants.find(v => {

              const opt1 = (v.option1 || '').toLowerCase();

              const opt2 = (v.option2 || '').toLowerCase();

              const matchFormat = opt1.includes(formatDim);

              const hasParete = opt2.includes('parete') || opt2.includes('kaleido') || opt2.includes('fluid') || opt2.includes('line') || opt2.includes('ribbed');

              if (finituraFromFormat) {

                return matchFormat && matchesFinitura(opt1, v.option3 || '', finituraFromFormat) && hasParete;

              }

              return matchFormat && hasParete;

            });

            if (targetVariant) {


            }

          }

        }



        // PRIORITÀ 2: Cerca variante che matcha formato + finitura (con sinonimi)

        // Per INTERNO o se non trovata variante 20mm/R11 per ESTERNO

        if (!targetVariant && finituraFromFormat) {

          // Per INTERNO: preferisci varianti non-20mm (9mm), fallback su 20mm se non trovate
          if (currentDestination === 'INTERNO') {
            targetVariant = this.product.variants.find(v => {
              const opt1 = (v.option1 || '').toLowerCase();
              const opt3 = (v.option3 || '').toLowerCase();
              const is20mm = opt3.includes('20mm') || opt3.includes('20 mm') || opt1.includes('20mm') || opt1.includes('20 mm');
              return !is20mm && opt1.includes(formatDim) && matchesFinitura(opt1, opt3, finituraFromFormat);
            });
          }

          // Fallback: cerca qualsiasi variante (incluso 20mm)
          if (!targetVariant) {
            targetVariant = this.product.variants.find(v => {
              const opt1 = (v.option1 || '').toLowerCase();
              const opt3 = (v.option3 || '').toLowerCase();
              return opt1.includes(formatDim) && matchesFinitura(opt1, opt3, finituraFromFormat);
            });
          }

        }



        // 🔧 FIX: Per formati base senza suffisso, cerca PRIMA varianti Matte

        // PRIORITÀ 3A: Cerca variante Matte per formato base

        if (!targetVariant && !finituraFromFormat) {

          targetVariant = this.product.variants.find(v => {

            const opt1 = (v.option1 || '').toLowerCase();

            const matchFormat = opt1.includes(formatDim);

            return matchFormat && (/\bmatte?\b/i.test(opt1) || opt1.includes('opaco'));

          });

          if (targetVariant) {

            finituraFromFormat = 'matte';

            finituraLabel = 'Opaca';


          }

        }



        // PRIORITÀ 3B: Fallback - cerca variante base per questo formato

        if (!targetVariant) {

          const isLuxFormat = format.value && format.value.includes('-lux');

          targetVariant = this.product.variants.find(v => {

            const opt1 = (v.option1 || '').toLowerCase();

            const hasLux = opt1.includes('lux');

            // Per formati standard (senza finitura), escludi varianti con finitura nel nome
            const hasFinituraInOpt1 = /\b(anti\s*slip|grip|antislip)\b/i.test(opt1);
            if (!finituraFromFormat && hasFinituraInOpt1) return false;

            // Per formati non-LUX, escludi varianti LUX. Per formati LUX, preferisci varianti LUX.

            return opt1.includes(formatDim) && (isLuxFormat ? hasLux : !hasLux);

          });

        }



        // 🔧 FIX: Aggiorna finituraLabel SOLO se non è già stato impostato (es. Matte)

        // NON sovrascrivere se il formato era intenzionalmente base/matte


        if (finituraLabel === 'Naturale' && !finituraFromFormat && targetVariant && targetVariant.option1) {

          const opt1Lower = targetVariant.option1.toLowerCase();

          for (const fin of finitureToMatch) {

            const finRegex = new RegExp('\\b' + fin + '\\b', 'i');

            if (finRegex.test(opt1Lower)) {

              finituraLabel = finitureNames[fin] || fin.charAt(0).toUpperCase() + fin.slice(1);

              finituraFromFormat = fin;


              break;

            }

          }

        }



        if (targetVariant && targetVariant.compare_at_price) {

          // Passa finitura e formato a getPrezzoByComparePrice per match preciso

          const prezzoFisso = window.getPrezzoByComparePrice(targetVariant.compare_at_price, this.product.title, finituraFromFormat || 'base', formatDim);

          if (prezzoFisso) {

            // Moltiplica per 100 per convertire in centesimi

            finalDisplayPrice = prezzoFisso.prezzo * 100;

            finalDisplayComparePrice = prezzoFisso.comparePrice * 100;

            // 🎯 Per INTERNO: forza aggiornamento se targetVariant ha prezzo diverso (es. antislip 9mm vs 20mm)
            // Per altri casi: mantieni aggregazione se già settata
            const shouldUpdate = !format.displayPrice || format.displayPrice === format.price ||
              (currentDestination === 'INTERNO' && Math.abs(finalDisplayPrice - format.displayPrice) > 100);

            if (shouldUpdate) {

              format.displayPrice = finalDisplayPrice;

              format.displayComparePrice = finalDisplayComparePrice;

            }


          }

        }

      }




      // 🔧 Salva finituraLabel nel dataset della card per il riepilogo

      card.dataset.finituraLabel = finituraLabel;

      card.dataset.khPriceSort = String((format.displayPrice || format.price || 999999999));



      // Escape finituraLabel per uso in attributi HTML

      const safeFinituraLabel = (finituraLabel || '').replace(/'/g, "\\'");



      card.innerHTML = `

        <div style="display: flex; align-items: center; justify-content: center; padding: 1rem 0; ${heightStyle}; width: 100%; overflow: visible !important; clip-path: none !important;">

          ${svgTile}

        </div>

        <button class="fx-format-info-btn"

                onclick="event.stopPropagation(); event.preventDefault();

        if (window.innerWidth <= 768) { window.ConfiguratoreDataUniversal.showFormatInfo('${safeFormatValue}', '${safeFormatLabel}', 'finitura', '${safeFinituraLabel}'); } return false;"

                ontouchstart="event.stopPropagation(); event.preventDefault();

        window.ConfiguratoreDataUniversal.showFormatInfo('${safeFormatValue}', '${safeFormatLabel}', 'finitura', '${safeFinituraLabel}'); return false;"

                onmouseenter="event.stopPropagation();

        if (window.innerWidth > 768) { window.ConfiguratoreDataUniversal.showFormatInfo('${safeFormatValue}', '${safeFormatLabel}', 'finitura', '${safeFinituraLabel}'); }"

                style="position: absolute; top: 8px; left: 8px; width: 32px; height: 32px;

                       background: white; border: 1px solid #ddd; border-radius: 50%;

                       display: flex; align-items: center; justify-content: center;

                       cursor: pointer; box-shadow: 0 2px 8px rgba(0,0,0,0.1);

                       z-index: 10;">

          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">

            <circle cx="12" cy="12" r="10" stroke="#2D5A3D" stroke-width="2"/>

            <path d="M12 16v-4M12 8h.01" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round"/>

          </svg>

        </button>

      `;



      // Aggiungi info con prezzo

      // Usa descrizione finitura se disponibile, altrimenti format.description

      const finituraDescription = finitureDescriptions[finituraLabel] || format.description || '';

      const toTitleCase = (str) => str.toLowerCase().replace(/\b\w/g, c => c.toUpperCase());

      const rawProductType = this.product ? (this.product.product_type || this.product.type || '') : '';

      const productTypeValue = rawProductType ? toTitleCase(rawProductType) : '';

      // Se product_type non disponibile, lo recupera via API e aggiorna i placeholder

      if (!productTypeValue && !window._productTypeFetched) {

        window._productTypeFetched = true;

        const handle = (this.product && this.product.handle) || window.location.pathname.split('/products/')[1]?.split('?')[0]?.split('#')[0];

        if (handle) {

          fetch('/products/' + handle + '.json')

            .then(r => r.json())

            .then(data => {

              const pType = data?.product?.product_type || '';

              if (pType && this.product) {

                this.product.product_type = pType;

                const titleCased = toTitleCase(pType);

                document.querySelectorAll('.fx-product-type-placeholder').forEach(el => {

                  el.textContent = titleCased;

                  el.style.display = '';

                });

              }

            })

            .catch(() => {});

        }

      }

      card.innerHTML += `

        <div class="fx-style-info">

          <div class="fx-price-container" style="width: 100%; text-align: center; background: rgba(248,249,250,0.95); border-radius: 12px; padding: 0.75rem 0.5rem; min-height: 112px; border: none; border-top: 1px solid #ebebeb; position: relative; overflow: visible; transition: var(--fx-transition, all 0.3s cubic-bezier(0.4, 0, 0.2, 1)); margin: 0; box-sizing: border-box;">

            <h4 style="margin: 0 0 0.25rem 0; color: var(--fx-text, #2d3436); font-size: 1.1rem; font-weight: 700; letter-spacing: -0.02em; font-family: var(--fx-font, 'Jost', -apple-system, BlinkMacSystemFont, sans-serif);">${finituraLabel}</h4>

            <p class="fx-product-type-placeholder" style="margin: 0 0 0.15rem 0; color: var(--fx-primary, #2D5A3D); font-size: 0.75rem; font-weight: 600; letter-spacing: 0.03em; font-family: var(--fx-font, 'Jost', -apple-system, BlinkMacSystemFont, sans-serif); ${productTypeValue ? '' : 'display: none;'}">${productTypeValue}</p>

            <p style="margin: 0 0 0.5rem 0; color: var(--fx-text-muted, #636e72); font-size: 0.85rem; font-family: var(--fx-font, 'Jost', -apple-system, BlinkMacSystemFont, sans-serif);">${finituraDescription}</p>

            ${format.price ? `

              <div class="fx-price-row" style="display: flex; align-items: center; justify-content: center; gap: 0.5rem; flex-wrap: wrap;">

                <span class="fx-price" style="font-weight: 800; color: var(--fx-primary, #2D5A3D); font-size: 1.3rem; line-height: 1; font-family: var(--fx-font, 'Jost', -apple-system, BlinkMacSystemFont, sans-serif); letter-spacing: -0.02em;">

                  ${currentDestinationFiniture === 'BATTISCOPA' ? this.formatMoney(format.price) : this.formatMoney(format.displayPrice || format.price)}<span style="font-size: 0.8em; font-weight: inherit;">${currentDestinationFiniture === 'BATTISCOPA' ? '/scatola' : priceUnitFiniture}</span>

                </span>

                ${currentDestinationFiniture === 'BATTISCOPA' ? (format.compareAtPrice && format.compareAtPrice > format.price ? `
                  <span class="fx-step-price-was">
                    ${this.formatMoney(format.compareAtPrice)}
                  </span>
                ` : '') : (format.displayComparePrice ? `

                  <span class="fx-step-price-was">

                    ${this.formatMoney(format.displayComparePrice)}

                  </span>

                ` : format.compareAtPrice && format.compareAtPrice > format.price ? `

                  <span class="fx-step-price-was">

                    ${this.formatMoney(format.compareAtPrice)}

                  </span>

                ` : '')}

              </div>

              ${currentDestinationFiniture === 'BATTISCOPA' ? (format.compareAtPrice && format.compareAtPrice > format.price ? `
                
              ` : '') : (format.displayComparePrice ? `

                

              ` : format.compareAtPrice && format.compareAtPrice > format.price ? `

                

              ` : '')}

              ${currentDestinationFiniture === 'BATTISCOPA' ? `<span class="fx-box-price" style="display:block;font-size:0.75rem;color:#b2bec3;font-weight:700;margin-top:0.25rem;text-align:center;font-family:var(--fx-font,Jost,sans-serif);">IVA incl.</span>` : `<span class="fx-box-price" style="display:block;font-size:0.75rem;color:#b2bec3;font-weight:700;margin-top:0.25rem;text-align:center;font-family:var(--fx-font,Jost,sans-serif);">${this.formatMoney(window.khScatolaPerMq(format.displayPrice||format.price, format.price))}/scatola · IVA incl.</span>`}

            ` : ''}

          </div>

        </div>

      `;



      // Gestione click singolo e doppio (come in populateFormats)

      let clickCount = 0;

      let clickTimer = null;



      const handleSelection = () => {

        // Rimuovi selezione da tutte le card

        container.querySelectorAll('.fx-style-card').forEach(c => {

          c.classList.remove('selected');

          c.style.borderColor = 'transparent';

        });



        // Seleziona questa card

        card.classList.add('selected');

        card.style.borderColor = '#2D5A3D';



        // Salva il formato completo selezionato

        this.selectedFormat = format.value;

        this.selectedFinitura = format.value;

        if (window.productConfigurator?.configuration) {

          window.productConfigurator.configuration.format = format.value;

          window.productConfigurator.configuration.finitura = format.value;

          // 🔧 Salva anche il label della finitura per il riepilogo

          window.productConfigurator.configuration.finituraLabel = card.dataset.finituraLabel || 'Naturale';

        }



        // 🎯 FILTRA I COLORI in base al formato+finitura selezionato

        this.filterColorsByFormat(format.value);



        // Abilita pulsante avanti

        if (nextBtn3) nextBtn3.disabled = false;

      };



      const proceedToNext = () => {

        handleSelection();

        if (nextBtn3) {

          nextBtn3.disabled = false;

          setTimeout(() => nextBtn3.click(), 50);

        }

      };



      // Gestione unificata per click e tap

      card.addEventListener('click', function(e) {

        clickCount++;



        if (clickCount === 1) {

          // Primo click/tap

          clickTimer = setTimeout(() => {

            // Click singolo

            handleSelection();

            clickCount = 0;

          }, 250);

        } else if (clickCount === 2) {

          // Doppio click/tap

          clearTimeout(clickTimer);

          proceedToNext();

          clickCount = 0;

        }

      });



      // Previeni doppio tap zoom su iOS

      card.addEventListener('touchstart', function(e) {

        if (e.touches.length > 1) {

          e.preventDefault();

        }

      });



      container.appendChild(card);

    });

    // 🎯 Ri-ordina le card per il PREZZO realmente mostrato (crescente): la piu economica prima
    try {
      var _khCards = Array.prototype.slice.call(container.children).filter(function(c){ return c.dataset && c.dataset.khPriceSort; });
      _khCards.sort(function(a,b){ return parseFloat(a.dataset.khPriceSort) - parseFloat(b.dataset.khPriceSort); });
      _khCards.forEach(function(c){ container.appendChild(c); });
    } catch(e){}




    this.addDiscountBadgesToStep(container);



  },



  // Filtra i colori disponibili in base alla finitura selezionata

  filterColorsByFinitura(finitura, formatoDimensionale) {

    // Costruisci il pattern del formato completo (dimensione + finitura)

    const formatoCompleto = finitura === 'standard' || finitura === 'naturale'

      ? formatoDimensionale

      : `${formatoDimensionale}-${finitura}`;



    // Aggiorna il formato selezionato con la finitura

    this.selectedFormat = formatoCompleto;

    if (window.productConfigurator?.configuration) {

      window.productConfigurator.configuration.format = formatoCompleto;

    }

  },



  // Ricostruisce lo step dei colori con il formato attuale

  renderColorStep() {

    const container = document.getElementById('fxVariantsContainer');

    if (!container) {

      return;

    }



    // Salva il colore selezionato se c'è

    const selectedColor = container.querySelector('.fx-style-card.selected')?.dataset.color;

    

    // Pulisci e ripopola

    container.innerHTML = '';

    this.populateColors();

    

    // Ripristina la selezione se c'era

    if (selectedColor) {

      const cardToSelect = container.querySelector(`[data-color="${selectedColor}"]`);

      if (cardToSelect) {

        cardToSelect.classList.add('selected');

        cardToSelect.style.borderColor = '#2D5A3D';

      }

    }

  },

  

  // Popola i colori nello step 4 (dopo la selezione della finitura)

  populateColors() {

    this.applyDisplayPrices();



    const container = document.getElementById('fxVariantsContainer');

    if (!container) {

      return;

    }



    container.innerHTML = '';



    // Usa i colori filtrati se disponibili, altrimenti tutti i colori

    let colorsToShow = this.filteredColorOptions || this.colorOptions;



    // 🎯 ORDINA I COLORI DAL MENO CARO AL PIÙ COSTOSO (solo step 3)

    const selectedFormat = window.productConfigurator?.configuration?.format || this.selectedFormat;

    if (selectedFormat && typeof window.getPrezzoFissoM2 === 'function') {

      let formatBase = selectedFormat.replace('-parete', '').replace('-fluid', '').replace('-Naturale', '').replace('-naturale', '');



      // 🎯 Determina lo spessore in base alla destinazione

      const savedDestination = window.productConfigurator?.configuration?.destination || this.selectedDestination;



      // Pre-calcola i prezzi per ogni colore per poter ordinare

      colorsToShow = colorsToShow.map(color => {

        let prezziFissi = null;

        let spessoreUsato = null;



        if (savedDestination === 'ESTERNO') {

          // Per ESTERNO: prova prima 20mm, poi 9mmr11, poi r11, poi grip

          prezziFissi = window.getPrezzoFissoM2(formatBase, this.product.title, color.label, '20mm');

          if (prezziFissi) spessoreUsato = '20mm';



          if (!prezziFissi) {

            prezziFissi = window.getPrezzoFissoM2(formatBase, this.product.title, color.label, '9mmr11');

            if (prezziFissi) spessoreUsato = '9mmr11';

          }



          if (!prezziFissi) {

            prezziFissi = window.getPrezzoFissoM2(formatBase, this.product.title, color.label, 'r11');

            if (prezziFissi) spessoreUsato = 'r11';

          }



          // 🎯 FIX AUTHENTIC LUXE: Per alcuni prodotti ESTERNO usa finitura "grip"

          if (!prezziFissi) {

            prezziFissi = window.getPrezzoFissoM2(formatBase + '-grip', this.product.title, color.label, null);

            if (prezziFissi) spessoreUsato = 'grip';

          }

        } else {

          // Per INTERNO: usa chiave standard

          prezziFissi = window.getPrezzoFissoM2(formatBase, this.product.title, color.label, null);

          spessoreUsato = 'default';

        }



        return {

          ...color,

          _sortPrice: prezziFissi ? prezziFissi.prezzo : (color.price || 999999) // Usa prezzo fisso o fallback

        };

      });



      // Ordina per prezzo crescente

      colorsToShow.sort((a, b) => a._sortPrice - b._sortPrice);

    }



    // Disabilita il pulsante Continua inizialmente (step 4 Colore → Spessore)

    const nextBtn4 = document.getElementById('fxNext4');

    if (nextBtn4) nextBtn4.disabled = true;



    // Assicurati che nessuna carta sia selezionata di default

    setTimeout(() => {

      container.querySelectorAll('.fx-style-card').forEach(card => {

        card.classList.remove('selected');

      });

    }, 10);



    if (colorsToShow.length === 0) {

      container.innerHTML = '<p style="color: var(--fx-text-muted); text-align: center; padding: 2rem;">Nessun colore disponibile per questo formato</p>';

      return;

    }



    // Variabile per tracciare l'ultimo tap (fuori dal loop)

    let lastTapTime = 0;



    /* KH-A04-ACC-SORT: accessori (senza prezzo fisso/_sortPrice) -> ordina per prezzo variante crescente, cosi il default e' la finitura piu economica */
      if (colorsToShow && colorsToShow.length && (colorsToShow[0]._sortPrice === undefined || colorsToShow[0]._sortPrice === null)) {
        colorsToShow = colorsToShow.slice().sort(function(a,b){ return (a.price != null ? a.price : 999999999) - (b.price != null ? b.price : 999999999); });
      }
      colorsToShow.forEach((color, index) => {

      const card = document.createElement('div');

      card.className = 'fx-style-card'; // Non aggiungere 'selected'

      card.dataset.color = color.value;

      card.style.animationDelay = `${index * 0.02}s`;

      card.style.borderColor = 'transparent'; // Forza bordo trasparente inizialmente



      // Genera visualizzazione basata sul formato selezionato

      let visual = '';

      // Prendi il formato selezionato dal configuratore o dalla proprietà salvata

      const selectedFormatValue = window.productConfigurator?.configuration?.format || this.selectedFormat;



      // Trova il prezzo corretto per questa combinazione formato-colore

      let currentPrice = color.price;

      let currentCompareAtPrice = color.compareAtPrice;
      /* FIX 25-06: scatola colore = stessa variante del €/mq (finish-aware) */
      try { var _afCol = this.selectedFormat || (window.productConfigurator && window.productConfigurator.configuration && window.productConfigurator.configuration.format); var _destCol = (window.productConfigurator && window.productConfigurator.configuration && window.productConfigurator.configuration.destination) || this.selectedDestination; if (typeof window.getPrezzoFissoM2==='function' && _destCol!=='BATTISCOPA' && _afCol) { var _pfCol=window.getPrezzoFissoM2(_afCol, this.product.title, (color.label||color.name||color.value), null, color.sku); if (_pfCol && _pfCol.scatola!=null) { currentPrice=_pfCol.scatola; currentCompareAtPrice=null; } } } catch(e){}

      let displayPrice = null; // Prezzo FISSO per visualizzazione

      let displayComparePrice = null;



      // Assicurati che il formato selezionato sia davvero quello giusto

      const actualSelectedFormat = this.selectedFormat || window.productConfigurator?.configuration?.format;

      const currentDestination = window.productConfigurator?.configuration?.destination || this.selectedDestination;



      // 🎯 Trova la variante CORRETTA per formato + colore + finitura + destinazione
      let targetVariant = null;

      if (this.product.variants && typeof window.getPrezzoByComparePrice === 'function') {

        const formatBase = (actualSelectedFormat || '').replace(/(?:-naturale|-lucido|-velvet|-satinato|-soft|-matte|-strutturato|-strutturasign|-strutturanet|-strutturamove|-twist|-bocciardato|-liscio|-levigato|-levigata|-patinato|-patinata|-lappato|-lappata|-comfort|-ptv|-parete|-lux|-fluid|-realupstrideup|-realup|-strideup|-grip|-antislip|-fade)+$/g, '');

        const formatDim = formatBase.split('-')[0]; // es: "60x60"



        // 🎯 Estrai la finitura dal formato selezionato (es: "80x80-lucido-parete" → "lucido")

        // IMPORTANTE: lappatasatinata PRIMA di lappata/satinata per match corretto, realupstrideup PRIMA di realup e strideup

        // 🆕 FIX: Aggiunto 'lux' per PURITY of MARBLE (LUX = Lucida)

        const finitureToMatch = ['lappatasatinata', 'lappata-satinata', 'lappata satinata', 'cannete', 'velvet', 'lucido', 'lucida', 'lux', 'naturale', 'satinato', 'satinata', 'strutturato', 'strutturata', 'bocciardato', 'liscio', 'liscia', 'levigato', 'levigata', 'patinato', 'patinata', 'lappato', 'lappata', 'comfort', 'soft', 'matte', 'grip', 'antislip', 'anti slip', 'anti-slip', 'glossy', 'realupstrideup', 'realup', 'strideup', 'battiscopa', 'fade', 't_20', 't20'];

        let finituraFromFormat = null;

        /* KH-FIX 13-07: allo step COLORE la finitura scelta sta in configuration.finitura ("60x60-lappata"), non in actualSelectedFormat ("60x60") -> preferisci quella */
        const _selFin = (window.productConfigurator && window.productConfigurator.configuration && window.productConfigurator.configuration.finitura) || '';
        const formatLower = (_selFin || (actualSelectedFormat || '')).toLowerCase();

        for (const fin of finitureToMatch) {

          if (formatLower.includes('-' + fin)) {

            finituraFromFormat = fin;

            break;

          }

        }



        // 🎯 Mapping sinonimi finiture (formato → possibili nomi in variante Shopify)

        // IMPORTANTE: ordine matters - realupstrideup DEVE essere prima di realup per match corretto

        // 🔧 FIX: Soft, Satinata e Matte sono finiture DIVERSE, non sinonimi

        // 🆕 FIX: LUX è una finitura specifica per PURITY of MARBLE (varianti contengono "lux")

        const finituraSinonimi = {

          'lucido': ['lucido', 'lucida', 'glossy', 'glossybright'],

          'lucida': ['lucido', 'lucida', 'glossy', 'glossybright'],

          'glossy': ['lucido', 'lucida', 'glossy', 'glossybright'],

          'lux': ['lux'],  // 🆕 PURITY of MARBLE - LUX è finitura separata

          'satinato': ['satinato', 'satinata'],

          'satinata': ['satinato', 'satinata'],

          'soft': ['soft'],

          'naturale': ['naturale', 'natural'],

          'matte': ['matte', 'matt', 'opaco', 'opaca'],

          'strutturato': ['strutturato', 'strutturata', 'structured', 'textured'],

          'strutturata': ['strutturato', 'strutturata', 'structured', 'textured'],

          'grip': ['grip', 'r11', 'antiscivolo'],

          'comfort': ['comfort'],

          'bocciardato': ['bocciardato', 'bush-hammered'],

          'liscio': ['liscio', 'liscia', 'smooth'],

          'liscia': ['liscio', 'liscia', 'smooth'],

          'cannete': ['cannete', 'canneté', 'cannette'],

          // 🎯 Finiture ITALGRANITI - I TRAVERTINI

          'realupstrideup': ['realupstrideup', 'realup+strideup', 'realup strideup', 'realup-strideup', 'RealUp-StrideUp'],

          'realup': ['realup'],

          'patinato': ['patinato', 'patinata'],

          'patinata': ['patinato', 'patinata'],
          'lappato': ['lappato', 'lappata'],
          'lappata': ['lappato', 'lappata'],

          'strideup': ['strideup', 'stride up'],

          'antislip': ['antislip', 'anti-slip', 'anti slip'],

          // 🎯 Finiture composte - DEVONO essere cercate con sinonimi corretti

          'lappatasatinata': ['lappata satinata', 'lappata-satinata', 'lappatasatinata'],

          'lappata-satinata': ['lappata satinata', 'lappata-satinata', 'lappatasatinata'],

          'lappata satinata': ['lappata satinata', 'lappata-satinata', 'lappatasatinata']

        };



        // Funzione helper per verificare se la variante matcha la finitura

        const matchesFinitura = (opt1, opt3, finitura) => {

          if (!finitura) return true;

          const sinonimi = finituraSinonimi[finitura] || [finitura];

          const combined = (opt1 + ' ' + opt3).toLowerCase().replace(/[\s_-]+/g, '');

          return sinonimi.some(sin => combined.includes(sin.toLowerCase().replace(/[\s_-]+/g, '')));

        };



        targetVariant = null;



        // 🎯 PRIORITÀ 1A: Per INTERNO cerca variante con prezzo PIÙ BASSO (qualsiasi rating)

        // 🔧 FIX 21-GEN-2026: Non filtrare per R9/R10, trova il prezzo minimo

        if (currentDestination === 'INTERNO') {

          const matchingVariants = this.product.variants.filter(v => {

            const opt1 = (v.option1 || '').toLowerCase();

            const opt2 = (v.option2 || '').toUpperCase();

            const opt3 = (v.option3 || '').toLowerCase();

            const matchFormat = opt1.includes(formatDim);

            const matchColor = opt2 === color.value.toUpperCase() || opt2 === color.label.toUpperCase();

            // Per INTERNO: escludi varianti 20mm con antislip/grip (vanno in ESTERNO)
            const variantText = (opt1 + ' ' + opt3).toLowerCase();
            const is20mm = /\b20\s*mm\b/.test(variantText) || /\b2\s*cm\b/.test(variantText);
            const hasAntislipGrip = variantText.includes('antislip') || variantText.includes('anti slip') || variantText.includes('grip');
            if (is20mm && hasAntislipGrip) return false;

            if (finituraFromFormat) {

              return matchFormat && matchColor && matchesFinitura(opt1, opt3, finituraFromFormat) && v.unit_price != null;

            }

            return matchFormat && matchColor && v.unit_price != null;

          });

          // Trova la variante con comparePrice più basso

          if (matchingVariants.length > 0) {

            targetVariant = matchingVariants.reduce((min, v) =>

              (v.unit_price < min.unit_price) ? v : min

            );


          }

        }



        // 🎯 PRIORITÀ 1B: Per ESTERNO cerca varianti con R11/R12/R13 (o 20mm SENZA R9/R10)

        // Questo deve venire PRIMA della ricerca generica per evitare di matchare varianti R9

        // 🔧 FIX 21-GEN-2026: Escludi esplicitamente varianti con R9/R10 (anche se 20mm)

        // 🔧 FIX 22-GEN-2026: Logica flessibile per ESTERNO

        // - Se formato è -20mm → cerca SOLO varianti 20mm

        // - Se formato ha finitura specifica (grip, antislip, ecc.) → usa matchesFinitura (funziona per 9mm o 20mm)

        // - Solo se nessuna finitura e non 20mm → escludi 20mm per evitare match errati

        if (currentDestination === 'ESTERNO' && !targetVariant) {

          const isFormat20mm = actualSelectedFormat.toLowerCase().includes('-20mm');



          targetVariant = this.product.variants.find(v => {

            const opt1 = (v.option1 || '').toLowerCase();

            const opt2 = (v.option2 || '').toUpperCase();

            const opt3 = (v.option3 || '').toLowerCase();

            const variantText = opt1 + ' ' + opt3;

            const matchFormat = opt1.includes(formatDim);

            const matchColor = opt2 === color.value.toUpperCase() || opt2 === color.label.toUpperCase();

            const variantIs20mm = /\b20\s*mm\b/.test(variantText) || variantText.includes('t_20') || variantText.includes('t20');

            const hasR11plus = /\br11\b|\br12\b|\br13\b/i.test(variantText);



            // 🎯 CASO 1: Se il formato selezionato è -20mm, cerca SOLO varianti 20mm

            if (isFormat20mm) {

              if (finituraFromFormat) {

                return matchFormat && matchColor && matchesFinitura(opt1, opt3, finituraFromFormat) && variantIs20mm && v.unit_price != null;

              }

              return matchFormat && matchColor && variantIs20mm && v.unit_price != null;

            }



            // 🎯 CASO 2: Se c'è una finitura specifica (grip, antislip, ecc.), usa matchesFinitura

            // NON escludere 20mm - se la finitura è "grip 20mm", la troverà correttamente

            if (finituraFromFormat) {

              return matchFormat && matchColor && matchesFinitura(opt1, opt3, finituraFromFormat) && hasR11plus && v.unit_price != null;

            }



            // 🎯 CASO 3: Nessuna finitura e non 20mm → cerca R11 generico, escludendo 20mm per evitare confusione

            return matchFormat && matchColor && hasR11plus && !variantIs20mm && v.unit_price != null;

          });

          if (targetVariant) {

            const variantType = isFormat20mm ? '20mm' : (finituraFromFormat || 'R11');


          }

        }



        // PRIORITÀ 2: Cerca variante che matcha formato + colore + finitura (con sinonimi)

        // Fallback se PRIORITÀ 1 non ha trovato nulla

        if (!targetVariant && finituraFromFormat) {

          targetVariant = this.product.variants.find(v => {

            const opt1 = (v.option1 || '').toLowerCase();

            const opt2 = (v.option2 || '').toUpperCase();

            const opt3 = (v.option3 || '').toLowerCase();

            const matchFormat = opt1.includes(formatDim);

            const matchColor = opt2 === color.value.toUpperCase() || opt2 === color.label.toUpperCase();

            return matchFormat && matchColor && matchesFinitura(opt1, opt3, finituraFromFormat);

          });

        }



        // PRIORITÀ 3: Fallback - cerca variante base per formato + colore

        if (!targetVariant) {

          targetVariant = this.product.variants.find(v => {

            const opt1 = (v.option1 || '').toLowerCase();

            const opt2 = (v.option2 || '').toUpperCase();

            const matchFormat = opt1.includes(formatDim);

            const matchColor = opt2 === color.value.toUpperCase() || opt2 === color.label.toUpperCase();

            return matchFormat && matchColor;

          });

        }



        // 🔧 Aggiorna finituraFromFormat da targetVariant.option1 se non ancora estratta

        if (targetVariant && !finituraFromFormat) {

          const opt1Lower = (targetVariant.option1 || '').toLowerCase();

          // IMPORTANTE: lappatasatinata/lappata-satinata PRIMA di lappata/satinata per match corretto

          // 🔧 FIX 22-GEN-2026: Aggiunto t_20 e t20 per varianti 20mm outdoor

          // 🆕 FIX: Aggiunto 'lux' per PURITY of MARBLE

          const finitureToCheck = ['lappatasatinata', 'lappata-satinata', 'lappata satinata', 'levigato', 'levigata', 'patinato', 'patinata', 'lappato', 'lappata', 'lucido', 'lucida', 'lux', 'satinato', 'satinata', 'naturale', 'strutturato', 'strutturata', 'bocciardato', 'liscio', 'liscia', 'realupstrideup', 'realup', 'strideup', 'grip', 'antislip', 'anti slip', 'anti-slip', 't_20', 't20'];

          for (const fin of finitureToCheck) {

            const finRegex = new RegExp('\\b' + fin.replace('_', '[_\\s]?') + '\\b', 'i');

            if (finRegex.test(opt1Lower)) {

              finituraFromFormat = fin;


              break;

            }

          }

        }



        if (targetVariant) { try { var _kuC = window.__KH_UNIT__ && window.__KH_UNIT__[targetVariant.id]; if (_kuC && _kuC.p) displayPrice = _kuC.p; if (targetVariant.price != null) currentPrice = parseInt(targetVariant.price) || currentPrice; } catch(e){} } /* KH-COL */
        if (targetVariant && targetVariant.compare_at_price) {

          // Passa finitura, formato e colore a getPrezzoByComparePrice per match preciso

          const prezzoFisso = window.getPrezzoByComparePrice(targetVariant.compare_at_price, this.product.title, finituraFromFormat || 'base', formatDim, color.label);

          if (prezzoFisso) {

            // Moltiplica per 100 per convertire in centesimi

            displayPrice = prezzoFisso.prezzo * 100;

            displayComparePrice = prezzoFisso.comparePrice * 100;


          }

        }

      }



      // 🎯 FALLBACK: usa getPrezzoFissoM2 se non trovato con comparePrice

      if (!displayPrice && actualSelectedFormat && typeof window.getPrezzoFissoM2 === 'function') {

        let formatBase = actualSelectedFormat;

        // 🔧 FIX PURITY of MARBLE: NON rimuovere -lux (è finitura Lucida con prezzi diversi)

        formatBase = formatBase.replace('-parete', '').replace('-fluid', '');



        // 🎯 Determina lo spessore in base alla destinazione

        const currentDestination = window.productConfigurator?.configuration?.destination || this.selectedDestination;



        // Per ESTERNO: prova prima 20mm, poi 9mmr11, poi r11

        let prezziFissi = null;

        let spessoreUsato = null;



        if (currentDestination === 'ESTERNO') {

          // Prova con 20mm

          prezziFissi = window.getPrezzoFissoM2(formatBase, this.product.title, color.label, '20mm');

          if (prezziFissi) spessoreUsato = '20mm';



          // Se non trovato, prova con 9mmr11

          if (!prezziFissi) {

            prezziFissi = window.getPrezzoFissoM2(formatBase, this.product.title, color.label, '9mmr11');

            if (prezziFissi) spessoreUsato = '9mmr11';

          }



          // Se non trovato, prova con r11

          if (!prezziFissi) {

            prezziFissi = window.getPrezzoFissoM2(formatBase, this.product.title, color.label, 'r11');

            if (prezziFissi) spessoreUsato = 'r11';

          }



          // 🎯 FIX AUTHENTIC LUXE: Per alcuni prodotti ESTERNO usa finitura "grip"

          if (!prezziFissi) {

            prezziFissi = window.getPrezzoFissoM2(formatBase + '-grip', this.product.title, color.label, null);

            if (prezziFissi) spessoreUsato = 'grip';

          }

        } else {

          // Per INTERNO: usa chiave standard (senza spessore speciale)

          prezziFissi = window.getPrezzoFissoM2(formatBase, this.product.title, color.label, null);

          spessoreUsato = 'default';

        }



        if (prezziFissi) {

          // Moltiplica per 100 per convertire in centesimi

          displayPrice = prezziFissi.prezzo * 100;

          displayComparePrice = prezziFissi.comparePrice * 100;


        } else {


        }

      }



      if (actualSelectedFormat && this.product.variants) {



        // Cerca la variante specifica per questo formato e colore

        let foundVariant = null;
        var _scatolaFin = (typeof prezziFissi!=='undefined' && prezziFissi && prezziFissi.scatola!=null) ? prezziFissi.scatola : null; /* FIX 25-06: scatola colore finish-aware */



        // 🎯 NUOVO MATCHING INTELLIGENTE

        // Estrai formato base e caratteristiche

        let formatBase = actualSelectedFormat

          .replace('-ptv', '')

          .replace('-lucido', '').replace('-stripe', '').replace('-riga', '').replace('-pliss', '').replace('-twist', '').replace('-strutturasign', '').replace('-strutturanet', '').replace('-strutturamove', '')

          .replace('-comfort', '')

          .replace('-strutturato', '')

          .replace('-strutturato20mm', '')

          .replace('-satinato', '').replace('-velvet', '')

          .replace('-bocciardato', '')

          .replace('-liscio', '')

          .replace('-parete', '')

          .replace('-lux', '')

          .replace('-fluid', '')

          .replace('-Naturale', '')

          .replace('-naturale', '')

          .replace('-squadrato', '')

          .replace('-squadrata', '')

          .replace('-cannete', '')

          .replace('-soft', '')

          .replace('-matte', '')

          .replace('-grip', '')

          .replace('-antislip', '')
          .replace('-20mm', '')
          .replace('-lappatasatinata', '')
          .replace('-lappata', '')
          .replace('-lappato', '')
          .replace('-battiscopa', '')
          .replace('-fade', '')
          .replace('-Fade', '')
          .replace('-realupstrideup', '')
          .replace('-RealUpStrideUp', '')
          .replace('-realup', '')
          .replace('-RealUp', '')
          .replace('-strideup', '')
          .replace('-StrideUp', '')
          .replace(/-+/g, '-')
          .replace(/^-|-$/g, '');



        const isFormatPTV = actualSelectedFormat.includes('-ptv');

        const isFormatLucido = actualSelectedFormat.includes('-lucido');

        const isFormatComfort = actualSelectedFormat.includes('-comfort');

        const isFormatStrutturato = actualSelectedFormat.includes('-strutturato');

        const isFormatSatinato = actualSelectedFormat.includes('-satinato');

        const isFormatSatinatoNaturale = actualSelectedFormat.includes('-satinatoNaturale');

        const isFormatBocciardato = actualSelectedFormat.includes('-bocciardato');

        const isFormatLiscio = actualSelectedFormat.includes('-liscio');

        const isFormatParete = actualSelectedFormat.includes('-parete');

        const isFormatLux = actualSelectedFormat.includes('-lux');

        const isFormatFluid = actualSelectedFormat.includes('-fluid');

        const isFormatNaturale = actualSelectedFormat.includes('-Naturale') || actualSelectedFormat.includes('-naturale');

        const isFormatSquadrato = actualSelectedFormat.includes('-squadrato') || actualSelectedFormat.includes('-squadrata');

        const isFormatCannete = actualSelectedFormat.includes('-cannete');

        const isFormatSoft = actualSelectedFormat.includes('-soft');

        const isFormatMatte = actualSelectedFormat.includes('-matte');



        // Prova con matching intelligente

        for (let variant of this.product.variants) {

          // Non filtriamo per available - cerchiamo il prezzo in tutte le varianti



          const variantTitle = variant.title || '';

          const variantFullText = `${variant.title || ''} ${variant.option1 || ''} ${variant.option2 || ''} ${variant.option3 || ''}`.toLowerCase();



          // 1️⃣ Verifica formato base (gestisci varianti di x/X/× e punto/virgola decimale)

          const formatPattern = formatBase.replace(/\./g, '[.,]').replace(/x/gi, '[xX×]');

          const formatRegex = new RegExp(formatPattern, 'i');

          let formatMatches = formatRegex.test(variantFullText);



          // 2️⃣ Verifica caratteristiche specifiche

          if (formatMatches && isFormatStrutturato) {

            formatMatches = formatMatches && (/strutturato|strutturata/i.test(variantFullText));

          }

          if (formatMatches && isFormatPTV) {

            formatMatches = formatMatches && (/ptv|p\.t\.v\./i.test(variantFullText));

          }

          if (formatMatches && isFormatLucido) {

            formatMatches = formatMatches && (/lucido|lucida/i.test(variantFullText));

          }

          if (formatMatches && isFormatComfort) {

            formatMatches = formatMatches && (/comfort/i.test(variantFullText));

          }

          // 🔧 FIX: Soft e Satinato sono finiture DIVERSE

          if (formatMatches && isFormatSatinato) {

            formatMatches = formatMatches && (/satinato|satinata/i.test(variantFullText));

          } else if (formatMatches && !isFormatSoft && !isFormatSatinatoNaturale) {

            // Se NON è formato satinato né soft, escludi varianti satinato

            formatMatches = formatMatches && !(/satinato|satinata/i.test(variantFullText));

          }

          if (formatMatches && isFormatBocciardato) {

            formatMatches = formatMatches && (/bocciardato|bocciardato|lithos/i.test(variantFullText));

          }

          if (formatMatches && isFormatLiscio) {

            formatMatches = formatMatches && (/liscio|smooth/i.test(variantFullText));

          } else {

            // Se NON è formato liscio, la variante NON deve avere "liscio"

            if (formatMatches) {

              formatMatches = formatMatches && !(/liscio|smooth/i.test(variantFullText));

            }

          }

          if (formatMatches && isFormatParete) {

            formatMatches = formatMatches && (/parete/i.test(variantFullText));

          }

          if (formatMatches && isFormatLux) {

            formatMatches = formatMatches && (/lux/i.test(variantFullText));

          }

          if (formatMatches && isFormatFluid) {

            formatMatches = formatMatches && (/fluid/i.test(variantFullText));

          }

          if (formatMatches && isFormatNaturale) {

            formatMatches = formatMatches && (/Naturale/i.test(variantFullText));

          }

          if (formatMatches && isFormatNaturale) {

            formatMatches = formatMatches && (/naturale/i.test(variantFullText));

          }

          if (formatMatches && isFormatSquadrato) {

            formatMatches = formatMatches && (/squadrato|squadrata/i.test(variantFullText));

          }

          if (formatMatches && isFormatCannete) {

            formatMatches = formatMatches && (/cannete|canneté|cannetté|cannetè/i.test(variantFullText));

          }

          if (formatMatches && isFormatSoft) {

            formatMatches = formatMatches && (/soft/i.test(variantFullText));

          } else if (formatMatches && !isFormatSatinato && !isFormatSatinatoNaturale) {

            // Se NON è formato soft, escludi varianti soft

            formatMatches = formatMatches && !(/\bsoft\b/i.test(variantFullText));

          }

          // 🔧 Controllo Matte/Opaca

          if (formatMatches && isFormatMatte) {

            formatMatches = formatMatches && (/matte|matt|opaco|opaca/i.test(variantFullText));

          } else if (formatMatches && !isFormatNaturale) {

            // Se NON è formato matte, escludi varianti matte/matt

            formatMatches = formatMatches && !(/\bmatte\b|\bmatt\b/i.test(variantFullText));

          }



          // 3️⃣ Controlla se contiene il colore

          const colorMatches =

            variantTitle.includes(color.value) ||

            variantTitle.toUpperCase().includes(color.value.toUpperCase());



          // 4️⃣ Filtra per destinazione (R11 o 20mm senza rating per ESTERNO)

          const currentDestination = window.productConfigurator?.configuration?.destination || this.selectedDestination;

          const variantText = `${variant.option1 || ''} ${variant.option3 || ''}`.toLowerCase();

          const variantHasR11 = /r11/i.test(variantText);

          const variantHasR10 = /r10/i.test(variantText);

          const variantHasR9 = /r9/i.test(variantText);

          const variantIs20mm = /\b20\s*mm\b/.test(variantText) || /\b2\s*cm\b/.test(variantText);

          const variantHasAnyRating = variantHasR9 || variantHasR10 || variantHasR11;

          // 🆕 20mm senza rating va in ESTERNO

          const is20mmNoRating = variantIs20mm && !variantHasAnyRating;



          // Per ESTERNO: accetta varianti R11 OPPURE 20mm senza rating

          if (currentDestination === 'ESTERNO' && !variantHasR11 && !is20mmNoRating) {

            continue;

          }

          // Per INTERNO: escludi R11 e 20mm senza rating

          if (currentDestination === 'INTERNO' && (variantHasR11 || is20mmNoRating)) {

            continue;

          }



          if (formatMatches && colorMatches) {

            foundVariant = variant;

            break;

          }

        }



        if (foundVariant) {
            currentPrice = (typeof _scatolaFin!=='undefined' && _scatolaFin!=null) ? _scatolaFin : foundVariant.price;

          currentCompareAtPrice = foundVariant.compare_at_price;
          /* KH 2026-08-07: €/mq coerente con la variante scelta (foundVariant) — evita mix interno/esterno nello step colore */
          try { var _kuF = window.__KH_UNIT__ && window.__KH_UNIT__[foundVariant.id]; if (_kuF && _kuF.p != null) displayPrice = _kuF.p; } catch(e){}



          // SALVA IL VARIANT ID

          if (window.productConfigurator) {

            window.productConfigurator.configuration.variantId = foundVariant.id;

            window.productConfigurator.configuration.selectedVariant = foundVariant;

          }

        }

        // 🔧 FIX: Se foundVariant non trovato ma targetVariant sì, usa targetVariant per currentPrice
        if (!foundVariant && targetVariant) {
          currentPrice = (typeof _scatolaFin!=='undefined' && _scatolaFin!=null) ? _scatolaFin : targetVariant.price;
          currentCompareAtPrice = targetVariant.compare_at_price;
          try { var _kuT = window.__KH_UNIT__ && window.__KH_UNIT__[targetVariant.id]; if (_kuT && _kuT.p != null) displayPrice = _kuT.p; } catch(e){}
          if (window.productConfigurator) {
            window.productConfigurator.configuration.variantId = targetVariant.id;
            window.productConfigurator.configuration.selectedVariant = targetVariant;
          }
        }

      }



      if (selectedFormatValue) {

        // Se c'è un formato selezionato, trova l'oggetto formato completo

        const selectedFormat = this.formatOptions.find(f => f.value === selectedFormatValue);

        if (selectedFormat) {

          visual = this.generateTileSVG(selectedFormat.value, color.code || '#D9D2C5', color.image || null);

        } else {

          visual = this.generateTileSVG('60x60', color.code || '#D9D2C5', color.image || null);

        }

      } else {

        // Se non c'è formato selezionato, usa un formato default

        visual = this.generateTileSVG('60x60', color.code || '#D9D2C5', color.image || null);

      }

      

      // Su mobile mantieni uniformità, su desktop usa dimensioni originali

      const isMobile = window.innerWidth <= 768;

      const imageHeight = isMobile ? '150px' : '200px'; // Desktop 200px come originale



      // Determina l'unità di prezzo: /box per BATTISCOPA, /mq per il resto

      /* KH 2026-08-07: coerenza finale €/mq<->scatola nello step colore — displayPrice dalla stessa variante che ha quella scatola (currentPrice) */
      try { var _pcC = this.product || window.productData; if (_pcC && _pcC.variants && typeof currentPrice !== 'undefined' && currentPrice != null) { var _mvC = _pcC.variants.find(function(v){ return Math.abs(parseInt(v.price,10) - currentPrice) < 1; }); if (_mvC) { var _kuMC = window.__KH_UNIT__ && window.__KH_UNIT__[_mvC.id]; if (_kuMC && _kuMC.p != null) displayPrice = _kuMC.p; } } } catch(e){}
      const priceUnitColor = currentDestination === 'BATTISCOPA' ? '/box' : '/mq';



      // Escape dei caratteri speciali per evitare problemi con apostrofi negli attributi HTML

      const safeImage = (color.image || '').replace(/'/g, "\\'");

      // Rimuovi "PARETE" e "PAVIMENTO" dal label visualizzato

      const safeLabel = (color.label || '').replace(/ PARETE$/i, '').replace(/ PAVIMENTO$/i, '').trim().replace(/'/g, "\\'");

      const safeCode = (color.code || '').replace(/'/g, "\\'");



      card.innerHTML = `

        <div class="fx-variant-visual" style="display: flex; justify-content: center; align-items: center; min-height: ${isMobile ? '150px' : '140px'}; margin-bottom: 0; overflow: ${isMobile ? 'hidden' : 'visible'} !important; background: transparent; border: none; box-shadow: none; padding: 0;">

          ${visual}

        </div>

        <button class="fx-color-zoom-btn fx-format-info-btn"

                onclick="event.stopPropagation(); event.preventDefault();

        window.ConfiguratoreDataUniversal.zoomColorImage('${safeImage}', '${safeLabel}', '${safeCode}'); return false;"

                ontouchstart="event.stopPropagation(); event.preventDefault();

        window.ConfiguratoreDataUniversal.zoomColorImage('${safeImage}', '${safeLabel}', '${safeCode}'); return false;"

                style="position: absolute; top: 8px; left: 8px; width: 32px; height: 32px;

                       background: white; border: 1px solid #ddd; border-radius: 50%;

                       display: flex; align-items: center; justify-content: center;

                       cursor: pointer; transition: all 0.15s ease; box-shadow: 0 2px 8px rgba(0,0,0,0.1);

                       z-index: 10;">

          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">

            <circle cx="11" cy="11" r="8" stroke="#2D5A3D" stroke-width="2"/>

            <path d="M21 21L16.65 16.65" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round"/>

          </svg>

        </button>

        <div class="fx-style-info">

          <div class="fx-price-container" style="width: 100%; text-align: center; background: rgba(248,249,250,0.95); border-radius: 12px; padding: 0.75rem 0.5rem; min-height: 112px; border: none; border-top: 1px solid #ebebeb; position: relative; overflow: visible; transition: var(--fx-transition, all 0.3s cubic-bezier(0.4, 0, 0.2, 1)); margin: 0; box-sizing: border-box;">

            <h4 style="margin: 0 0 0.25rem 0; color: var(--fx-text, #2d3436); font-size: 1.1rem; font-weight: 700; letter-spacing: -0.02em; font-family: var(--fx-font, 'Jost', -apple-system, BlinkMacSystemFont, sans-serif);">${color.label.replace(/ PARETE$/i, '').replace(/ PAVIMENTO$/i, '').trim()}</h4>

            ${currentPrice ? `

              <div class="fx-price-row" style="display: flex; align-items: center; justify-content: center; gap: 0.5rem; flex-wrap: wrap;">

                <span class="fx-price" style="font-weight: 800; color: var(--fx-primary, #2D5A3D); font-size: 1.3rem; line-height: 1; font-family: var(--fx-font, 'Jost', -apple-system, BlinkMacSystemFont, sans-serif); letter-spacing: -0.02em;">

                  ${currentDestination === 'BATTISCOPA' ? this.formatMoney(currentPrice) : this.formatMoney(displayPrice || currentPrice)}<span style="font-size: 0.8em; font-weight: inherit;">${currentDestination === 'BATTISCOPA' ? '/scatola' : priceUnitColor}</span>

                </span>

                ${currentDestination === 'BATTISCOPA' ? (currentCompareAtPrice && currentCompareAtPrice > currentPrice ? `
                  <span class="fx-step-price-was">
                    ${this.formatMoney(currentCompareAtPrice)}
                  </span>
                ` : '') : (displayComparePrice ? `

                  <span class="fx-step-price-was">

                    ${this.formatMoney(displayComparePrice)}

                  </span>

                ` : currentCompareAtPrice && currentCompareAtPrice > currentPrice ? `

                  <span class="fx-step-price-was">

                    ${this.formatMoney(currentCompareAtPrice)}

                  </span>

                ` : '')}

              </div>

              ${currentDestination === 'BATTISCOPA' ? (currentCompareAtPrice && currentCompareAtPrice > currentPrice ? `
                
              ` : '') : (displayComparePrice ? `

                

              ` : currentCompareAtPrice && currentCompareAtPrice > currentPrice ? `

                

              ` : '')}

              ${currentDestination === 'BATTISCOPA' ? `<span class="fx-box-price" style="display:block;font-size:0.75rem;color:#b2bec3;font-weight:700;margin-top:0.25rem;text-align:center;font-family:var(--fx-font,Jost,sans-serif);">IVA incl.</span>` : `<span class="fx-box-price" style="display:block;font-size:0.75rem;color:#b2bec3;font-weight:700;margin-top:0.25rem;text-align:center;font-family:var(--fx-font,Jost,sans-serif);">${this.formatMoney(window.khScatolaPerMq((typeof displayPrice!=='undefined'?displayPrice:null)||currentPrice, currentPrice))}/scatola · IVA incl.</span>`}

            ` : ''}

          </div>

        </div>

      `;



      // Gestione click singolo e doppio (desktop e mobile)

      let clickCount = 0;

      let clickTimer = null;

      

      const handleSelection = () => {

        container.querySelectorAll('.fx-style-card').forEach(c => {

          c.classList.remove('selected');

        });

        card.classList.add('selected');



        // Step 4: Colore → Spessore (fxNext4)

        const nextBtn = document.getElementById('fxNext4');

        if (nextBtn) nextBtn.disabled = false;



        if (window.productConfigurator) {

          window.productConfigurator.configuration.color = color.value;

        }



        // Dopo la selezione del colore, filtra gli spessori basandosi su destinazione

        setTimeout(() => {

        this.filterThicknessByDestinationAndColor();

        }, 100);

      };



      const proceedToNext = () => {

        handleSelection();

        // Step 4: Colore → Spessore (fxNext4)

        const nextBtn = document.getElementById('fxNext4');

        if (nextBtn) {

          nextBtn.disabled = false;

          setTimeout(() => nextBtn.click(), 50);

        }

      };

      

      // Gestione unificata per click e tap

      card.addEventListener('click', function(e) {

        // Ignora click sul pulsante zoom

        if (e.target.closest('.fx-color-zoom-btn')) {

          return;

        }

        

        clickCount++;

        

        if (clickCount === 1) {

          // Primo click/tap

          clickTimer = setTimeout(() => {

            // Click singolo

            handleSelection();

            clickCount = 0;

          }, 250);

        } else if (clickCount === 2) {

          // Doppio click/tap

          clearTimeout(clickTimer);

          proceedToNext();

          clickCount = 0;

        }

      });

      

      // Previeni doppio tap zoom su iOS

      card.addEventListener('touchstart', function(e) {

        if (e.touches.length > 1) {

          e.preventDefault();

        }

      });

      

      container.appendChild(card);

    });



    this.addDiscountBadgesToStep(container);

  },



  // Popola gli spessori nello step 5 (dopo colore)

  populateThickness() {

    this.applyDisplayPrices();
    /* OVERRIDE SEMPLICE 25-06: spessori = varianti reali (formato+finitura+colore), destinazione: no-R/<=12mm=INTERNO, R11+/20mm=ESTERNO */
    try {
      var _self = this;
      var _cfg = (window.productConfigurator && window.productConfigurator.configuration) || {};
      var _selFmt = (_cfg.format || this.selectedFormat || '').normalize('NFD').replace(/[̀-ͯ]/g,'').toLowerCase();
      var _selCol = (_cfg.colore || _cfg.color || this.selectedColor || '').toLowerCase();
      var _dest = _cfg.destination || this.selectedDestination || 'INTERNO';
      var _fmtDim = (_selFmt.split('-')[0]||'').replace(/\s+/g,'').replace(/[.,]/g,'');
      var _finTok = _selFmt.split('-').slice(1).filter(function(t){return t && t!=='battiscopa';});
      if (_dest !== 'BATTISCOPA' && _selFmt && _fmtDim && _self.product && _self.product.variants && (_self.thicknessOptions||[]).length) {
        var _vts = _self.product.variants;
        var _valid = (_self.thicknessOptions||[]).filter(function(thk){
          var _tv = (thk.value||thk.label||'').toLowerCase();
          var _tn = parseFloat(((((_tv.match(/(\d+(?:[.,]\d+)?)/))||[])[1])||'0').replace(',','.'));
          var _rThk=(((_tv.match(/r1[0-3]|r9/i))||[''])[0]).toUpperCase();
          return _vts.some(function(v){
            var o1=(v.option1||'').toLowerCase(), o2=(v.option2||'').toLowerCase(), o3=(v.option3||'').toLowerCase();
            var hay=((o1+' '+o3).normalize('NFD').replace(/[̀-ͯ]/g,'')).replace(/\s+/g,'').replace(/[.,]/g,'');
            if (hay.indexOf(_fmtDim)===-1) return false;
            for (var i=0;i<_finTok.length;i++){ var _tk=_finTok[i].replace(/\s+/g,'').replace(/[oae]$/,''); /* KH stem fin */ if(_tk && hay.indexOf(_tk)===-1) return false; }
            if (_selCol && o2 !== _selCol) return false;
            var _vtn=parseFloat(((((o3.match(/(\d+(?:[.,]\d+)?)\s*mm/))||[])[1])||'0').replace(',','.')); if (_tn>0 && _vtn!==_tn) return false; var _rVar=(((o3.match(/r1[0-3]|r9/i))||[''])[0]).toUpperCase(); if(_rThk){if(_rVar!==_rThk)return false;}else{if(_rVar)return false;}
            var _r11=/r1[123]/i.test(o3); var _is20=(_tn>=20)||/20\s*mm|2\s*cm/i.test(o3);
            var _est=_r11||_is20;
            if (_dest==='ESTERNO') return _est;
            return !_est;
          });
        });
        _self.filteredThicknessOptions = _valid;
      }
    } catch(e){ }



    const container = document.getElementById('fxFinishContainer');

    if (!container) {

      return;

    }



    container.innerHTML = '';



    // Mantieni l'overflow del container per lo scrolling

    // Non modificare overflow qui



    // Disabilita il pulsante Continua inizialmente (step 5 Spessore → Quantità)

    const nextBtn5 = document.getElementById('fxNext5');

    if (nextBtn5) nextBtn5.disabled = true;



    // Assicurati che nessuna carta sia selezionata di default

    setTimeout(() => {

      container.querySelectorAll('.fx-style-card').forEach(card => {

        card.classList.remove('selected');

      });

    }, 10);



    // Usa gli spessori filtrati se disponibili, altrimenti usa tutti

    const thicknessToShow = this.filteredThicknessOptions || this.thicknessOptions;








    if (thicknessToShow.length === 0) {

      container.innerHTML = '<p style="color: var(--fx-text-muted); text-align: center; padding: 2rem;">Nessuno spessore disponibile per questa combinazione</p>';

      return;

    }



    // Trova il colore e formato selezionati per creare la piastrella 3D

    const selectedColor = window.productConfigurator?.configuration?.color;

    const selectedFormatValue = window.productConfigurator?.configuration?.format || this.selectedFormat;






    const selectedColorObj = this.colorOptions.find(c => c.value === selectedColor);



    // Genera la piastrella 3D con lo stesso metodo dello step 3

    let tileVisual = '';

    if (selectedFormatValue && selectedColorObj) {

      const selectedFormat = this.formatOptions.find(f => f.value === selectedFormatValue);

      if (selectedFormat) {

        tileVisual = this.generateTileSVG(selectedFormat.value, selectedColorObj.code || '#D9D2C5', selectedColorObj.image || null);

      }

    }



    if (!tileVisual) {

      // Usa un formato default se non ci sono selezioni

      tileVisual = this.generateTileSVG('60x60', '#D9D2C5', null);

    }



    // Variabile per tracciare l'ultimo tap (fuori dal loop)

    let lastTapTime = 0;



    // Determina l'unità di prezzo: /box per BATTISCOPA, /mq per il resto

    const selectedDestination = window.productConfigurator?.configuration?.destination || this.selectedDestination;

    const priceUnit = selectedDestination === 'BATTISCOPA' ? '/box' : '/mq';



    thicknessToShow.forEach((thickness, index) => {

      const card = document.createElement('div');

      card.className = 'fx-style-card fx-format-card'; // Identico a step 2/3

      card.dataset.thickness = thickness.value;

      card.style.animationDelay = `${index * 0.02}s`;

      card.style.borderColor = 'transparent'; // Forza bordo trasparente inizialmente

      card.style.position = 'relative'; // Per il posizionamento assoluto interno

      card.style.cssText += 'overflow: visible !important; clip-path: none !important; contain: none !important;';



      // Trova il prezzo per questa combinazione di formato + colore + spessore

      let currentPrice = null;

      let currentCompareAtPrice = null;

      let displayPrice = null; // Prezzo FISSO per visualizzazione

      let displayComparePrice = null;



      if (selectedFormatValue && selectedColor && this.product && this.product.variants) {

        // Cerca la variante che corrisponde a questa combinazione

        const matchingVariant = this.product.variants.find(v => {

          const options = [v.option1, v.option2, v.option3].filter(opt => opt);

          const variantFullText = [v.title, v.option1, v.option2, v.option3].filter(t => t).join(' ').toUpperCase();



          // Estrai formato base (rimuovi tutti i suffissi)

          let formatBase = selectedFormatValue;

          formatBase = formatBase.replace('-parete', '');

          formatBase = formatBase.replace('-lux', '');

          formatBase = formatBase.replace('-fluid', '');

          formatBase = formatBase.replace('-ptv', '');

          formatBase = formatBase.replace('-comfort', '');

          formatBase = formatBase.replace('-lucido', '').replace('-stripe', '').replace('-riga', '').replace('-pliss', '').replace('-twist', '').replace('-strutturasign', '').replace('-strutturanet', '').replace('-strutturamove', '');

          formatBase = formatBase.replace('-satinato', '').replace('-velvet', '');

          formatBase = formatBase.replace('-strutturato20mm', '');

          formatBase = formatBase.replace('-strutturato', '');

          formatBase = formatBase.replace('-bocciardato', '');

          formatBase = formatBase.replace('-liscio', '');

          formatBase = formatBase.replace('-levigato', '');

          formatBase = formatBase.replace('-levigata', '').replace('-patinato', '').replace('-patinata', '');

          formatBase = formatBase.replace('-Naturale', '');

          formatBase = formatBase.replace('-naturale', '');

          formatBase = formatBase.replace('-squadrato', '');

          formatBase = formatBase.replace('-squadrata', '');

          formatBase = formatBase.replace('-Naturalecuoio', '');

          formatBase = formatBase.replace('-cannete', '');

          formatBase = formatBase.replace('-soft', '');

          formatBase = formatBase.replace('-matte', '');

          formatBase = formatBase.replace('-grip', '');

          formatBase = formatBase.replace('-antislip', '');

          formatBase = formatBase.replace('-20mm', '');

          formatBase = formatBase.replace('-realupstrideup', '');

          formatBase = formatBase.replace('-RealUpStrideUp', '');

          formatBase = formatBase.replace('-realup', '');

          formatBase = formatBase.replace('-RealUp', '');

          formatBase = formatBase.replace('-strideup', '');

          formatBase = formatBase.replace('-StrideUp', '');

          formatBase = formatBase.replace('-lappata', '');

          formatBase = formatBase.replace('-lappato', '');

          formatBase = formatBase.replace('-parete', '');

          formatBase = formatBase.replace('-battiscopa', '');

          formatBase = formatBase.replace('-fade', '');
          formatBase = formatBase.replace(/-+/g, '-').replace(/^-|-$/g, '');



          const isFormatParete = selectedFormatValue.includes('-parete');

          const isFormatLux = selectedFormatValue.includes('-lux');

          const isFormatFluid = selectedFormatValue.includes('-fluid');

          const isFormatPTV = selectedFormatValue.includes('-ptv');

          const isFormatComfort = selectedFormatValue.includes('-comfort');

          const isFormatLucido = selectedFormatValue.includes('-lucido');

          const isFormatSatinato = selectedFormatValue.includes('-satinato');

          const isFormatSatinatoNaturale = selectedFormatValue.includes('-satinatoNaturale');

          const isFormatStrutturato = selectedFormatValue.includes('-strutturato');

          const isFormatBocciardato = selectedFormatValue.includes('-bocciardato');

          const isFormatLiscio = selectedFormatValue.includes('-liscio');

          const isFormatNaturale = selectedFormatValue.includes('-Naturale') || selectedFormatValue.includes('-naturale');

          const isFormatSquadrato = selectedFormatValue.includes('-squadrato') || selectedFormatValue.includes('-squadrata');

          const isFormatCannete = selectedFormatValue.includes('-cannete');

          const isFormatSoft = selectedFormatValue.includes('-soft');

          const isFormatMatte = selectedFormatValue.includes('-matte');

          const isFormatNaturalecuoio = selectedFormatValue.includes('-Naturalecuoio') || selectedFormatValue.includes('-naturalecuoio');

          const isFormatLappata = selectedFormatValue.includes('-lappata') || selectedFormatValue.includes('-lappato');

          const isFormatRealUp = selectedFormatValue.includes('-realup') || selectedFormatValue.includes('-RealUp');

          const isFormatGrip = selectedFormatValue.includes('-grip') || selectedFormatValue.includes('-Grip');

          const isFormatAntislip = selectedFormatValue.includes('-antislip') || selectedFormatValue.includes('-Antislip');

          const isFormatBattiscopa = selectedFormatValue.includes('-battiscopa');

          const isFormatFade = selectedFormatValue.includes('-fade');

          const isFormatLappataSatinata = selectedFormatValue.includes('-lappatasatinata');



          // Verifica formato: deve contenere il formato base E se è formato parete/lux/fluid/comfort/lucido/satinato/strutturato, deve contenere le rispettive parole

          // 🔧 FIX: normalizza × unicode → x e virgola/punto per matching corretto battiscopa
          const norm1 = s => s ? s.replace(/\u00d7/g, 'x').replace(/X/g, 'x').replace(/,/g, '.') : '';
          let hasFormat = options.some(opt => opt && norm1(opt).includes(norm1(formatBase)));

          if (isFormatParete) {

            hasFormat = hasFormat && variantFullText.includes('PARETE');

          } else {

            // Se NON è formato parete, la variante NON deve avere "PARETE"

            hasFormat = hasFormat && !variantFullText.includes('PARETE');

          }



          if (isFormatLux) {

            hasFormat = hasFormat && variantFullText.includes('LUX');

          } else {

            // Se NON è formato lux, la variante NON deve avere "LUX"

            hasFormat = hasFormat && !variantFullText.includes('LUX');

          }



          if (isFormatFluid) {

            hasFormat = hasFormat && variantFullText.includes('FLUID');

          } else {

            // Se NON è formato fluid, la variante NON deve avere "FLUID"

            hasFormat = hasFormat && !variantFullText.includes('FLUID');

          }



          if (isFormatPTV) {

            hasFormat = hasFormat && variantFullText.includes('PTV');

          } else {

            // Se NON è formato PTV, la variante NON deve avere "PTV"

            hasFormat = hasFormat && !variantFullText.includes('PTV');

          }



          if (isFormatComfort) {

            hasFormat = hasFormat && variantFullText.includes('COMFORT');

          }



          // 🔧 FIX: LUCIDO - deve escludere varianti Lucido quando NON richiesto

          if (isFormatLucido) {

            hasFormat = hasFormat && (variantFullText.includes('LUCIDO') || variantFullText.includes('LUCIDA'));

          } else if (!isFormatSoft && !isFormatMatte && !isFormatSatinato) {

            // Se NON è lucido né soft né matte né satinato, escludi varianti lucido

            hasFormat = hasFormat && !variantFullText.includes('LUCIDO') && !variantFullText.includes('LUCIDA');

          }



          // 🔧 FIX: Soft e Satinato sono finiture DIVERSE

          if (isFormatSatinato) {

            hasFormat = hasFormat && (variantFullText.includes('SATINATO') || variantFullText.includes('SATINATA') || variantFullText.includes('SILK'));

          } else if (!isFormatSoft && !isFormatSatinatoNaturale) {

            // Se NON è formato satinato né soft, escludi satinato/silk

            hasFormat = hasFormat && !(/\bSATINATO\b|\bSATINATA\b|\bSILK\b/i.test(variantFullText));

          }

          // Verifica SOFT (finitura separata)

          if (isFormatSoft) {

            hasFormat = hasFormat && variantFullText.includes('SOFT');

          } else if (!isFormatSatinato && !isFormatSatinatoNaturale) {

            hasFormat = hasFormat && !(/\bSOFT\b/i.test(variantFullText));

          }



          // 🔧 FIX: Verifica MATTE/OPACA - finitura economica di I CLASSICI

          if (isFormatMatte) {

            hasFormat = hasFormat && /\bMATTE?\b|OPAC/i.test(variantFullText);

          } else if (!isFormatSoft && !isFormatLucido) {

            // Se NON è matte né soft né lucido, escludi varianti matte

            hasFormat = hasFormat && !/\bMATTE?\b/i.test(variantFullText) && !(/\bOPAC/i.test(variantFullText));

          }



          if (isFormatStrutturato) {

            hasFormat = hasFormat && (variantFullText.includes('STRUTTURATO') || variantFullText.includes('STRUTTURATA'));

          }



          if (isFormatBocciardato) {

            hasFormat = hasFormat && (variantFullText.includes('BOCCIARDATO') || variantFullText.includes('BOCCIARDATO-NATURALE'));

          }



          if (isFormatLiscio) {

            hasFormat = hasFormat && (variantFullText.includes('LISCIO') || variantFullText.includes('LISCIA') || variantFullText.includes('SMOOTH'));

          } else {

            hasFormat = hasFormat && !variantFullText.includes('LISCIO') && !variantFullText.includes('LISCIA') && !variantFullText.includes('SMOOTH');

          }



          if (isFormatNaturale) {

            hasFormat = hasFormat && variantFullText.includes('NATURALE') && !variantFullText.includes('BOCCIARDATO-NATURALE');

          } else {

            hasFormat = hasFormat && (!variantFullText.includes('NATURALE') || variantFullText.includes('BOCCIARDATO-NATURALE'));

          }



          // Verifica SQUADRATO

          if (isFormatSquadrato) {

            hasFormat = hasFormat && (variantFullText.includes('SQUADRATO') || variantFullText.includes('SQUADRATA'));

          } else {

            hasFormat = hasFormat && !variantFullText.includes('SQUADRATO') && !variantFullText.includes('SQUADRATA');

          }



          // Verifica CANNETE

          if (isFormatCannete) {

            hasFormat = hasFormat && (variantFullText.includes('CANNETE') || variantFullText.includes('CANNETÉ') || variantFullText.includes('CANNETTÉ') || variantFullText.includes('CANNETÈ'));

          } else {

            hasFormat = hasFormat && !variantFullText.includes('CANNETE') && !variantFullText.includes('CANNETÉ') && !variantFullText.includes('CANNETTÉ') && !variantFullText.includes('CANNETÈ');

          }



          // 🔧 FIX: Soft è una finitura DIVERSA da Satinato

          if (isFormatSoft) {

            hasFormat = hasFormat && variantFullText.includes('SOFT');

          } else if (!isFormatSatinatoNaturale) {

            // Se NON è formato soft, escludi varianti soft

            hasFormat = hasFormat && !variantFullText.includes('SOFT');

          }



          // Verifica NaturaleCUOIO (corrisponde a Naturale LEATHER)

          if (isFormatNaturalecuoio) {

            hasFormat = hasFormat && variantFullText.includes('NATURALE LEATHER');

          }



          // Verifica LAPPATA/LAPPATO

          if (isFormatLappata) {

            hasFormat = hasFormat && (variantFullText.includes('LAPPATA') || variantFullText.includes('LAPPATO'));

          } else {

            hasFormat = hasFormat && !variantFullText.includes('LAPPATA') && !variantFullText.includes('LAPPATO');

          }



          // Verifica REALUP

          if (isFormatRealUp) {

            hasFormat = hasFormat && variantFullText.includes('REALUP');

          } else {

            hasFormat = hasFormat && !variantFullText.includes('REALUP');

          }



          // Verifica GRIP

          if (isFormatGrip) {

            hasFormat = hasFormat && variantFullText.includes('GRIP');

          } else {

            hasFormat = hasFormat && !variantFullText.includes('GRIP');

          }



          // Verifica ANTISLIP

          if (isFormatAntislip) {

            hasFormat = hasFormat && /ANTI[\s_-]?SLIP/i.test(variantFullText);

          } else {

            hasFormat = hasFormat && !/ANTI[\s_-]?SLIP/i.test(variantFullText);

          }



          // Verifica BATTISCOPA

          if (isFormatBattiscopa) {

            hasFormat = hasFormat && variantFullText.includes('BATTISCOPA');

          } else {

            hasFormat = hasFormat && !variantFullText.includes('BATTISCOPA');

          }



          // Verifica FADE

          if (isFormatFade) {

            hasFormat = hasFormat && variantFullText.includes('FADE');

          } else {

            hasFormat = hasFormat && !variantFullText.includes('FADE');

          }



          // Verifica LAPPATA-SATINATA

          if (isFormatLappataSatinata) {

            hasFormat = hasFormat && (variantFullText.includes('LAPPATA SATINATA') || variantFullText.includes('LAPPATA-SATINATA'));

          } else {

            hasFormat = hasFormat && !variantFullText.includes('LAPPATA SATINATA') && !variantFullText.includes('LAPPATA-SATINATA');

          }



          // IMPORTANTE: Se selectedColor è vuoto/undefined, NON fare match (evita di trovare WHITE per tutti)

          const hasColor = selectedColor && selectedColor.length > 0 && options.some(opt => opt && opt.toUpperCase().includes(selectedColor.toUpperCase()));



          // Per lo spessore: se non è ancora stato selezionato, non controllarlo (ritorna true)

          let hasThickness = true; // Default: nessun controllo spessore

          if (thickness && thickness.label) {

            hasThickness = options.some(opt => {

              if (!opt) return false;



              // Rimuovi spazi per confronto

              const optLower = opt.toLowerCase().replace(/\s+/g, '');



              // MATCH ESATTO: deve contenere sia lo spessore (es: 20mm) che il rating (es: r11)

              // Estrai lo spessore numerico dalla label (es: "20mm" o "20 mm" da "20mm R11")

              const thicknessMatch = thickness.label.match(/([\d.]+\s*mm)/i);

              const thicknessValue = thicknessMatch ? thicknessMatch[1].toLowerCase().replace(/\s+/g, '') : null;



              // Deve contenere ESATTAMENTE lo spessore numerico

              const hasExactThickness = thicknessValue && optLower.includes(thicknessValue.replace(/\s+/g, ''));



              // E deve contenere il rating se specificato

              const hasRating = !thickness.rating || optLower.includes(thickness.rating.toLowerCase().replace(/\s+/g, ''));



              return hasExactThickness && hasRating;

            });

          }



          return hasFormat && hasColor && hasThickness;

        });



        if (matchingVariant) {

          currentPrice = matchingVariant.price;
          try { var _kuT = window.__KH_UNIT__ && window.__KH_UNIT__[matchingVariant.id]; if (_kuT && _kuT.p) displayPrice = _kuT.p; } catch(e){} /* KH-THK */

          currentCompareAtPrice = matchingVariant.compare_at_price;




          // SALVA IL VARIANT ID PER USARLO NEL CARRELLO

          if (window.productConfigurator) {

            window.productConfigurator.configuration.variantId = matchingVariant.id;

            window.productConfigurator.configuration.selectedVariant = matchingVariant;

          }

        } else {




          // Fallback: prova a trovare almeno una variante con formato e colore

          const fallbackVariant = this.product.variants.find(v => {

            const options = [v.option1, v.option2, v.option3].filter(opt => opt);

            const variantFullText = [v.title, v.option1, v.option2, v.option3].filter(t => t).join(' ').toUpperCase();



            let formatBase = selectedFormatValue;

            formatBase = formatBase.replace('-parete', '');

            formatBase = formatBase.replace('-lux', '');

            formatBase = formatBase.replace('-fluid', '');

            formatBase = formatBase.replace('-ptv', '');

            formatBase = formatBase.replace('-comfort', '');

            formatBase = formatBase.replace('-lucido', '').replace('-stripe', '').replace('-riga', '').replace('-pliss', '').replace('-twist', '').replace('-strutturasign', '').replace('-strutturanet', '').replace('-strutturamove', '');

            formatBase = formatBase.replace('-satinato', '').replace('-velvet', '');

            formatBase = formatBase.replace('-strutturato20mm', '');

            formatBase = formatBase.replace('-strutturato', '');

            formatBase = formatBase.replace('-bocciardato', '');

            formatBase = formatBase.replace('-liscio', '');

            formatBase = formatBase.replace('-levigato', '');

            formatBase = formatBase.replace('-levigata', '').replace('-patinato', '').replace('-patinata', '');

            formatBase = formatBase.replace('-Naturale', '');

            formatBase = formatBase.replace('-naturale', '');

            formatBase = formatBase.replace('-squadrato', '');

            formatBase = formatBase.replace('-squadrata', '');

            formatBase = formatBase.replace('-cannete', '');

            formatBase = formatBase.replace('-soft', '');

            formatBase = formatBase.replace('-matte', '');

            formatBase = formatBase.replace('-Naturalecuoio', '');

            formatBase = formatBase.replace('-realupstrideup', '');

            formatBase = formatBase.replace('-RealUpStrideUp', '');

            formatBase = formatBase.replace('-realup', '');

            formatBase = formatBase.replace('-RealUp', '');

            formatBase = formatBase.replace('-strideup', '');

            formatBase = formatBase.replace('-StrideUp', '');

            formatBase = formatBase.replace('-grip', '');

            formatBase = formatBase.replace('-antislip', '');

            formatBase = formatBase.replace('-20mm', '');

            formatBase = formatBase.replace('-lappata', '');

            formatBase = formatBase.replace('-lappato', '');

            formatBase = formatBase.replace('-battiscopa', '');

            formatBase = formatBase.replace('-fade', '');
            formatBase = formatBase.replace(/-+/g, '-').replace(/^-|-$/g, '');



            const isFormatParete = selectedFormatValue.includes('-parete');

            const isFormatLux = selectedFormatValue.includes('-lux');

            const isFormatFluid = selectedFormatValue.includes('-fluid');

            const isFormatPTV = selectedFormatValue.includes('-ptv');

            const isFormatComfort = selectedFormatValue.includes('-comfort');

            const isFormatLucido = selectedFormatValue.includes('-lucido');

            const isFormatSatinato = selectedFormatValue.includes('-satinato');

            const isFormatSatinatoNaturale = selectedFormatValue.includes('-satinatoNaturale');

            const isFormatStrutturato = selectedFormatValue.includes('-strutturato');

            const isFormatBocciardato = selectedFormatValue.includes('-bocciardato');

            const isFormatLiscio = selectedFormatValue.includes('-liscio');

            const isFormatLevigato = selectedFormatValue.includes('-levigato') || selectedFormatValue.includes('-levigata');

            const isFormatNaturale = selectedFormatValue.includes('-Naturale') || selectedFormatValue.includes('-naturale');

            const isFormatSquadrato = selectedFormatValue.includes('-squadrato') || selectedFormatValue.includes('-squadrata');

            const isFormatCannete = selectedFormatValue.includes('-cannete');

            const isFormatSoft = selectedFormatValue.includes('-soft');

            const isFormatMatte = selectedFormatValue.includes('-matte');

            const isFormatNaturalecuoio = selectedFormatValue.includes('-Naturalecuoio') || selectedFormatValue.includes('-naturalecuoio');

            const isFormatRealUp = selectedFormatValue.includes('-realup') || selectedFormatValue.includes('-RealUp');

            const isFormatGrip = selectedFormatValue.includes('-grip') || selectedFormatValue.includes('-Grip');

            const isFormatAntislip = selectedFormatValue.includes('-antislip') || selectedFormatValue.includes('-Antislip');

            const isFormatLappata = selectedFormatValue.includes('-lappata') || selectedFormatValue.includes('-lappato');

            const isFormatBattiscopa = selectedFormatValue.includes('-battiscopa');

            const isFormatFade = selectedFormatValue.includes('-fade');

            const isFormatLappataSatinata = selectedFormatValue.includes('-lappatasatinata');



            // 🔧 FIX: normalizza × unicode → x e virgola/punto per matching corretto battiscopa
            const norm2 = s => s ? s.replace(/\u00d7/g, 'x').replace(/X/g, 'x').replace(/,/g, '.') : '';
            let hasFormat = options.some(opt => opt && norm2(opt).includes(norm2(formatBase)));

            if (isFormatParete) {

              hasFormat = hasFormat && variantFullText.includes('PARETE');

            } else {

              hasFormat = hasFormat && !variantFullText.includes('PARETE');

            }



            if (isFormatLux) {

              hasFormat = hasFormat && variantFullText.includes('LUX');

            } else {

              hasFormat = hasFormat && !variantFullText.includes('LUX');

            }



            if (isFormatFluid) {

              hasFormat = hasFormat && variantFullText.includes('FLUID');

            } else {

              hasFormat = hasFormat && !variantFullText.includes('FLUID');

            }



            if (isFormatPTV) {

              hasFormat = hasFormat && variantFullText.includes('PTV');

            } else {

              hasFormat = hasFormat && !variantFullText.includes('PTV');

            }



            if (isFormatComfort) {

              hasFormat = hasFormat && variantFullText.includes('COMFORT');

            }



            // 🔧 FIX: LUCIDO - deve escludere varianti Lucido quando NON richiesto

            if (isFormatLucido) {

              hasFormat = hasFormat && (variantFullText.includes('LUCIDO') || variantFullText.includes('LUCIDA'));

            } else if (!isFormatSoft && !isFormatMatte && !isFormatSatinato) {

              // Se NON è lucido né soft né matte né satinato, escludi varianti lucido

              hasFormat = hasFormat && !variantFullText.includes('LUCIDO') && !variantFullText.includes('LUCIDA');

            }



            // 🔧 FIX: Soft e Satinato sono finiture DIVERSE

            if (isFormatSatinato) {

              hasFormat = hasFormat && (variantFullText.includes('SATINATO') || variantFullText.includes('SATINATA') || variantFullText.includes('SILK'));

            } else if (!isFormatSoft && !isFormatSatinatoNaturale) {

              // Se NON è formato satinato né soft, escludi satinato/silk

              hasFormat = hasFormat && !(/\bSATINATO\b|\bSATINATA\b|\bSILK\b/i.test(variantFullText));

            }



            if (isFormatStrutturato) {

              hasFormat = hasFormat && (variantFullText.includes('STRUTTURATO') || variantFullText.includes('STRUTTURATA'));

            }



            if (isFormatBocciardato) {

              hasFormat = hasFormat && (variantFullText.includes('BOCCIARDATO') || variantFullText.includes('BOCCIARDATO-NATURALE'));

            }



            if (isFormatLiscio) {

              hasFormat = hasFormat && (variantFullText.includes('LISCIO') || variantFullText.includes('LISCIA') || variantFullText.includes('SMOOTH'));

            } else {

              hasFormat = hasFormat && !variantFullText.includes('LISCIO') && !variantFullText.includes('LISCIA') && !variantFullText.includes('SMOOTH');

            }



            if (isFormatNaturale) {

              hasFormat = hasFormat && variantFullText.includes('NATURALE') && !variantFullText.includes('BOCCIARDATO-NATURALE');

            } else {

              hasFormat = hasFormat && (!variantFullText.includes('NATURALE') || variantFullText.includes('BOCCIARDATO-NATURALE'));

            }



            // Verifica SQUADRATO

            if (isFormatSquadrato) {

              hasFormat = hasFormat && (variantFullText.includes('SQUADRATO') || variantFullText.includes('SQUADRATA'));

            } else {

              hasFormat = hasFormat && !variantFullText.includes('SQUADRATO') && !variantFullText.includes('SQUADRATA');

            }



            // Verifica CANNETE

            if (isFormatCannete) {

              hasFormat = hasFormat && (variantFullText.includes('CANNETE') || variantFullText.includes('CANNETÉ') || variantFullText.includes('CANNETTÉ') || variantFullText.includes('CANNETÈ'));

            } else {

              hasFormat = hasFormat && !variantFullText.includes('CANNETE') && !variantFullText.includes('CANNETÉ') && !variantFullText.includes('CANNETTÉ') && !variantFullText.includes('CANNETÈ');

            }



            // 🔧 FIX: Soft è una finitura DIVERSA da Satinato

            if (isFormatSoft) {

              hasFormat = hasFormat && variantFullText.includes('SOFT');

            } else if (!isFormatSatinatoNaturale) {

              // Se NON è formato soft, escludi varianti soft

              hasFormat = hasFormat && !variantFullText.includes('SOFT');

            }



            // 🔧 FIX: Verifica MATTE/OPACA - finitura economica di I CLASSICI

            if (isFormatMatte) {

              hasFormat = hasFormat && /\bMATTE?\b|OPAC/i.test(variantFullText);

            } else if (!isFormatSoft && !isFormatLucido) {

              // Se NON è matte né soft né lucido, escludi varianti matte

              hasFormat = hasFormat && !/\bMATTE?\b/i.test(variantFullText) && !(/\bOPAC/i.test(variantFullText));

            }



            // Verifica NaturaleCUOIO (corrisponde a Naturale LEATHER)

            if (isFormatNaturalecuoio) {

              hasFormat = hasFormat && variantFullText.includes('NATURALE LEATHER');

            }



            // Verifica REALUP

            if (isFormatRealUp) {

              hasFormat = hasFormat && variantFullText.includes('REALUP');

            } else {

              hasFormat = hasFormat && !variantFullText.includes('REALUP');

            }



            // Verifica GRIP

            if (isFormatGrip) {

              hasFormat = hasFormat && variantFullText.includes('GRIP');

            } else {

              hasFormat = hasFormat && !variantFullText.includes('GRIP');

            }



            // Verifica ANTISLIP

            if (isFormatAntislip) {

              hasFormat = hasFormat && /ANTI[\s_-]?SLIP/i.test(variantFullText);

            } else {

              hasFormat = hasFormat && !/ANTI[\s_-]?SLIP/i.test(variantFullText);

            }



            // Verifica LAPPATA/LAPPATO

            if (isFormatLappata) {

              hasFormat = hasFormat && (variantFullText.includes('LAPPATA') || variantFullText.includes('LAPPATO'));

            } else {

              hasFormat = hasFormat && !variantFullText.includes('LAPPATA') && !variantFullText.includes('LAPPATO');

            }



            // Verifica BATTISCOPA

            if (isFormatBattiscopa) {

              hasFormat = hasFormat && variantFullText.includes('BATTISCOPA');

            } else {

              hasFormat = hasFormat && !variantFullText.includes('BATTISCOPA');

            }



            // Verifica FADE

            if (isFormatFade) {

              hasFormat = hasFormat && variantFullText.includes('FADE');

            } else {

              hasFormat = hasFormat && !variantFullText.includes('FADE');

            }



            // Verifica LAPPATA-SATINATA

            if (isFormatLappataSatinata) {

              hasFormat = hasFormat && (variantFullText.includes('LAPPATA SATINATA') || variantFullText.includes('LAPPATA-SATINATA'));

            } else {

              hasFormat = hasFormat && !variantFullText.includes('LAPPATA SATINATA') && !variantFullText.includes('LAPPATA-SATINATA');

            }



            // IMPORTANTE: Se selectedColor è vuoto/undefined, NON fare match (evita di trovare WHITE per tutti)

            const hasColor = selectedColor && selectedColor.length > 0 && options.some(opt => opt && opt.toUpperCase().includes(selectedColor.toUpperCase()));

            return hasFormat && hasColor && v.available;

          });



          if (fallbackVariant) {

            currentPrice = fallbackVariant.price;
          try { var _kuFb = window.__KH_UNIT__ && window.__KH_UNIT__[fallbackVariant.id]; if (_kuFb && _kuFb.p != null) displayPrice = _kuFb.p; } catch(e){} /* KH sync €/mq */

            currentCompareAtPrice = fallbackVariant.compare_at_price;



            // SALVA ANCHE IL VARIANT ID DEL FALLBACK

            if (window.productConfigurator) {

              window.productConfigurator.configuration.variantId = fallbackVariant.id;

              window.productConfigurator.configuration.selectedVariant = fallbackVariant;

            }

          }

        }

      }



      // 🎯 PRIMA prova con getPrezzoByComparePrice usando il comparePrice della variante trovata

      if (typeof window.getPrezzoByComparePrice === 'function' && currentCompareAtPrice) {

        // Estrai finitura dal formato selezionato (es: "60x60-satinato" → "satinato")

        // IMPORTANTE: lappatasatinata PRIMA di lappata/satinata per match corretto, realupstrideup PRIMA di realup e strideup

        // 🆕 FIX: Aggiunto 'lux' per PURITY of MARBLE (LUX = Lucida)

        const finitureToMatch = ['lappatasatinata', 'lappata-satinata', 'lappata satinata', 'cannete', 'velvet', 'lucido', 'lucida', 'lux', 'naturale', 'satinato', 'satinata', 'strutturato', 'strutturata', 'bocciardato', 'liscio', 'liscia', 'levigato', 'levigata', 'patinato', 'patinata', 'lappato', 'lappata', 'comfort', 'soft', 'matte', 'grip', 'antislip', 'anti slip', 'anti-slip', 'glossy', 'realupstrideup', 'realup', 'strideup', 'battiscopa', 'fade', 't_20', 't20'];

        let finituraFromFormat = null;

        const formatLower = (selectedFormatValue || '').toLowerCase();

        for (const fin of finitureToMatch) {

          if (formatLower.includes('-' + fin)) {

            finituraFromFormat = fin;

            break;

          }

        }



        // 🔧 Se finitura non trovata nel formato, estraila dalla variante selezionata

        if (!finituraFromFormat) {

          const selectedVariant = window.productConfigurator?.configuration?.selectedVariant;

          if (selectedVariant && selectedVariant.option1) {

            const opt1Lower = selectedVariant.option1.toLowerCase();

            for (const fin of finitureToMatch) {

              const finRegex = new RegExp('\\b' + fin + '\\b', 'i');

              if (finRegex.test(opt1Lower)) {

                finituraFromFormat = fin;


                break;

              }

            }

          }

        }



        // Estrai formato base (es: "60x60-satinato" → "60x60")

        const formatDim = (selectedFormatValue || '').split('-')[0];



        // 🔍 DEBUG STONEWORK




        const prezzoFisso = window.getPrezzoByComparePrice(currentCompareAtPrice, this.product.title, finituraFromFormat || 'base', formatDim);

        if (prezzoFisso) {

          // Moltiplica per 100 per convertire in centesimi

          displayPrice = prezzoFisso.prezzo * 100;

          displayComparePrice = prezzoFisso.comparePrice * 100;


        }

      }



      // 🎯 FALLBACK: Prova con getPrezzoFissoM2 se non trovato

      if (!displayPrice && selectedFormatValue && typeof window.getPrezzoFissoM2 === 'function') {

        // Rimuovi solo suffissi architettonici, mantieni finiture (comfort/lucido/satinato/strutturato/Naturale/naturale/lux)

        // perché getPrezzoFissoM2() le gestisce internamente

        // 🔧 FIX PURITY of MARBLE: NON rimuovere -lux (è finitura Lucida con prezzi diversi)

        let formatBase = selectedFormatValue;

        formatBase = formatBase.replace('-parete', '').replace('-fluid', '');



        // 🎯 Estrai lo spessore dalla label dello spessore corrente (es: "20mm R11" → "20mmr11", "9mm R11" → "9mmr11")

        let spessorePerDisplay = null;

        if (thickness && thickness.label) {

          const thicknessLabel = thickness.label.toLowerCase();



          // Controlla se contiene R11/R12/R13 (rating antiscivolo)

          const hasRating = /r11|r12|r13/i.test(thicknessLabel);



          const thicknessMatch = thicknessLabel.match(/([\d.]+\s*mm)/i);

          if (thicknessMatch) {

            const baseSpessore = thicknessMatch[1].toLowerCase().replace(/\s+/g, '');



            if (hasRating) {

              // Se ha rating R11/R12/R13, costruisci chiave con rating (es: "9mmr11", "20mmr11")

              const ratingMatch = thicknessLabel.match(/(r11|r12|r13)/i);

              spessorePerDisplay = `${baseSpessore}${ratingMatch[1].toLowerCase()}`;

            } else {

              // Ignora spessori standard (6mm, 9mm sono i default per interno)

              if (baseSpessore !== '6mm' && baseSpessore !== '9mm' && baseSpessore !== '9.5mm' && baseSpessore !== '9.2mm') {

                spessorePerDisplay = baseSpessore;

              }

            }

          }

        }



        const prezziFissi = window.getPrezzoFissoM2(formatBase, this.product.title, selectedColor, spessorePerDisplay);

        if (prezziFissi) {

          // Moltiplica per 100 per convertire in centesimi

          displayPrice = prezziFissi.prezzo * 100;

          displayComparePrice = prezziFissi.comparePrice * 100;


        } else {


        }

      }



      // Su mobile mantieni uniformità, su desktop usa layout originale
      try { var _pcS = window.productData || (window.ConfiguratoreDataUniversal&&window.ConfiguratoreDataUniversal.product); if (_pcS && _pcS.variants && typeof currentPrice !== 'undefined' && currentPrice != null && typeof displayPrice !== 'undefined') { var _mvS = _pcS.variants.find(function(v){ return Math.abs(parseInt(v.price,10) - currentPrice) < 1; }); if (_mvS) { var _kuS = window.__KH_UNIT__ && window.__KH_UNIT__[_mvS.id]; if (_kuS && _kuS.p != null) displayPrice = _kuS.p; } } } catch(e){} /* KH sync €/mq */


      const isMobile = window.innerWidth <= 768;



      if (isMobile) {

        card.innerHTML = `

          <div class="fx-variant-visual" style="position: relative; display: flex; justify-content: center; align-items: center; min-height: 140px; margin-bottom: 0; overflow: visible !important; background: transparent; border: none; box-shadow: none; padding: 0;">

            ${tileVisual || ''}

          </div>

          <div class="fx-style-info">

            <div class="fx-price-container" style="width: 100%; text-align: center; background: rgba(248,249,250,0.95); border-radius: 12px; padding: 0.75rem 0.5rem; min-height: 112px; border: none; border-top: 1px solid #ebebeb; position: relative; overflow: visible; transition: var(--fx-transition, all 0.3s cubic-bezier(0.4, 0, 0.2, 1)); margin: 0; box-sizing: border-box;">

              <h4 style="margin: 0 0 0.25rem 0; color: var(--fx-text, #2d3436); font-size: 1.1rem; font-weight: 700; letter-spacing: -0.02em; font-family: var(--fx-font, 'Jost', -apple-system, BlinkMacSystemFont, sans-serif);">${thickness.label}</h4>

              <p style="margin: 0 0 0.5rem 0; color: var(--fx-text-muted, #636e72); font-size: 0.85rem; font-family: var(--fx-font, 'Jost', -apple-system, BlinkMacSystemFont, sans-serif);">${thickness.description}</p>

              ${(currentPrice || displayPrice) ? `

                <div class="fx-price-row" style="display: flex; align-items: center; justify-content: center; gap: 0.5rem; flex-wrap: wrap;">

                  <span class="fx-price" style="font-weight: 800; color: var(--fx-primary, #2D5A3D); font-size: 1.3rem; line-height: 1; font-family: var(--fx-font, 'Jost', -apple-system, BlinkMacSystemFont, sans-serif); letter-spacing: -0.02em;">

                    ${selectedDestination === 'BATTISCOPA' ? this.formatMoney(currentPrice) : this.formatMoney(displayPrice || currentPrice)}<span style="font-size: 0.8em; font-weight: inherit;">${selectedDestination === 'BATTISCOPA' ? '/scatola' : priceUnit}</span>

                  </span>

                  ${selectedDestination === 'BATTISCOPA' ? (currentCompareAtPrice && currentCompareAtPrice > currentPrice ? `
                    <span class="fx-step-price-was">
                      ${this.formatMoney(currentCompareAtPrice)}
                    </span>
                  ` : '') : (displayComparePrice ? `

                    <span class="fx-step-price-was">

                      ${this.formatMoney(displayComparePrice)}

                    </span>

                  ` : currentCompareAtPrice && currentCompareAtPrice > currentPrice ? `

                    <span class="fx-step-price-was">

                      ${this.formatMoney(currentCompareAtPrice)}

                    </span>

                  ` : displayComparePrice ? `

                    <span class="fx-step-price-was">

                      ${this.formatMoney(displayComparePrice)}

                    </span>

                  ` : `

                    <span class="fx-original-price" style="display: none; color: transparent; text-decoration: none; font-size: 1rem; font-weight: 500; font-family: var(--fx-font, 'Jost', -apple-system, BlinkMacSystemFont, sans-serif);">

                      €00,00

                    </span>

                  `)}

                </div>

                ${selectedDestination === 'BATTISCOPA' ? (currentCompareAtPrice && currentCompareAtPrice > currentPrice ? `
                  
                ` : '') : (displayComparePrice ? `

                  

                ` : currentCompareAtPrice && currentCompareAtPrice > currentPrice ? `

                  

                ` : '')}

                ${selectedDestination === 'BATTISCOPA' ? `<span class="fx-box-price" style="display:block;font-size:0.75rem;color:#b2bec3;font-weight:700;margin-top:0.25rem;text-align:center;font-family:var(--fx-font,Jost,sans-serif);">IVA incl.</span>` : `<span class="fx-box-price" style="display:block;font-size:0.75rem;color:#b2bec3;font-weight:700;margin-top:0.25rem;text-align:center;font-family:var(--fx-font,Jost,sans-serif);">${this.formatMoney(window.khScatolaPerMq((typeof displayPrice!=='undefined'?displayPrice:null)||currentPrice, currentPrice))}/scatola · IVA incl.</span>`}

              ` : `

                <div class="fx-price-row" style="display: flex; align-items: center; justify-content: center; gap: 0.5rem; flex-wrap: wrap; min-height: 40px;">

                  <span class="fx-price" style="font-weight: 800; color: var(--fx-primary, #2D5A3D); font-size: 1.3rem; line-height: 1; font-family: var(--fx-font, 'Jost', -apple-system, BlinkMacSystemFont, sans-serif); letter-spacing: -0.02em;">

                    Da €00,00<span style="font-size: 0.8em; font-weight: inherit;">${priceUnit}</span>

                  </span>

                </div>

              `}

            </div>

          </div>

        `;

      } else {

        // Desktop: layout originale

        card.innerHTML = `

          <div class="fx-variant-visual" style="position: relative; display: flex; justify-content: center; align-items: center; min-height: 140px; margin-bottom: 0; overflow: visible !important; background: transparent; border: none; box-shadow: none; padding: 0;">

            ${tileVisual || ''}

          </div>

          <div class="fx-style-info">

            <div class="fx-price-container" style="width: 100%; text-align: center; background: rgba(248,249,250,0.95); border-radius: 12px; padding: 0.75rem 0.5rem; min-height: 112px; border: none; border-top: 1px solid #ebebeb; position: relative; overflow: visible; transition: var(--fx-transition, all 0.3s cubic-bezier(0.4, 0, 0.2, 1)); margin: 0; box-sizing: border-box;">

              <h4 style="margin: 0 0 0.25rem 0; color: var(--fx-text, #2d3436); font-size: 1.1rem; font-weight: 700; letter-spacing: -0.02em; font-family: var(--fx-font, 'Jost', -apple-system, BlinkMacSystemFont, sans-serif);">${thickness.label}</h4>

              <p style="margin: 0 0 0.5rem 0; color: var(--fx-text-muted, #636e72); font-size: 0.85rem; font-family: var(--fx-font, 'Jost', -apple-system, BlinkMacSystemFont, sans-serif);">${thickness.description}</p>

              ${(currentPrice || displayPrice) ? `

                <div class="fx-price-row" style="display: flex; align-items: center; justify-content: center; gap: 0.5rem; flex-wrap: wrap;">

                  <span class="fx-price" style="font-weight: 800; color: var(--fx-primary, #2D5A3D); font-size: 1.3rem; line-height: 1; font-family: var(--fx-font, 'Jost', -apple-system, BlinkMacSystemFont, sans-serif); letter-spacing: -0.02em;">

                    ${selectedDestination === 'BATTISCOPA' ? this.formatMoney(currentPrice) : this.formatMoney(displayPrice || currentPrice)}<span style="font-size: 0.8em; font-weight: inherit;">${selectedDestination === 'BATTISCOPA' ? '/scatola' : priceUnit}</span>

                  </span>

                  ${selectedDestination === 'BATTISCOPA' ? (currentCompareAtPrice && currentCompareAtPrice > currentPrice ? `
                    <span class="fx-step-price-was">
                      ${this.formatMoney(currentCompareAtPrice)}
                    </span>
                  ` : '') : (displayComparePrice ? `

                    <span class="fx-step-price-was">

                      ${this.formatMoney(displayComparePrice)}

                    </span>

                  ` : currentCompareAtPrice && currentCompareAtPrice > currentPrice ? `

                    <span class="fx-step-price-was">

                      ${this.formatMoney(currentCompareAtPrice)}

                    </span>

                  ` : displayComparePrice ? `

                    <span class="fx-step-price-was">

                      ${this.formatMoney(displayComparePrice)}

                    </span>

                  ` : `

                    <span class="fx-original-price" style="display: none; color: transparent; text-decoration: none; font-size: 1rem; font-weight: 500; font-family: var(--fx-font, 'Jost', -apple-system, BlinkMacSystemFont, sans-serif);">

                      €00,00

                    </span>

                  `)}

                </div>

                ${selectedDestination === 'BATTISCOPA' ? (currentCompareAtPrice && currentCompareAtPrice > currentPrice ? `
                  
                ` : '') : (displayComparePrice ? `

                  

                ` : currentCompareAtPrice && currentCompareAtPrice > currentPrice ? `

                  

                ` : '')}

                ${selectedDestination === 'BATTISCOPA' ? `<span class="fx-box-price" style="display:block;font-size:0.75rem;color:#b2bec3;font-weight:700;margin-top:0.25rem;text-align:center;font-family:var(--fx-font,Jost,sans-serif);">IVA incl.</span>` : `<span class="fx-box-price" style="display:block;font-size:0.75rem;color:#b2bec3;font-weight:700;margin-top:0.25rem;text-align:center;font-family:var(--fx-font,Jost,sans-serif);">${this.formatMoney(window.khScatolaPerMq((typeof displayPrice!=='undefined'?displayPrice:null)||currentPrice, currentPrice))}/scatola · IVA incl.</span>`}

              ` : `

                <div class="fx-price-row" style="display: flex; align-items: center; justify-content: center; gap: 0.5rem; flex-wrap: wrap; min-height: 40px;">

                  <span class="fx-price" style="font-weight: 800; color: var(--fx-primary, #2D5A3D); font-size: 1.3rem; line-height: 1; font-family: var(--fx-font, 'Jost', -apple-system, BlinkMacSystemFont, sans-serif); letter-spacing: -0.02em;">

                    Da €00,00<span style="font-size: 0.8em; font-weight: inherit;">${priceUnit}</span>

                  </span>

                </div>

              `}

            </div>

          </div>

        `;

      }

      

      // Gestione click singolo e doppio (desktop e mobile)

      let clickCount = 0;

      let clickTimer = null;

      

      const handleSelection = () => {

        container.querySelectorAll('.fx-style-card').forEach(c => {

          c.classList.remove('selected');

        });

        card.classList.add('selected');



        // Step 5: Spessore → Quantità (fxNext5)

        const nextBtn = document.getElementById('fxNext5');

        if (nextBtn) nextBtn.disabled = false;



        if (window.productConfigurator) {

          window.productConfigurator.configuration.thickness = thickness.value;

        }

      };



      const proceedToNext = () => {

        handleSelection();

        // Step 5: Spessore → Quantità (fxNext5)

        const nextBtn = document.getElementById('fxNext5');

        if (nextBtn) {

          nextBtn.disabled = false;

          setTimeout(() => nextBtn.click(), 50);

        }

      };

      

      // Gestione unificata per click e tap

      card.addEventListener('click', function(e) {

        clickCount++;

        

        if (clickCount === 1) {

          // Primo click/tap

          clickTimer = setTimeout(() => {

            // Click singolo

            handleSelection();

            clickCount = 0;

          }, 250);

        } else if (clickCount === 2) {

          // Doppio click/tap

          clearTimeout(clickTimer);

          proceedToNext();

          clickCount = 0;

        }

      });

      

      // Previeni doppio tap zoom su iOS

      card.addEventListener('touchstart', function(e) {

        if (e.touches.length > 1) {

          e.preventDefault();

        }

      });



      container.appendChild(card);

    });



    this.addDiscountBadgesToStep(container);

  },



  // Aggiunge badge sconto in position:absolute sulle card che hanno prezzo e prezzo barrato

  addDiscountBadgesToStep(container) {

    if (!container) return;



    container.querySelectorAll('.fx-style-card').forEach(card => {

      // Rimuovi badge overlay esistente per evitare duplicati

      const existing = card.querySelector('.fx-overlay-badge');

      if (existing) existing.remove();



      const priceEl = card.querySelector('.fx-price');

      const compareEl = card.querySelector('.fx-step-price-was');

      if (!priceEl || !compareEl) return;



      // Estrai il valore numerico dal primo text node di .fx-price (ignora span figli /mq, )

      let priceText = '';

      for (const node of priceEl.childNodes) {

        if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {

          priceText = node.textContent.trim();

          break;

        }

      }

      if (!priceText) priceText = priceEl.textContent;



      const compareText = compareEl.textContent.trim();



      // Converti in numero (gestisce formato italiano con virgola come decimale)

      const toNum = (s) => parseFloat(s.replace(/[^\d,]/g, '').replace(',', '.')) || 0;

      const price = toNum(priceText);

      const compare = toNum(compareText);



      if (!price || !compare || compare <= price) return;



      const pct = Math.round((1 - price / compare) * 100);

      if (pct <= 0) return;



      // Trova la riga del prezzo per inserire il badge accanto al prezzo barrato

      const priceRow = card.querySelector('.fx-price-row');

      if (!priceRow) return;



      const badge = document.createElement('span');

      badge.className = 'fx-overlay-badge';

      badge.textContent = '';

      priceRow.appendChild(badge);

    });

  },



  // Popola le finiture nello step 4 (reindirizza a populateThickness)

  populateFinishes() {

    // Chiama populateThickness per retrocompatibilità

    this.populateThickness();

  },



  // ========================================

  // HELPER: Normalizza stringa per matching (rimuove accenti, spazi, caratteri speciali)

  // ========================================

  normalizeForMatching(str) {

    if (!str) return '';

    return str

      .toLowerCase()

      .replace(/æ/g, 'ae')

      .replace(/œ/g, 'oe')

      .replace(/[éèê]/g, 'e')

      .replace(/[àâ]/g, 'a')

      .replace(/[ùû]/g, 'u')

      .replace(/[òô]/g, 'o')

      .replace(/[ìî]/g, 'i')

      .replace(/['`´]/g, '')

      .replace(/[^a-z0-9]/g, '');

  },



  // ========================================

  // HELPER: Estrai nome collezione dal titolo prodotto

  // ========================================

  extractCollectionName(productTitle) {

    if (!productTitle) return '';



    // Rimuovi brand names (Supergres, Florim, Tagina, Imola, Rex, Cerim, etc.)

    let title = productTitle

      .replace(/\s+by\s+\w+/gi, '')                    // "by Supergres", "by Florim", etc.

      .replace(/\s*\(\w+\)\s*/gi, '')                  // "(Supergres)", "(Florim)", etc.

      .replace(/\s+(supergres|florim|tagina|imola|rex|cerim|refin|ceramiche|ceramica|la\s*faenza|lafaenza|leonardo)\s*/gi, '')

      .replace(/\s*[-–—]\s*gres\s+porcellanato.*/gi, '')  // "- Gres Porcellanato..."

      .replace(/\s*[-–—]\s*ceramica.*/gi, '')             // "- Ceramica..."

      .split(/\s*[-–—]\s*/)[0]                         // Prende prima parte prima del trattino

      .trim();



    return title;

  },



  // ========================================

  // HELPER: Normalizza vendor/produttore per confronto

  // ========================================

  normalizeVendor(str) {

    if (!str) return '';

    return str.toUpperCase().replace(/[^A-Z0-9]/g, '').trim();

  },



  // ========================================

  // HELPER: Filtra collezioni per vendor/produttore - AUTOMATICO

  // Confronta il vendor del prodotto con il campo "produttore" nel JSON

  // Non serve aggiungere manualmente ogni vendor!

  // ========================================

  filterCollezioniByVendor(collezioni, productVendor) {

    if (!collezioni || collezioni.length === 0) return [];



    const vendorNorm = this.normalizeVendor(productVendor);




    // Prima cerca collezioni con produttore corrispondente al vendor

    // NOTA: Il JSON può usare sia "produttore" che "vendor" come campo

    let filtered = collezioni.filter(collezione => {

      // Cerca in entrambi i campi: "produttore" o "vendor"

      const collezioneProduttore = this.normalizeVendor(collezione.produttore || collezione.vendor || '');



      // Se vendor vuoto, cerca in TUTTE le collezioni

      if (!vendorNorm) return true;



      // Se la collezione ha un produttore/vendor, verifica match

      if (collezioneProduttore) {

        // Match se vendor contiene produttore o viceversa

        return vendorNorm.includes(collezioneProduttore) || collezioneProduttore.includes(vendorNorm);

      }



      // Collezioni senza produttore = Ceramica Euro (default)

      return false;

    });



    // Se non trova collezioni con produttore corrispondente, cerca in quelle senza produttore

    if (filtered.length === 0) {


      filtered = collezioni.filter(collezione => {

        // Collezioni senza produttore specifico

        return !collezione.produttore || collezione.produttore === '';

      });

    }



    // Ultimo fallback: cerca in TUTTE le collezioni

    if (filtered.length === 0) {


      filtered = collezioni;

    }




    return filtered;

  },



  // ========================================

  // HELPER: Trova la collezione corrispondente al prodotto (SMART MATCHING)

  // ========================================

  findCollezioneByProduct(productTitle) {

    if (!this.ceramicaSpecifiche?.collezioni || !productTitle) {


      return null;

    }



    const collectionName = this.extractCollectionName(productTitle);

    const productNorm = this.normalizeForMatching(collectionName);



    // Ottieni il vendor del prodotto (se disponibile)

    const productVendor = this.product?.vendor || '';



    // Filtra le collezioni per vendor/produttore - AUTOMATICO

    const filteredCollezioni = this.filterCollezioniByVendor(

      this.ceramicaSpecifiche.collezioni,

      productVendor

    );













    // PRIORITÀ 1: Match esatto normalizzato


    // KH-FIX PRIORITA 0: match esatto sul titolo COMPLETO + vendor-aware (evita "MET-ALL WALL"->"METAL" e omonimi cross-vendor)
    const fullTitleNorm = this.normalizeForMatching(productTitle);
    if (fullTitleNorm) {
      const exactMatches = filteredCollezioni.filter(c => this.normalizeForMatching(c.nome) === fullTitleNorm);
      if (exactMatches.length === 1) return exactMatches[0];
      if (exactMatches.length > 1) {
        const vNorm = this.normalizeForMatching(this.product?.vendor || "");
        const byVendor = exactMatches.find(c => { const pn = this.normalizeForMatching(c.produttore || ""); return pn && vNorm && (pn === vNorm || vNorm.includes(pn) || pn.includes(vNorm)); });
        return byVendor || exactMatches[0];
      }
    }

    for (const collezione of filteredCollezioni) {

      const collezioneNorm = this.normalizeForMatching(collezione.nome);

      if (collezioneNorm === productNorm) {




        return collezione;

      }

    }



    // PRIORITÀ 2: Match senza numeri di versione (WALKS/1.0 = WALKS 1.0, NEUTRA 6.0 = NEUTRA6.0)


    const productBase = productNorm.replace(/\d+/g, '');  // Rimuove tutti i numeri

    for (const collezione of filteredCollezioni) {

      const collezioneNorm = this.normalizeForMatching(collezione.nome);

      const collezioneBase = collezioneNorm.replace(/\d+/g, '');



      if (productBase === collezioneBase && productBase.length >= 3) {




        return collezione;

      }

    }



    // PRIORITÀ 3: Match parziale (uno contiene l'altro)


    // KH-FIX: match parziale vendor-aware + nome piu lungo (evita bug tipo METAL)
    const _p3 = [];
    for (const collezione of filteredCollezioni) {
      const collezioneNorm = this.normalizeForMatching(collezione.nome);
      if (collezioneNorm.length < 4) continue;
      if (productNorm.includes(collezioneNorm) || collezioneNorm.includes(productNorm)) {
        _p3.push(collezione);
      }
    }
    if (_p3.length) {
      const _vN = this.normalizeForMatching(this.product?.vendor || "");
      const _vm = _p3.filter(c => { const pn = this.normalizeForMatching(c.produttore || ""); return pn && _vN && (pn === _vN || _vN.includes(pn) || pn.includes(_vN)); });
      const _pool = _vm.length ? _vm : _p3;
      _pool.sort((a,b) => this.normalizeForMatching(b.nome).length - this.normalizeForMatching(a.nome).length);
      return _pool[0];
    }



    // PRIORITÀ 4: Match parole nel titolo originale (per nomi con spazi: "ROCK SALT", "PURITY of MARBLE")


    const titleLower = productTitle.toLowerCase();

    for (const collezione of filteredCollezioni) {

      const collezioneLower = collezione.nome.toLowerCase();



      // Cerca il nome collezione completo nel titolo

      if (collezioneLower.length >= 4 && titleLower.includes(collezioneLower)) {




        return collezione;

      }

    }



    // PRIORITÀ 5: Match fuzzy - prima parola significativa


    const firstWord = collectionName.split(/\s+/)[0];

    if (firstWord && firstWord.length >= 4) {

      const firstWordNorm = this.normalizeForMatching(firstWord);


      for (const collezione of filteredCollezioni) {

        const collezioneNorm = this.normalizeForMatching(collezione.nome);

        const collezioneFirstWord = this.normalizeForMatching(collezione.nome.split(/\s+/)[0]);



        if (firstWordNorm === collezioneFirstWord || firstWordNorm === collezioneNorm) {




          return collezione;

        }

      }

    }






    return null;

  },



  // ========================================

  // HELPER: Ottieni TUTTE le specifiche di una variante in una volta sola

  // Più efficiente di chiamare 4 funzioni separate

  // ========================================

  getSpecificheComplete(formato, spessore, productTitle, finitura, destinazione) {

    const result = {

      mq_box: null,

      kg_box: null,

      pezzi_box: null,

      box_pal: null,

      mq_pal: null,

      kg_pal: null,

      collezione: null,

      variante: null

    };



    if (!this.ceramicaSpecifiche?.collezioni) return result;



    const title = productTitle || this.product?.title;

    const collezione = this.findCollezioneByProduct(title);



    if (collezione) {

      const variante = this.findVarianteInCollezione(collezione, formato, spessore, finitura, destinazione);

      if (variante) {

        result.mq_box = variante.mq_box || null;

        result.kg_box = variante.kg_box || null;

        result.pezzi_box = variante.pezzi_box || null;

        result.box_pal = variante.box_pal || null;

        result.mq_pal = variante.mq_pal || null;

        result.kg_pal = variante.kg_pal || null;

        result.collezione = collezione.nome;

        result.variante = variante;




      }

    }



    return result;

  },



  // ========================================

  // HELPER: Cerca variante in una collezione specifica

  // ========================================

  findVarianteInCollezione(collezione, formato, spessore, finitura, destinazione) {

    if (!collezione?.varianti) return null;



    // Check if we're looking for battiscopa

    const isBattiscopa = destinazione === 'BATTISCOPA' || formato.toLowerCase().includes('battiscopa');



    // Estrai solo la parte dimensionale del formato (es: "20x20-naturale" → "20x20")

    // Rimuovi suffissi come -naturale, -r9, -r10, -parete, -lux, -fluid, -battiscopa, etc.

    let formatoClean = (formato || '').replace(/,/g, '.')

      .replace(/-+(naturale|r9|r10|r11|parete|lux|fluid|soft|comfort|bocciardato|strutturato|strutturamove|strutturasign|strutturanet|twist|stripe|riga|pliss|levigato|levigata|patinato|patinata|lappato|lappata|liscio|satinato|lucido|realupstrideup|realup|strideup|grip|battiscopa)/gi, '')

      .replace(/-+\d+mm/gi, '') // Rimuove spessori come -20mm, -9mm, -12mm

      .trim();



    const formatoNorm = formatoClean.replace(/\s/g, '').replace(/[x×X]/g, 'x').toLowerCase();



    // Debug battiscopa

    if (isBattiscopa) {


    }



    // Helper: estrae solo le dimensioni dal formato (rimuove Rettificato, Squadrato, Mosaico, Battiscopa, etc.)

    const extractDimensions = (fmt) => {

      return fmt

        .replace(/\s*\(battiscopa\)\s*/gi, '') // Rimuove (Battiscopa) dal formato JSON

        .replace(/\s*(rettificato|squadrato|mosaico|naturale|lappato|lappata|levigato|levigata|patinato|patinata|satinato|lucido|bocciardato|strutturato|strutturamove|strutturasign|strutturanet|twist|stripe|riga|pliss|spazzolato|fiammato|bouchardé|matt|grip|antislip|realup)\s*/gi, '')

        .replace(/\s/g, '')

        .replace(/[x×X]/g, 'x')

        .toLowerCase()

        .trim();

    };

    const spessoreNorm = spessore ? spessore.replace(/\s/g, '').replace(/,/g, '.').toLowerCase() : null;

    const finituraNorm = finitura ? finitura.toLowerCase() : null;

    const isEsterno = destinazione === 'ESTERNO';



    // Debug: mostra normalizzazione formato

    if (formato !== formatoClean) {


    }



    // PRIORITÀ 1: Match esatto con formato + spessore + finitura + outdoor

    for (const variante of collezione.varianti) {

      const formatoVar = extractDimensions(variante.formato);

      if (formatoVar !== formatoNorm) continue;



      // Filtra per battiscopa: se cerchiamo battiscopa, deve avere tipo=battiscopa

      // Se NON cerchiamo battiscopa, salta le varianti battiscopa

      const varIsBattiscopa = variante.tipo?.toLowerCase() === 'battiscopa';

      if (isBattiscopa && !varIsBattiscopa) continue;

      if (!isBattiscopa && varIsBattiscopa) continue;



      // Se battiscopa, ritorna subito la variante trovata

      if (isBattiscopa && varIsBattiscopa) {


        return variante;

      }



      // Per ESTERNO, cerca varianti outdoor o 20mm o R11

      if (isEsterno) {

        const isOutdoor = variante.outdoor === true;

        const is20mm = /\b20\s*mm\b/.test((variante.spessore || '').toLowerCase());

        const isR11 = variante.finitura?.toLowerCase().includes('r11');



        if (isOutdoor || is20mm || isR11) {


          return variante;

        }

      }



      // Match con spessore se specificato

      if (spessoreNorm && variante.spessore) {

        const spessoreVar = variante.spessore.replace(/\s/g, '').replace(/,/g, '.').toLowerCase();

        if (spessoreVar.includes(spessoreNorm) || spessoreNorm.includes(spessoreVar.replace('mm', ''))) {

          // Match con finitura se specificata

          if (finituraNorm && variante.finitura) {

            const finituraVar = variante.finitura.toLowerCase();

            if (finituraVar.includes(finituraNorm) || finituraNorm.includes(finituraVar)) {

              return variante;

            }

          } else {

            return variante;

          }

        }

      }

    }



    // PRIORITÀ 2: Match solo con formato + spessore

    for (const variante of collezione.varianti) {

      const formatoVar = extractDimensions(variante.formato);

      if (formatoVar !== formatoNorm) continue;



      // Filtra battiscopa

      const varIsBattiscopa = variante.tipo?.toLowerCase() === 'battiscopa';

      if (isBattiscopa && !varIsBattiscopa) continue;

      if (!isBattiscopa && varIsBattiscopa) continue;



      // Se battiscopa, ritorna subito

      if (isBattiscopa && varIsBattiscopa) {


        return variante;

      }



      if (spessoreNorm && variante.spessore) {

        const spessoreVar = variante.spessore.replace(/\s/g, '').replace(/,/g, '.').toLowerCase();

        if (spessoreVar.includes(spessoreNorm) || spessoreNorm.includes(spessoreVar.replace('mm', ''))) {

          // Per INTERNO, salta le varianti outdoor

          if (!isEsterno && variante.outdoor === true) continue;

          return variante;

        }

      }

    }



    // PRIORITÀ 3: Match solo con formato (primo risultato non-outdoor per INTERNO)

    for (const variante of collezione.varianti) {

      const formatoVar = extractDimensions(variante.formato);

      if (formatoVar === formatoNorm) {

        // Filtra battiscopa

        const varIsBattiscopa = variante.tipo?.toLowerCase() === 'battiscopa';

        if (isBattiscopa && !varIsBattiscopa) continue;

        if (!isBattiscopa && varIsBattiscopa) continue;



        // Se battiscopa, ritorna subito

        if (isBattiscopa && varIsBattiscopa) {


          return variante;

        }



        if (!isEsterno && variante.outdoor === true) continue;

        return variante;

      }

    }



    return null;

  },



  // Funzione helper per ottenere m² dal JSON delle specifiche

  getMqFromSpecifiche(formato, spessore, productTitle, finitura, destinazione) {

    if (!this.ceramicaSpecifiche?.collezioni) return null;



    // Usa il titolo del prodotto corrente se non passato

    const title = productTitle || this.product?.title;



    // 🆕 FIX 22-GEN-2026: Per battiscopa usa ml_box (metri lineari) invece di mq_box

    const isBattiscopa = destinazione === 'BATTISCOPA' || formato?.toLowerCase().includes('battiscopa');



    // PRIORITÀ 1: Cerca nella collezione specifica del prodotto

    const collezione = this.findCollezioneByProduct(title);

    if (collezione) {

      const variante = this.findVarianteInCollezione(collezione, formato, spessore, finitura, destinazione);

      if (variante) {

        // Per battiscopa usa ml_box se disponibile, altrimenti mq_box

        if (isBattiscopa || variante.tipo === 'battiscopa') {

          if (variante.ml_box) {


            return variante.ml_box;

          }

        }

        if (variante.mq_box) {


          return variante.mq_box;

        }

      }

    }



    // PRIORITÀ 2: Fallback - cerca nelle collezioni filtrate per vendor

    const formatoNormalizzato = formato.replace(/\s/g, '').replace(/[x×X]/g, 'x').toLowerCase();

    const fallbackCollezioni = this.filterCollezioniByVendor(this.ceramicaSpecifiche.collezioni, this.product?.vendor || '');

    for (const coll of fallbackCollezioni) {

      if (coll.varianti) {

        for (const variante of coll.varianti) {

          const formatoVariante = variante.formato.replace(/\s/g, '').replace(/[x×X]/g, 'x').toLowerCase();

          if (formatoVariante === formatoNormalizzato) {

            if (spessore && variante.spessore) {

              const spessoreNormalizzato = spessore.replace(/\s/g, '').replace(/,/g, '.').toLowerCase();

              const spessoreVariante = variante.spessore.replace(/\s/g, '').replace(/,/g, '.').toLowerCase();

              if (spessoreVariante === spessoreNormalizzato) {

                // Per battiscopa usa ml_box se disponibile

                if ((isBattiscopa || variante.tipo === 'battiscopa') && variante.ml_box) {

                  return variante.ml_box;

                }

                return variante.mq_box;

              }

            } else if (!spessore) {

              // Per battiscopa usa ml_box se disponibile

              if ((isBattiscopa || variante.tipo === 'battiscopa') && variante.ml_box) {

                return variante.ml_box;

              }

              return variante.mq_box;

            }

          }

        }

      }

    }



    return null;

  },



  // Funzione helper per ottenere kg per box dal JSON delle specifiche

  getKgFromSpecifiche(formato, spessore, productTitle, finitura, destinazione) {

    if (!this.ceramicaSpecifiche?.collezioni) return null;



    // Usa il titolo del prodotto corrente se non passato

    const title = productTitle || this.product?.title;



    // PRIORITÀ 1: Cerca nella collezione specifica del prodotto

    const collezione = this.findCollezioneByProduct(title);

    if (collezione) {

      const variante = this.findVarianteInCollezione(collezione, formato, spessore, finitura, destinazione);

      if (variante?.kg_box) {


        return variante.kg_box;

      }

    }



    // PRIORITÀ 2: Fallback - cerca nelle collezioni filtrate per vendor

    const formatoNormalizzato = formato.replace(/\s/g, '').replace(/[x×X]/g, 'x').toLowerCase();

    const fallbackCollezioni = this.filterCollezioniByVendor(this.ceramicaSpecifiche.collezioni, this.product?.vendor || '');

    for (const coll of fallbackCollezioni) {

      if (coll.varianti) {

        for (const variante of coll.varianti) {

          const formatoVariante = variante.formato.replace(/\s/g, '').replace(/[x×X]/g, 'x').toLowerCase();

          if (formatoVariante === formatoNormalizzato) {

            if (spessore && variante.spessore) {

              const spessoreNormalizzato = spessore.replace(/\s/g, '').replace(/,/g, '.').toLowerCase();

              const spessoreVariante = variante.spessore.replace(/\s/g, '').replace(/,/g, '.').toLowerCase();

              if (spessoreVariante === spessoreNormalizzato) {

                return variante.kg_box;

              }

            } else if (!spessore) {

              return variante.kg_box;

            }

          }

        }

      }

    }



    return null;

  },



  // Funzione helper per ottenere box per pallet dal JSON delle specifiche

  getBoxPerPalletFromSpecifiche(formato, spessore, productTitle, finitura, destinazione) {

    if (!this.ceramicaSpecifiche?.collezioni) return null;



    // Usa il titolo del prodotto corrente se non passato

    const title = productTitle || this.product?.title;



    // PRIORITÀ 1: Cerca nella collezione specifica del prodotto

    const collezione = this.findCollezioneByProduct(title);

    if (collezione) {

      const variante = this.findVarianteInCollezione(collezione, formato, spessore, finitura, destinazione);

      if (variante?.box_pal) {


        return variante.box_pal;

      }

    }



    // PRIORITÀ 2: Fallback - cerca nelle collezioni filtrate per vendor

    const formatoNormalizzato = formato.replace(/\s/g, '').replace(/[x×X]/g, 'x').toLowerCase();

    const fallbackCollezioni = this.filterCollezioniByVendor(this.ceramicaSpecifiche.collezioni, this.product?.vendor || '');

    for (const coll of fallbackCollezioni) {

      if (coll.varianti) {

        for (const variante of coll.varianti) {

          const formatoVariante = variante.formato.replace(/\s/g, '').replace(/[x×X]/g, 'x').toLowerCase();

          if (formatoVariante === formatoNormalizzato) {

            if (spessore && variante.spessore) {

              const spessoreNormalizzato = spessore.replace(/\s/g, '').replace(/,/g, '.').toLowerCase();

              const spessoreVariante = variante.spessore.replace(/\s/g, '').replace(/,/g, '.').toLowerCase();

              if (spessoreVariante === spessoreNormalizzato) {

                return variante.box_pal;

              }

            } else if (!spessore) {

              return variante.box_pal;

            }

          }

        }

      }

    }



    return null;

  },



  // Funzione helper per ottenere pezzi per box dal JSON delle specifiche

  getPezziFromSpecifiche(formato, spessore, productTitle, finitura, destinazione) {

    if (!this.ceramicaSpecifiche?.collezioni) return null;



    // Usa il titolo del prodotto corrente se non passato

    const title = productTitle || this.product?.title;



    // PRIORITÀ 1: Cerca nella collezione specifica del prodotto

    const collezione = this.findCollezioneByProduct(title);

    if (collezione) {

      const variante = this.findVarianteInCollezione(collezione, formato, spessore, finitura, destinazione);

      if (variante?.pezzi_box) {


        return variante.pezzi_box;

      }

    }



    // PRIORITÀ 2: Fallback - cerca nelle collezioni filtrate per vendor

    const formatoNormalizzato = formato.replace(/\s/g, '').replace(/[x×X]/g, 'x').toLowerCase();

    const fallbackCollezioni = this.filterCollezioniByVendor(this.ceramicaSpecifiche.collezioni, this.product?.vendor || '');

    for (const coll of fallbackCollezioni) {

      if (coll.varianti) {

        for (const variante of coll.varianti) {

          const formatoVariante = variante.formato.replace(/\s/g, '').replace(/[x×X]/g, 'x').toLowerCase();

          if (formatoVariante === formatoNormalizzato) {

            if (spessore && variante.spessore) {

              const spessoreNormalizzato = spessore.replace(/\s/g, '').replace(/,/g, '.').toLowerCase();

              const spessoreVariante = variante.spessore.replace(/\s/g, '').replace(/,/g, '.').toLowerCase();

              if (spessoreVariante === spessoreNormalizzato) {

                return variante.pezzi_box;

              }

            } else if (!spessore) {

              return variante.pezzi_box;

            }

          }

        }

      }

    }



    return null;

  },



  // Valori di fallback per formati comuni

  getMqFallback(formato) {

    const formatoNormalizzato = formato.replace(/\s/g, '').replace(/[x×X]/g, 'x').toLowerCase();

    const defaultMq = {

      '120x120': 2.88,

      '80x80': 1.28,

      '60x120': 1.44,

      '60x60': 1.08,

      '40x80': 0.96,

      '40x60': 0.96,

      '40x40': 0.96,

      '30x120': 1.08,

      '30x90': 1.35,

      '30x60': 1.08,

      '30x30': 1.08,

      '29x25': 0.44,

      '25x50': 1.25,

      '25x25': 1.25,

      '20x120': 1.20,

      '20x40': 1.04,

      '20x20': 1.04,

      '10x60': 0.84,

      '10x30': 0.96,

      '7.5x30': 1.08

    };



    return defaultMq[formatoNormalizzato] || null;

  },



  // Popola il selettore di quantità nello step 5

  async populateQuantitySelector() {

    const container = document.getElementById('fxQuantityContainer');

    if (!container) {

      return;

    }



    // Assicura che il JSON delle specifiche tecniche sia caricato

    await this.loadCeramicaSpecifiche();



    // Debug: verifica che le specifiche siano disponibili




    container.innerHTML = '';



    // Recupera i dati della piastrella selezionata

    const selectedFormat = window.productConfigurator?.configuration?.format;

    const selectedColor = window.productConfigurator?.configuration?.color;

    const selectedThickness = window.productConfigurator?.configuration?.thickness;

    const selectedDestination = window.productConfigurator?.configuration?.destination || this.selectedDestination;

    const selectedFinitura = window.productConfigurator?.configuration?.finituraLabel || window.productConfigurator?.configuration?.finitura;



    // Determina l'unità di prezzo: /box per BATTISCOPA, /mq per il resto

    const priceUnitQty = selectedDestination === 'BATTISCOPA' ? '/box' : '/mq';



    // Trova i dettagli per creare il riepilogo

    const colorDetails = this.colorOptions.find(c => c.value === selectedColor);

    const formatDetails = this.formatOptions.find(f => f.value === selectedFormat);

    const thicknessDetails = this.thicknessOptions.find(t => t.value === selectedThickness);



    // Crea il nome completo del prodotto (per compatibilità)

    const productName = [

      colorDetails?.label,

      formatDetails?.label,

      thicknessDetails?.label

    ].filter(Boolean).join(' - ') || 'Configurazione personalizzata';



    // Elementi separati per layout in colonna

    // Rimuovi "PARETE" e "PAVIMENTO" dal label visualizzato

    const productColorName = (colorDetails?.label || '').replace(/ PARETE$/i, '').replace(/ PAVIMENTO$/i, '').trim();

    let productFormatName = this.convertFinituraToFemminile(formatDetails?.label || '');



    // 🔧 Usa config.finituraLabel (salvato dallo step 3 Finitura) - DINAMICO, non serve lista!

    const configFinituraLabel = window.productConfigurator?.configuration?.finituraLabel || '';

    let productFinituraName = configFinituraLabel;



    // Se abbiamo la finitura, rimuovila dal formato per non mostrarla duplicata

    if (productFinituraName) {

      // Escape caratteri speciali regex (es. + in RealUp+StrideUp)

      const finituraEscaped = productFinituraName.replace(/[+*?^${}()|[\]\\]/g, '\\$&');

      const replaceRegex = new RegExp(`\\s+${finituraEscaped}\\b`, 'gi');

      productFormatName = productFormatName.replace(replaceRegex, '').trim();

    }



    const productThicknessName = thicknessDetails?.label || '';



    // Calcola i mq per scatola basandosi sul formato

    let mqPerBox = 1.08; // Default



    // Prima prova a prendere i m² dal JSON delle specifiche tecniche

    if (selectedFormat && this.ceramicaSpecifiche?.collezioni) {

      const mqFromJson = this.getMqFromSpecifiche(selectedFormat, selectedThickness, this.product?.title, selectedFinitura, selectedDestination);


      if (mqFromJson) {

        mqPerBox = mqFromJson;

      } else {


        // Usa la tabella di fallback invece del calcolo approssimativo

        const formatoNormalizzato = selectedFormat.replace(/\s/g, '').replace(/[x×X]/g, 'x').toLowerCase();

        const defaultMq = {

          '120x120': 2.88,

          '80x80': 1.28,

          '60x120': 1.44,

          '60x60': 1.08,

          '40x80': 0.96,

          '40x60': 0.96,

          '40x40': 0.96,

          '30x120': 1.08,

          '30x90': 1.35,

          '30x60': 1.08,

          '30x30': 1.08,

          '29x25': 0.44,

          '25x50': 1.25,

          '25x25': 1.25,

          '20x120': 1.20,

          '20x40': 1.04,

          '20x20': 1.04,

          '10x60': 0.84,

          '10x30': 0.96,

          '7.5x30': 1.08

        };

        mqPerBox = defaultMq[formatoNormalizzato] || mqPerBox;

      }

    } else if (selectedFormat) {

      // Usa la tabella di fallback invece del calcolo approssimativo

      const formatoNormalizzato = selectedFormat.replace(/\s/g, '').replace(/[x×X]/g, 'x').toLowerCase();

      const spessoreNormalizzato = selectedThickness?.replace(/\s/g, '').toLowerCase();



      // CASO SPECIALE: 60x120 da 20mm ha 0.72 mq per scatola invece di 1.44

      if (formatoNormalizzato === '60x120' && spessoreNormalizzato?.includes('20mm')) {

        mqPerBox = 0.72;

      } else {

        const defaultMq = {

          '120x120': 2.88,

          '80x80': 1.28,

          '60x120': 1.44,

          '60x60': 1.08,

          '40x80': 0.96,

          '40x60': 0.96,

          '40x40': 0.96,

          '30x120': 1.08,

          '30x90': 1.35,

          '30x60': 1.08,

          '30x30': 1.08,

          '29x25': 0.44,

          '25x50': 1.25,

          '25x25': 1.25,

          '20x120': 1.20,

          '20x40': 1.04,

          '20x20': 1.04,

          '10x60': 0.84,

          '10x30': 0.96,

          '7.5x30': 1.08

        };

        mqPerBox = defaultMq[formatoNormalizzato] || mqPerBox;

      }

    }



    // Trova il prezzo della variante corretta

    let currentPrice = null;

    let currentCompareAtPrice = null;



    // Recupera la variante salvata nel configuratore (se esiste)

    const savedVariantId = window.productConfigurator?.configuration?.variantId;




    if (savedVariantId && this.product?.variants) {

      // Usa la variante già selezionata MA SOLO SE CORRISPONDE AL FORMATO CORRENTE

      const savedVariant = this.product.variants.find(v => v.id === savedVariantId);

      if (savedVariant) {

        // 🔧 FIX 22-DIC-2024: Verifica che la variante salvata corrisponda al formato selezionato

        // Estrai formato base dal selectedFormat (es: "120x280-lappata" → "120x280")

        let formatBaseCheck = selectedFormat || '';

        formatBaseCheck = formatBaseCheck.replace('-parete', '').replace('-lux', '').replace('-fluid', '').replace('-ptv', '');

        formatBaseCheck = formatBaseCheck.replace('-comfort', '').replace('-lucido', '').replace('-stripe', '').replace('-riga', '').replace('-pliss', '').replace('-twist', '').replace('-strutturasign', '').replace('-strutturanet', '').replace('-strutturamove', '').replace('-satinato', '').replace('-velvet', '');

        formatBaseCheck = formatBaseCheck.replace('-strutturato20mm', '').replace('-strutturato', '').replace('-bocciardato', '');

        formatBaseCheck = formatBaseCheck.replace('-liscio', '').replace('-levigato', '').replace('-levigata', '').replace('-patinato', '').replace('-patinata', '').replace('-Naturale', '').replace('-naturale', '');

        formatBaseCheck = formatBaseCheck.replace('-squadrato', '').replace('-squadrata', '').replace('-cannete', '');

        formatBaseCheck = formatBaseCheck.replace('-soft', '').replace('-matte', '').replace('-grip', '').replace('-antislip', '').replace('-20mm', '').replace('-Naturalecuoio', '').replace('-lappata', '').replace('-lappato', '');

        formatBaseCheck = formatBaseCheck.replace('-realupstrideup', '').replace('-RealUpStrideUp', '').replace('-realup', '').replace('-RealUp', '').replace('-strideup', '').replace('-StrideUp', '').replace('-fade', '').replace('-Fade', '').replace(/-+/g, '-').replace(/^-|-$/g, '');



        // Verifica che il formato della variante salvata contenga il formato base selezionato

        const savedVariantFormat = savedVariant.option1 || '';

        let savedVariantMatchesFormat = savedVariantFormat.includes(formatBaseCheck);



        // 🔧 FIX 23-DIC-2024: Verifica anche la FINITURA oltre al formato base

        // Se selectedFormat contiene una finitura specifica, verifica che anche la variante salvata la abbia

        const savedVariantUpper = savedVariantFormat.toUpperCase();

        const selectedFormatLower = (selectedFormat || '').toLowerCase();



        // Controlla finiture specifiche

        const isSelectedLappata = selectedFormatLower.includes('-lappata') || selectedFormatLower.includes('-lappato');

        const isSelectedRealUp = selectedFormatLower.includes('-realup');

        const isSelectedGrip = selectedFormatLower.includes('-grip');

        const isSelectedLucida = selectedFormatLower.includes('-lucido') || selectedFormatLower.includes('-lucida');

        // 🔧 FIX: Soft, Satinata e Matte sono finiture DIVERSE

        const isSelectedSatinato = selectedFormatLower.includes('-satinato');

        const isSelectedSoft = selectedFormatLower.includes('-soft');

        const isSelectedMatte = selectedFormatLower.includes('-matte');  // 🔧 FIX: Matte/Opaca

        const isSelectedStrutturato = selectedFormatLower.includes('-strutturato');

        const isSelectedLevigato = selectedFormatLower.includes('-levigato') || selectedFormatLower.includes('-levigata');

        const isSelectedFade = selectedFormatLower.includes('-fade');



        const savedHasLappata = savedVariantUpper.includes('LAPPATA') || savedVariantUpper.includes('LAPPATO');

        const savedHasRealUp = savedVariantUpper.includes('REALUP');

        const savedHasGrip = savedVariantUpper.includes('GRIP');

        const savedHasLucida = savedVariantUpper.includes('LUCID');

        // 🔧 FIX: Soft, Satinata e Matte sono finiture DIVERSE

        const savedHasSatinato = savedVariantUpper.includes('SATINAT') || savedVariantUpper.includes('SILK');

        const savedHasSoft = savedVariantUpper.includes('SOFT');

        const savedHasMatte = /\bMATTE?\b/i.test(savedVariantUpper) || savedVariantUpper.includes('OPAC');  // 🔧 FIX: Matte/Opaca (word boundary per non matchare MATTONE)

        const savedHasStrutturato = savedVariantUpper.includes('STRUTTURAT');

        const savedHasLevigato = savedVariantUpper.includes('LEVIGAT');

        const savedHasFade = savedVariantUpper.includes('FADE');



        // Se è richiesta una finitura specifica, verifica che la variante salvata la abbia

        if (isSelectedLappata && !savedHasLappata) {

          savedVariantMatchesFormat = false;


        } else if (isSelectedRealUp && !savedHasRealUp) {

          savedVariantMatchesFormat = false;


        } else if (isSelectedGrip && !savedHasGrip) {

          savedVariantMatchesFormat = false;


        } else if (isSelectedLucida && !savedHasLucida) {

          savedVariantMatchesFormat = false;


        } else if (isSelectedSatinato && !savedHasSatinato) {

          savedVariantMatchesFormat = false;


        } else if (isSelectedSoft && !savedHasSoft) {

          savedVariantMatchesFormat = false;


        } else if (isSelectedMatte && !savedHasMatte) {

          savedVariantMatchesFormat = false;


        } else if (isSelectedStrutturato && !savedHasStrutturato) {

          savedVariantMatchesFormat = false;


        } else if (isSelectedLevigato && !savedHasLevigato) {

          savedVariantMatchesFormat = false;


        } else if (isSelectedFade && !savedHasFade) {

          savedVariantMatchesFormat = false;


        }

        // Caso inverso: la variante salvata ha una finitura ma il formato selezionato no (o ha finitura diversa)

        else if (!isSelectedLappata && !isSelectedRealUp && !isSelectedGrip && !isSelectedLucida && !isSelectedSatinato && !isSelectedSoft && !isSelectedMatte && !isSelectedStrutturato && !isSelectedLevigato && !isSelectedFade) {

          // Il formato selezionato non ha finitura specifica, ma la variante salvata potrebbe averne una

          if (savedHasLappata || savedHasRealUp || savedHasGrip || savedHasLucida || savedHasSatinato || savedHasSoft || savedHasMatte || savedHasStrutturato || savedHasLevigato || savedHasFade) {

            // La variante salvata ha una finitura ma il formato selezionato non la richiede - potrebbe essere ok per formati "base"

            // Non invalidiamo per evitare problemi con formati senza finitura esplicita

          }

        }






        // 🔧 FIX 23-DIC-2024: Verifica anche il COLORE oltre al formato

        // Se il colore selezionato non corrisponde ESATTAMENTE al colore della variante salvata, invalida

        if (savedVariantMatchesFormat && selectedColor) {

          const savedColor = (savedVariant.option2 || '').toUpperCase().trim();

          const selectedColorUpper = (selectedColor || '').toUpperCase().trim();



          // Confronto esatto: "AVORIO" ≠ "STRIPE AVORIO PARETE"

          // Questo evita di usare prezzi STRIPE per colori base

          // 🔧 FIX STRUTTURATO: "Groove Beige" / "Dark Beige" devono matchare "Beige" (word boundary)
          const _escC = selectedColorUpper.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
          const _colorWordRegex = new RegExp('(?:^| )' + _escC + '(?:$| )', 'i');
          const colorsMatch = savedColor === selectedColorUpper ||
                             (isSelectedStrutturato && _colorWordRegex.test(savedColor));



          if (!colorsMatch) {

            savedVariantMatchesFormat = false;


          } else {


          }

        }



        if (savedVariantMatchesFormat) {

          currentPrice = savedVariant.price;

          currentCompareAtPrice = savedVariant.compare_at_price;




          // IMPORTANTE: Assicurati che variantId sia ancora salvato

          if (window.productConfigurator?.configuration) {

            window.productConfigurator.configuration.variantId = savedVariant.id;

            window.productConfigurator.configuration.selectedVariant = savedVariant;


          }

        } else {


          // Invalida la variante salvata se il formato non corrisponde

          if (window.productConfigurator?.configuration) {

            window.productConfigurator.configuration.variantId = null;

            window.productConfigurator.configuration.selectedVariant = null;

          }

        }

      }

    }



    // Se non c'è una variante salvata, cerca quella corrispondente

    if (!currentPrice && this.product?.variants && selectedFormat && selectedColor) {

      // Estrai formato base e finitura da selectedFormat (es: "60x120-satinato" → "60x120", "satinato")

      let formatBase = selectedFormat;

      formatBase = formatBase.replace('-parete', '').replace('-lux', '').replace('-fluid', '').replace('-ptv', '');

      formatBase = formatBase.replace('-comfort', '').replace('-lucido', '').replace('-stripe', '').replace('-riga', '').replace('-pliss', '').replace('-twist', '').replace('-strutturasign', '').replace('-strutturanet', '').replace('-strutturamove', '').replace('-satinato', '').replace('-velvet', '');

      formatBase = formatBase.replace('-strutturato20mm', '').replace('-strutturato', '').replace('-bocciardato', '');

      formatBase = formatBase.replace('-liscio', '').replace('-levigato', '').replace('-levigata', '').replace('-patinato', '').replace('-patinata', '').replace('-Naturale', '').replace('-naturale', '');

      formatBase = formatBase.replace('-squadrato', '').replace('-squadrata', '').replace('-cannete', '');

      formatBase = formatBase.replace('-soft', '').replace('-matte', '').replace('-grip', '').replace('-antislip', '').replace('-Naturalecuoio', '').replace('-lappatasatinata', '').replace('-lappata', '').replace('-lappato', '').replace('-battiscopa', '').replace('-fade', '').replace('-Fade', '').replace('-20mm', '').replace(/-+/g, '-').replace(/^-|-$/g, '');



      // 🔧 FIX: Soft, Satinata e Matte sono finiture DIVERSE

      const isFormatSatinato = selectedFormat.includes('-satinato');

      const isFormatSoft = selectedFormat.includes('-soft');

      const isFormatMatte = selectedFormat.includes('-matte');

      const isFormatNaturale = selectedFormat.includes('-naturale') || selectedFormat.includes('-Naturale');

      const isFormatLucido = selectedFormat.includes('-lucido');

      const isFormatLevigato = selectedFormat.includes('-levigato') || selectedFormat.includes('-levigata');

      const isFormatStrutturato = selectedFormat.includes('-strutturato');

      const isFormatLappata = (selectedFormat.includes('-lappata') || selectedFormat.includes('-lappato')) && !selectedFormat.includes('-lappatasatinata');

      const isFormatBattiscopa = selectedFormat.includes('-battiscopa');

      const isFormatFade = selectedFormat.includes('-fade') || selectedFormat.includes('-Fade');

      const isFormatLappataSatinata = selectedFormat.includes('-lappatasatinata');

      // 🔧 FIX PURITY of MARBLE: LUX è finitura Lucida separata

      const isFormatLux = selectedFormat.includes('-lux');






      // 🔧 Crea pattern regex flessibile per matchare formati con punto/virgola e x/×

      const formatPattern = formatBase

        .replace(/\./g, '[.,]')  // 6.3 → 6[.,]3 (matcha punto o virgola)

        .replace(/x/gi, '[xX×]'); // x → [xX×] (matcha x, X, ×)

      const formatRegex = new RegExp(formatPattern, 'i');



      for (let variant of this.product.variants) {

        // Non filtriamo per available - cerchiamo il prezzo in tutte le varianti

        const variantFullText = [variant.title, variant.option1, variant.option2, variant.option3].filter(t => t).join(' ').toUpperCase();



        // Verifica formato base con regex flessibile (supporta punto/virgola e x/×)

        let formatMatch = formatRegex.test(variant.option1 || '');



        // 🔧 FIX: Soft e Satinato sono finiture DIVERSE

        if (isFormatSatinato) {

          formatMatch = formatMatch && (variantFullText.includes('SATINATO') || variantFullText.includes('SATINATA') || variantFullText.includes('SILK'));

        } else if (isFormatSoft) {

          formatMatch = formatMatch && variantFullText.includes('SOFT');

        } else if (isFormatNaturale) {

          formatMatch = formatMatch && variantFullText.includes('NATURALE') && !variantFullText.includes('SATINATO') && !variantFullText.includes('SATINATA') && !variantFullText.includes('SILK');

        } else if (isFormatMatte) {

          formatMatch = formatMatch && (/\bMATTE?\b/i.test(variantFullText) || variantFullText.includes('OPACO') || variantFullText.includes('OPACA'));

        } else if (isFormatLucido) {

          formatMatch = formatMatch && (variantFullText.includes('LUCIDO') || variantFullText.includes('LUCIDA'));

        } else if (isFormatStrutturato) {

          formatMatch = formatMatch && (variantFullText.includes('STRUTTURATO') || variantFullText.includes('STRUTTURATA'));

        } else if (isFormatLappata) {

          formatMatch = formatMatch && (variantFullText.includes('LAPPATA') || variantFullText.includes('LAPPATO')) && !variantFullText.includes('LAPPATA SATINATA') && !variantFullText.includes('LAPPATA-SATINATA');

        } else if (isFormatFade) {

          formatMatch = formatMatch && variantFullText.includes('FADE');

        } else if (isFormatLappataSatinata) {

          formatMatch = formatMatch && (variantFullText.includes('LAPPATA SATINATA') || variantFullText.includes('LAPPATA-SATINATA'));

        } else if (isFormatLux) {

          // 🔧 FIX PURITY of MARBLE: LUX match per varianti con "LUX" nel nome

          formatMatch = formatMatch && variantFullText.includes('LUX');

        }



        // Check separato per BATTISCOPA (si cumula con gli altri check)

        if (isFormatBattiscopa) {

          formatMatch = formatMatch && variantFullText.includes('BATTISCOPA');

        } else {

          // Se NON è battiscopa, la variante NON deve contenere BATTISCOPA

          formatMatch = formatMatch && !variantFullText.includes('BATTISCOPA');

        }



        // Verifica colore - cerca in option2, option3 o nel testo completo (per battiscopa)

        const selectedColorUpper = selectedColor.toUpperCase().trim();

        const opt2Upper = (variant.option2 || '').toUpperCase().trim();

        const opt3Upper = (variant.option3 || '').toUpperCase().trim();

        // 🔧 FIX STRUTTURATO: "Groove Beige" / "Dark Beige" devono matchare "Beige" (word boundary)
        const _escSC = selectedColorUpper.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const _strutColorRegex = new RegExp('(?:^| )' + _escSC + '(?:$| )', 'i');
        const colorMatch = opt2Upper === selectedColorUpper ||
                          (isFormatStrutturato && _strutColorRegex.test(opt2Upper)) ||
                          (isFormatBattiscopa && (opt3Upper === selectedColorUpper || variantFullText.includes(selectedColorUpper)));



        // Verifica spessore con match più flessibile

        let thicknessMatch = true;

        if (selectedThickness) {

          const thicknessValue = (selectedThickness.match(/([\d.]+\s*mm)/i)?.[1]?.toLowerCase() || '').replace(/\s+/g, '');

          const hasR11 = selectedThickness.toUpperCase().includes('R11');

          const optionLower = (variant.option3 || '').toLowerCase().replace(/\s+/g, '');

          thicknessMatch = optionLower.includes(thicknessValue.replace(/\s+/g, ''));

          if (hasR11) {

            thicknessMatch = thicknessMatch && optionLower.includes('r11');

          }

        }



        if (formatMatch && colorMatch && thicknessMatch) {

          currentPrice = variant.price;

          currentCompareAtPrice = variant.compare_at_price;




          // SALVA IL VARIANT ID

          if (window.productConfigurator) {

            window.productConfigurator.configuration.variantId = variant.id;

            window.productConfigurator.configuration.selectedVariant = variant;

          }



          break;

        }

      }



      // 🔧 FIX 23-DIC-2024: Se formato è -parete e colore NON è STRIPE, cerca variante formato BASE

      // Questo perché per INTERNO_SOLO_PARETE le varianti parete hanno solo colori STRIPE,

      // ma il configuratore mostra anche i colori base che devono usare il prezzo base (non STRIPE)

      if (!currentPrice && selectedFormat.includes('-parete') && !selectedColor.toUpperCase().includes('STRIPE')) {




        // Estrai solo la dimensione (es. "60x120" da "60x120-realup-parete")

        const formatDimension = selectedFormat.split('-')[0]; // "60x120"

        const isRealUp = selectedFormat.includes('-realup');

        const isLappata = selectedFormat.includes('-lappata') || selectedFormat.includes('-lappato');






        // Cerca QUALSIASI variante con formato+finitura che NON sia STRIPE

        // Non cerchiamo il colore esatto perché potrebbe non esistere

        for (let variant of this.product.variants) {

          const variantFullText = [variant.title, variant.option1, variant.option2, variant.option3].filter(t => t).join(' ').toUpperCase();

          const opt1 = (variant.option1 || '').toUpperCase();



          // Verifica formato dimensionale (es. "60x120" in "60x120 24"x48" RealUp Rettificato")

          let formatMatch = opt1.includes(formatDimension);

          const hasRealUp = variantFullText.includes('REALUP');

          const hasLappata = variantFullText.includes('LAPPATA') || variantFullText.includes('LAPPATO');



          // Verifica finitura RealUp/Lappata

          if (isRealUp) {

            formatMatch = formatMatch && hasRealUp;

          } else if (isLappata) {

            formatMatch = formatMatch && hasLappata;

          }



          // Escludi varianti STRIPE/PARETE - cerchiamo una variante BASE

          const variantColor = (variant.option2 || '').toUpperCase();

          const isStripeVariant = variantColor.includes('STRIPE') || variantColor.includes('PARETE');



          // Trova la prima variante che matcha formato+finitura e NON è STRIPE

          if (formatMatch && !isStripeVariant) {

            currentPrice = variant.price;

            currentCompareAtPrice = variant.compare_at_price;




            // NON salvare questa variante come selectedVariant (perché il formato parete è diverso)

            // Ma usa il suo comparePrice per ottenere il prezzo corretto

            break;

          }

        }



        // Se ancora non trovato, log per debug

        if (!currentPrice) {


        }

      }



      // 🔧 FIX BATTISCOPA: Se non ha trovato variante, cerca con match più flessibile

      if (!currentPrice && selectedFormat.includes('-battiscopa')) {




        const formatDimension = selectedFormat.split('-')[0]; // es: "7.2x120" o "6.3x120"

        const isLappata = selectedFormat.includes('-lappata') || selectedFormat.includes('-lappato');

        const isRealUp = selectedFormat.includes('-realup');

        const isGrip = selectedFormat.includes('-grip');



        // 🔧 Crea pattern regex flessibile per matchare formati con punto/virgola e x/×

        const formatPattern = formatDimension

          .replace(/\./g, '[.,]')  // 6.3 → 6[.,]3 (matcha punto o virgola)

          .replace(/x/gi, '[xX×]'); // x → [xX×] (matcha x, X, ×)

        const formatRegex = new RegExp(formatPattern, 'i');




        for (let variant of this.product.variants) {

          const variantFullText = [variant.title, variant.option1, variant.option2, variant.option3].filter(t => t).join(' ').toUpperCase();

          const opt1 = variant.option1 || '';



          // Deve contenere BATTISCOPA

          if (!variantFullText.includes('BATTISCOPA')) continue;



          // Verifica formato dimensionale con regex flessibile

          let formatMatch = formatRegex.test(opt1);



          // Verifica finitura

          if (isLappata) {

            formatMatch = formatMatch && (variantFullText.includes('LAPPATA') || variantFullText.includes('LAPPATO'));

          } else if (isRealUp) {

            formatMatch = formatMatch && variantFullText.includes('REALUP');

          } else if (isGrip) {

            formatMatch = formatMatch && variantFullText.includes('GRIP');

          }



          // Verifica colore - cerca in option2, option3 o nel testo completo

          const selectedColorUpper = selectedColor.toUpperCase().trim();

          const opt2Upper = (variant.option2 || '').toUpperCase().trim();

          const opt3Upper = (variant.option3 || '').toUpperCase().trim();

          const colorMatch = opt2Upper === selectedColorUpper ||

                            opt3Upper === selectedColorUpper ||

                            variantFullText.includes(selectedColorUpper);






          if (formatMatch && colorMatch) {

            currentPrice = variant.price;

            currentCompareAtPrice = variant.compare_at_price;




            // SALVA IL VARIANT ID

            if (window.productConfigurator) {

              window.productConfigurator.configuration.variantId = variant.id;

              window.productConfigurator.configuration.selectedVariant = variant;

            }

            break;

          }

        }



        if (!currentPrice) {


          // Log delle varianti battiscopa disponibili per debug

          const battiscopaVariants = this.product.variants.filter(v =>

            [v.title, v.option1, v.option2, v.option3].filter(t => t).join(' ').toUpperCase().includes('BATTISCOPA')

          );


        }

      }

    }



    // Fallback finale

    if (!currentPrice) {

      currentPrice = formatDetails?.price || colorDetails?.price || 0;

      currentCompareAtPrice = formatDetails?.compareAtPrice || colorDetails?.compareAtPrice;

    }



    // 💾 Salva il prezzo della variante nella configurazione (prima di generare l'HTML)

    if (window.productConfigurator?.configuration) {

      window.productConfigurator.configuration.variantPrice = currentPrice;

      window.productConfigurator.configuration.variantComparePrice = currentCompareAtPrice || null;

    }



    // 🎯 Prova a ottenere prezzo fisso per visualizzazione

    let displayPrice = null;

    let displayComparePrice = null;



    // 🔧 Prima prova con getPrezzoByComparePrice usando la finitura dalla variante

    if (currentCompareAtPrice && typeof window.getPrezzoByComparePrice === 'function') {

      const selectedVariant = window.productConfigurator?.configuration?.selectedVariant;

      let finituraFromVariant = null;

      if (selectedVariant && selectedVariant.option1) {

        const opt1Lower = selectedVariant.option1.toLowerCase();

        // 🆕 FIX: Aggiunto 'lux' per PURITY of MARBLE (LUX = Lucida)

        const finitureToCheck = ['levigato', 'levigata', 'patinato', 'patinata', 'lappato', 'lappata', 'lucido', 'lucida', 'lux', 'satinato', 'satinata', 'naturale', 'strutturato', 'strutturata', 'bocciardato', 'liscio', 'liscia', 'realupstrideup', 'realup', 'strideup', 'grip', 'antislip'];

        for (const fin of finitureToCheck) {

          const finRegex = new RegExp('\\b' + fin + '\\b', 'i');

          if (finRegex.test(opt1Lower)) {

            finituraFromVariant = fin;

            break;

          }

        }

      }

      const formatDim = (selectedFormat || '').split('-')[0];

      const prezzoFisso = window.getPrezzoByComparePrice(currentCompareAtPrice, this.product.title, finituraFromVariant || 'base', formatDim, selectedColor);

      if (prezzoFisso) {

        // Moltiplica per 100 per convertire in centesimi

        displayPrice = prezzoFisso.prezzo * 100;

        displayComparePrice = prezzoFisso.comparePrice * 100;


      }

    }



    // 🎯 Fallback: usa getPrezzoFissoM2

    if (!displayPrice && selectedFormat && typeof window.getPrezzoFissoM2 === 'function') {

      // IMPORTANTE: Usa il selectedFormat COMPLETO (con suffisso finitura) per getPrezzoFissoM2

      // così può trovare la chiave corretta (es: "60x120-attitude-satinato" o "60x120-attitude-silk")

      let formatForPricing = selectedFormat;



      // 🎯 Estrai lo spessore dalla selezione, incluso R11 se presente (es: "10mm R11" → "10mmr11")

      let spessorePerDisplay = null;

      if (selectedThickness) {

        // Prima controlla se contiene R11/R10 - per ESTERNO

        const hasR11 = selectedThickness.toUpperCase().includes('R11');

        const hasR10 = selectedThickness.toUpperCase().includes('R10');



        const thicknessMatch = selectedThickness.match(/([\d.]+\s*mm)/i);

        if (thicknessMatch) {

          spessorePerDisplay = thicknessMatch[1].toLowerCase().replace(/\s+/g, '');

          // Ignora spessori standard (6mm, 9mm sono i default per interno) - MA SOLO SE NON È R11

          if (!hasR11 && !hasR10 && (spessorePerDisplay === '6mm' || spessorePerDisplay === '9mm' || spessorePerDisplay === '9.5mm' || spessorePerDisplay === '9.2mm')) {

            spessorePerDisplay = null;

          } else if (hasR11) {

            // Per ESTERNO con R11, aggiungi r11 allo spessore (es: "10mm" → "10mmr11" oppure solo "r11")

            spessorePerDisplay = spessorePerDisplay + 'r11';

          }

        } else if (hasR11) {

          // Se non c'è un match numerico ma c'è R11, usa solo "r11"

          spessorePerDisplay = 'r11';

        }

      }



      const prezziFissi = window.getPrezzoFissoM2(formatForPricing, this.product.title, selectedColor, spessorePerDisplay);


      if (prezziFissi) {

        // Moltiplica per 100 per convertire in centesimi

        displayPrice = prezziFissi.prezzo * 100;

        displayComparePrice = prezziFissi.comparePrice * 100;

      }

    }



    // Ottieni i pezzi per box dal JSON

    let pezziPerBox = null;

    if (selectedFormat && this.ceramicaSpecifiche?.collezioni) {

      pezziPerBox = this.getPezziFromSpecifiche(selectedFormat, selectedThickness, this.product?.title, selectedFinitura, selectedDestination);


    }



    // Se non trova i pezzi nel JSON, usa un valore di emergenza basato sul formato

    if (!pezziPerBox) {


      // Stima basata sulle dimensioni del formato

      const formatoNormalizzato = selectedFormat?.replace(/\s/g, '').replace(/[x×X]/g, 'x').toLowerCase();

      const spessoreNormalizzato = selectedThickness?.replace(/\s/g, '').toLowerCase();



      // CASO SPECIALE: 60x120 da 20mm ha 1 pezzo per scatola invece di 2

      if (formatoNormalizzato === '60x120' && spessoreNormalizzato.includes('20mm')) {

        pezziPerBox = 1;

      } else {

        const emergencyPezzi = {

          '120x120': 2,

          '80x80': 2,

          '60x120': 2,

          '60x60': 3,

          '40x80': 3,

          '40x60': 4,

          '40x40': 6,

          '30x120': 3,

          '30x90': 5,

          '30x60': 6,

          '30x30': 12,

          '20x120': 5,

          '20x40': 13,

          '20x20': 26,

          '10x30': 32,

          '7.5x30': 48

        };

        pezziPerBox = emergencyPezzi[formatoNormalizzato] || 3;

      }

    }



    // Ottieni i kg per box da SHOPIFY (peso variante selezionata)

    let kgPerBox = null;

    // 🔧 FIX: Usa window.productConfigurator invece di this
    const selectedVariant = window.productConfigurator?.configuration?.selectedVariant;

    if (selectedVariant) {
    }

    // Recupera peso dalla variante Shopify selezionata (selectedVariant.weight è in grams)
    if (selectedVariant) {
      const weightInGrams = selectedVariant.grams || selectedVariant.weight || 0;
      if (weightInGrams > 0) {
        kgPerBox = weightInGrams / 1000; // Converti grams in kg
      } else {
      }
    } else {
    }

    // Se non c'è variante selezionata o non ha peso, usa fallback

    if (!kgPerBox) {


      const formatoNormalizzato = selectedFormat?.replace(/\s/g, '').replace(/[x×X]/g, 'x').toLowerCase();

      const spessoreNormalizzato = selectedThickness?.replace(/\s/g, '').toLowerCase();



      // CASO SPECIALE: 60x120 da 20mm ha 34.00 kg per scatola invece di 29.60

      if (formatoNormalizzato === '60x120' && spessoreNormalizzato.includes('20mm')) {

        kgPerBox = 34.00;

      } else {

        const emergencyKg = {

          '120x120': 55.90,

          '80x80': 24.96,

          '60x120': 29.60,

          '60x60': 21.30,

          '40x80': 18.66,

          '40x60': 18.67,

          '40x40': 19.34,

          '30x120': 22.05,

          '30x90': 23.80,

          '30x60': 21.00,

          '30x30': 21.00,

          '20x120': 24.41,

          '20x40': 20.90,

          '20x20': 20.60,

          '10x30': 19.30,

          '7.5x30': 19.40

        };

        kgPerBox = emergencyKg[formatoNormalizzato] || 20;

      }

    }



    // Ottieni il numero di scatole per bancale dal JSON o usa default

    let boxesPerPallet = null;

    if (selectedFormat && this.ceramicaSpecifiche?.collezioni) {

      boxesPerPallet = this.getBoxPerPalletFromSpecifiche(selectedFormat, selectedThickness, this.product?.title, selectedFinitura, selectedDestination);


    }



    // Se non trova nel JSON, usa il valore di default basato sul formato e spessore

    if (!boxesPerPallet) {


      const formatoNormalizzato = selectedFormat?.replace(/\s/g, '').replace(/[x×X]/g, 'x').toLowerCase();

      const spessoreNormalizzato = selectedThickness?.replace(/\s/g, '').toLowerCase();



      // CASO SPECIALE: 60x120 da 20mm ha 30 scatole per bancale invece di 36

      // Il controllo deve includere sia "20mm" che "20mmr11" perché lo spessore include il rating

      if (formatoNormalizzato === '60x120' && spessoreNormalizzato.includes('20mm')) {

        boxesPerPallet = 30;

      } else {

        const defaultBoxPerPallet = {

          '120x120': 18,

          '80x80': 40,

          '60x120': 36,  // Valore di default per 9.5mm

          '60x60': 40,

          '40x80': 28,

          '40x60': 60,

          '40x40': 64,

          '30x120': 48,

          '30x90': 48,

          '30x60': 48,

          '30x30': 48,

          '20x120': 48,

          '20x40': 64,

          '20x20': 64,

          '10x60': 40,

          '10x30': 36,

          '7.5x30': 44

        };

        boxesPerPallet = defaultBoxPerPallet[formatoNormalizzato] || 40;

      }

    }



    // Calcola kg per bancale (kg_pal = peso_box_kg * box_pal)
    let kgPerPallet = null;
    if (kgPerBox && boxesPerPallet) {
      kgPerPallet = kgPerBox * boxesPerPallet;
    }

    // 🚚 CAP a 1100 kg/bancale = limite corriere ONE Express (coerenza configuratore <-> spedizione)
    if (kgPerBox && boxesPerPallet) {
      const maxBoxes1100 = Math.floor(1100 / kgPerBox);
      if (maxBoxes1100 >= 1 && boxesPerPallet > maxBoxes1100) {
        boxesPerPallet = maxBoxes1100;
        kgPerPallet = kgPerBox * boxesPerPallet;
      }
    }



    // Riepilogo dati estratti dal JSON delle specifiche tecniche




    // Salva boxesPerPallet e kgPerPallet nella configurazione

    if (window.productConfigurator?.configuration) {

      window.productConfigurator.configuration.boxesPerPallet = boxesPerPallet;

      window.productConfigurator.configuration.kgPerPallet = kgPerPallet;

      // 🎯 Salva il prezzo al mq fisso per il carrello

      if (displayPrice) {

        window.productConfigurator.configuration.displayPriceM2 = displayPrice; // in cents


      }

      // 🎯 Salva il compare price (prezzo originale) per il carrello

      if (displayComparePrice) {

        window.productConfigurator.configuration.variantComparePrice = displayComparePrice; // in cents


      } else if (currentCompareAtPrice) {

        // Fallback: usa il compare price della variante se displayComparePrice non disponibile

        window.productConfigurator.configuration.variantComparePrice = currentCompareAtPrice; // in cents


      }

    }



    // Inizializza la quantità a zero

    let quantity = 0;

    let totalMq = 0;

    let totalPezzi = 0;

    let totalKg = 0;



    // Genera la piastrella 3D per la visualizzazione

    let tileVisual = '';

    if (selectedFormat && colorDetails) {

      tileVisual = this.generateTileSVG(selectedFormat, colorDetails.code || '#D9D2C5', colorDetails.image || null);

    } else {

      // Usa un formato default se non ci sono selezioni

      tileVisual = this.generateTileSVG('60x60', '#D9D2C5', null);

    }



    // Crea il contenuto HTML in stile con gli altri step

    const quantityHTML = `

      <div class="fx-variants-grid" style="max-height: none; overflow: visible;">




        <!-- Card selettore quantità -->

        <div class="fx-style-card" style="grid-column: 1/-1; background: linear-gradient(135deg, rgba(45, 90, 61,0.05) 0%, rgba(74, 122, 90,0.05) 100%);">

          <div style="text-align: center; padding: 1rem;">

            <!-- Display con layout responsive -->

            <div class="fx-quantity-display" style="margin: 2rem 0;">

              <!-- Metri Quadri/Lineari grande sopra -->

              <div style="text-align: center; margin-bottom: 2rem; position: relative;">

                <div style="font-size: 3.5rem; font-weight: 800; line-height: 1;">

                  <span id="fxMqNumber" style="background: linear-gradient(135deg, #2D5A3D 0%, #4A7A5A 100%); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text;">${totalMq.toFixed(2)}</span>

                </div>

                <div id="fxMqLabel" style="font-size: 0.9rem; color: var(--fx-text-muted); text-transform: uppercase; margin-top: 0.5rem; letter-spacing: 0.05em;">

                  ${selectedDestination === 'BATTISCOPA' ? 'Metri Lineari' : 'Metri Quadri'}

                </div>

              </div>



              <!-- Controlli quantità (tra MQ e resto) -->

              <div class="fx-quantity-controls" style="display: flex; justify-content: center; gap: 0.5rem; flex-wrap: wrap; margin: 2rem 0;">

                <button class="fx-btn fx-btn-ghost" id="fxBtnPalletMinus">

                  <span>− BANCALE</span>

                </button>

                <button class="fx-btn fx-btn-ghost" id="fxBtnMinus10">

                  <span>−10</span>

                </button>

                <button class="fx-btn fx-btn-ghost" id="fxBtnMinus1">

                  <span>−1</span>

                </button>

                <button class="fx-btn fx-btn-ghost" id="fxBtnPlus1">

                  <span>+1</span>

                </button>

                <button class="fx-btn fx-btn-ghost" id="fxBtnPlus10">

                  <span>+10</span>

                </button>

                <button class="fx-btn fx-btn-ghost" id="fxBtnPalletPlus">

                  <span>+ BANCALE</span>

                </button>

              </div>



              <!-- Riga inferiore con gli altri valori più piccoli -->

              <div class="fx-quantity-info" style="display: flex; justify-content: center; align-items: center; gap: 2rem; flex-wrap: wrap;">

                <!-- Box quantità -->

                <div style="text-align: center;">

                  <div style="font-size: 1.75rem; font-weight: 700; color: var(--fx-text); line-height: 1;">

                    <span id="fxQuantityNumber">${quantity}</span>

                  </div>

                  <div style="font-size: 0.75rem; color: var(--fx-text-muted); text-transform: uppercase; margin-top: 0.25rem;">

                    <span id="fxQuantityLabel">${quantity === 1 ? 'Scatola' : 'Scatole'}</span>

                  </div>

                </div>



                <!-- Separatore visuale -->

                <div style="width: 1px; height: 35px; background: linear-gradient(to bottom, transparent, var(--fx-border), transparent); opacity: 0.5;"></div>



                <!-- Box Pezzi Totali -->

                <div style="text-align: center;">

                  <div style="font-size: 1.75rem; font-weight: 700; color: #2D5A3D; line-height: 1;">

                    <span id="fxPezziNumber">${totalPezzi}</span>

                  </div>

                  <div style="font-size: 0.75rem; color: var(--fx-text-muted); text-transform: uppercase; margin-top: 0.25rem;">

                    Pezzi

                  </div>

                </div>



                <!-- Separatore visuale -->

                <div style="width: 1px; height: 35px; background: linear-gradient(to bottom, transparent, var(--fx-border), transparent); opacity: 0.5;"></div>



                <!-- Box Kg Totali -->

                <div style="text-align: center;">

                  <div style="font-size: 1.75rem; font-weight: 700; color: #FF9500; line-height: 1;">

                    <span id="fxKgNumber">${totalKg.toFixed(1)}</span>

                  </div>

                  <div style="font-size: 0.75rem; color: var(--fx-text-muted); text-transform: uppercase; margin-top: 0.25rem;">

                    Kilogrammi

                  </div>

                </div>



                <!-- Separatore visuale -->

                <div style="width: 1px; height: 35px; background: linear-gradient(to bottom, transparent, var(--fx-border), transparent); opacity: 0.5;"></div>



                <!-- Box Prezzo per Scatola (prezzo fisso variante reale) -->

                <div style="text-align: center;">

                  <div style="font-size: 1.75rem; font-weight: 700; color: #2ECC71; line-height: 1;">

                    <span id="fxPromoPrice">${(window.productConfigurator?.configuration?.variantPrice || currentPrice) ?

        this.formatMoney(window.productConfigurator?.configuration?.variantPrice || currentPrice) : '€0,00'}</span>

                  </div>

                  <div style="font-size: 0.75rem; color: var(--fx-text-muted); text-transform: uppercase; margin-top: 0.25rem;">

                    Prezzo per Scatola

                  </div>

                </div>



                <!-- Separatore visuale (nascosto su mobile) -->

                <div class="fx-price-separator" style="width: 1px; height: 35px; background: linear-gradient(to bottom, transparent, var(--fx-border), transparent); opacity: 0.5;"></div>



                <!-- Box Prezzo Totale -->

                <div style="position: relative; text-align: center;">

                  <div style="font-size: 1.75rem; font-weight: 700; color: var(--fx-primary, #2D5A3D); line-height: 1.2;">

                    <span id="fxPriceNumber">${(window.productConfigurator?.configuration?.variantPrice || currentPrice) ?

        this.formatMoney((window.productConfigurator?.configuration?.variantPrice || currentPrice) * quantity) : '€0,00'}</span>

                  </div>

                  <div style="font-size: 0.75rem; color: var(--fx-text-muted); text-transform: uppercase; margin-top: 0.25rem;">

                    Prezzo Totale

                  </div>

                </div>

              </div>

            </div>



            <!-- Info aggiuntiva -->

            <div style="margin-top: 1.5rem; padding-top: 1.5rem; border-top: 1px solid var(--fx-border);">


              <p style="color: var(--fx-text-muted); font-size: 0.875rem; text-align: center;">

                <strong id="fxPezziPerBoxLabel">${pezziPerBox} pezzi</strong> per scatola •

                <strong id="fxBoxPerPalletLabel">${boxesPerPallet} scatole</strong> per bancale

              </p>

            </div>

          </div>

        </div>

      </div>

    `;



    container.innerHTML = quantityHTML;



    // Aggiungi stile responsive per font-size su mobile

    if (!document.getElementById('fx-header-price-responsive')) {

      const style = document.createElement('style');

      style.id = 'fx-header-price-responsive';

      style.textContent = `

        @media (max-width: 768px) {

          #fxPromoPrice, #fxPriceNumber {

            font-size: 1.5rem !important;

          }

          #fxQuantityNumber, #fxPezziNumber, #fxKgNumber {

            font-size: 1.25rem !important;

          }

        }

        @media (max-width: 480px) {

          #fxPromoPrice, #fxPriceNumber {

            font-size: 1.4rem !important;

          }

          #fxQuantityNumber, #fxPezziNumber, #fxKgNumber {

            font-size: 1.15rem !important;

          }

        }

      `;

      document.head.appendChild(style);

    }



    // Funzione per aggiornare i numeri con effetto pulse

    const animateNumber = (element, newValue, decimals = 0) => {

      if (!element) return;



      // Salva gli stili originali per preservare il gradiente dei metri quadri

      const originalBackground = element.style.background;

      const originalWebkitBackgroundClip = element.style.webkitBackgroundClip;

      const originalWebkitTextFillColor = element.style.webkitTextFillColor;



      // Imposta le proprietà necessarie per la trasformazione

      element.style.display = 'inline-block';

      element.style.transformOrigin = 'center center';

      element.style.transition = 'none'; // Disabilita transizioni CSS durante l'animazione



      const oldValue = parseFloat(element.textContent) || 0;

      const startTime = performance.now();

      const duration = 300;



      const animate = (currentTime) => {

        const elapsed = currentTime - startTime;

        const progress = Math.min(elapsed / duration, 1);



        // Calcola il valore corrente

        const current = oldValue + (newValue - oldValue) * progress;

        element.textContent = decimals > 0 ? current.toFixed(decimals) : Math.round(current);



        // Calcola lo scale per l'effetto pulse

        let scale = 1;

        if (progress < 0.5) {

          scale = 1 + (progress * 2) * 0.15; // Da 1 a 1.15

        } else {

          scale = 1.15 - ((progress - 0.5) * 2) * 0.15; // Da 1.15 a 1

        }



        element.style.transform = `scale(${scale})`;



        if (progress < 1) {

          requestAnimationFrame(animate);

        } else {

          element.style.transform = 'scale(1)';

          element.style.transition = ''; // Ripristina le transizioni



          // Ripristina gli stili originali del gradiente se presenti

          if (originalBackground) element.style.background = originalBackground;

          if (originalWebkitBackgroundClip) element.style.webkitBackgroundClip = originalWebkitBackgroundClip;

          if (originalWebkitTextFillColor) element.style.webkitTextFillColor = originalWebkitTextFillColor;

        }

      };



      requestAnimationFrame(animate);

    };



    // Funzione per aggiornare i display

    const updateDisplay = () => {

      const newTotalMq = quantity * mqPerBox;

      const newTotalPezzi = quantity * pezziPerBox;

      const newTotalKg = quantity * kgPerBox;

      // 💰 Calcolo: prezzo reale Shopify per scatola × numero scatole

      const realVariantPrice = window.productConfigurator?.configuration?.variantPrice || currentPrice;

      const newTotalPrice = realVariantPrice ? realVariantPrice * quantity : 0;



      // Aggiorna i numeri con animazione

      const quantityNumber = document.getElementById('fxQuantityNumber');

      const quantityLabel = document.getElementById('fxQuantityLabel');

      const pezziNumber = document.getElementById('fxPezziNumber');

      const kgNumber = document.getElementById('fxKgNumber');

      const mqNumber = document.getElementById('fxMqNumber');

      const priceNumber = document.getElementById('fxPriceNumber');



      // Anima i numeri

      animateNumber(quantityNumber, quantity, 0);

      animateNumber(pezziNumber, newTotalPezzi, 0);

      animateNumber(kgNumber, newTotalKg, 1);

      animateNumber(mqNumber, newTotalMq, 2);



      // Il prezzo per scatola rimane FISSO e non viene aggiornato

      // (è il prezzo della variante reale, non cambia con la quantità)



      // Anima il prezzo totale con formattazione speciale

      if (priceNumber && realVariantPrice) {

        const targetPrice = newTotalPrice;



        const oldPrice = parseFloat(priceNumber.textContent.replace(/[€.,\s]/g, '').replace(',', '.')) / 100 || 0;

        const startTime = performance.now();

        const duration = 300;



        const animatePrice = (currentTime) => {

          const elapsed = currentTime - startTime;

          const progress = Math.min(elapsed / duration, 1);



          const current = oldPrice + (targetPrice - oldPrice) * progress;

          priceNumber.textContent =

        this.formatMoney(current);



          // Effetto pulse

          let scale = 1;

          if (progress < 0.5) {

            scale = 1 + (progress * 2) * 0.15;

          } else {

            scale = 1.15 - ((progress - 0.5) * 2) * 0.15;

          }

          priceNumber.style.transform = `scale(${scale})`;

          priceNumber.style.display = 'inline-block';



          if (progress < 1) {

            requestAnimationFrame(animatePrice);

          } else {

            priceNumber.style.transform = 'scale(1)';

          }

        };



        requestAnimationFrame(animatePrice);

      }



      // Aggiorna label scatola/scatole

      if (quantityLabel) {

        const newLabel = quantity === 1 ? 'Scatola' : 'Scatole';

        if (quantityLabel.textContent !== newLabel) {

          quantityLabel.style.opacity = '0';

          setTimeout(() => {

            quantityLabel.textContent = newLabel;

            quantityLabel.style.transition = 'opacity 0.3s ease';

            quantityLabel.style.opacity = '1';

          }, 150);

        }

      }



      // Aggiorna i valori totali per il salvataggio

      totalMq = newTotalMq;

      totalPezzi = newTotalPezzi;

      totalKg = newTotalKg;



      // Badge sconto bancale rimosso



      // Salva nel configuratore

      if (window.productConfigurator) {

        window.productConfigurator.configuration.quantity = quantity;

        window.productConfigurator.configuration.totalMq = totalMq;

        window.productConfigurator.configuration.totalPezzi = totalPezzi;

        window.productConfigurator.configuration.totalKg = totalKg;

        window.productConfigurator.configuration.pezziPerBox = pezziPerBox;

        window.productConfigurator.configuration.kgPerBox = kgPerBox;

        window.productConfigurator.configuration.mqPerBox = mqPerBox;

        window.productConfigurator.configuration.boxesPerPallet = boxesPerPallet;



        // 💰 Il prezzo della variante Shopify è già stato salvato prima di generare l'HTML

        // Non sovrascriverlo qui per evitare problemi

        // Verifica solo che sia salvato, altrimenti usa currentPrice come fallback

        if (!window.productConfigurator.configuration.variantPrice) {

          window.productConfigurator.configuration.variantPrice = currentPrice;

          window.productConfigurator.configuration.variantComparePrice = currentCompareAtPrice || null;

        }

      }



      // Abilita il pulsante "Vai al Riepilogo" se c'è almeno 1 scatola

      // NOTA: dopo aggiunta step Finitura, Quantità è Step 6, quindi usa fxNext6

      const nextBtn6 = document.getElementById('fxNext6');

      if (nextBtn6) {

        nextBtn6.disabled = quantity < 1;

      }



      // Disabilita il pulsante minus se siamo a 0

      const btnMinus1 = document.getElementById('fxBtnMinus1');

      const btnMinus10 = document.getElementById('fxBtnMinus10');

      const btnPalletMinus = document.getElementById('fxBtnPalletMinus');



      if (btnMinus1) btnMinus1.disabled = quantity <= 0;

      if (btnMinus10) btnMinus10.disabled = quantity <= 0;

      if (btnPalletMinus) btnPalletMinus.disabled = quantity <= boxesPerPallet;

    };



    // Event listeners per i pulsanti

    document.getElementById('fxBtnMinus1').addEventListener('click', () => {

      if (quantity > 0) {

        quantity--;

        updateDisplay();

      }

    });



    document.getElementById('fxBtnPlus1').addEventListener('click', () => {

      quantity++;

      updateDisplay();

    });



    document.getElementById('fxBtnMinus10').addEventListener('click', () => {

      quantity = Math.max(0, quantity - 10);

      updateDisplay();

    });



    document.getElementById('fxBtnPlus10').addEventListener('click', () => {

      quantity += 10;

      updateDisplay();

    });



    document.getElementById('fxBtnPalletMinus').addEventListener('click', () => {

      if (quantity > boxesPerPallet) {

        // Arrotonda verso il basso al multiplo di boxesPerPallet più vicino

        quantity = Math.floor((quantity - 1) / boxesPerPallet) * boxesPerPallet;

        if (quantity < 0) quantity = 0;



        updateDisplay();

      }

    });



    document.getElementById('fxBtnPalletPlus').addEventListener('click', () => {

      // Arrotonda verso l'alto al multiplo di boxesPerPallet più vicino

      quantity = Math.ceil((quantity + 1) / boxesPerPallet) * boxesPerPallet;



      updateDisplay();

    });



    // Inizializza il display

    updateDisplay();




  },



  // Metodo helper per aggiornare il titolo dello step 4

  updateStep4Title() {

    // Cerca tutti i possibili elementi che contengono "Finitura" e li aggiorna

    const step4Elements = document.querySelectorAll('#fxStep4 *');

    step4Elements.forEach(element => {

      if (element.textContent && element.textContent.includes('Finitura')) {

        element.textContent = element.textContent.replace(/Finitura/g, 'Spessore');

      }

      if (element.textContent && element.textContent.includes('finitura')) {

        element.textContent = element.textContent.replace(/finitura/g, 'spessore');

      }

    });

  },

  

  // Inietta i font Jost all'avvio

  injectFontStyles() {

    if (document.getElementById('fx-Jost-fonts')) return;



    const style = document.createElement('style');

    style.id = 'fx-Jost-fonts';

    style.textContent = `

      /* MONTSERRAT FONT - Caricamento locale da Shopify CDN */

      @font-face {

        font-family: 'Jost';

        src: url('https://cdn.shopify.com/s/files/1/0949/7713/0845/files/Jost-Light.woff2?v=1765447737') format('woff2');

        font-weight: 300;

        font-style: normal;

        font-display: swap;

      }

      @font-face {

        font-family: 'Jost';

        src: url('https://cdn.shopify.com/s/files/1/0949/7713/0845/files/Jost-Regular.woff2?v=1765447737') format('woff2');

        font-weight: 400;

        font-style: normal;

        font-display: swap;

      }

      @font-face {

        font-family: 'Jost';

        src: url('https://cdn.shopify.com/s/files/1/0949/7713/0845/files/Jost-Medium.woff2?v=1765447736') format('woff2');

        font-weight: 500;

        font-style: normal;

        font-display: swap;

      }

      @font-face {

        font-family: 'Jost';

        src: url('https://cdn.shopify.com/s/files/1/0949/7713/0845/files/Jost-SemiBold.woff2?v=1765447736') format('woff2');

        font-weight: 600;

        font-style: normal;

        font-display: swap;

      }

      @font-face {

        font-family: 'Jost';

        src: url('https://cdn.shopify.com/s/files/1/0949/7713/0845/files/Jost-Bold.woff2?v=1765447735') format('woff2');

        font-weight: 700;

        font-style: normal;

        font-display: swap;

      }

      @font-face {

        font-family: 'Jost';

        src: url('https://cdn.shopify.com/s/files/1/0949/7713/0845/files/Jost-ExtraBold.woff2?v=1765447736') format('woff2');

        font-weight: 800;

        font-style: normal;

        font-display: swap;

      }

      @font-face {

        font-family: 'Jost';

        src: url('https://cdn.shopify.com/s/files/1/0949/7713/0845/files/Jost-Black.woff2?v=1765447732') format('woff2');

        font-weight: 900;

        font-style: normal;

        font-display: swap;

      }



      /* Variabile CSS per il font e applicazione globale al configuratore */

      :root {

        --fx-font: 'Jost', -apple-system, BlinkMacSystemFont, sans-serif;

      }



      /* Applica Jost a TUTTI gli elementi del configuratore */

      .fx-style-card,

      .fx-style-card *,

      .fx-price-container,

      .fx-price-container *,

      .fx-price,

      .fx-step-price-was,

      .fx-discount-badge,

      .fx-style-info,

      .fx-style-info *,

      .fx-variant-info,

      .fx-variant-info *,

      [class^="fx-"],

      [class*=" fx-"] {

        font-family: 'Jost', -apple-system, BlinkMacSystemFont, sans-serif !important;

      }

    `;

    document.head.appendChild(style);

  },



  // Inizializzazione principale

  init() {

    // Inietta i font Jost subito

    this.injectFontStyles();



    // Inizializza i dati da Shopify

    this.initializeFromShopify();

    

    // Attendi che il DOM sia pronto e popola

    setTimeout(() => {

      this.populateDestinations();

      this.populateFormats();

      this.populateColors();

      this.populateThickness();

      

      // Aggiorna il titolo dello step 4

      this.updateStep4Title();

      

      // Osserva cambiamenti negli step

      this.observeStepChanges();

    }, 100);

  },

  

  // Filtra i formati basandosi sulla destinazione selezionata

  filterFormatsByDestination(destination) {

    if (!destination || !this.formatOptions) {

      return;

    }



    // 🆕 Se il prodotto non ha rating system, filtra comunque per PARETE

    if (!this.productHasRatingSystem) {

      if (destination === 'INTERNO') {

        // INTERNO: solo formati SENZA -parete
        // 20mm con R11/R12/R13 = solo ESTERNO (antiscivolo outdoor)
        // 20mm senza R11+ = può essere anche INTERNO

        this.filteredFormatOptions = this.formatOptions.filter(format => {

          const hasParete = format.isParete === true || format.value.includes('-parete');

          const is20mm = format.is20mm === true;

          // 20mm va sempre in ESTERNO (non INTERNO)
          return !hasParete && !is20mm;

        });

      } else if (destination === 'INTERNO_SOLO_PARETE') {

        // INTERNO SOLO A PARETE: solo formati CON -parete

        this.filteredFormatOptions = this.formatOptions.filter(format => {

          const hasParete = format.isParete === true || format.value.includes('-parete');

          return hasParete;

        });

      } else if (destination === 'BATTISCOPA') {

        // BATTISCOPA: solo formati con BATTISCOPA nel nome

        this.filteredFormatOptions = this.formatOptions.filter(format => {

          const isBattiscopa = format.isBattiscopa === true || (format.value || '').toUpperCase().includes('BATTISCOPA') || (format.label || '').toUpperCase().includes('BATTISCOPA');

          return isBattiscopa;

        });

      } else if (destination === 'ESTERNO') {

        // ESTERNO senza rating system: tutti i formati 20mm (strutturato, antislip, grip, ecc.)
        this.filteredFormatOptions = this.formatOptions.filter(format => {
          const is20mm = format.is20mm === true;
          return is20mm;
        });

      } else {

        // Altre destinazioni: tutti i formati

        this.filteredFormatOptions = this.formatOptions;

      }

      return;

    }



    // Usa i rating salvati durante l'estrazione per filtrare

    this.filteredFormatOptions = this.formatOptions.filter(format => {

      const hasParete = format.isParete === true;



      // Se non ha info sui rating E non è formato PARETE, escludi

      if (!format.availableRatings && !hasParete) {

        return false;

      }



      let shouldInclude = false;



      if (destination === 'INTERNO') {

        // Per INTERNO: deve avere R9, R10, varianti senza rating (non 20mm), o caratteristiche speciali

        // MA NON deve essere un formato PARETE

        // ESCLUDI: formati Strutturato (sono R11+ e solo per ESTERNO) - SOLO PER SENSI

        // ESCLUDI: formati Bocciardato (vanno in INTERNO SOLO A PARETE) - TUTTI I PRODOTTI

        // ESCLUDI: formati GRIP (sono antiscivolo, vanno in ESTERNO) - TUTTI I PRODOTTI

        // 🆕 ESCLUDI: formati 20mm senza rating (vanno in ESTERNO)

        const ratings = format.availableRatings || {};

        const hasSpecialCharacteristics = format.hasLucido || format.hasLiscio || format.hasComfort || format.hasSatinato || format.hasVelvet || format.hasPTV || format.hasLux || format.hasFluid || format.hasNaturale || format.hasNaturaleLeather;

        const excludeStrutturato = this.isSensiProduct() && format.hasStrutturato;

        const excludeBocciardato = format.hasBocciardato; // Bocciardato va solo in INTERNO SOLO A PARETE

        // 🔧 FIX: usa format.is20mm impostato durante l'estrazione dei formati

        const is20mm = format.is20mm === true;

        // 20mm con SOLO R11/R12/R13 = solo ESTERNO (antiscivolo outdoor)
        // 20mm con anche R9/R10 = può essere INTERNO (es. MOONLIT 20mm R9)
        const is20mmOnlyOutdoor = is20mm && (ratings.R11 || ratings.R12 || ratings.R13) && !(ratings.R9 || ratings.R10);

        // NOTA: Grip e Antislip vanno in ESTERNO solo se hanno R11/R12/R13

        // Se non hanno rating alto (R9/R10/noRating), possono andare in INTERNO

        shouldInclude = ((ratings.R9 || ratings.R10 || ratings.noRating || hasSpecialCharacteristics)) && !hasParete && !excludeStrutturato && !excludeBocciardato && !is20mmOnlyOutdoor;

      } else if (destination === 'ESTERNO') {

        // Per ESTERNO: deve avere R11, R12, R13 OPPURE essere 20mm senza rating, e NON deve essere formato PARETE

        // NOTA: Grip e Antislip vanno in ESTERNO solo se hanno R11/R12/R13 (non automaticamente)

        // 🆕 20mm senza rating vanno sempre in ESTERNO

        const ratings = format.availableRatings || {};

        // 🔧 FIX: usa format.is20mm impostato durante l'estrazione dei formati

        const is20mm = format.is20mm === true;

        const hasAnyRating = ratings.R9 || ratings.R10 || ratings.R11 || ratings.R12 || ratings.R13;

        const is20mmNoRating = is20mm && !hasAnyRating;

        shouldInclude = (ratings.R11 || ratings.R12 || ratings.R13 || is20mmNoRating) && !hasParete;

      } else if (destination === 'INTERNO_SOLO_PARETE') {

        // Per INTERNO SOLO A PARETE: formati PARETE o formati BOCCIARDATO (qualunque prodotto)

        const isBocciardato = format.hasBocciardato;

        shouldInclude = hasParete || isBocciardato;

      } else if (destination === 'BATTISCOPA') {

        // Per BATTISCOPA: solo formati con BATTISCOPA nel nome

        const isBattiscopa = format.isBattiscopa === true || (format.value || '').toUpperCase().includes('BATTISCOPA') || (format.label || '').toUpperCase().includes('BATTISCOPA');

        shouldInclude = isBattiscopa;

      }



      return shouldInclude;

    });

  },



  // Filtra i colori basandosi sul formato selezionato e sulla destinazione

  filterColorsByFormat(selectedFormat) {

    const destination = this.selectedDestination;


    if (!this.product.variants || !selectedFormat) {

      return;

    }



    // Trova quali colori hanno varianti per questo formato E destinazione

    // NOTA: processiamo TUTTE le varianti, anche quelle non disponibili, per mostrare le opzioni

    const availableColors = new Set();

    const debugInfo = [];



    this.product.variants.forEach(variant => {

      // Non filtriamo più per available - mostriamo comunque le opzioni

      const isVariantAvailable = variant.available !== false;

      if (!isVariantAvailable) {

        debugInfo.push(`⚠️ Variante non disponibile ma processata comunque`);

      }



      const variantText = `${variant.title || ''} ${variant.option1 || ''} ${variant.option2 || ''} ${variant.option3 || ''}`.toLowerCase();



      // Usa regex più precisi per evitare falsi positivi

      const hasR9 = /\br9\b/.test(variantText);

      const hasR10 = /\br10\b/.test(variantText);

      const hasR11 = /\br11\b/.test(variantText);

      const hasR12 = /\br12\b/.test(variantText);

      const hasR13 = /\br13\b/.test(variantText);

      const hasAnyRating = hasR9 || hasR10 || hasR11 || hasR12 || hasR13;



      // Verifica se ha PARETE e NEST

      const hasParete = /parete/i.test(variantText);

      const hasNest = /nest/i.test(variantText);



      // Verifica se è Lithos (bocciardato)

      const isLithos = /lithos|bocciardato/i.test(variantText);



      // Verifica se ha caratteristiche speciali

      const hasSpecialCharacteristics = /lucido|comfort|satinato|satinata|ptv|lux|fluid|liscio|smooth|levigato|levigata|patinato|patinata|lappato|lappata|soft|silk|Naturale|Naturale leather/i.test(variantText);



      // Verifica se è BATTISCOPA

      const isBattiscopa = /battiscopa/i.test(variantText);



      // 🆕 Se il prodotto non ha rating system, salta TUTTI i controlli rating

      if (!this.productHasRatingSystem) {

        // 🔧 FIX 23-DIC-2024: Per INTERNO_SOLO_PARETE, anche senza rating system,

        // filtra solo varianti con PARETE nel colore (escludi colori base come CREMA, AVORIO)

        if (destination === 'INTERNO_SOLO_PARETE' && !hasParete) {

          debugInfo.push(`Variante esclusa per INTERNO SOLO PARETE (colore "${variant.option2}" senza PARETE nel nome)`);

          return;

        }

        // Per BATTISCOPA: filtra solo varianti con BATTISCOPA nel nome

        if (destination === 'BATTISCOPA' && !isBattiscopa) {

          debugInfo.push(`Variante esclusa per BATTISCOPA (non contiene BATTISCOPA nel nome)`);

          return;

        }

        // Per ESTERNO senza rating system: solo varianti 20mm

        if (destination === 'ESTERNO') {

          const is20mm = /\b20\s*mm\b/.test(variantText) || /\b2\s*cm\b/.test(variantText);

          if (!is20mm) {

            debugInfo.push(`Variante esclusa per ESTERNO (non è 20mm)`);

            return;

          }

          debugInfo.push(`✅ Variante 20mm inclusa per ESTERNO`);

        }

        // 🆕 Per INTERNO senza rating system: escludi solo varianti 20mm con antislip/grip
        // Le 20mm normali (senza antislip/grip) restano in INTERNO
        if (destination === 'INTERNO') {

          const is20mm = /\b20\s*mm\b/.test(variantText) || /\b2\s*cm\b/.test(variantText);
          const hasAntislipOrGrip = variantText.includes('antislip') || variantText.includes('anti slip') || variantText.includes('anti-slip') || variantText.includes('grip');

          if (is20mm && hasAntislipOrGrip) {

            debugInfo.push(`Variante 20mm antislip/grip esclusa da INTERNO (va in ESTERNO)`);

            return;

          }

        }

        debugInfo.push(`✅ Prodotto senza rating system: includi variante`);

        // Salta direttamente al matching formato/colore (continua sotto)

      } else {

        // MODALITÀ CON RATING: applica tutti i filtri



        // Se la variante non ha rating, gestiscila in base alla destinazione

        if (!hasAnyRating) {

          // Per INTERNO SOLO A PARETE: accetta varianti senza rating se hanno PARETE o sono BOCCIARDATO

          if (destination === 'INTERNO_SOLO_PARETE' && (hasParete || isLithos)) {

            debugInfo.push(`✅ Variante ${hasParete?'PARETE':'BOCCIARDATO'} senza rating inclusa per INTERNO SOLO A PARETE`);

            // Continua il processing - non fare return

          } else if (destination === 'BATTISCOPA' && isBattiscopa) {

            // Per BATTISCOPA: accetta varianti BATTISCOPA senza rating

            debugInfo.push(`✅ Variante BATTISCOPA senza rating inclusa`);

            // Continua il processing - non fare return

          } else if (destination === 'INTERNO' && !hasParete) {

            // Per INTERNO: accetta varianti senza rating SE NON sono PARETE e NON sono 20mm

            // 🆕 20mm senza rating vanno in ESTERNO

            const is20mm = /\b20\s*mm\b/.test(variantText) || /\b2\s*cm\b/.test(variantText);

            if (is20mm) {

              debugInfo.push(`Variante 20mm senza rating esclusa da INTERNO (va in ESTERNO)`);

              return;

            }

            debugInfo.push(`✅ Variante senza rating inclusa per INTERNO (non è PARETE, non è 20mm)`);

            // Continua il processing - non fare return

          } else if (destination === 'ESTERNO' && (variantText.includes('grip') || /\b20\s*mm\b/.test(variantText) || /\b2\s*cm\b/.test(variantText))) {

            // 🎯 FIX GRIP: Per ESTERNO accetta varianti GRIP anche senza rating R11/R12/R13

            // 🆕 Per ESTERNO accetta anche varianti 20mm senza rating

            debugInfo.push(`✅ Variante GRIP/20mm senza rating inclusa per ESTERNO (antiscivolo/outdoor)`);

            // Continua il processing - non fare return

          } else if (hasSpecialCharacteristics) {

            debugInfo.push(`✅ Variante con caratteristiche speciali senza rating inclusa`);

            // Continua il processing - non fare return

          } else {

            debugInfo.push(`Variante senza rating saltata`);

            return;

          }

        }



        // Verifica se ha il rating corretto per la destinazione

        let hasCorrectRating = false;



        if (destination === 'INTERNO') {

        // Per INTERNO accetta R9, R10, varianti senza rating (non PARETE, non 20mm), o caratteristiche speciali

        // 🆕 Escludi 20mm senza rating (vanno in ESTERNO)

        const is20mmVar = /\b20\s*mm\b/.test(variantText) || /\b2\s*cm\b/.test(variantText);

        const is20mmNoRatingVar = is20mmVar && !hasAnyRating;

        hasCorrectRating = (hasR9 || hasR10 || (!hasAnyRating && !is20mmNoRatingVar) || hasSpecialCharacteristics) && !is20mmNoRatingVar;

        if (!hasCorrectRating) {

          debugInfo.push(`Variante esclusa per INTERNO (solo R11, 20mm senza rating, o senza caratteristiche speciali)`);

          return;

        }

        // Escludi colori Lithos con R10 da INTERNO (devono andare solo in SOLO PARETE) - SOLO PER SENSI

        if (this.isSensiProduct() && isLithos && hasR10) {

          debugInfo.push(`Variante Lithos R10 esclusa per INTERNO (solo INTERNO SOLO PARETE - Sensi)`);

          return;

        }

        // Escludi varianti NEST da INTERNO (devono andare solo in SOLO PARETE)

        if (hasNest) {

          debugInfo.push(`Variante NEST esclusa per INTERNO (solo SOLO PARETE)`);

          return;

        }

        // Escludi varianti PARETE da INTERNO (devono andare in SOLO PARETE)

        if (hasParete) {

          debugInfo.push(`Variante PARETE esclusa per INTERNO (solo SOLO PARETE)`);

          return;

        }

      } else if (destination === 'ESTERNO') {

        // Per ESTERNO accetta R11, R12, R13 OPPURE 20mm senza rating

        // NOTA: Grip e Antislip vanno in ESTERNO solo se hanno R11/R12/R13

        // 🆕 20mm senza rating vanno sempre in ESTERNO

        const is20mmVar = /\b20\s*mm\b/.test(variantText) || /\b2\s*cm\b/.test(variantText);

        const is20mmNoRatingVar = is20mmVar && !hasAnyRating;

        hasCorrectRating = hasR11 || hasR12 || hasR13 || is20mmNoRatingVar;

        if (!hasCorrectRating) {

          debugInfo.push(`Variante esclusa per ESTERNO (richiede R11/R12/R13 o 20mm)`);

          return;

        }

      } else if (destination === 'INTERNO_SOLO_PARETE') {

        // Per INTERNO SOLO A PARETE: formati PARETE o BOCCIARDATO con qualsiasi rating

        const isLithosR10Sensi = this.isSensiProduct() && isLithos && hasR10;

        const isBocciardatoParete = isLithos && hasParete;



        if (!hasParete && !isLithosR10Sensi && !isLithos) {

          debugInfo.push(`Variante esclusa per INTERNO SOLO PARETE (non contiene PARETE né Bocciardato)`);

          return;

        }



        // SPECIAL RULE PER SENSI: escludi bocciardato R11 (SAND) da INTERNO_SOLO_PARETE

        if (this.isSensiProduct() && isLithos && hasR11) {

          debugInfo.push(`Variante Bocciardato R11 (SAND) esclusa per INTERNO SOLO PARETE Sensi (solo LITHOS R10 ammessi)`);

          return;

        }



        // Per bocciardato/PARETE: accetta QUALSIASI rating (R9, R10, R11, R12, R13)

        // Per altri formati PARETE: accetta solo R9/R10 (interni)

        if (hasAnyRating) {

          if (isLithos) {

            // Bocciardato: qualsiasi rating è OK (eccetto R11 per Sensi, già filtrato sopra)

            hasCorrectRating = true;

            debugInfo.push(`✅ Variante Bocciardato con rating ${hasR9?'R9':hasR10?'R10':hasR11?'R11':hasR12?'R12':'R13'} inclusa per INTERNO SOLO PARETE`);

          } else {

            // Altri formati PARETE: solo R9/R10

            hasCorrectRating = hasR9 || hasR10;

            if (!hasCorrectRating) {

              debugInfo.push(`Variante esclusa per INTERNO SOLO PARETE (rating non valido - deve essere R9 o R10 per non-bocciardato)`);

              return;

            }

          }

        }

      } else if (destination === 'BATTISCOPA') {

        // Per BATTISCOPA: accetta solo varianti con BATTISCOPA nel nome

        if (!isBattiscopa) {

          debugInfo.push(`Variante esclusa per BATTISCOPA (non contiene BATTISCOPA nel nome)`);

          return;

        }

        hasCorrectRating = true; // I battiscopa non hanno rating

        debugInfo.push(`✅ Variante BATTISCOPA inclusa`);

      }

      } // Fine modalità con rating



      // Estrai il formato base (rimuovi tutti i suffissi delle caratteristiche speciali)

      let formatBase = selectedFormat;

      formatBase = formatBase

        .replace('-parete', '')

        .replace('-lux', '')

        .replace('-fluid', '')

        .replace('-lucido', '').replace('-stripe', '').replace('-riga', '').replace('-pliss', '').replace('-twist', '').replace('-strutturasign', '').replace('-strutturanet', '').replace('-strutturamove', '')

        .replace('-comfort', '')

        .replace('-strutturato20mm', '')

        .replace('-strutturato', '')

        .replace('-satinatoNaturale', '')  // DEVE essere PRIMA di -satinato!

        .replace('-satinato', '').replace('-velvet', '')

        .replace('-bocciardato', '')

        .replace('-liscio', '')

        .replace('-Naturalecuoio', '')

        .replace('-Naturale', '')

        .replace('-naturale', '')

        .replace('-squadrato', '')

        .replace('-squadrata', '')

        .replace('-cannete', '')

        .replace('-soft', '')

        .replace('-matte', '')

        .replace('-ptv', '')

        .replace('-lappatasatinata', '')

        .replace('-lappata', '')

        .replace('-lappato', '')

        .replace('-levigata', '').replace('-patinato', '').replace('-patinata', '')

        .replace('-levigato', '')

        .replace('-realupstrideup', '')

        .replace('-RealUpStrideUp', '')

        .replace('-realup', '')

        .replace('-RealUp', '')

        .replace('-strideup', '')

        .replace('-StrideUp', '')

        .replace('-grip', '')

        .replace('-Grip', '')

        .replace('-antislip', '')

        .replace('-Antislip', '')

        .replace('-20mm', '')

        .replace('-battiscopa', '')

        .replace('-fade', '')

        .replace('-Fade', '')
        .replace(/-+/g, '-').replace(/^-|-$/g, '');



      const isFormatParete = selectedFormat.includes('-parete');

      const isFormatBattiscopa = selectedFormat.includes('-battiscopa');

      const isFormatFade = selectedFormat.includes('-fade');

      const isFormatLappataSatinata = selectedFormat.includes('-lappatasatinata');

      const isFormatLux = selectedFormat.includes('-lux');

      const isFormatFluid = selectedFormat.includes('-fluid');

      const isFormatLucido = selectedFormat.includes('-lucido');

      const isFormatComfort = selectedFormat.includes('-comfort');

      const isFormatStrutturato = selectedFormat.includes('-strutturato');
      const isFormatTwist = selectedFormat.includes('-twist');
      const isFormatStrutturaMove = selectedFormat.includes('-strutturamove');
      const isFormatStrutturaSign = selectedFormat.includes('-strutturasign');
      const isFormatStrutturaNet = selectedFormat.includes('-strutturanet');
      const isFormatStripe = selectedFormat.includes('-stripe');
      const isFormatRiga = selectedFormat.includes('-riga');
      const isFormatPliss = selectedFormat.includes('-pliss');
      const isFormatSatinatoNaturale = selectedFormat.includes('-satinatoNaturale');

      const isFormatSatinato = selectedFormat.includes('-satinato') && !isFormatSatinatoNaturale;

      const isFormatBocciardato = selectedFormat.includes('-bocciardato');

      const isFormatLiscio = selectedFormat.includes('-liscio');

      const isFormatNaturalecuoio = selectedFormat.includes('-naturalecuoio');

      const isFormatNaturale = (selectedFormat.includes('-Naturale') && !isFormatNaturalecuoio) || selectedFormat.includes('-naturale'); // Naturale normale, non Cuoio Naturale

      const isFormatSquadrato = selectedFormat.includes('-squadrato') || selectedFormat.includes('-squadrata');

      const isFormatCannete = selectedFormat.includes('-cannete');

      const isFormatSoft = selectedFormat.includes('-soft');

      const isFormatPTV = selectedFormat.includes('-ptv');

      const isFormatLappata = (selectedFormat.includes('-lappata') || selectedFormat.includes('-lappato')) && !selectedFormat.includes('-lappatasatinata');

      const isFormatLevigata = selectedFormat.includes('-levigata') || selectedFormat.includes('-levigato');

      const isFormatRealUp = selectedFormat.includes('-realup') || selectedFormat.includes('-RealUp');

      const isFormatGrip = selectedFormat.includes('-grip') || selectedFormat.includes('-Grip');

      const isFormatAntislip = selectedFormat.includes('-antislip') || selectedFormat.includes('-Antislip');

      const isFormat20mm = selectedFormat.includes('-20mm');



      // Controlla se la variante contiene il formato selezionato

      // Supporta sia punto che virgola come separatore decimale (es: 26.5x180 vs 26,5x180)

      const formatPattern = formatBase.toLowerCase().replace(/\./g, '[.,]').replace(/x/gi, '[xX×]');

      let formatMatch = new RegExp(formatPattern, 'i').test(variantText);



      // Verifica PARETE

      if (isFormatParete) {

        formatMatch = formatMatch && hasParete;

      } else {

        formatMatch = formatMatch && !hasParete;

      }



      // Verifica LUX

      if (isFormatLux) {

        formatMatch = formatMatch && variantText.includes('lux');

      } else {

        formatMatch = formatMatch && !variantText.includes('lux');

      }



      // Verifica FLUID

      if (isFormatFluid) {

        formatMatch = formatMatch && variantText.includes('fluid');

      } else {

        formatMatch = formatMatch && !variantText.includes('fluid');

      }



      // Verifica LUCIDO (include anche "lucida" femminile)

      if (isFormatLucido) {

        formatMatch = formatMatch && (variantText.includes('lucido') || variantText.includes('lucida'));

      } else {

        formatMatch = formatMatch && !variantText.includes('lucido') && !variantText.includes('lucida');

      }



      // Verifica COMFORT

      if (isFormatComfort) {

        formatMatch = formatMatch && variantText.includes('comfort');

      } else {

        formatMatch = formatMatch && !variantText.includes('comfort');

      }



      // Verifica STRUTTURATO

      if (isFormatStrutturato) {

        formatMatch = formatMatch && (variantText.includes('strutturato') || variantText.includes('strutturata'));

      } else {

        formatMatch = formatMatch && !variantText.includes('strutturato') && !variantText.includes('strutturata');

      }

      // Verifica TWIST
      if (isFormatTwist) {
        formatMatch = formatMatch && variantText.includes('twist');
      } else {
        formatMatch = formatMatch && !variantText.includes('twist');
      }

      // Verifica STRUTTURA MOVE
      if (isFormatStrutturaMove) {
        formatMatch = formatMatch && variantText.includes('struttura move');
      } else {
        formatMatch = formatMatch && !variantText.includes('struttura move');
      }

      // Verifica STRUTTURA SIGN
      if (isFormatStrutturaSign) {
        formatMatch = formatMatch && variantText.includes('struttura sign');
      } else {
        formatMatch = formatMatch && !variantText.includes('struttura sign');
      }

      // Verifica STRUTTURA NET
      if (isFormatStrutturaNet) {
        formatMatch = formatMatch && variantText.includes('struttura net');
      } else {
        formatMatch = formatMatch && !variantText.includes('struttura net');
      }

      // Verifica STRIPE (solo INX WALL: 'stripe parete' adiacente, non CALCIS)
      if (isFormatStripe) {
        formatMatch = formatMatch && variantText.includes('stripe parete');
      } else {
        formatMatch = formatMatch && !variantText.includes('stripe parete');
      }

      // Verifica RIGA (token ' riga ' con spazi, sicuro da 'irrigante')
      if (isFormatRiga) {
        formatMatch = formatMatch && variantText.includes(' riga ');
      } else {
        formatMatch = formatMatch && !variantText.includes(' riga ');
      }

      // Verifica PLISSE
      if (isFormatPliss) {
        formatMatch = formatMatch && variantText.includes('pliss');
      } else {
        formatMatch = formatMatch && !variantText.includes('pliss');
      }



      // Verifica SATINATONaturale (Naturale Silk) - deve essere prima di SATINATO

      if (isFormatSatinatoNaturale) {

        formatMatch = formatMatch && variantText.includes('naturale silk');

      } else {

        formatMatch = formatMatch && !variantText.includes('naturale silk');

      }



      // 🔧 FIX: Soft, Satinata e Matte sono finiture DIVERSE

      // Verifica SATINATO (NON include soft - sono finiture diverse)

      if (isFormatSatinato) {

        const hasSatinato = variantText.includes('satinato') || variantText.includes('satinata');

        const hasSilkNotNaturale = variantText.includes('silk') && !variantText.includes('naturale silk');

        formatMatch = formatMatch && (hasSatinato || hasSilkNotNaturale);

      } else if (!isFormatSatinatoNaturale && !isFormatLappataSatinata && !isFormatSoft) {

        // Se non è satinato/satinatoNaturale/lappata-satinata/soft, escludi satinato/satinata

        const hasSilkNotNaturale = variantText.includes('silk') && !variantText.includes('naturale silk');

        formatMatch = formatMatch && !variantText.includes('satinato') && !variantText.includes('satinata') && !hasSilkNotNaturale;

      }



      // Verifica SOFT (finitura separata da Satinata)

      if (isFormatSoft) {

        formatMatch = formatMatch && variantText.includes('soft');

      } else if (!isFormatSatinato && !isFormatSatinatoNaturale && !isFormatLappataSatinata) {

        // Se non è soft né satinato, escludi soft

        formatMatch = formatMatch && !variantText.includes('soft');

      }



      // Verifica BOCCIARDATO

      if (isFormatBocciardato) {

        formatMatch = formatMatch && variantText.includes('bocciardato');

      } else {

        formatMatch = formatMatch && !variantText.includes('bocciardato');

      }



      // Verifica PTV

      if (isFormatPTV) {

        formatMatch = formatMatch && variantText.includes('ptv');

      } else {

        formatMatch = formatMatch && !variantText.includes('ptv');

      }



      // Verifica LISCIO

      if (isFormatLiscio) {

        formatMatch = formatMatch && (variantText.includes('liscio') || variantText.includes('liscia') || variantText.includes('smooth'));

      } else {

        formatMatch = formatMatch && !variantText.includes('liscio') && !variantText.includes('liscia') && !variantText.includes('smooth');

      }



      // Verifica NaturaleCUOIO (Naturale Leather)

      if (isFormatNaturalecuoio) {

        formatMatch = formatMatch && variantText.includes('naturale leather');

      } else {

        formatMatch = formatMatch && !variantText.includes('naturale leather');

      }



      // Verifica Naturale (solo Naturale normale, non Naturale leather né Naturale silk)

      // 🆕 FIX 22-GEN-2026: Controlla "naturale" come finitura SOLO in option1 (formato)

      // Per prodotti come 4EVER, "Naturale" è un nome colore in option2, non una finitura

      const option1LowerForFilter = (variant.option1 || '').toLowerCase();

      const hasNaturaleInOption1 = option1LowerForFilter.includes('naturale') && !option1LowerForFilter.includes('naturale leather') && !option1LowerForFilter.includes('naturale silk');



      if (isFormatNaturale) {

        // Deve avere "naturale" in option1 (formato) ma NON "naturale leather" né "naturale silk"

        formatMatch = formatMatch && hasNaturaleInOption1;

      } else if (!isFormatNaturalecuoio && !isFormatSatinatoNaturale) {

        // Se non è né Naturale né Naturalecuoio né SatinatoNaturale, escludi varianti con Naturale IN OPTION1

        // NON escludere varianti dove "Naturale" è solo il nome del colore (option2)

        formatMatch = formatMatch && !hasNaturaleInOption1;

      }



      // Verifica SQUADRATO

      if (isFormatSquadrato) {

        formatMatch = formatMatch && (variantText.includes('squadrato') || variantText.includes('squadrata'));

      } else {

        formatMatch = formatMatch && !variantText.includes('squadrato') && !variantText.includes('squadrata');

      }



      // Verifica CANNETE

      if (isFormatCannete) {

        formatMatch = formatMatch && (variantText.includes('cannete') || variantText.includes('canneté') || variantText.includes('cannetté') || variantText.includes('cannetè'));

      } else {

        formatMatch = formatMatch && !variantText.includes('cannete') && !variantText.includes('canneté') && !variantText.includes('cannetté') && !variantText.includes('cannetè');

      }



      // Verifica LAPPATA/LAPPATO

      if (isFormatLappata) {

        formatMatch = formatMatch && (variantText.includes('lappata') || variantText.includes('lappato'));

      } else if (!isFormatLappataSatinata) {

        // Se NON è Lappata-Satinata, escludi varianti con lappata/lappato

        // (le varianti Lappata-Satinata contengono "lappata" quindi non devono essere escluse qui)

        formatMatch = formatMatch && !variantText.includes('lappata') && !variantText.includes('lappato');

      }



      // Verifica LEVIGATA/LEVIGATO

      if (isFormatLevigata) {

        formatMatch = formatMatch && (variantText.includes('levigata') || variantText.includes('levigato'));

      } else {

        formatMatch = formatMatch && !variantText.includes('levigata') && !variantText.includes('levigato');

      }



      // Verifica REALUP

      if (isFormatRealUp) {

        formatMatch = formatMatch && variantText.includes('realup');

      } else {

        formatMatch = formatMatch && !variantText.includes('realup');

      }



      // Verifica GRIP

      if (isFormatGrip) {

        formatMatch = formatMatch && variantText.includes('grip');

      } else {

        formatMatch = formatMatch && !variantText.includes('grip');

      }



      // Verifica ANTISLIP (supporta: antislip, anti slip, anti-slip)

      if (isFormatAntislip) {

        const hasAntislip = variantText.includes('antislip') || variantText.includes('anti slip') || variantText.includes('anti-slip');

        formatMatch = formatMatch && hasAntislip;

      } else {

        const hasAntislip = variantText.includes('antislip') || variantText.includes('anti slip') || variantText.includes('anti-slip');

        formatMatch = formatMatch && !hasAntislip;

      }



      // Verifica 20MM

      if (isFormat20mm) {

        const variant20mm = /\b20\s*mm\b/.test(variantText) || /\b2\s*cm\b/.test(variantText);

        formatMatch = formatMatch && variant20mm;

      } else {

        const variant20mm = /\b20\s*mm\b/.test(variantText) || /\b2\s*cm\b/.test(variantText);

        formatMatch = formatMatch && !variant20mm;

      }



      // Verifica BATTISCOPA

      if (isFormatBattiscopa) {

        formatMatch = formatMatch && isBattiscopa;

      } else {

        formatMatch = formatMatch && !isBattiscopa;

      }



      // Verifica FADE

      if (isFormatFade) {

        formatMatch = formatMatch && variantText.includes('fade');

      } else {

        formatMatch = formatMatch && !variantText.includes('fade');

      }



      // Verifica LAPPATA-SATINATA

      if (isFormatLappataSatinata) {

        formatMatch = formatMatch && (variantText.includes('lappata satinata') || variantText.includes('lappata-satinata'));

      } else {

        formatMatch = formatMatch && !variantText.includes('lappata satinata') && !variantText.includes('lappata-satinata');

      }



      // 🔧 FIX: Soft è una finitura DIVERSA da Satinato (SILK va gestito con Satinato)



      if (formatMatch) {

        // Estrai il colore da questa variante

        this.colorOptions.forEach(color => {

          if (variantText.includes(color.value.toLowerCase())) {

            availableColors.add(color.value);

            debugInfo.push(`✅ Colore ${color.value} trovato per formato ${selectedFormat}`);

          }

        });

      }

    });

    // Salva i colori filtrati

    this.filteredColorOptions = this.colorOptions.filter(color =>

      availableColors.has(color.value)

    );




    // 🔧 FIX 23-DIC-2024: Per INTERNO_SOLO_PARETE, filtra SOLO colori con "PARETE" o "FLUID" nel nome

    // Questo è un filtro finale esplicito che rimuove i colori base (CREMA, AVORIO, etc.)

    // 🔧 FIX 22-GEN-2026: Aggiunto supporto per colori FLUID (es. "Beige Royal Struttura Fluid")

    // 🔧 FIX 22-GEN-2026: NON filtrare se NESSUN colore ha PARETE/FLUID (es. YOUR MATCH PALETTE)

    if (destination === 'INTERNO_SOLO_PARETE') {

      // Prima verifica se ci sono colori con PARETE/FLUID

      const hasAnyPareteOrFluidColor = this.filteredColorOptions.some(color => {

        const colorUpper = (color.label || color.value || '').toUpperCase();

        return colorUpper.includes('PARETE') || colorUpper.includes('FLUID') || colorUpper.includes('LINE') || colorUpper.includes('RIBBED');

      });



      // Applica il filtro SOLO se ci sono alcuni colori con PARETE/FLUID (prodotti misti)

      // Se nessun colore ha PARETE/FLUID, significa che il prodotto ha solo formati parete con colori normali

      if (hasAnyPareteOrFluidColor) {

        const beforeCount = this.filteredColorOptions.length;

        this.filteredColorOptions = this.filteredColorOptions.filter(color => {

          const colorUpper = (color.label || color.value || '').toUpperCase();

          const hasPareteOrFluid = colorUpper.includes('PARETE') || colorUpper.includes('FLUID') || colorUpper.includes('LINE') || colorUpper.includes('RIBBED');

          if (!hasPareteOrFluid) {


          }

          return hasPareteOrFluid;

        });


      } else {


      }

    }



    // 🔧 FIX 09-GEN-2026: Per INTERNO, escludi colori LINE/RIBBED (sono solo per PARETE)

    // I colori LINE e RIBBED devono apparire SOLO in INTERNO_SOLO_PARETE, non in INTERNO normale

    if (destination === 'INTERNO') {

      const beforeCount = this.filteredColorOptions.length;

      this.filteredColorOptions = this.filteredColorOptions.filter(color => {

        const colorUpper = (color.label || color.value || '').toUpperCase();

        const isLineOrRibbed = colorUpper.includes('LINE') || colorUpper.includes('RIBBED');

        if (isLineOrRibbed) {


        }

        return !isLineOrRibbed;

      });

      if (beforeCount !== this.filteredColorOptions.length) {


      }

    }



    // NOTA: Per BATTISCOPA, il filtro è già gestito nel matching formato (isFormatBattiscopa)

    // I colori vengono filtrati automaticamente in base alle varianti disponibili per il formato battiscopa selezionato

  },



  // Osserva quando gli step diventano attivi

  // Filtra varianti basandosi sulla destinazione selezionata

  filterVariantsByDestination(destination) {

    // Salva la destinazione selezionata per il filtraggio successivo

    this.selectedDestination = destination;



    // NON filtrare le varianti qui - mostra tutti i formati e colori disponibili

    // Il filtraggio basato su R9/R10/R11 avverrà dopo la selezione del colore

  },



  // Filtra gli spessori basandosi su destinazione e colore selezionati

  filterThicknessByDestinationAndColor() {

    if (!this.product.variants || this.product.variants.length === 0) {

      return;

    }



    const destination = this.selectedDestination;

    const selectedColor = window.productConfigurator?.configuration?.color;

    const selectedFormat = window.productConfigurator?.configuration?.format;







    // FILTRA gli spessori in base al rating e alla destinazione

    let filteredThickness = this.thicknessOptions.filter(thickness => {

      // 🆕 Se il prodotto non ha rating system, filtra per PARETE e per FINITURA

      if (!this.productHasRatingSystem) {

        // Usa il flag isParete impostato durante l'estrazione

        const isParete = thickness.isParete === true;



        if (destination === 'INTERNO') {

          // INTERNO: mostra solo spessori NON parete e NON 20mm

          if (isParete) {

            return false;

          }

          // 20mm va sempre in ESTERNO, non in INTERNO

          const thicknessValue = (thickness.value || thickness.label || '').toLowerCase();

          const is20mm = /\b20\s*mm\b/.test(thicknessValue) || /\b2\s*cm\b/.test(thicknessValue);

          if (is20mm) {
            return false;
          }

        } else if (destination === 'INTERNO_SOLO_PARETE') {

          // INTERNO_SOLO_PARETE: mostra solo spessori parete

          // 🆕 FIX: Se lo spessore non ha isParete, verifica se il formato o colore selezionato contiene "parete"

          // Questo gestisce prodotti come NUANCES dove "PARETE" è nel colore, non nello spessore

          const formatHasParete = selectedFormat && selectedFormat.toLowerCase().includes('parete');

          const colorHasParete = selectedColor && selectedColor.toLowerCase().includes('parete');






          if (!isParete && !formatHasParete && !colorHasParete) {


            return false;

          }


        } else if (destination === 'BATTISCOPA') {

          // BATTISCOPA: NON filtrare per nome spessore - gli spessori sono "10.5 mm" etc.

          // Il filtro corretto avviene nel matching varianti sotto (verifica che esistano varianti BATTISCOPA con questo spessore)

        } else if (destination === 'ESTERNO') {

          // 🆕 ESTERNO senza rating system: mostra solo spessore 20mm

          const thicknessValue = (thickness.value || thickness.label || '').toLowerCase();

          const is20mm = /\b20\s*mm\b/.test(thicknessValue) || /\b2\s*cm\b/.test(thicknessValue);

          if (!is20mm) {

            return false;

          }

        }



        // 🆕 FIX: Verifica che lo spessore esista nelle varianti per formato+colore+finitura selezionati

        if (selectedFormat && selectedColor && this.product && this.product.variants) {

          const formatParts = selectedFormat.split('-');

          const formatBase = formatParts[0]; // es: "60x120"



          // Estrai info finitura dal formato selezionato

          const isFormatLux = selectedFormat.includes('-lux');

          const isFormatLucido = selectedFormat.includes('-lucido');

          const isFormatNaturale = selectedFormat.includes('-naturale') && !selectedFormat.includes('-satinatoNaturale');

          const isFormatSatinatoNaturale = selectedFormat.includes('-satinatoNaturale');

          const isFormatSatinato = selectedFormat.includes('-satinato') && !isFormatSatinatoNaturale;

          const isFormatComfort = selectedFormat.includes('-comfort');

          const isFormatStrutturato = selectedFormat.includes('-strutturato');

          const isFormatBocciardato = selectedFormat.includes('-bocciardato');

          const isFormatSquadrato = selectedFormat.includes('-squadrato') || selectedFormat.includes('-squadrata');

          const isFormatCannete = selectedFormat.includes('-cannete');

          const isFormatSoft = selectedFormat.includes('-soft');

          const isFormatLappata = (selectedFormat.includes('-lappata') || selectedFormat.includes('-lappato')) && !selectedFormat.includes('-lappatasatinata');

          const isFormatRealUp = selectedFormat.includes('-realup') || selectedFormat.includes('-RealUp');

          const isFormatGrip = selectedFormat.includes('-grip') || selectedFormat.includes('-Grip');

          const isFormatAntislip = selectedFormat.includes('-antislip') || selectedFormat.includes('-Antislip');

          const isFormatBattiscopa = selectedFormat.includes('-battiscopa');

          const isFormatFade = selectedFormat.includes('-fade');

          const isFormatLappataSatinata = selectedFormat.includes('-lappatasatinata');



          // Estrai il valore numerico dello spessore

          const thicknessLabel = (thickness.value || thickness.label);

          const thicknessNum = thicknessLabel.match(/(\d+(?:[.,]\d+)?)/)?.[0];



          if (thicknessNum) {

            // Cerca se esiste una variante con questo spessore per formato+colore+finitura

            const hasMatchingVariant = this.product.variants.some(variant => {

              const variantText = `${variant.title || ''} ${variant.option1 || ''} ${variant.option2 || ''} ${variant.option3 || ''}`.toLowerCase();



              // Deve contenere il formato base

              const formatPattern = formatBase.replace(/\./g, '[.,]').replace(/x/gi, '[xX×]');

              if (!new RegExp(formatPattern, 'i').test(variantText)) return false;



              // Deve contenere il colore

              if (!variantText.includes(selectedColor.toLowerCase())) return false;



              // Deve contenere lo spessore

              const thicknessPattern = new RegExp(`${thicknessNum.replace('.', '\\.')}\\s*mm`, 'i');

              if (!thicknessPattern.test(variantText)) return false;



              // Verifica finitura - deve corrispondere alla finitura selezionata

              if (isFormatLux) {

                if (!variantText.includes('lux')) return false;

              }

              if (isFormatLucido) {

                if (!variantText.includes('lucido') && !variantText.includes('lucida')) return false;

              }

              if (isFormatNaturale) {

                // Naturale ma NON Naturale silk

                if (!variantText.includes('naturale') || variantText.includes('naturale silk')) return false;

              }

              if (isFormatSatinatoNaturale) {

                if (!variantText.includes('naturale silk')) return false;

              }

              // 🔧 FIX: Soft e Satinata sono finiture DIVERSE

              if (isFormatSatinato) {

                const hasSilkNotNaturale = variantText.includes('silk') && !variantText.includes('naturale silk');

                if (!variantText.includes('satinato') && !variantText.includes('satinata') && !hasSilkNotNaturale) return false;

              }

              if (isFormatComfort) {

                if (!variantText.includes('comfort')) return false;

              }

              if (isFormatStrutturato) {

                if (!variantText.includes('strutturato') && !variantText.includes('strutturata')) return false;

              }

              if (isFormatBocciardato) {

                if (!variantText.includes('bocciardato') && !variantText.includes('lithos')) return false;

              }

              if (isFormatSquadrato) {

                if (!variantText.includes('squadrato') && !variantText.includes('squadrata')) return false;

              }

              if (isFormatCannete) {

                if (!variantText.includes('cannete') && !variantText.includes('canneté')) return false;

              }

              if (isFormatSoft) {

                if (!variantText.includes('soft')) return false;

              }

              if (isFormatLappata) {

                if ((!variantText.includes('lappata') && !variantText.includes('lappato')) || variantText.includes('lappata satinata') || variantText.includes('lappata-satinata')) return false;

              }

              if (isFormatRealUp) {

                if (!variantText.includes('realup')) return false;

              }

              if (isFormatGrip) {

                if (!variantText.includes('grip')) return false;

              }

              if (isFormatAntislip) {

                if (!/anti[\s_-]?slip/i.test(variantText)) return false;

              }

              if (isFormatBattiscopa) {

                if (!variantText.includes('battiscopa')) return false;

              }

              if (isFormatFade) {

                if (!variantText.includes('fade')) return false;

              }

              if (isFormatLappataSatinata) {

                if (!variantText.includes('lappata satinata') && !variantText.includes('lappata-satinata')) return false;

              }



              // Se nessuna finitura specifica, escludi varianti con finiture specifiche

              if (!isFormatLux && !isFormatLucido && !isFormatNaturale && !isFormatSatinatoNaturale && !isFormatSatinato &&

                  !isFormatComfort && !isFormatStrutturato && !isFormatBocciardato && !isFormatCannete && !isFormatSoft && !isFormatLappata && !isFormatRealUp && !isFormatGrip && !isFormatAntislip && !isFormatBattiscopa && !isFormatFade && !isFormatLappataSatinata) {

                // Formato base senza finitura - accetta tutto

              }



              return true;

            });



            if (!hasMatchingVariant) {

              return false;

            }

          }

        }



        return true;

      }



      // 🆕 RILEVAMENTO AUTOMATICO: verifica se le varianti del formato selezionato hanno rating o no

      // Invece di assumere quali finiture hanno rating, controlliamo le varianti effettive

      if (selectedFormat && selectedColor) {

        // Estrai la finitura dal formato (es: "lucido" da "60x60-lucido-squadrato")

        const formatParts = selectedFormat.split('-');

        const formatBase = formatParts[0]; // es: "60x60"



        // Cerca le varianti che corrispondono a questo formato

        const matchingVariants = this.product.variants.filter(variant => {

          const variantText = `${variant.title || ''} ${variant.option1 || ''} ${variant.option2 || ''} ${variant.option3 || ''}`.toLowerCase();



          // Deve contenere il formato base (supporta punto/virgola decimale)

          const formatPattern = formatBase.replace(/\./g, '[.,]').replace(/x/gi, '[xX×]');

          if (!new RegExp(formatPattern, 'i').test(variantText)) return false;



          // Deve contenere il colore

          if (!variantText.includes(selectedColor.toLowerCase())) return false;



          // Verifica tutte le finiture presenti nel formato selezionato

          if (selectedFormat.includes('-lux') && !variantText.includes('lux')) return false;

          if (selectedFormat.includes('-lucido') && !variantText.includes('lucido') && !variantText.includes('lucida')) return false;

          if (selectedFormat.includes('-naturale') && !variantText.includes('naturale')) return false;

          // IMPORTANTE: satinatoNaturale DEVE essere controllato PRIMA di satinato!

          if (selectedFormat.includes('-satinatoNaturale') && !variantText.includes('naturale silk')) return false;

          // 🔧 FIX: Soft e Satinata sono finiture DIVERSE

          if (selectedFormat.includes('-satinato') && !selectedFormat.includes('-satinatoNaturale') && !variantText.includes('satinato') && !variantText.includes('satinata') && !(variantText.includes('silk') && !variantText.includes('naturale silk'))) return false;

          if (selectedFormat.includes('-soft') && !variantText.includes('soft')) return false;

          if (selectedFormat.includes('-comfort') && !variantText.includes('comfort')) return false;

          if (selectedFormat.includes('-strutturato') && !variantText.includes('strutturato') && !variantText.includes('strutturata')) return false;

          if (selectedFormat.includes('-bocciardato') && !variantText.includes('bocciardato') && !variantText.includes('lithos')) return false;

          if ((selectedFormat.includes('-squadrato') || selectedFormat.includes('-squadrata')) && !variantText.includes('squadrato') && !variantText.includes('squadrata')) return false;

          if ((selectedFormat.includes('-realup') || selectedFormat.includes('-RealUp')) && !variantText.includes('realup')) return false;

          if ((selectedFormat.includes('-grip') || selectedFormat.includes('-Grip')) && !variantText.includes('grip')) return false;

          if ((selectedFormat.includes('-antislip') || selectedFormat.includes('-Antislip')) && !/anti[\s_-]?slip/i.test(variantText)) return false;

          if ((selectedFormat.includes('-lappata') || selectedFormat.includes('-lappato')) && !variantText.includes('lappata') && !variantText.includes('lappato')) return false;

          // Verifica FADE

          if (selectedFormat.includes('-fade')) {

            if (!variantText.includes('fade')) return false;

          } else {

            if (variantText.includes('fade')) return false;

          }

          // Verifica BATTISCOPA

          if (selectedFormat.includes('-battiscopa')) {

            if (!variantText.includes('battiscopa')) return false;

          } else {

            if (variantText.includes('battiscopa')) return false;

          }



          return true;

        });



        // Controlla se le varianti matching hanno rating

        const variantsHaveRating = matchingVariants.some(variant => {

          const variantText = `${variant.title || ''} ${variant.option1 || ''} ${variant.option2 || ''} ${variant.option3 || ''}`.toUpperCase();

          return /\bR9\b|\bR10\b|\bR11\b|\bR12\b|\bR13\b/i.test(variantText);

        });



        const variantsWithoutRating = matchingVariants.some(variant => {

          const variantText = `${variant.title || ''} ${variant.option1 || ''} ${variant.option2 || ''} ${variant.option3 || ''}`.toUpperCase();

          return !/\bR9\b|\bR10\b|\bR11\b|\bR12\b|\bR13\b/i.test(variantText);

        });



        // Se le varianti di questo formato NON hanno rating, escludi spessori CON rating

        if (variantsWithoutRating && !variantsHaveRating && thickness.rating) {

          return false;

        }



        // Se le varianti di questo formato HANNO rating, escludi spessori SENZA rating

        if (variantsHaveRating && !variantsWithoutRating && !thickness.rating) {

          return false;

        }

      }



      // Se lo spessore non ha rating, verifica se appartiene a varianti con caratteristiche speciali

      if (!thickness.rating) {

        if (destination === 'INTERNO_SOLO_PARETE') {




          // 🆕 FIX NUANCES: Se il formato o colore selezionato contiene "parete",

          // cerchiamo varianti che matchano formato+colore+spessore (senza richiedere "parete" nella variante stessa)

          const formatHasParete = selectedFormat && selectedFormat.toLowerCase().includes('parete');

          const colorHasParete = selectedColor && selectedColor.toLowerCase().includes('parete');






          // Verifica se esiste una variante PARETE o BOCCIARDATO con questo spessore

          // OPPURE se formato/colore ha "parete" e esiste variante con formato+colore+spessore

          const hasPareteOrBocciardatoVariant = this.product.variants.some(variant => {

            // Non filtriamo per available

            const variantText = `${variant.title || ''} ${variant.option1 || ''} ${variant.option2 || ''} ${variant.option3 || ''}`.toLowerCase();



            // 🆕 FIX: Se formato o colore ha "parete", non richiedere "parete" nel testo variante

            // perché per NUANCES il "PARETE" è già nel colore selezionato che matcheremo dopo

            const hasPareteOrBocciardato = /parete|bocciardato|lithos/i.test(variantText);

            if (!hasPareteOrBocciardato && !formatHasParete && !colorHasParete) {

              return false;

            }



            // Deve contenere il formato selezionato (supporta punto/virgola decimale)

            if (selectedFormat) {

              let formatBase = selectedFormat.replace('-lucido', '').replace('-stripe', '').replace('-riga', '').replace('-pliss', '').replace('-twist', '').replace('-strutturasign', '').replace('-strutturanet', '').replace('-strutturamove', '').replace('-comfort', '').replace('-strutturato20mm', '').replace('-strutturato', '').replace('-satinatoNaturale', '').replace('-satinato', '').replace('-velvet', '').replace('-bocciardato', '').replace('-ptv', '').replace('-parete', '').replace('-lux', '').replace('-fluid', '').replace('-liscio', '').replace('-levigato', '').replace('-levigata', '').replace('-patinato', '').replace('-patinata', '').replace('-lappatasatinata', '').replace('-lappata', '').replace('-lappato', '').replace('-Naturale', '').replace('-naturale', '').replace('-squadrato', '').replace('-squadrata', '').replace('-cannete', '').replace('-soft', '').replace('-matte', '').replace('-Naturalecuoio', '').replace('-realupstrideup', '').replace('-RealUpStrideUp', '').replace('-realup', '').replace('-RealUp', '').replace('-strideup', '').replace('-StrideUp', '').replace('-grip', '').replace('-Grip', '').replace('-antislip', '').replace('-Antislip', '').replace('-battiscopa', '').replace('-fade', '').replace('-Fade', '').replace('-20mm', '');

              const formatPattern = formatBase.replace(/\./g, '[.,]').replace(/x/gi, '[xX×]');

              if (!new RegExp(formatPattern, 'i').test(variantText)) return false;



              // 🆕 FIX: Verifica che la finitura corrisponda (StrideUp vs Antislip)

              // Se il formato selezionato è StrideUp, la variante deve essere StrideUp (non Antislip)

              // Se il formato selezionato è Antislip, la variante deve essere Antislip (non StrideUp)

              const isFormatStrideUp = selectedFormat.toLowerCase().includes('strideup');

              const isFormatAntislip = selectedFormat.toLowerCase().includes('antislip');

              const variantIsStrideUp = variantText.includes('strideup');

              const variantIsAntislip = /anti[\s_-]?slip/i.test(variantText);



              if (isFormatStrideUp && variantIsAntislip && !variantIsStrideUp) {

                return false; // Formato è StrideUp ma variante è Antislip

              }

              if (isFormatAntislip && variantIsStrideUp && !variantIsAntislip) {

                return false; // Formato è Antislip ma variante è StrideUp

              }

            }



            // Deve contenere il colore selezionato

            // 🆕 FIX: Per colori con "PARETE", cerchiamo anche senza "PARETE" nella variante

            // es. colore selezionato = "Bianco Ribbed PARETE" ma variante ha "Bianco Ribbed"

            if (selectedColor) {

              const colorLower = selectedColor.toLowerCase();

              const colorWithoutParete = colorLower.replace(/\s*parete\s*/gi, '').trim();

              const variantHasColor = variantText.includes(colorLower) || variantText.includes(colorWithoutParete);

              if (!variantHasColor) {

                return false;

              }

            }



            // Deve contenere lo spessore

            const thicknessLabel = (thickness.value || thickness.label);

            const thicknessNum = thicknessLabel.match(/(\d+(?:[.,]\d+)?)/)?.[0]?.replace('.', '\\.');

            if (thicknessNum) {

              const thicknessPattern = new RegExp(`${thicknessNum}\\s*mm`, 'i');

              if (!thicknessPattern.test(variantText)) return false;

            }




            return true;

          });






          if (hasPareteOrBocciardatoVariant) {

            return true;

          } else {


            return false;

          }

        } else if (destination === 'INTERNO') {

          // Verifica se esiste una variante per INTERNO (senza rating o con caratteristiche speciali)

          // Le varianti senza rating (non PARETE) sono valide per INTERNO

          const hasValidVariant = this.product.variants.some(variant => {

            // Non filtriamo per available

            const variantText = `${variant.title || ''} ${variant.option1 || ''} ${variant.option2 || ''} ${variant.option3 || ''}`.toLowerCase();



            // Escludi varianti PARETE

            if (variantText.includes('parete')) return false;



            // 🎯 FIX GRIP: Escludi varianti GRIP da INTERNO (sono antiscivolo, vanno in ESTERNO)

            if (variantText.includes('grip')) return false;



            // Verifica che non abbia rating (è per INTERNO)

            const hasRating = /\br9\b|\br10\b|\br11\b|\br12\b|\br13\b/i.test(variantText);

            // Deve NON avere rating O avere caratteristiche speciali (incluso Naturale silk per satinatoNaturale)

            const hasSpecial = /lucido|levigato|levigata|patinato|patinata|lappato|lappata|comfort|satinato|satinata|ptv|lux|fluid|Naturale silk/i.test(variantText);

            if (hasRating && !hasSpecial) return false;



            // Deve contenere il formato selezionato (supporta punto/virgola decimale)

            if (selectedFormat) {

              let formatBase = selectedFormat.replace('-lucido', '').replace('-stripe', '').replace('-riga', '').replace('-pliss', '').replace('-twist', '').replace('-strutturasign', '').replace('-strutturanet', '').replace('-strutturamove', '').replace('-comfort', '').replace('-strutturato20mm', '').replace('-strutturato', '').replace('-satinatoNaturale', '').replace('-satinato', '').replace('-velvet', '').replace('-bocciardato', '').replace('-ptv', '').replace('-parete', '').replace('-lux', '').replace('-fluid', '').replace('-liscio', '').replace('-levigato', '').replace('-levigata', '').replace('-patinato', '').replace('-patinata', '').replace('-lappatasatinata', '').replace('-lappata', '').replace('-lappato', '').replace('-Naturale', '').replace('-naturale', '').replace('-squadrato', '').replace('-squadrata', '').replace('-cannete', '').replace('-soft', '').replace('-matte', '').replace('-Naturalecuoio', '').replace('-realupstrideup', '').replace('-RealUpStrideUp', '').replace('-realup', '').replace('-RealUp', '').replace('-strideup', '').replace('-StrideUp', '').replace('-grip', '').replace('-Grip', '').replace('-antislip', '').replace('-Antislip', '').replace('-battiscopa', '').replace('-fade', '').replace('-Fade', '').replace('-20mm', '');

              const formatPattern = formatBase.replace(/\./g, '[.,]').replace(/x/gi, '[xX×]');

              if (!new RegExp(formatPattern, 'i').test(variantText)) return false;



              // Verifica che la finitura corrisponda al formato selezionato

              const isFormatLux = selectedFormat.includes('-lux');

              const isFormatLucido = selectedFormat.includes('-lucido');

              const isFormatLevigato = selectedFormat.includes('-levigato') || selectedFormat.includes('-levigata');

              const isFormatNaturale = selectedFormat.includes('-naturale');

              const isFormatSatinatoNaturale = selectedFormat.includes('-satinatoNaturale');

              const isFormatSatinato = selectedFormat.includes('-satinato') && !isFormatSatinatoNaturale;

              const isFormatComfort = selectedFormat.includes('-comfort');

              const isFormatStrutturato = selectedFormat.includes('-strutturato');

              const isFormatBocciardato = selectedFormat.includes('-bocciardato');

              const isFormatSquadrato = selectedFormat.includes('-squadrato') || selectedFormat.includes('-squadrata');

              const isFormatCannete = selectedFormat.includes('-cannete');

              const isFormatSoft = selectedFormat.includes('-soft');

              const isFormatNaturalecuoio = selectedFormat.includes('-naturalecuoio');

              const isFormatLappata = (selectedFormat.includes('-lappata') || selectedFormat.includes('-lappato')) && !selectedFormat.includes('-lappatasatinata');

              const isFormatRealUp = selectedFormat.includes('-realup') || selectedFormat.includes('-RealUp');

              const isFormatGrip = selectedFormat.includes('-grip') || selectedFormat.includes('-Grip');

              const isFormatBattiscopa = selectedFormat.includes('-battiscopa');

              const isFormatFade = selectedFormat.includes('-fade');

              const isFormatLappataSatinata = selectedFormat.includes('-lappatasatinata');



              // 🆕 FIX: LUX è una finitura (Lucida per PURITY of MARBLE)

              if (isFormatLux) {

                if (!variantText.includes('lux')) return false;

              } else {

                // Se il formato NON è LUX, la variante NON deve essere LUX

                if (/\blux\b/i.test(variantText)) return false;

              }

              if (isFormatLucido) {

                if (!variantText.includes('lucido') && !variantText.includes('lucida')) return false;

              }

              if (isFormatNaturale) {

                if (!variantText.includes('naturale')) return false;

              }

              if (isFormatLappata) {

                if ((!variantText.includes('lappata') && !variantText.includes('lappato')) || variantText.includes('lappata satinata') || variantText.includes('lappata-satinata')) return false;

              }

              // 🔧 FIX: Soft e Satinata sono finiture DIVERSE

              if (isFormatSatinato) {

                const hasSilkNotNaturale = variantText.includes('silk') && !variantText.includes('naturale silk');

                if (!variantText.includes('satinato') && !variantText.includes('satinata') && !hasSilkNotNaturale) return false;

              }

              if (isFormatSoft) {

                if (!variantText.includes('soft')) return false;

              }

              if (isFormatComfort) {

                if (!variantText.includes('comfort')) return false;

              }

              if (isFormatStrutturato) {

                if (!variantText.includes('strutturato') && !variantText.includes('strutturata')) return false;

              }

              if (isFormatBocciardato) {

                if (!variantText.includes('bocciardato') && !variantText.includes('lithos')) return false;

              }

              if (isFormatSquadrato) {

                if (!variantText.includes('squadrato') && !variantText.includes('squadrata')) return false;

              } else {

                // Se il formato NON è squadrato, la variante NON deve essere squadrata

                if (variantText.includes('squadrato') || variantText.includes('squadrata')) return false;

              }

              if (isFormatCannete) {

                if (!variantText.includes('cannete') && !variantText.includes('canneté') && !variantText.includes('cannetté') && !variantText.includes('cannetè')) return false;

              } else {

                // Se il formato NON è canneté, la variante NON deve essere canneté

                if (variantText.includes('cannete') || variantText.includes('canneté') || variantText.includes('cannetté') || variantText.includes('cannetè')) return false;

              }

              // 🔧 FIX: Soft è una finitura DIVERSA da Satinato

              if (isFormatSoft) {

                if (!variantText.includes('soft')) return false;

              } else if (!isFormatSatinatoNaturale) {

                // Se NON è formato soft, escludi varianti soft

                if (variantText.includes('soft')) return false;

              }

              if (isFormatNaturalecuoio) {

                // Naturalecuoio corrisponde a "Naturale Leather" nelle varianti Shopify

                if (!variantText.includes('naturale leather')) return false;

              }

              if (isFormatSatinatoNaturale) {

                // satinatoNaturale corrisponde a "Naturale Silk" nelle varianti Shopify

                if (!variantText.includes('naturale silk')) return false;

              } else if (!isFormatSatinato) {

                // Se il formato NON è satinatoNaturale e NON è satinato, la variante NON deve essere Naturale silk

                if (variantText.includes('naturale silk')) return false;

              }

              if (isFormatRealUp) {

                if (!variantText.includes('realup')) return false;

              } else {

                // Se il formato NON è RealUp, la variante NON deve essere RealUp

                if (variantText.includes('realup')) return false;

              }

              if (isFormatGrip) {

                if (!variantText.includes('grip')) return false;

              } else {

                // Se il formato NON è Grip, la variante NON deve essere Grip

                if (variantText.includes('grip')) return false;

              }

              if (isFormatBattiscopa) {

                if (!variantText.includes('battiscopa')) return false;

              } else {

                // Se il formato NON è Battiscopa, la variante NON deve essere Battiscopa

                if (variantText.includes('battiscopa')) return false;

              }

              if (isFormatFade) {

                if (!variantText.includes('fade')) return false;

              } else {

                // Se il formato NON è Fade, la variante NON deve essere Fade

                if (variantText.includes('fade')) return false;

              }

              if (isFormatLappataSatinata) {

                if (!variantText.includes('lappata satinata') && !variantText.includes('lappata-satinata')) return false;

              } else {

                // Se il formato NON è Lappata-Satinata, la variante NON deve essere Lappata-Satinata

                if (variantText.includes('lappata satinata') || variantText.includes('lappata-satinata')) return false;

              }

            }



            // Deve contenere il colore selezionato

            if (selectedColor && !variantText.includes(selectedColor.toLowerCase())) return false;



            // Deve contenere lo spessore (es: "9mm" deve matchare "9 mm" o "9mm")

            const thicknessLabel = (thickness.value || thickness.label);

            // Estrai solo il numero (es: "9" da "9mm")

            const thicknessNum = thicknessLabel.match(/(\d+(?:[.,]\d+)?)/)?.[0]?.replace('.', '\\.');

            if (thicknessNum) {

              // Pattern che cerca il numero seguito da mm con spazi opzionali

              const thicknessPattern = new RegExp(`${thicknessNum}\\s*mm`, 'i');

              if (!thicknessPattern.test(variantText)) return false;

            } else {

              // Fallback al pattern originale

              const thicknessValue = thicknessLabel.replace(/\s+/g, '\\s*');

              const thicknessPattern = new RegExp(thicknessValue, 'i');

              if (!thicknessPattern.test(variantText)) return false;

            }



            return true;

          });



          if (hasValidVariant) {

            return true;

          } else {

            return false;

          }

        } else if (destination === 'BATTISCOPA') {

          // Verifica se esiste una variante BATTISCOPA con questo spessore

          const hasBattiscopaVariant = this.product.variants.some(variant => {

            const variantText = `${variant.title || ''} ${variant.option1 || ''} ${variant.option2 || ''} ${variant.option3 || ''}`.toLowerCase();



            // Deve contenere BATTISCOPA

            if (!variantText.includes('battiscopa')) return false;



            // Deve contenere il formato selezionato se specificato

            if (selectedFormat) {

              let formatBase = selectedFormat.replace('-battiscopa', '').replace(/-[a-z]+$/gi, '');

              const formatPattern = formatBase.replace(/\./g, '[.,]').replace(/x/gi, '[xX×]');

              if (!new RegExp(formatPattern, 'i').test(variantText)) return false;

            }



            // Deve contenere il colore selezionato se specificato

            if (selectedColor && !variantText.includes(selectedColor.toLowerCase())) return false;



            // Deve contenere lo spessore

            const thicknessLabel = (thickness.value || thickness.label);

            const thicknessNum = thicknessLabel.match(/(\d+(?:[.,]\d+)?)/)?.[0]?.replace('.', '\\.');

            if (thicknessNum) {

              const thicknessPattern = new RegExp(`${thicknessNum}\\s*mm`, 'i');

              if (!thicknessPattern.test(variantText)) return false;

            }



            return true;

          });



          return hasBattiscopaVariant;

        } else if (destination === 'ESTERNO') {

          // 🆕 Per ESTERNO: accetta spessori 20mm senza rating

          const thicknessLabel = (thickness.value || thickness.label || '').toLowerCase();

          const is20mm = /\b20\s*mm\b/.test(thicknessLabel) || /\b2\s*cm\b/.test(thicknessLabel);

          if (is20mm) {

            // Verifica se esiste una variante 20mm per questo formato e colore

            const has20mmVariant = this.product.variants.some(variant => {

              const variantText = `${variant.title || ''} ${variant.option1 || ''} ${variant.option2 || ''} ${variant.option3 || ''}`.toLowerCase();



              // Deve essere 20mm

              if (!/\b20\s*mm\b/.test(variantText) && !/\b2\s*cm\b/.test(variantText)) return false;



              // Deve contenere il formato selezionato se specificato

              if (selectedFormat) {

                let formatBase = selectedFormat.replace(/-[a-z]+$/gi, '');

                const formatPattern = formatBase.replace(/\./g, '[.,]').replace(/x/gi, '[xX×]');

                if (!new RegExp(formatPattern, 'i').test(variantText)) return false;

              }



              // Deve contenere il colore selezionato se specificato

              if (selectedColor && !variantText.includes(selectedColor.toLowerCase())) return false;



              return true;

            });

            return has20mmVariant;

          }

          // Grip e Antislip senza rating R11/R12/R13 non vanno in ESTERNO (tranne 20mm)

          return false;

        } else {

          // Altri casi senza rating

          return false;

        }

      }



      const rating = thickness.rating.toUpperCase();

      let shouldInclude = false;



      if (destination === 'INTERNO') {

        // Per INTERNO: solo R9 o R10 (incluso 20mm R9/R10) E verifica che esista per il formato+colore selezionato
        var _thkVal = (thickness.value || thickness.label || '').toLowerCase();
        var _thkNum = parseFloat((((_thkVal.match(/(\d+(?:[.,]\d+)?)\s*mm/)||[])[1])||'0').replace(',', '.'));
        var _noRating = !rating || rating === '-';
        const hasCorrectRating = rating === 'R9' || rating === 'R10' || (_noRating && _thkNum > 0 && _thkNum <= 12); /* REGOLA 25-06: senza rating + <=12mm = INTERNO */



        if (hasCorrectRating && selectedFormat && selectedColor) {

          // Verifica che esista una variante con formato + colore + spessore

          const hasMatchingVariant = this.product.variants.some(variant => {

            // Non filtriamo per available



            const variantText = `${variant.title || ''} ${variant.option1 || ''} ${variant.option2 || ''} ${variant.option3 || ''}`.toLowerCase();



            // Escludi varianti Lithos/Bocciardato con R10 da INTERNO (SOLO PER SENSI)

            if (this.isSensiProduct()) {

              const isLithos = /lithos|bocciardato/i.test(variantText);

              const hasR10 = /\br10\b/i.test(variantText);

              if (isLithos && hasR10) return false;

            }



            // Deve contenere il formato selezionato (supporta punto/virgola decimale)

            let formatBase = selectedFormat.replace('-lucido', '').replace('-stripe', '').replace('-riga', '').replace('-pliss', '').replace('-twist', '').replace('-strutturasign', '').replace('-strutturanet', '').replace('-strutturamove', '').replace('-comfort', '').replace('-strutturato20mm', '').replace('-strutturato', '').replace('-satinatoNaturale', '').replace('-satinato', '').replace('-velvet', '').replace('-bocciardato', '').replace('-ptv', '').replace('-liscio', '').replace('-levigato', '').replace('-levigata', '').replace('-patinato', '').replace('-patinata', '').replace('-Naturale', '').replace('-naturale', '').replace('-squadrato', '').replace('-squadrata', '').replace('-cannete', '').replace('-soft', '').replace('-matte', '').replace('-Naturalecuoio', '').replace('-realupstrideup', '').replace('-RealUpStrideUp', '').replace('-realup', '').replace('-RealUp', '').replace('-strideup', '').replace('-StrideUp', '').replace('-grip', '').replace('-Grip', '').replace('-antislip', '').replace('-Antislip', '').replace('-lappata', '').replace('-lappato', '').replace('-battiscopa', '').replace('-fade', '').replace('-Fade', '').replace('-lux', '').replace('-20mm', '');

            const formatPattern = formatBase.replace(/\./g, '[.,]').replace(/x/gi, '[xX×]');

            if (!new RegExp(formatPattern, 'i').test(variantText)) return false;



            // Verifica che la finitura corrisponda al formato selezionato

            const isFormatLux = selectedFormat.includes('-lux');

            const isFormatLucido = selectedFormat.includes('-lucido');

            const isFormatNaturale = selectedFormat.includes('-naturale');

            const isFormatSatinatoNaturale = selectedFormat.includes('-satinatoNaturale');

            const isFormatSatinato = selectedFormat.includes('-satinato') && !isFormatSatinatoNaturale;

            const isFormatComfort = selectedFormat.includes('-comfort');

            const isFormatStrutturato = selectedFormat.includes('-strutturato');

            const isFormatBocciardato = selectedFormat.includes('-bocciardato');

            const isFormatSquadrato = selectedFormat.includes('-squadrato') || selectedFormat.includes('-squadrata');

            const isFormatCannete = selectedFormat.includes('-cannete');

            const isFormatSoft = selectedFormat.includes('-soft');

            const isFormatNaturalecuoio = selectedFormat.includes('-naturalecuoio');

            const isFormatRealUp = selectedFormat.includes('-realup') || selectedFormat.includes('-RealUp');

            const isFormatGrip = selectedFormat.includes('-grip') || selectedFormat.includes('-Grip');

            const isFormatLappata = (selectedFormat.includes('-lappata') || selectedFormat.includes('-lappato')) && !selectedFormat.includes('-lappatasatinata');

            const isFormatBattiscopa = selectedFormat.includes('-battiscopa');

            const isFormatFade = selectedFormat.includes('-fade');

            const isFormatLappataSatinata = selectedFormat.includes('-lappatasatinata');



            // 🆕 FIX: LUX è una finitura (Lucida per PURITY of MARBLE)

            if (isFormatLux) {

              if (!variantText.includes('lux')) return false;

            } else {

              // Se il formato NON è LUX, la variante NON deve essere LUX

              if (/\blux\b/i.test(variantText)) return false;

            }

            if (isFormatLucido) {

              if (!variantText.includes('lucido') && !variantText.includes('lucida')) return false;

            }

            if (isFormatNaturale) {

              if (!variantText.includes('naturale')) return false;

            }

            // 🔧 FIX: Soft e Satinata sono finiture DIVERSE

            if (isFormatSatinato) {

              const hasSilkNotNaturale = variantText.includes('silk') && !variantText.includes('naturale silk');

              if (!variantText.includes('satinato') && !variantText.includes('satinata') && !hasSilkNotNaturale) return false;

            }

            if (isFormatSoft) {

              if (!variantText.includes('soft')) return false;

            }

            if (isFormatComfort) {

              if (!variantText.includes('comfort')) return false;

            }

            if (isFormatStrutturato) {

              if (!variantText.includes('strutturato') && !variantText.includes('strutturata')) return false;

            }

            if (isFormatBocciardato) {

              if (!variantText.includes('bocciardato') && !variantText.includes('lithos')) return false;

            }

            if (isFormatSquadrato) {

              if (!variantText.includes('squadrato') && !variantText.includes('squadrata')) return false;

            } else {

              // Se il formato NON è squadrato, la variante NON deve essere squadrata

              if (variantText.includes('squadrato') || variantText.includes('squadrata')) return false;

            }

            if (isFormatCannete) {

              if (!variantText.includes('cannete') && !variantText.includes('canneté') && !variantText.includes('cannetté') && !variantText.includes('cannetè')) return false;

            } else {

              // Se il formato NON è canneté, la variante NON deve essere canneté

              if (variantText.includes('cannete') || variantText.includes('canneté') || variantText.includes('cannetté') || variantText.includes('cannetè')) return false;

            }

            // 🔧 FIX: Soft è una finitura DIVERSA da Satinato

            if (isFormatSoft) {

              if (!variantText.includes('soft')) return false;

            } else if (!isFormatSatinatoNaturale) {

              // Se NON è formato soft, escludi varianti soft

              if (variantText.includes('soft')) return false;

            }

            if (isFormatNaturalecuoio) {

              // Naturalecuoio corrisponde a "Naturale Leather" nelle varianti Shopify

              if (!variantText.includes('naturale leather')) return false;

            }

            if (isFormatSatinatoNaturale) {

              // satinatoNaturale corrisponde a "Naturale Silk" nelle varianti Shopify

              if (!variantText.includes('naturale silk')) return false;

            } else if (!isFormatSatinato) {

              // Se il formato NON è satinatoNaturale e NON è satinato, la variante NON deve essere Naturale silk

              if (variantText.includes('naturale silk')) return false;

            }

            if (isFormatRealUp) {

              if (!variantText.includes('realup')) return false;

            } else {

              if (variantText.includes('realup')) return false;

            }

            if (isFormatGrip) {

              if (!variantText.includes('grip')) return false;

            } else {

              if (variantText.includes('grip')) return false;

            }

            if (isFormatLappata) {

              if ((!variantText.includes('lappata') && !variantText.includes('lappato')) || variantText.includes('lappata satinata') || variantText.includes('lappata-satinata')) return false;

            } else if (!isFormatLappataSatinata) {

              if ((variantText.includes('lappata') || variantText.includes('lappato')) && !variantText.includes('lappata satinata') && !variantText.includes('lappata-satinata')) return false;

            }

            if (isFormatBattiscopa) {

              if (!variantText.includes('battiscopa')) return false;

            } else {

              if (variantText.includes('battiscopa')) return false;

            }

            if (isFormatFade) {

              if (!variantText.includes('fade')) return false;

            } else {

              if (variantText.includes('fade')) return false;

            }

            if (isFormatLappataSatinata) {

              if (!variantText.includes('lappata satinata') && !variantText.includes('lappata-satinata')) return false;

            } else {

              if (variantText.includes('lappata satinata') || variantText.includes('lappata-satinata')) return false;

            }



            // Deve contenere il colore selezionato

            if (!variantText.includes(selectedColor.toLowerCase())) return false;



            // Deve contenere lo spessore specifico (es: "9mm" o "9 mm" o "9.5mm")

            const thicknessLabel = (thickness.value || thickness.label);

            // Estrai solo numero e unità, rendi spazi opzionali (es: "9mm" → "9\s*mm", "9.5mm" → "9\.5\s*mm")

            const thicknessNum = thicknessLabel.match(/(\d+(?:[.,]\d+)?)/)?.[0]?.replace('.', '\\.');

            if (thicknessNum) {

              const thicknessPattern = new RegExp(`${thicknessNum}\\s*mm`, 'i');

              if (!thicknessPattern.test(variantText)) return false;

            } else {

              // Fallback al pattern originale se non trova numero

              const thicknessValue = thicknessLabel.replace(/\s+/g, '\\s*');

              const thicknessPattern = new RegExp(thicknessValue, 'i');

              if (!thicknessPattern.test(variantText)) return false;

            }



            // IMPORTANTE: verifica che il rating dello spessore corrisponda alla variante

            // (es: se cerchiamo 9mm R9, la variante deve avere R9, non R10)

            if (rating) {

              const ratingPattern = new RegExp(`\\b${rating}\\b`, 'i');

              if (!ratingPattern.test(variantText)) return false;

            }



            return true;

          });



          shouldInclude = hasMatchingVariant;

        } else {

          shouldInclude = hasCorrectRating;

        }

      } else if (destination === 'ESTERNO') {

        // Per ESTERNO: R11, R12, R13 OPPURE 20mm senza rating (NO 20mm R9/R10 - vanno in INTERNO)

        const thicknessLabel = (thickness.value || thickness.label || '').toLowerCase();

        const is20mm = /\b20\s*mm\b/.test(thicknessLabel) || /\b2\s*cm\b/.test(thicknessLabel);



        // 🆕 FIX: Se il formato selezionato contiene "-20mm", mostra SOLO spessori 20mm

        const isFormat20mm = selectedFormat && selectedFormat.includes('-20mm');

        if (isFormat20mm && !is20mm) {

          return false;  // Escludi spessori non-20mm quando il formato è 20mm

        }



        // 🆕 FIX: Se il formato selezionato NON contiene "-20mm", escludi spessori 20mm
        // 🔧 FIX: Per grip/antislip, non escludere 20mm (possono avere sia 9mm che 20mm)
        const isGripAntislipFmt = selectedFormat && (selectedFormat.includes('-grip') || selectedFormat.includes('-Grip') || selectedFormat.includes('-antislip') || selectedFormat.includes('-Antislip'));

        if (selectedFormat && !isFormat20mm && is20mm && !isGripAntislipFmt) {

          return false;  // Escludi spessori 20mm quando il formato NON è 20mm

        }



        // 🆕 FIX: 20mm R9/R10 NON devono andare in ESTERNO - solo 20mm con R11+ o senza rating

        const is20mmForEsterno = is20mm && rating !== 'R9' && rating !== 'R10';

        const hasCorrectRating = rating === 'R11' || rating === 'R12' || rating === 'R13' || is20mmForEsterno;



        if (hasCorrectRating && selectedFormat && selectedColor) {

          // Verifica che esista una variante con formato + colore + spessore

          const hasMatchingVariant = this.product.variants.some(variant => {

            // Non filtriamo per available



            const variantText = `${variant.title || ''} ${variant.option1 || ''} ${variant.option2 || ''} ${variant.option3 || ''}`.toLowerCase();



            // Deve contenere il formato selezionato (supporta punto/virgola decimale)

            let formatBase = selectedFormat.replace('-lucido', '').replace('-stripe', '').replace('-riga', '').replace('-pliss', '').replace('-twist', '').replace('-strutturasign', '').replace('-strutturanet', '').replace('-strutturamove', '').replace('-comfort', '').replace('-strutturato20mm', '').replace('-strutturato', '').replace('-satinatoNaturale', '').replace('-satinato', '').replace('-velvet', '').replace('-bocciardato', '').replace('-grip', '').replace('-antislip', '').replace('-ptv', '').replace('-liscio', '').replace('-levigato', '').replace('-levigata', '').replace('-patinato', '').replace('-patinata', '').replace('-Naturale', '').replace('-naturale', '').replace('-squadrato', '').replace('-squadrata', '').replace('-cannete', '').replace('-soft', '').replace('-matte', '').replace('-Naturalecuoio', '').replace('-realupstrideup', '').replace('-RealUpStrideUp', '').replace('-realup', '').replace('-RealUp', '').replace('-strideup', '').replace('-StrideUp', '').replace('-lappata', '').replace('-lappato', '').replace('-parete', '').replace('-battiscopa', '').replace('-fade', '').replace('-Fade', '').replace('-20mm', '');

            const formatPattern = formatBase.replace(/\./g, '[.,]').replace(/x/gi, '[xX×]');

            if (!new RegExp(formatPattern, 'i').test(variantText)) return false;



            // Per 20mm, verifica che la variante contenga 20mm

            if (is20mm) {

              if (!/\b20\s*mm\b/.test(variantText) && !/\bt_?20\b/i.test(variantText)) return false;

            }



            // Verifica che la finitura corrisponda al formato selezionato

            const isFormatLucido = selectedFormat.includes('-lucido');

            const isFormatNaturale = selectedFormat.includes('-naturale');

            const isFormatSatinatoNaturale = selectedFormat.includes('-satinatoNaturale');

            const isFormatSatinato = selectedFormat.includes('-satinato') && !isFormatSatinatoNaturale;

            const isFormatComfort = selectedFormat.includes('-comfort');

            const isFormatStrutturato = selectedFormat.includes('-strutturato');

            const isFormatBocciardato = selectedFormat.includes('-bocciardato');

            const isFormatSquadrato = selectedFormat.includes('-squadrato') || selectedFormat.includes('-squadrata');

            const isFormatCannete = selectedFormat.includes('-cannete');

            const isFormatSoft = selectedFormat.includes('-soft');

            const isFormatNaturalecuoio = selectedFormat.includes('-naturalecuoio');

            const isFormatRealUp = selectedFormat.includes('-realup');

            const isFormatGrip = selectedFormat.includes('-grip');

            const isFormatLappata = (selectedFormat.includes('-lappata') || selectedFormat.includes('-lappato')) && !selectedFormat.includes('-lappatasatinata');

            const isFormatBattiscopa = selectedFormat.includes('-battiscopa');

            const isFormatFade = selectedFormat.includes('-fade');

            const isFormatLappataSatinata = selectedFormat.includes('-lappatasatinata');



            if (isFormatLucido) {

              if (!variantText.includes('lucido') && !variantText.includes('lucida')) return false;

            }

            if (isFormatNaturale) {

              if (!variantText.includes('naturale')) return false;

            }

            // 🔧 FIX: Soft e Satinata sono finiture DIVERSE

            if (isFormatSatinato) {

              const hasSilkNotNaturale = variantText.includes('silk') && !variantText.includes('naturale silk');

              if (!variantText.includes('satinato') && !variantText.includes('satinata') && !hasSilkNotNaturale) return false;

            }

            if (isFormatSoft) {

              if (!variantText.includes('soft')) return false;

            }

            if (isFormatComfort) {

              if (!variantText.includes('comfort')) return false;

            }

            if (isFormatStrutturato) {

              if (!variantText.includes('strutturato') && !variantText.includes('strutturata')) return false;

            }

            if (isFormatBocciardato) {

              if (!variantText.includes('bocciardato') && !variantText.includes('lithos')) return false;

            }

            if (isFormatSquadrato) {

              if (!variantText.includes('squadrato') && !variantText.includes('squadrata')) return false;

            } else {

              // Se il formato NON è squadrato, la variante NON deve essere squadrata

              if (variantText.includes('squadrato') || variantText.includes('squadrata')) return false;

            }

            if (isFormatCannete) {

              if (!variantText.includes('cannete') && !variantText.includes('canneté') && !variantText.includes('cannetté') && !variantText.includes('cannetè')) return false;

            } else {

              // Se il formato NON è canneté, la variante NON deve essere canneté

              if (variantText.includes('cannete') || variantText.includes('canneté') || variantText.includes('cannetté') || variantText.includes('cannetè')) return false;

            }

            // 🔧 FIX: Soft è una finitura DIVERSA da Satinato

            if (isFormatSoft) {

              if (!variantText.includes('soft')) return false;

            } else if (!isFormatSatinatoNaturale) {

              // Se NON è formato soft, escludi varianti soft

              if (variantText.includes('soft')) return false;

            }

            if (isFormatNaturalecuoio) {

              // Naturalecuoio corrisponde a "Naturale Leather" nelle varianti Shopify

              if (!variantText.includes('naturale leather')) return false;

            }

            if (isFormatSatinatoNaturale) {

              // satinatoNaturale corrisponde a "Naturale Silk" nelle varianti Shopify

              if (!variantText.includes('naturale silk')) return false;

            } else if (!isFormatSatinato) {

              // Se il formato NON è satinatoNaturale e NON è satinato, la variante NON deve essere Naturale silk

              if (variantText.includes('naturale silk')) return false;

            }

            if (isFormatRealUp) {

              if (!variantText.includes('realup')) return false;

            } else {

              if (variantText.includes('realup')) return false;

            }

            if (isFormatGrip) {

              if (!variantText.includes('grip')) return false;

            } else {

              if (variantText.includes('grip')) return false;

            }

            if (isFormatLappata) {

              if ((!variantText.includes('lappata') && !variantText.includes('lappato')) || variantText.includes('lappata satinata') || variantText.includes('lappata-satinata')) return false;

            } else if (!isFormatLappataSatinata) {

              if ((variantText.includes('lappata') || variantText.includes('lappato')) && !variantText.includes('lappata satinata') && !variantText.includes('lappata-satinata')) return false;

            }

            if (isFormatBattiscopa) {

              if (!variantText.includes('battiscopa')) return false;

            } else {

              if (variantText.includes('battiscopa')) return false;

            }

            if (isFormatFade) {

              if (!variantText.includes('fade')) return false;

            } else {

              if (variantText.includes('fade')) return false;

            }

            if (isFormatLappataSatinata) {

              if (!variantText.includes('lappata satinata') && !variantText.includes('lappata-satinata')) return false;

            } else {

              if (variantText.includes('lappata satinata') || variantText.includes('lappata-satinata')) return false;

            }



            // Deve contenere il colore selezionato

            if (!variantText.includes(selectedColor.toLowerCase())) return false;



            // Deve contenere lo spessore specifico (es: "9mm" o "9 mm" o "9.5mm")

            const thicknessLabel = (thickness.value || thickness.label);

            // Estrai solo numero e unità, rendi spazi opzionali (es: "9mm" → "9\s*mm", "9.5mm" → "9\.5\s*mm")

            const thicknessNum = thicknessLabel.match(/(\d+(?:[.,]\d+)?)/)?.[0]?.replace('.', '\\.');

            if (thicknessNum) {

              const thicknessPattern = new RegExp(`${thicknessNum}\\s*mm`, 'i');

              if (!thicknessPattern.test(variantText)) return false;

            } else {

              // Fallback al pattern originale se non trova numero

              const thicknessValue = thicknessLabel.replace(/\s+/g, '\\s*');

              const thicknessPattern = new RegExp(thicknessValue, 'i');

              if (!thicknessPattern.test(variantText)) return false;

            }



            // IMPORTANTE: verifica che il rating dello spessore corrisponda alla variante

            if (rating) {

              const ratingPattern = new RegExp(`\\b${rating}\\b`, 'i');

              if (!ratingPattern.test(variantText)) return false;

            }



            return true;

          });



          shouldInclude = hasMatchingVariant;

        } else {

          shouldInclude = hasCorrectRating;

        }

      } else if (destination === 'INTERNO_SOLO_PARETE') {

        // SPECIAL RULE PER SENSI: escludi spessori R11 (SAND) da INTERNO_SOLO_PARETE

        if (this.isSensiProduct() && rating === 'R11') {

          shouldInclude = false;

        } else if (rating === 'R9' || rating === 'R10' || rating === 'R11') {

          // Verifica che esista una variante con formato, colore, NOME SPESSORE E la parola PARETE

          const hasMatchingVariant = this.product.variants.some(variant => {

            // Non filtriamo per available



            const variantText = `${variant.title || ''} ${variant.option1 || ''} ${variant.option2 || ''} ${variant.option3 || ''}`.toLowerCase();



            // Deve contenere PARETE (nel formato)

            if (!variantText.includes('parete')) return false;



            // Deve contenere il formato selezionato (es. 30x90, 26.5x180 - supporta punto/virgola)

            if (selectedFormat) {

              let formatBase = selectedFormat;

              formatBase = formatBase.replace('-parete', '').replace('-lux', '').replace('-fluid', '').replace('-lucido', '').replace('-stripe', '').replace('-riga', '').replace('-pliss', '').replace('-twist', '').replace('-strutturasign', '').replace('-strutturanet', '').replace('-strutturamove', '').replace('-comfort', '').replace('-strutturato20mm', '').replace('-strutturato', '').replace('-satinato', '').replace('-velvet', '').replace('-bocciardato', '').replace('-ptv', '').replace('-liscio', '').replace('-levigato', '').replace('-levigata', '').replace('-patinato', '').replace('-patinata', '').replace('-lappata', '').replace('-lappato', '').replace('-Naturale', '').replace('-naturale', '').replace('-squadrato', '').replace('-squadrata', '').replace('-cannete', '').replace('-soft', '').replace('-matte', '').replace('-Naturalecuoio', '').replace('-fade', '').replace('-Fade', '').replace('-20mm', '');

              const formatPattern = formatBase.replace(/\./g, '[.,]').replace(/x/gi, '[xX×]');

              if (!new RegExp(formatPattern, 'i').test(variantText)) return false;



              // Verifica LUX se presente nel formato selezionato

              const isFormatLux = selectedFormat.includes('-lux');

              if (isFormatLux && !variantText.includes('lux')) return false;

              if (!isFormatLux && variantText.includes('lux')) return false;



              // Verifica FLUID se presente nel formato selezionato

              const isFormatFluid = selectedFormat.includes('-fluid');

              if (isFormatFluid && !variantText.includes('fluid')) return false;

              if (!isFormatFluid && variantText.includes('fluid')) return false;



              // Verifica BOCCIARDATO/LITHOS se presente nel formato selezionato (SOLO PER SENSI)

              if (this.isSensiProduct()) {

                const isFormatBocciardato = selectedFormat.includes('-bocciardato');

                if (isFormatBocciardato && !(variantText.includes('bocciardato') || variantText.includes('lithos'))) return false;

                if (!isFormatBocciardato && (variantText.includes('bocciardato') || variantText.includes('lithos'))) return false;

              }



              // Verifica che la finitura corrisponda al formato selezionato

              const isFormatLucido = selectedFormat.includes('-lucido');

              const isFormatNaturale = selectedFormat.includes('-naturale');

              const isFormatSatinatoNaturale = selectedFormat.includes('-satinatoNaturale');

              const isFormatSatinato = selectedFormat.includes('-satinato') && !isFormatSatinatoNaturale;

              const isFormatComfort = selectedFormat.includes('-comfort');

              const isFormatStrutturato = selectedFormat.includes('-strutturato');

              const isFormatSquadrato = selectedFormat.includes('-squadrato') || selectedFormat.includes('-squadrata');

              const isFormatCannete = selectedFormat.includes('-cannete');

              const isFormatSoft = selectedFormat.includes('-soft');

              const isFormatNaturalecuoio = selectedFormat.includes('-naturalecuoio');

              const isFormatLappata = (selectedFormat.includes('-lappata') || selectedFormat.includes('-lappato')) && !selectedFormat.includes('-lappatasatinata');

              const isFormatBattiscopa = selectedFormat.includes('-battiscopa');

              const isFormatFade = selectedFormat.includes('-fade');

              const isFormatLappataSatinata = selectedFormat.includes('-lappatasatinata');



              if (isFormatLucido) {

                if (!variantText.includes('lucido') && !variantText.includes('lucida')) return false;

              }

              if (isFormatNaturale) {

                if (!variantText.includes('naturale')) return false;

              }

              if (isFormatLappata) {

                if ((!variantText.includes('lappata') && !variantText.includes('lappato')) || variantText.includes('lappata satinata') || variantText.includes('lappata-satinata')) return false;

              }

              // 🔧 FIX: Soft e Satinata sono finiture DIVERSE

              if (isFormatSatinato) {

                const hasSilkNotNaturale = variantText.includes('silk') && !variantText.includes('naturale silk');

                if (!variantText.includes('satinato') && !variantText.includes('satinata') && !hasSilkNotNaturale) return false;

              }

              if (isFormatSoft) {

                if (!variantText.includes('soft')) return false;

              }

              if (isFormatComfort) {

                if (!variantText.includes('comfort')) return false;

              }

              if (isFormatStrutturato) {

                if (!variantText.includes('strutturato') && !variantText.includes('strutturata')) return false;

              }

              if (isFormatSquadrato) {

                if (!variantText.includes('squadrato') && !variantText.includes('squadrata')) return false;

              } else {

                // Se il formato NON è squadrato, la variante NON deve essere squadrata

                if (variantText.includes('squadrato') || variantText.includes('squadrata')) return false;

              }

              if (isFormatCannete) {

                if (!variantText.includes('cannete') && !variantText.includes('canneté') && !variantText.includes('cannetté') && !variantText.includes('cannetè')) return false;

              } else {

                // Se il formato NON è canneté, la variante NON deve essere canneté

                if (variantText.includes('cannete') || variantText.includes('canneté') || variantText.includes('cannetté') || variantText.includes('cannetè')) return false;

              }

              // 🔧 FIX: Soft è una finitura DIVERSA da Satinato

              if (isFormatSoft) {

                if (!variantText.includes('soft')) return false;

              } else if (!isFormatSatinatoNaturale) {

                // Se NON è formato soft, escludi varianti soft

                if (variantText.includes('soft')) return false;

              }

              if (isFormatNaturalecuoio) {

                // Naturalecuoio corrisponde a "Naturale Leather" nelle varianti Shopify

                if (!variantText.includes('naturale leather')) return false;

              }

              if (isFormatBattiscopa) {

                if (!variantText.includes('battiscopa')) return false;

              } else {

                if (variantText.includes('battiscopa')) return false;

              }

              if (isFormatFade) {

                if (!variantText.includes('fade')) return false;

              } else {

                if (variantText.includes('fade')) return false;

              }

              if (isFormatLappataSatinata) {

                if (!variantText.includes('lappata satinata') && !variantText.includes('lappata-satinata')) return false;

              } else {

                if (variantText.includes('lappata satinata') || variantText.includes('lappata-satinata')) return false;

              }

            }



            // Deve contenere il colore selezionato (es. BIANCO)

            if (selectedColor && !variantText.includes(selectedColor.toLowerCase())) return false;



            // Deve contenere lo spessore specifico (es: "9mm" o "9 mm" o "9.5mm")

            const thicknessLabel = (thickness.value || thickness.label);

            // Estrai solo numero e unità, rendi spazi opzionali (es: "9mm" → "9\s*mm", "9.5mm" → "9\.5\s*mm")

            const thicknessNum = thicknessLabel.match(/(\d+(?:[.,]\d+)?)/)?.[0]?.replace('.', '\\.');

            if (thicknessNum) {

              const thicknessPattern = new RegExp(`${thicknessNum}\\s*mm`, 'i');

              if (!thicknessPattern.test(variantText)) return false;

            } else {

              // Fallback al pattern originale se non trova numero

              const thicknessValue = thicknessLabel.replace(/\s+/g, '\\s*');

              const thicknessPattern = new RegExp(thicknessValue, 'i');

              if (!thicknessPattern.test(variantText)) return false;

            }



            // IMPORTANTE: verifica che il rating dello spessore corrisponda alla variante

            if (rating) {

              const ratingPattern = new RegExp(`\\b${rating}\\b`, 'i');

              if (!ratingPattern.test(variantText)) return false;

            }



            return true;

          });



          shouldInclude = hasMatchingVariant;

        } else {

        }

      } else if (destination === 'BATTISCOPA') {

        // Per BATTISCOPA: verifica che esista una variante BATTISCOPA con questo spessore

        const hasBattiscopaVariant = this.product.variants.some(variant => {

          const variantText = `${variant.title || ''} ${variant.option1 || ''} ${variant.option2 || ''} ${variant.option3 || ''}`.toLowerCase();



          // Deve contenere BATTISCOPA

          if (!variantText.includes('battiscopa')) return false;



          // Deve contenere il formato selezionato se specificato

          if (selectedFormat) {

            let formatBase = selectedFormat.replace('-battiscopa', '').replace(/-[a-z]+$/gi, '');

            const formatPattern = formatBase.replace(/\./g, '[.,]').replace(/x/gi, '[xX×]');

            if (!new RegExp(formatPattern, 'i').test(variantText)) return false;

          }



          // Deve contenere il colore selezionato se specificato

          if (selectedColor && !variantText.includes(selectedColor.toLowerCase())) return false;



          // Deve contenere lo spessore

          const thicknessLabel = (thickness.value || thickness.label);

          const thicknessNum = thicknessLabel.match(/(\d+(?:[.,]\d+)?)/)?.[0]?.replace('.', '\\.');

          if (thicknessNum) {

            const thicknessPattern = new RegExp(`${thicknessNum}\\s*mm`, 'i');

            if (!thicknessPattern.test(variantText)) return false;

          }



          return true;

        });



        shouldInclude = hasBattiscopaVariant;

      }



      return shouldInclude;

    });

    // Aggiorna temporaneamente gli spessori disponibili

    this.filteredThicknessOptions = filteredThickness;

    

    // Aggiorna lo step degli spessori

    this.populateThickness();



    // Aggiorna anche il titolo dello step 4

    this.updateStep4Title();

  },

  

  observeStepChanges() {

    const observer = new MutationObserver((mutations) => {

      mutations.forEach((mutation) => {

        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {

          const target = mutation.target;

          

          // Verifica se lo step è stato popolato almeno una volta

          // Se è già popolato, non ripopolare (per mantenere gli event listener)

          if (target.id === 'fxStep1' && target.classList.contains('active')) {

            const container = target.querySelector('.fx-style-grid');

            // Popola solo se è vuoto

            if (container && container.children.length === 0) {

              this.populateDestinations();

            }

          }

          else if (target.id === 'fxStep2' && target.classList.contains('active')) {

            const container = target.querySelector('.fx-style-grid');

            // Popola solo se è vuoto

            if (container && container.children.length === 0) {

              // Verifica se c'è una destinazione selezionata prima di popolare

              const destination = window.productConfigurator?.configuration?.destination || this.selectedDestination;

              if (destination) {

                this.filterFormatsByDestination(destination);

              }

              this.populateFormats();

            }

          }

          else if (target.id === 'fxStep3' && target.classList.contains('active')) {

            // Finitura viene popolata dal liquid tramite populateFiniture()

          }

          else if (target.id === 'fxStep4' && target.classList.contains('active')) {

            const container = target.querySelector('#fxVariantsContainer');

            // 🎯 SEMPRE ripopola per mostrare solo i colori filtrati per formato+finitura

            if (container) {

              container.innerHTML = ''; // Pulisci prima

              this.populateColors();

            }

          }

          else if (target.id === 'fxStep5' && target.classList.contains('active')) {

            const container = target.querySelector('#fxFinishContainer');

            // Popola solo se è vuoto

            if (container && container.children.length === 0) {

              this.populateThickness();

            }

            // Aggiorna sempre il titolo quando lo step 5 diventa attivo

            this.updateStep4Title();

          }

          else if (target.id === 'fxStep6' && target.classList.contains('active')) {

            const container = target.querySelector('#fxQuantityContainer');

            // Ripopola sempre per aggiornare con i nuovi dati selezionati

            if (container) {

              this.populateQuantitySelector();

            }



          }

          else if (target.id === 'fxStep7' && target.classList.contains('active')) {

            this.populateRecap();

          }

        }

      });

    });

    

    // Osserva tutti gli step

    const steps = document.querySelectorAll('.fx-section');

    steps.forEach(step => {

      observer.observe(step, { attributes: true });

    });

  },



  // Popola il recap finale (Step 6)

  populateRecap() {

    const config = window.productConfigurator?.configuration;

    if (!config) {

      return;

    }

    // Aggiorna destinazione

    const destinationEl = document.getElementById('fxRecapDestination');

    if (destinationEl && config.destination) {

      const destinationNames = {

        'INTERNO': 'Interno',

        'ESTERNO': 'Esterno',

        'INTERNO_SOLO_PARETE': 'Interno solo parete',

        'BATTISCOPA': 'Battiscopa'

      };

      destinationEl.textContent = destinationNames[config.destination] || config.destination;

    }



    // Aggiorna formato e finitura separatamente

    const formatEl = document.getElementById('fxRecapFormat');

    const finituraEl = document.getElementById('fxRecapFinitura');

    if (formatEl && config.format) {

      // Trova il label formattato dal formatOptions

      const formatDetails = this.formatOptions.find(f => f.value === config.format);

      let formatLabel = formatDetails?.label || config.format;

      formatLabel = this.convertFinituraToFemminile(formatLabel);



      let formatoSenzaFinitura = formatLabel;



      // 🔧 Usa config.finituraLabel (salvato dallo step 3 Finitura) - DINAMICO, non serve lista!

      const finituraLabel = config.finituraLabel || '';



      // Se abbiamo la finitura, rimuovila dal formato per non mostrarla duplicata

      if (finituraLabel) {

        // Escape caratteri speciali regex (es. + in RealUp+StrideUp)

        const finituraEscaped = finituraLabel.replace(/[+*?^${}()|[\]\\]/g, '\\$&');

        const replaceRegex = new RegExp(`\\s+${finituraEscaped}\\b`, 'gi');

        formatoSenzaFinitura = formatLabel.replace(replaceRegex, '').trim();

      }



      // Rimuovi "Battiscopa" dal formato (è già mostrato in Destinazione)

      formatoSenzaFinitura = formatoSenzaFinitura.replace(/\s*Battiscopa\b/gi, '').trim();

      // Mostra formato senza finitura

      formatEl.textContent = formatoSenzaFinitura;



      // Mostra finitura nel campo dedicato

      if (finituraEl) {

        finituraEl.textContent = finituraLabel || 'Naturale';

      }

    }



    // Aggiorna colore e anteprima tile

    const colorEl = document.getElementById('fxRecapColor');

    if (colorEl && config.color) {

      const colorDetails = this.colorOptions.find(c => c.value === config.color);

      // Rimuovi "PARETE" e "PAVIMENTO" dal label visualizzato

      const colorLabel = (colorDetails?.label || config.color).replace(/ PARETE$/i, '').replace(/ PAVIMENTO$/i, '').trim();

      // Mostra solo il testo del colore (la tile va nel preview dedicato)

      colorEl.style.cssText = '';

      colorEl.textContent = colorLabel;

      // Inserisci la tile SVG grande nel preview dedicato

      const tilePreview = document.getElementById('fxRecapTilePreview');

      if (tilePreview && (colorDetails?.image || colorDetails?.code)) {

        const formatValue = config.format || '60x60';

        const tileSVG = this.generateTileSVG(formatValue, colorDetails.code || '#D9D2C5', colorDetails.image || null);

        // Scala la tile per riempire il preview (sempre centrata)

        tilePreview.innerHTML = `<div style="transform: scale(1.4); transform-origin: center; display: flex; align-items: center; justify-content: center;">${tileSVG}</div>`;

      }

    }



    // Aggiorna spessore (rimuovi -parete dalla visualizzazione)

    const thicknessEl = document.getElementById('fxRecapThickness');

    if (thicknessEl && config.thickness) {

      // Rimuovi "-parete" dallo spessore per mostrare solo es. "6mm"

      const thicknessDisplay = config.thickness.replace(/-parete/gi, '').trim();

      thicknessEl.textContent = thicknessDisplay;

    }



    // Aggiorna quantità - se non esiste l'elemento, lo creiamo

    if (config.quantity) {

      let quantityRow = document.getElementById('fxRecapQuantityRow');



      // Se non esiste la riga della quantità, la creiamo dopo lo spessore

      if (!quantityRow && thicknessEl) {

        const thicknessRow = thicknessEl.closest('.fx-spec-row');

        if (thicknessRow) {

          quantityRow = document.createElement('div');

          quantityRow.className = 'fx-spec-row';

          quantityRow.id = 'fxRecapQuantityRow';

          quantityRow.innerHTML = `

            <div class="fx-spec-left"><span class="fx-spec-label">Quantità</span></div>

            <span class="fx-spec-value" id="fxRecapQuantity">-</span>

          `;

          thicknessRow.insertAdjacentElement('afterend', quantityRow);

        }

      }



      const quantityEl = document.getElementById('fxRecapQuantity');

      if (quantityEl) {

        const mqText = config.totalMq ? ` (${config.totalMq.toFixed(2)} m²)` : '';

        const pezziText = config.totalPezzi ? ` - ${config.totalPezzi} pezzi` : '';

        const kgText = config.totalKg ? ` - ${config.totalKg.toFixed(2).replace('.', ',')} kg` : '';

        quantityEl.textContent = `${config.quantity} ${config.quantity === 1 ? 'scatola' : 'scatole'}${mqText}${pezziText}${kgText}`;

      }

    }



    const priceEl = document.getElementById('fxRecapPrice');

    if (priceEl && config.variantPrice) {

      const baseTotalPrice = config.quantity ? config.variantPrice * config.quantity : config.variantPrice;



      // Sconto bancale: usa BancaleDiscount per percentuali corrette (Florim: 5%/10%, Ceramica Euro: 7%/15%)

      let discountAmount = 0;

      let discountPercentage = 0;

      const boxesPerPallet = config.boxesPerPallet || 40;

      const numeroBancali = Math.floor(config.quantity / boxesPerPallet);



      // Usa BancaleDiscount se disponibile per ottenere la percentuale corretta

      if (window.BancaleDiscount && numeroBancali >= 1) {

        discountPercentage = window.BancaleDiscount.calculateDiscount(numeroBancali);

      }



      if (discountPercentage > 0) {

        // Calcola come Shopify: sconto per unità (floor), poi moltiplica per quantità

        discountAmount = Math.floor(config.variantPrice * discountPercentage / 100) * (config.quantity || 1);

      }



      // Totale finale dopo sconto

      const finalTotalPrice = baseTotalPrice - discountAmount;



      // SALVA il prezzo finale nella configurazione per usarlo quando si aggiunge al carrello

      config.finalTotalPrice = finalTotalPrice;

      config.baseTotalPrice = baseTotalPrice;

      config.discountAmount = discountAmount;



      // Prezzo di confronto

      const comparePrice = config.variantComparePrice;

      // Se comparePrice < variantPrice (prezzo per scatola), allora comparePrice è in €/m²
      // e va moltiplicato per i m² totali, non per le scatole.

      const isPricePerMq = comparePrice && comparePrice < config.variantPrice;

      const totalComparePrice = comparePrice
        ? (isPricePerMq && config.totalMq
            ? Math.round(comparePrice * config.totalMq)
            : (config.quantity ? comparePrice * config.quantity : comparePrice))
        : 0;



      // Crea breakdown prezzi

      let breakdownHTML = '<div class="fx-pricing-breakdown">';



      // Subtotale con compare price barrato (mostra solo se c'è sconto)

      if (discountAmount > 0) {

        breakdownHTML += `

          <div style="display: flex; justify-content: space-between; align-items: center; padding: 0.15rem 0; font-size: 0.9rem; color: #636e72; font-weight: 600;">

            <span>Subtotale</span>

            <div style="display: flex; align-items: center; gap: 0.5rem;">

              <span>${this.formatMoney(baseTotalPrice)}</span>

              ${comparePrice && totalComparePrice > baseTotalPrice ? `

                <span style="text-decoration: line-through; color: #b2bec3; font-size: 0.85rem;">${this.formatMoney(totalComparePrice)}</span>

              ` : ''}

            </div>

          </div>

        `;



        // Sconti applicati

        breakdownHTML += `

          <div style="display: flex; justify-content: space-between; align-items: center; padding: 0.15rem 0; font-size: 0.9rem; color: #E12D2D; font-weight: 600;">

            <span style="display: flex; align-items: center; gap: 4px;">

              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" style="display: inline-block; vertical-align: middle;">

                <path d="M12 2L2 7l10 5 10-5-10-5z" stroke="#E12D2D" stroke-width="1.5" fill="none"/>

                <path d="M2 17l10 5 10-5M2 12l10 5 10-5" stroke="#E12D2D" stroke-width="1.5"/>

              </svg>

              Sconti applicati

            </span>

            <span style="font-weight: 700; font-size: 1rem;">-${this.formatMoney(discountAmount)}</span>

          </div>

        `;



        // Divider

        breakdownHTML += `

          <div style="height: 1px; background: linear-gradient(90deg, transparent 0%, rgba(45, 90, 61, 0.2) 50%, transparent 100%); margin: 0.5rem 0;"></div>

        `;

      }



      // Totale finale (sempre visibile)

      breakdownHTML += `

        <div style="display: flex; justify-content: space-between; align-items: center; padding-top: ${discountAmount > 0 ? '0.5rem' : '0'}; font-weight: 700; font-size: 1.1rem;">

          <span>Totale</span>

          <span style="font-size: 1.5rem;">${this.formatMoney(finalTotalPrice)}</span>

        </div>

        <div style="text-align: right; font-size: 0.75rem; color: #636e72; font-weight: 700; margin-top: 0.15rem; font-family: var(--fx-font, 'Jost', sans-serif);">IVA incl.</div>

      `;



      // Risparmi vs listino

      if (comparePrice) {

        const totalSavings = totalComparePrice - finalTotalPrice;



        if (totalSavings > 0) {

          breakdownHTML += `

            <div style="height: 1px; background: linear-gradient(90deg, transparent 0%, rgba(45, 90, 61, 0.2) 50%, transparent 100%); margin: 0.5rem 0;"></div>

          `;

          breakdownHTML += `

            <div style="display: flex; justify-content: space-between; align-items: center; padding-top: 0.5rem; font-weight: 700; font-size: 1rem; color: var(--fx-primary, #2D5A3D);">

              <span>Risparmi</span>

              <span style="font-size: 1.3rem;">${this.formatMoney(totalSavings)}</span>

            </div>

          `;

        }

      }



      breakdownHTML += '</div>'; // Chiude fx-pricing-breakdown



      // Forza il container padre a occupare tutto lo spazio

      priceEl.style.width = '100%';

      priceEl.style.maxWidth = 'none';

      priceEl.style.display = 'block';



      priceEl.innerHTML = breakdownHTML;



      // Mantieni gli stili CSS del contenitore .fx-recap-pricing (border-left verde, sfondo, ecc.)
      // NON sovrascrivere con transparent/none - il CSS definisce lo stile



      // Aggiungi stile hover per il contenitore bianco

      if (!document.getElementById('fx-pricing-breakdown-style')) {

        const style = document.createElement('style');

        style.id = 'fx-pricing-breakdown-style';

        style.textContent = `

          .fx-pricing-breakdown:hover {

            border-color: var(--fx-primary, #2D5A3D) !important;

            transform: translateY(-2px);

            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;

          }

          /* DISABILITA HOVER SU MOBILE */

          @media (max-width: 768px) {

            .fx-pricing-breakdown:hover {

              border-color: inherit !important;

              transform: none !important;

              box-shadow: none !important;

            }

          }

        `;

        document.head.appendChild(style);

      }

    }



    // Nascondi l'elemento risparmi separato (ora è nel contenitore)

    const savingsEl = document.getElementById('fxRecapSavings');

    if (savingsEl) {

      savingsEl.style.display = 'none';

    }



    // Forza lo stile delle etichette dei prezzi per uniformarle alle altre

    const priceLabelElements = document.querySelectorAll('.fx-recap-pricing .fx-price-label');



    // Prima troviamo una etichetta di riferimento per copiare lo stile esatto

    const referenceLabel = document.querySelector('.fx-spec-label');



    if (referenceLabel) {

      const computedStyle = window.getComputedStyle(referenceLabel);

      priceLabelElements.forEach(label => {

        // Copia lo stile esatto dall'etichetta di riferimento

        label.setAttribute('style',

          `font-size: ${computedStyle.fontSize} !important;` +

          `font-weight: ${computedStyle.fontWeight} !important;` +

          `color: ${computedStyle.color} !important;` +

          `font-family: ${computedStyle.fontFamily} !important;` +

          `line-height: ${computedStyle.lineHeight} !important;` +

          'text-transform: none !important;' +

          'background: transparent !important;' +

          'border: none !important;' +

          'padding: 0 !important;'

        );

      });

    } else {

      // Fallback: usa font-weight 400 che è il più comune

      priceLabelElements.forEach(label => {

        label.setAttribute('style',

          'font-size: 0.875rem !important;' +

          'font-weight: 400 !important;' +

          'color: #636e72 !important;' +

          'text-transform: none !important;' +

          'background: transparent !important;' +

          'border: none !important;' +

          'padding: 0 !important;'

        );

      });

    }



    // Nascondi il compare price separato (ora è integrato nel breakdown)

    const comparePriceEl = document.getElementById('fxRecapComparePrice');

    if (comparePriceEl) {

      comparePriceEl.style.display = 'none';

      // Nascondi anche la label "Prezzo listino" se esiste

      if (comparePriceEl.previousElementSibling && comparePriceEl.previousElementSibling.classList.contains('fx-price-label')) {

        comparePriceEl.previousElementSibling.style.display = 'none';

      }

      // Nascondi il parent row se esiste

      const compareParent = comparePriceEl.closest('.fx-price-row');

      if (compareParent) {

        compareParent.style.display = 'none';

      }

    }



    // Nascondi la label "Prezzo finale" se esiste

    if (priceEl && priceEl.previousElementSibling && priceEl.previousElementSibling.classList.contains('fx-price-label')) {

      priceEl.previousElementSibling.style.display = 'none';

    }

  },



  // === FUNZIONI PER AGGIUNTA AL CARRELLO ===



  async complete() {

    try {

      const config = window.productConfigurator?.configuration;

      // 🔍 DEBUG: mostra lo stato della configurazione







      // Validation: assicurati che ci sia una variante selezionata

      if (!config?.variantId) {



        alert('Per favore seleziona una variante prima di procedere.');

        return;

      }



      // Trova la variante completa dal variantId

      const variant = this.product?.variants?.find(v => v.id === config.variantId);

      if (!variant) {

        alert('Variante non trovata. Riprova.');

        return;

      }



      // Aggiungi la variante completa alla configurazione temporaneamente

      config.selectedVariant = variant;



      // Applica la configurazione al form e aggiungi al carrello

      const addedToCart = await this.applyToShopifyProduct();



      if (addedToCart) {

        // Chiudi il modale configuratore
        const modal = document.querySelector('.fx-modal');
        if (modal) {
          modal.classList.remove('active');
        }
        // Ripristina scroll pagina
        if (window.productConfigurator) {
          window.productConfigurator.closeModal();
        } else {
          document.body.style.overflow = '';
          document.body.style.position = '';
          document.body.style.width = '';
          document.body.style.top = '';
          const scrollY = document.body.dataset.scrollPosition || 0;
          window.scrollTo(0, parseInt(scrollY));
        }

        // Apri il cart drawer
        setTimeout(() => {
          const cartDrawer = document.querySelector('cart-drawer') || document.querySelector('.cart-drawer');
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          } else {
            const cartIcon = document.querySelector('.Header__Action--cart a, .cart-icon-bubble, [data-cart-toggle]');
            if (cartIcon) cartIcon.click();
          }
        }, 300);

      }



    } catch (error) {


    }

  },



  async applyToShopifyProduct() {

    try {

      const config = window.productConfigurator?.configuration;



      // Usa selectedVariant se esiste, altrimenti cerca dalla variantId

      let variant = config?.selectedVariant;

      if (!variant && config?.variantId) {

        variant = this.product?.variants?.find(v => v.id === config.variantId);

        if (variant) {

          config.selectedVariant = variant;

        }

      }



      if (!variant) {


        return false;

      }



      // Update success details PRIMA di aggiungere al carrello

      this.updateSuccessDetails(variant);



      // Prepara l'immagine del prodotto principale (non della variante)

      const productImage = this.product?.featured_image || this.product?.image || null;



      // Prepara i dati del carrello

      const finalPrice = config.selectedVariant.price;



      // Prepara properties solo se hanno un valore valido (non "Non selezionato")

      const properties = {

        '_Configuratore': 'CERAMICAEURO v2.1',

        '_product_image': productImage

      };



      // Mapping per formattare i valori nel carrello

      const destinationNames = {

        'INTERNO': 'Interno',

        'ESTERNO': 'Esterno',

        'INTERNO_SOLO_PARETE': 'Interno solo parete',

        'BATTISCOPA': 'Battiscopa'

      };



      // Lista delle finiture da estrarre dal formato

      // IMPORTANTE: RealUp+StrideUp deve venire PRIMA di RealUp per matching corretto

      // IMPORTANTE: Lappata-Satinata deve venire PRIMA di Satinata e Lappata per matching corretto

      const finiture = ['RealUp+StrideUp', 'RealUp', 'StrideUp', 'Antislip', 'Lucida', 'Naturale', 'Opaca', 'Matte', 'Soft', 'Lappata-Satinata', 'Satinata', 'Strutturata', 'Comfort', 'Fluid', 'PTV', 'Bocciardato', 'Liscia', 'Levigata', 'Lappata', 'Spazzolata', 'Grip'];



      // Aggiungi solo properties con valori validi E FORMATTATI

      if (config.format && config.format !== 'Non selezionato') {

        // Trova il label formattato dal formatOptions

        const formatDetails = this.formatOptions.find(f => f.value === config.format);

        let formatLabel = formatDetails?.label || config.format;

        formatLabel = this.convertFinituraToFemminile(formatLabel);



        // Estrai finitura dal formato

        let finituraEstratta = '';

        let formatoSenzaFinitura = formatLabel;



        // PRIORITÀ: Usa config.finituraLabel se disponibile (è già il valore corretto)

        if (config.finituraLabel && config.finituraLabel !== 'Non selezionato') {

          finituraEstratta = config.finituraLabel;

          // Rimuovi la finitura dal formato per ottenere solo le dimensioni

          const finituraLower = config.finituraLabel.toLowerCase().replace(/-/g, '');

          for (const finitura of finiture) {

            const finituraEscaped = finitura.replace(/[+*?^${}()|[\]\\]/g, '\\$&');

            const regex = new RegExp(`\\s+${finituraEscaped}\\b`, 'gi');

            formatoSenzaFinitura = formatoSenzaFinitura.replace(regex, '').trim();

          }

        }

        // Fallback: Prima controlla se contiene Canneté/Cannete (con qualsiasi accento)

        else if (/\s+Cannet[eéè]\b/gi.test(formatLabel)) {

          finituraEstratta = 'Canneté';

          formatoSenzaFinitura = formatLabel.replace(/\s+Cannet[eéè]\b/gi, '').trim();

        } else {

          // Cerca altre finiture nel formatLabel

          for (const finitura of finiture) {

            // Escape caratteri speciali regex (es. + in RealUp+StrideUp)

            const finituraEscaped = finitura.replace(/[+*?^${}()|[\]\\]/g, '\\$&');

            const regex = new RegExp(`\\s+${finituraEscaped}\\b`, 'gi');

            if (regex.test(formatLabel)) {

              finituraEstratta = finitura;

              formatoSenzaFinitura = formatLabel.replace(regex, '').trim();

              break;

            }

          }

        }



        // Rimuovi "Battiscopa" dal formato (è già mostrato in Destinazione)

        formatoSenzaFinitura = formatoSenzaFinitura.replace(/\s*Battiscopa\b/gi, '').trim();



        // Salva la finitura estratta per aggiungerla dopo

        config._finituraEstratta = finituraEstratta || 'Naturale';

        config._formatoSenzaFinitura = formatoSenzaFinitura;

      }



      // ORDINE PROPERTIES: Destinazione, Formato, Finitura, Colore, Spessore


      if (config.destination && config.destination !== 'Non selezionato') {

        // Formatta la destinazione in modo leggibile

        properties['Destinazione'] = destinationNames[config.destination] || config.destination;

      }

      if (config._formatoSenzaFinitura) {

        properties['Formato'] = config._formatoSenzaFinitura;

      }

      if (config._finituraEstratta) {

        properties['Finitura'] = config._finituraEstratta;

      }

      if (config.color && config.color !== 'Non selezionato') {

        properties['Colore'] = config.color;

      }

      if (config.thickness && config.thickness !== 'Non selezionato') {

        // Rimuovi -parete dallo spessore

        properties['Spessore'] = config.thickness.replace(/-parete/gi, '').trim();

      }



      // ====== PROPERTIES VISIBILI AL CHECKOUT (per cliente) ======
      // Queste appaiono nel checkout Shopify (le _* sotto sono solo per cart drawer JS)
      const isBattiscopaProp = config.destination === 'BATTISCOPA';
      if (config.totalMq && !isBattiscopaProp) {
        properties['Superficie ordinata'] = config.totalMq.toFixed(2).replace('.', ',') + ' m²';
      }
      if (config.displayPriceM2) {
        const labelPrezzo = isBattiscopaProp ? 'Prezzo a confezione' : 'Prezzo al m²';
        properties[labelPrezzo] = this.formatMoney(config.displayPriceM2);
        if (config.variantPrice && !isBattiscopaProp) { properties['Prezzo alla scatola'] = this.formatMoney(config.variantPrice); }
      }

      // ====== DATI PER CALCOLO PREZZI E SCONTI ======

      // Salva il numero di SCATOLE nelle proprietà (per visualizzazione)

      if (config.quantity) {

        properties['_Numero_Scatole'] = config.quantity.toString();

      }



      // Salva i metri quadri totali

      if (config.totalMq) {

        properties['_Total_Mq'] = config.totalMq.toString();

      }



      // 🎯 Usa displayPriceM2 (prezzo fisso al mq) SOLO se disponibile

      // NON usare variantPrice come fallback perché è il prezzo per scatola, non al mq!

      // Per BATTISCOPA usa /box invece di /mq

      const isBattiscopa = config.destination === 'BATTISCOPA';

      const priceUnit = isBattiscopa ? 'box' : 'mq';



      if (config.displayPriceM2) {

        properties['_Prezzo_Mq'] = this.formatMoney(config.displayPriceM2);

        properties['_Unita_Prezzo'] = priceUnit;


      } else {


      }



      // Salva il compare price (prezzo originale) per mostrare lo sconto nel carrello

      if (config.variantComparePrice) {

        properties['_Compare_Price_Mq'] = this.formatMoney(config.variantComparePrice);


      }



      // Sconto bancale: usa BancaleDiscount per percentuali corrette

      const boxesPerPallet = config.boxesPerPallet || 40;

      const numeroScatole = config.quantity || 1;

      const numeroBancali = Math.floor(numeroScatole / boxesPerPallet);

      let discountPercentage = 0;



      // Usa BancaleDiscount se disponibile per ottenere la percentuale corretta

      if (window.BancaleDiscount && numeroBancali >= 1) {

        discountPercentage = window.BancaleDiscount.calculateDiscount(numeroBancali);

      }



      if (discountPercentage > 0) {

        properties['_Sconto_Bancale'] = 'Attivo';

        properties['_Sconto_Bancale_Percentuale'] = discountPercentage.toString();

        properties['_Numero_Bancali'] = numeroBancali.toString();

      }



      // Salva sempre il numero di scatole per bancale

      properties['_Boxes_Per_Pallet'] = boxesPerPallet.toString();



      // IMPORTANTE: Invia il NUMERO DI SCATOLE come quantity

      // Shopify calcola: prezzo/scatola × numero scatole

      // FORZA la quantity come numero intero per evitare conversioni errate

      const quantityForShopify = parseInt(config.quantity, 10) || 1;



      // VERIFICA che la quantity sia corretta

      if (quantityForShopify !== config.quantity) {


      }

      const cartData = {

        items: [{

          id: config.selectedVariant.id,

          quantity: quantityForShopify,  // Numero di scatole

          properties: properties

        }]

      };



      // ====== SCONTO BANCALE VIA CLOUDFLARE WORKER ======
      // Se ci sono bancali interi, chiama il Worker per creare un codice sconto Shopify
      if (numeroBancali >= 1 && discountPercentage > 0) {
        try {

          // Recupera il carrello attuale per includere TUTTI gli item
          // Risolvi vendor con fallback (this.product.vendor può essere vuoto)
          let workerVendor = (this.product?.vendor || '').toLowerCase();
          if (!workerVendor && window.BancaleDiscount?.config?.vendor) {
            workerVendor = window.BancaleDiscount.config.vendor.toLowerCase();
          }
          if (!workerVendor && window.ShopifyAnalytics?.meta?.product?.vendor) {
            workerVendor = window.ShopifyAnalytics.meta.product.vendor.toLowerCase();
          }
          if (!workerVendor && window.meta?.product?.vendor) {
            workerVendor = window.meta.product.vendor.toLowerCase();
          }

          let currentCartItems = [];
          try {
            const cartResp = await fetch('/cart.js');
            const cartJson = await cartResp.json();
            // Mappa gli item del carrello esistenti (escluso quello che stiamo aggiungendo)
            currentCartItems = (cartJson.items || []).map(item => {
              const props = item.properties || {};
              return {
                collection: (item.product_title || this.product?.title || '').toLowerCase(),
                format: props['Formato'] || '',
                vendor: (item.vendor || workerVendor || '').toLowerCase(),
                quantity: item.quantity,
                price_per_box: item.price / 100,  // Shopify salva in centesimi
                variant_id: item.variant_id,
                product_id: item.product_id
              };
            });
          } catch(e) {
          }

          // Aggiungi l'item corrente
          const currentItem = {
            collection: (this.product?.title || '').toLowerCase(),
            format: config._formatoSenzaFinitura || config.format || '',
            vendor: workerVendor,
            quantity: quantityForShopify,
            price_per_box: (config.selectedVariant.price || 0) / 100,
            variant_id: config.selectedVariant.id,
            product_id: this.product?.id
          };

          const allItems = [...currentCartItems, currentItem];

          // Recupera vecchi ID sconti automatici + vecchio price_rule_id (backward compat)
          const oldAutoIds = JSON.parse(localStorage.getItem('kreo_automatic_discount_ids') || '[]');
          const oldPriceRuleId = localStorage.getItem('kreo_discount_price_rule_id');

          const workerPayload = {
            items: allItems,
            old_automatic_discount_ids: oldAutoIds,
            old_code_price_rule_id: oldPriceRuleId ? parseInt(oldPriceRuleId) : null
          };


          const discountResp = await fetch('https://kreo-discount.assistenzahomeup.workers.dev/', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(workerPayload)
          });

          const discountData = await discountResp.json();

          if (discountData.success && discountData.has_discount && discountData.automatic_discounts) {
            // Salva i nuovi ID degli sconti automatici
            const newAutoIds = discountData.automatic_discounts.map(d => d.id);
            localStorage.setItem('kreo_automatic_discount_ids', JSON.stringify(newAutoIds));
            // Pulisci vecchi dati codice sconto (non piu usati)
            localStorage.removeItem('kreo_discount_price_rule_id');
            localStorage.removeItem('kreo_discount_code');
          } else {
            localStorage.removeItem('kreo_automatic_discount_ids');
            localStorage.removeItem('kreo_discount_price_rule_id');
            localStorage.removeItem('kreo_discount_code');
          }
        } catch(workerError) {
          // Non bloccare l'add-to-cart se il Worker fallisce
        }
      } else {
        // Se non ci sono bancali, rimuovi eventuali vecchi sconti
        const oldAutoIds = JSON.parse(localStorage.getItem('kreo_automatic_discount_ids') || '[]');
        const oldPriceRuleId = localStorage.getItem('kreo_discount_price_rule_id');
        if (oldAutoIds.length > 0 || oldPriceRuleId) {
          try {
            await fetch('https://kreo-discount.assistenzahomeup.workers.dev/', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                items: [],
                old_automatic_discount_ids: oldAutoIds,
                old_code_price_rule_id: oldPriceRuleId ? parseInt(oldPriceRuleId) : null
              })
            });
          } catch(e) { /* ignora */ }
          localStorage.removeItem('kreo_automatic_discount_ids');
          localStorage.removeItem('kreo_discount_price_rule_id');
          localStorage.removeItem('kreo_discount_code');
        }
      }

      // Blocca eventi cart drawer durante l'add-to-cart per evitare cascata 429
      window.__suppressCartEvents = true;

      // STEP 1: Usa XMLHttpRequest per bypassare interceptor (Appstle/analytics) che causano 429
      const response = await new Promise((resolve, reject) => {
        const maxRetries = 3;
        let attempt = 0;
        function tryAdd() {
          attempt++;
          const xhr = new XMLHttpRequest();
          xhr.open('POST', '/cart/add.js?t=' + Date.now(), true);
          xhr.setRequestHeader('Content-Type', 'application/json');
          xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
          xhr.onload = function() {
            if (xhr.status === 429 && attempt < maxRetries) {
              const delay = attempt * 3000;
              setTimeout(tryAdd, delay);
              return;
            }
            let jsonData = null;
            try { jsonData = JSON.parse(xhr.responseText); } catch(e) { console.error('\u274c JSON parse failed:', e.message); }
            resolve({
              ok: xhr.status >= 200 && xhr.status < 300,
              status: xhr.status,
              json: () => Promise.resolve(jsonData),
              jsonData: jsonData
            });
          };
          xhr.onerror = () => {
            if (attempt < maxRetries) {
              setTimeout(tryAdd, attempt * 1500);
              return;
            }
            reject(new Error('Errore di rete dopo ' + maxRetries + ' tentativi'));
          };
          xhr.send(JSON.stringify(cartData));
        }
        tryAdd();
      });

      // cart:updated spostato DOPO apertura drawer per evitare cascata 429
      // (il flag __suppressCartEvents blocca le reazioni premature del drawer)

      if (response.ok) {

        const result = await response.json();

        // IMPORTANTE: /cart/add.js con {items: [...]} restituisce {items: [...]}, non un singolo item!

        const addedItem = result.items ? result.items[0] : result;




        // STEP 2: Se Appstle ha modificato la quantity, CORREGGI con XMLHttpRequest (bypassa Appstle!)

        // Gli sconti sono già stati calcolati da Appstle, ora sistemiamo solo la quantity

        if (addedItem.quantity !== quantityForShopify) {


          try {

            const itemKey = addedItem.key || `${addedItem.variant_id}:${addedItem.id}`;



            // Usa XMLHttpRequest per bypassare Appstle nella correzione (mantiene gli sconti già calcolati)

            const updateResponse = await new Promise((resolve, reject) => {

              const xhr = new XMLHttpRequest();

              xhr.open('POST', '/cart/change.js?t=' + Date.now(), true);

              xhr.setRequestHeader('Content-Type', 'application/json');

              xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

              xhr.onload = function() {

                resolve({

                  ok: xhr.status >= 200 && xhr.status < 300,

                  json: () => { try { return Promise.resolve(JSON.parse(xhr.responseText)); } catch(e) { return Promise.reject(e); } }

                });

              };

              xhr.onerror = () => reject(new Error('Network error'));

              xhr.send(JSON.stringify({

                id: itemKey,

                quantity: quantityForShopify

              }));

            });



            if (updateResponse.ok) {


            } else {


            }

          } catch (updateError) {


          }

        } else {


        }



        // Trigger custom event for other integrations

        window.dispatchEvent(new CustomEvent('ceramicaConfigurationApplied', {

          detail: {

            configuration: config,

            variant: config.selectedVariant,

            price: config.selectedVariant.price,

            flow: 'STANDARD',

            cartResult: result

          }

        }));

        // Meta Pixel — AddToCart event
        if (typeof fbq !== 'undefined' && config.selectedVariant) {
          fbq('track', 'AddToCart', {
            content_ids: [String(config.selectedVariant.id)],
            content_type: 'product',
            content_name: this.product?.title || '',
            value: config.selectedVariant.price ? config.selectedVariant.price / 100 : 0,
            currency: 'EUR'
          });
        }

        // Aggiorna il prezzo nell'header ISTANTANEAMENTE (senza await = più veloce!)

        this.updateHeaderPriceImmediate(result);



        // Update cart UI immediately

        this.updateCartUI();



        // DOUBLE-FETCH + FIX QUANTITY: Appstle modifica quantity quando aggiunge properties

        // Aspettiamo che Appstle finisca, poi correggiamo la quantity

        setTimeout(async () => {

          try {

            // Fetch carrello con XMLHttpRequest per vedere lo stato reale

            const cartData = await new Promise((resolve, reject) => {

              const xhr = new XMLHttpRequest();

              xhr.open('GET', '/cart.js?t=' + Date.now(), true);

              xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

              xhr.onload = () => {

                if (xhr.status >= 200 && xhr.status < 300) {

                  try { resolve(JSON.parse(xhr.responseText)); } catch(e) { reject(new Error("Invalid cart JSON")); }

                } else {

                  reject(new Error('Failed to fetch cart'));

                }

              };

              xhr.onerror = () => reject(new Error('Network error'));

              xhr.send();

            });



            // Trova l'item appena aggiunto e verifica se Appstle ha cambiato la quantity

            const addedItem = cartData.items.find(item =>

              item.variant_id === config.selectedVariant.id ||

              item.id === config.selectedVariant.id

            );



            if (addedItem && addedItem.properties && addedItem.properties['_Numero_Scatole']) {

              const expectedQuantity = parseInt(addedItem.properties['_Numero_Scatole']);



              if (addedItem.quantity !== expectedQuantity) {




                // CORREGGI con XMLHttpRequest (bypassa Appstle!)

                await new Promise((resolve, reject) => {

                  const xhr = new XMLHttpRequest();

                  xhr.open('POST', '/cart/change.js?t=' + Date.now(), true);

                  xhr.setRequestHeader('Content-Type', 'application/json');

                  xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

                  xhr.onload = () => {


                    resolve();

                  };

                  xhr.onerror = () => reject(new Error('Network error'));

                  xhr.send(JSON.stringify({

                    id: addedItem.key,

                    quantity: expectedQuantity

                  }));

                });



                // Fetch aggiornato dopo la correzione

                const finalCart = await fetch('/cart.js', {

                  method: 'GET',

                  headers: { 'Content-Type': 'application/json', 'Cache-Control': 'no-cache' }

                });



                if (finalCart.ok) {

                  const finalCartData = await finalCart.json();

                  document.dispatchEvent(new CustomEvent('cart:refresh', {

                    bubbles: true,

                    detail: { cart: finalCartData }

                  }));

                }

              } else {


                document.dispatchEvent(new CustomEvent('cart:refresh', {

                  bubbles: true,

                  detail: { cart: cartData }

                }));

              }

            } else {

              // Item senza properties del configuratore

              document.dispatchEvent(new CustomEvent('cart:refresh', {

                bubbles: true,

                detail: { cart: cartData }

              }));

            }

          } catch (error) {


          }

        }, 2000);  // Aumentato a 2000ms per evitare 429



        // Rilascia blocco cart drawer dopo che drawer si è aperto e Appstle ha finito

        setTimeout(() => {

          window.__suppressCartEvents = false;

          // Aggiorna drawer con dati finali dopo le correzioni Appstle

          try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch(e) {}

        }, 4500);



        return true;

      } else {

        window.__suppressCartEvents = false; // Rilascia blocco in caso di errore
        let errorMsg = 'Errore durante l\'aggiunta al carrello';

        try {

          const ct = (response.headers && response.headers.get) ? (response.headers.get('content-type') || '') : 'application/json';

          if (ct.includes('application/json')) {

            const errorData = await response.json();

            errorMsg = errorData.message || errorData.description || errorMsg;

          } else {

            errorMsg = 'Shopify ha risposto con errore ' + response.status + '. Riprova tra qualche secondo.';

          }

        } catch(e) { /* risposta non parsabile */ }

        throw new Error(errorMsg + ' [HTTP ' + response.status + ']');

      }



    } catch (error) {

      window.__suppressCartEvents = false; // Rilascia blocco in caso di errore




      // Fallback: try with form submission

      const productForm = document.querySelector('form[action*="/cart/add"]');

      if (productForm) {

        return this.fallbackFormSubmission(productForm);

      }



      throw error;

    }

  },



  async fallbackFormSubmission(productForm) {

    try {

      const config = window.productConfigurator?.configuration;



      // Usa selectedVariant se esiste, altrimenti usa variantId

      const variantId = config?.selectedVariant?.id || config?.variantId;



      if (!variantId) {

        return false;

      }



      // Update variant selector if exists

      const variantSelector = document.querySelector('select[name="id"]');

      if (variantSelector) {

        variantSelector.value = variantId;

      }



      // Update hidden variant input if exists

      const variantInput = document.querySelector('input[name="id"]');

      if (variantInput) {

        variantInput.value = variantId;

      }



      const variant = config.selectedVariant || this.product?.variants?.find(v => v.id === variantId);



      // Costruisci configData solo con properties valide

      const configData = [];



      // Aggiungi properties solo se hanno valori validi

      if (config.format && config.format !== 'Non selezionato') {

        configData.push({ name: 'properties[Formato]', value: config.format });

      }

      if (config.color && config.color !== 'Non selezionato') {

        configData.push({ name: 'properties[Colore]', value: config.color });

      }

      if (config.thickness && config.thickness !== 'Non selezionato') {

        configData.push({ name: 'properties[Spessore]', value: config.thickness });

      }

      if (config.finish && config.finish !== 'Non selezionato') {

        configData.push({ name: 'properties[Finitura]', value: config.finish });

      }

      if (config.destination && config.destination !== 'Non selezionato') {

        configData.push({ name: 'properties[Destinazione]', value: config.destination });

      }



      // Aggiungi properties interne

      configData.push(

        { name: 'properties[_Variante ID]', value: variantId || '' },

        { name: 'properties[_Prezzo Configurato]', value: variant ? this.formatMoney(variant.price) : '' },

        { name: 'properties[_Configurazione ID]', value: this.generateConfigId() },

        { name: 'properties[_Configurazione Data]', value: new Date().toISOString() },

        { name: 'properties[_Configuratore]', value: 'CERAMICAEURO v2.1' },

        { name: 'properties[_Flusso]', value: 'STANDARD' }

      );



      // Remove existing configuration properties

      productForm.querySelectorAll('input[name^="properties["]').forEach(input => {

        if (input.name.includes('Formato') || input.name.includes('Colore') ||

            input.name.includes('Spessore') || input.name.includes('Finitura') ||

            input.name.includes('Destinazione') || input.name.includes('_Configurazione') ||

            input.name.includes('_Variante') || input.name.includes('_Prezzo') ||

            input.name.includes('_Flusso')) {

          input.remove();

        }

      });



      // Add new configuration properties

      configData.forEach(({ name, value }) => {

        const input = document.createElement('input');

        input.type = 'hidden';

        input.name = name;

        input.value = value;

        productForm.appendChild(input);

      });



      // Submit form

      productForm.submit();

      return true;



    } catch (error) {


      throw error;

    }

  },



  updateCartUI(cartData = null) {

    // Refresh cart content first, then open drawer

    this.refreshCartContent(cartData).then((refreshedCart) => {

      setTimeout(() => {

        this.openCartDrawer();

        // Rilascia il blocco eventi cart drawer dopo apertura

        setTimeout(() => {

          window.__suppressCartEvents = false;

          try { window.dispatchEvent(new Event('cart:updated')); } catch(e) {}

        }, 300);

        // Sostituisci le immagini dopo l'apertura del drawer

        setTimeout(() => {

          this.replaceVariantImagesWithProductImage();

        }, 500);

      }, 800);

    });

  },



  // Aggiorna il prezzo header ISTANTANEAMENTE senza aspettare fetch

  updateHeaderPriceImmediate(cartResult) {

    try {

      const config = window.productConfigurator?.configuration;



      // Prendi il prezzo finale DIRETTAMENTE dal recap già calcolato

      let finalPrice = 0;



      if (config.finalTotalPrice) {

        finalPrice = config.finalTotalPrice;

      } else {

        const baseTotalPrice = config.quantity ? config.variantPrice * config.quantity : config.variantPrice;

        let discountAmount = 0;

        const boxesPerPallet = config.boxesPerPallet || 40;

        const numeroBancali = Math.floor(config.quantity / boxesPerPallet);

        let discountPercentage = 0;



        // Usa BancaleDiscount se disponibile per ottenere la percentuale corretta

        if (window.BancaleDiscount && numeroBancali >= 1) {

          discountPercentage = window.BancaleDiscount.calculateDiscount(numeroBancali);

        }



        if (discountPercentage > 0) {

          // Calcola come Shopify: sconto per unità (floor), poi moltiplica per quantità

          discountAmount = Math.floor(config.variantPrice * discountPercentage / 100) * (config.quantity || 1);

        }



        finalPrice = baseTotalPrice - discountAmount;

      }



      // Leggi il prezzo attuale del carrello dall'header

      const cartPriceElement = document.querySelector('.cart-price, [data-cart-price]');

      let currentCartPrice = 0;

      if (cartPriceElement) {

        const currentText = cartPriceElement.textContent.replace('€', '').replace(/\./g, '').replace(',', '.');

        currentCartPrice = parseFloat(currentText) * 100 || 0;

      }



      // Nuovo prezzo = prezzo attuale + prezzo appena aggiunto

      const newTotalPrice = currentCartPrice + finalPrice;



      // Formatta il prezzo

      const priceInEuros = (newTotalPrice / 100).toFixed(2);

      const forNaturaledPrice = `€${priceInEuros.replace('.', ',')}`;



      // Aggiorna TUTTI gli elementi del prezzo nell'header ISTANTANEAMENTE

      const cartPriceElements = document.querySelectorAll('.cart-price, [data-cart-price]');

      cartPriceElements.forEach(priceElement => {

        priceElement.textContent = forNaturaledPrice;

      });

      // Poi fai il fetch in background per sincronizzare (senza aspettare)

      setTimeout(() => {

        fetch('/cart.js')

          .then(response => response.json())

          .then(cart => {

            // Ricalcola il prezzo corretto dal carrello completo - STESSO SISTEMA DEL CART-DRAWER

            let totalPrice = 0;

            if (cart.items && cart.items.length > 0) {

              cart.items.forEach(item => {

                // NUOVO SISTEMA: item.quantity contiene i METRI QUADRI

                // Shopify calcola già correttamente: prezzo/m² × m²

                let baseTotalPrice = item.line_price;



                // Calcola sconto bancale - USA _Numero_Scatole dalle proprietà

                let discountAmount = 0;



                if (item.properties && item.properties['_Numero_Scatole']) {

                  const numeroScatole = parseInt(item.properties['_Numero_Scatole']);

                  const boxesPerPallet = item.properties['_Boxes_Per_Pallet']

                    ? parseInt(item.properties['_Boxes_Per_Pallet'])

                    : 40;

                  const numeroBancali = Math.floor(numeroScatole / boxesPerPallet);



                  let discountPercentage = 0;



                  // Usa BancaleDiscount se disponibile per ottenere la percentuale corretta

                  if (window.BancaleDiscount && numeroBancali >= 1) {

                    discountPercentage = window.BancaleDiscount.calculateDiscount(numeroBancali);

                  }



                  if (discountPercentage > 0) {

                    // Calcola come Shopify: sconto per unità (floor), poi moltiplica per quantità

                    discountAmount = Math.floor(item.price * discountPercentage / 100) * item.quantity;

                  }

                }



                const itemTotal = baseTotalPrice - discountAmount;

                totalPrice += itemTotal;

              });

            }



            // Aggiorna con il prezzo preciso dal server

            const precisePriceInEuros = (totalPrice / 100).toFixed(2);

            const preciseForNaturaledPrice = `€${precisePriceInEuros.replace('.', ',')}`;



            cartPriceElements.forEach(priceElement => {

              priceElement.textContent = preciseForNaturaledPrice;

            });

          })

          .catch(error => {


          });

      }, 100);



    } catch (error) {


    }

  },



  async refreshCartContent(providedCartData = null) {

    try {

      // Use provided cart data or fetch fresh data

      let cartData = providedCartData;

      if (!cartData) {

        const cartResponse = await fetch('/cart.js');

        cartData = await cartResponse.json();

      }



      // Update cart count in header

      const cartCountElements = document.querySelectorAll('[data-cart-count], .cart-count, .Header__CartCount, .cart-link__bubble');

      cartCountElements.forEach(element => {

        if (element) {

          element.textContent = cartData.item_count;

          element.style.display = cartData.item_count > 0 ? 'block' : 'none';

        }

      });



      // Update cart price in header

      const cartPriceElements = document.querySelectorAll('.cart-price, [data-cart-price]');

      if (cartPriceElements.length > 0 && cartData) {

        // Usa il prezzo totale standard

        let totalPrice = cartData.total_price;



        // Formatta il prezzo

        const forNaturaledPrice = (totalPrice / 100).toFixed(2).replace('.', ',');



        cartPriceElements.forEach(element => {

          element.textContent = `€${forNaturaledPrice}`;

        });

      }



      // Trigger various cart refresh methods

      if (window.CartJS && window.CartJS.getCart) {

        await window.CartJS.getCart();

      }



      if (window.theme && window.theme.updateCart) {

        window.theme.updateCart();

      }



      if (window.ajaxCart && window.ajaxCart.load) {

        window.ajaxCart.load();

      }



      // Dispatch cart events

      const cartEvents = ['cart:updated', 'cart:refresh', 'cart:build', 'ajaxCart:updated', 'cart:ready'];

      cartEvents.forEach(eventName => {

        document.dispatchEvent(new CustomEvent(eventName, {

          bubbles: true,

          detail: { cart: cartData }

        }));

        window.dispatchEvent(new CustomEvent(eventName, {

          detail: { cart: cartData }

        }));

      });



      // Try to refresh cart drawer content directly

      await this.updateCartDrawerContent(cartData);



      return cartData;



    } catch (error) {


      return null;

    }

  },



  async updateCartDrawerContent(cartData) {

    const cartDrawer = document.querySelector('[data-cart-drawer], .cart-drawer, .drawer--right, #CartDrawer');

    if (!cartDrawer) return;



    // Look for cart items container and update it

    const cartItemsContainer = cartDrawer.querySelector('[data-cart-items], .cart-items, .Cart__ItemList, .drawer__cart-items');

    if (!cartItemsContainer) return;



    try {

      // Try multiple approaches to get cart HTML

      const cartUrls = ['/cart?view=drawer', '/cart?view=ajax', '/cart.js'];



      for (const url of cartUrls) {

        try {

          const response = await fetch(url);

          if (response.ok) {

            if (url.endsWith('.js')) {

              continue;

            }



            const cartHTML = await response.text();

            const tempDiv = document.createElement('div');

            tempDiv.innerHTML = cartHTML;



            const newCartItems = tempDiv.querySelector('[data-cart-items], .cart-items, .Cart__ItemList, .drawer__cart-items');

            if (newCartItems) {

              cartItemsContainer.innerHTML = newCartItems.innerHTML;



              // Sostituisci le immagini delle varianti con l'immagine del prodotto

              this.replaceVariantImagesWithProductImage();



              break;

            }

          }

        } catch (err) {

          continue;

        }

      }



      // Fallback: Build cart items manually from cart data

      if (cartData && cartData.items && cartData.items.length > 0) {

        const config = window.productConfigurator?.configuration;



        // Find our configured item

        const configuredItem = cartData.items.find(item =>

          item.variant_id === config?.selectedVariant?.id &&

          item.properties &&

          item.properties['_Configuratore']

        );



        if (configuredItem && cartItemsContainer.children.length === 0) {

          const itemEl = document.createElement('div');

          itemEl.className = 'cart-item configured-item';

          itemEl.innerHTML = `

            <div style="padding: 1rem; border: 2px solid #2D5A3D; border-radius: 8px; margin-bottom: 1rem; background: #F5F2EB;">

              <h4 style="margin: 0 0 0.5rem 0; color: #2D5A3D;">

                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display: inline-block; vertical-align: middle; margin-right: 6px;">

                  <polyline points="20 6 9 17 4 12"></polyline>

                </svg>

                ${configuredItem.product_title}

              </h4>

              <p style="margin: 0 0 0.5rem 0; font-size: 0.9rem;">${configuredItem.variant_title}</p>

              <p style="margin: 0; font-weight: bold;">${this.formatMoney(configuredItem.price)} × ${configuredItem.quantity}</p>

              ${configuredItem.properties.Formato ? `<small style="color: #666;">Formato: ${configuredItem.properties.Formato}</small><br>` : ''}

              ${configuredItem.properties.Colore ? `<small style="color: #666;">Colore: ${configuredItem.properties.Colore}</small><br>` : ''}

              ${configuredItem.properties.Spessore ? `<small style="color: #666;">Spessore: ${configuredItem.properties.Spessore}</small>` : ''}

            </div>

          `;

          cartItemsContainer.appendChild(itemEl);

        }

      }



    } catch (error) {


    }

  },



  openCartDrawer() {

    // Method 1: Selettori specifici per il cart drawer

    const specificCartTriggers = [

      '[data-drawer-id="sidebar-cart"]',

      '[data-drawer-id="cart"]',

      '.js-drawer-open-cart',

      '.Header__CartIcon',

      '[data-action="open-cart-drawer"]',

      '[data-action="open-drawer"][data-drawer="cart"]',

      '.cart-drawer-toggle',

      '.Header__CartCount'

    ];



    let drawerOpened = false;



    for (const selector of specificCartTriggers) {

      const elements = document.querySelectorAll(selector);

      if (elements.length > 0) {

        const element = elements[0];

        const isNotMobileMenu = !element.closest('.Header__Icon--nav') &&

                               !element.classList.contains('Header__Icon--nav') &&

                               !element.closest('[data-action="open-sidebar"]') &&

                               !element.closest('.js-drawer-open-nav');



        if (isNotMobileMenu) {

          element.click();

          drawerOpened = true;

          break;

        }

      }

    }



    // Method 2: Cerca elementi che contengono "cart" nel testo o attributi

    if (!drawerOpened) {

      const cartElements = document.querySelectorAll('[class*="cart"], [data-*="cart"], [id*="cart"]');

      for (const element of cartElements) {

        if (element.tagName === 'A' || element.tagName === 'BUTTON') {

          const elementText = element.textContent.toLowerCase();

          const isCartRelated = elementText.includes('cart') ||

                               element.getAttribute('href')?.includes('cart') ||

                               element.getAttribute('data-action')?.includes('cart');



          const isMobileMenu = element.closest('.Header__Icon--nav') ||

                              element.classList.contains('Header__Icon--nav') ||

                              element.closest('[data-action="open-sidebar"]') ||

                              element.closest('.js-drawer-open-nav') ||

                              element.textContent.toLowerCase().includes('menu') ||

                              element.textContent.toLowerCase().includes('nav');



          if (isCartRelated && !isMobileMenu) {

            element.click();

            drawerOpened = true;

            break;

          }

        }

      }

    }



    // Method 3: Call theme functions

    if (!drawerOpened) {

      setTimeout(() => {

        if (window.theme && window.theme.openCartDrawer) {

          window.theme.openCartDrawer();

          drawerOpened = true;

        } else if (window.Shopify && window.Shopify.drawer && window.Shopify.drawer.open) {

          window.Shopify.drawer.open();

          drawerOpened = true;

        } else if (window.timber && window.timber.RightDrawer) {

          window.timber.RightDrawer.open();

          drawerOpened = true;

        }

      }, 100);

    }



    // Method 4: Manual drawer opening ONLY for cart drawer

    if (!drawerOpened) {

      setTimeout(() => {

        const cartDrawers = document.querySelectorAll('[data-cart-drawer], .cart-drawer, .drawer--right[data-drawer="cart"], #CartDrawer');

        cartDrawers.forEach(drawer => {

          if (drawer && !drawer.classList.contains('Header__Icon--nav')) {

            drawer.classList.add('is-open', 'is-visible', 'drawer--open');

            drawer.style.display = 'block';

            drawer.style.transform = 'translateX(0)';

            drawerOpened = true;

          }

        });



        // Add overlay only if cart drawer was opened

        if (drawerOpened) {

          const overlay = document.querySelector('.drawer-overlay, .Overlay') || document.createElement('div');

          if (!overlay.classList.contains('drawer-overlay')) {

            overlay.className = 'drawer-overlay';

            overlay.style.cssText = 'position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 999;';

            document.body.appendChild(overlay);

          }

          overlay.style.display = 'block';

        }

      }, 200);

    }



    // Fallback: Try to redirect to cart page if no drawer found

    if (!drawerOpened) {

      setTimeout(() => {

        window.location.href = '/cart';

      }, 1000);

    }

  },



  generateConfigId() {

    return 'CE' + Date.now().toString(36).toUpperCase();

  },



  updateSuccessDetails(variant) {

    const config = window.productConfigurator?.configuration;



    // USA IL PREZZO DIRETTAMENTE DAL RECAP (già calcolato con m² e sconto)

    let totalPrice = 0;



    if (config && config.finalTotalPrice) {

      // Prendi il prezzo finale dal recap (già con m² e sconto bancale)

      totalPrice = config.finalTotalPrice;

    } else {

      // Fallback: calcola manualmente (non dovrebbe mai accadere)




      if (!variant) {

        variant = config?.selectedVariant;

        if (!variant && config?.variantId) {

          variant = this.product?.variants?.find(v => v.id === config.variantId);

        }

      }



      if (!variant) {


        return;

      }



      const baseTotalPrice = config.quantity ? config.variantPrice * config.quantity : config.variantPrice;

      let discountAmount = 0;

      const boxesPerPallet = config.boxesPerPallet || 40;

      const numeroBancali = Math.floor(config.quantity / boxesPerPallet);

      let discountPercentage = 0;



      // Usa BancaleDiscount se disponibile per ottenere la percentuale corretta

      if (window.BancaleDiscount && numeroBancali >= 1) {

        discountPercentage = window.BancaleDiscount.calculateDiscount(numeroBancali);

      }



      if (discountPercentage > 0) {

        // Calcola come Shopify: sconto per unità (floor), poi moltiplica per quantità

        discountAmount = Math.floor(config.variantPrice * discountPercentage / 100) * (config.quantity || 1);

      }



      totalPrice = baseTotalPrice - discountAmount;

    }



    const successSavings = document.getElementById('successSavings');

    if (successSavings) {

      const forNaturaledPrice = this.formatMoney(totalPrice);

      successSavings.innerHTML = `${forNaturaledPrice}`;

    }

  },



  replaceVariantImagesWithProductImage() {

    // Ottieni l'immagine principale del prodotto

    const productImage = this.product?.featured_image || this.product?.image;

    if (!productImage) {

      return;

    }



    const productImageUrl = typeof productImage === 'string' ? productImage : productImage.src;

    // Ottieni l'URL dell'immagine della variante da NON sostituire negli altri prodotti

    const config = window.productConfigurator?.configuration;

    const currentVariantId = config?.selectedVariant?.id;



    // Funzione per sostituire le immagini

    const replaceImages = () => {

      // Cerca nel drawer del carrello

      const cartContainers = [

        document.querySelector('[data-cart-drawer]'),

        document.querySelector('.cart-drawer'),

        document.querySelector('.drawer--right'),

        document.querySelector('#CartDrawer'),

        document.querySelector('.Cart')

      ].filter(el => el);



      if (cartContainers.length === 0) {

        return;

      }

      cartContainers.forEach(container => {

        // Cerca solo immagini di prodotti (non icone, non badge)

        const productImages = container.querySelectorAll('.Cart__ItemImage img, .cart-item__image img, [data-cart-item-image] img, .drawer__cart-item img');

        if (productImages.length === 0) {

          // Fallback: cerca tutte le immagini più grandi di 50x50px

          const allImages = container.querySelectorAll('img');

          allImages.forEach(img => {

            if (img.width > 50 && img.height > 50 && img.src && img.src.includes('cdn.shopify.com/s/files')) {

              img.src = productImageUrl;

              img.srcset = '';

            }

          });

        } else {

          // Sostituisci le immagini trovate

          productImages.forEach(img => {

            if (img.src && img.src.includes('cdn.shopify.com')) {

              img.src = productImageUrl;

              img.srcset = '';

            }

          });

        }

      });

    };



    // Esegui subito

    replaceImages();



    // E poi ancora dopo 200ms, 500ms e 1000ms per catturare immagini caricate dinamicamente

    setTimeout(replaceImages, 200);

    setTimeout(replaceImages, 500);

    setTimeout(replaceImages, 1000);

  }

};



  // Alias per compatibilità con il template Liquid che cerca ConfiguratoreDataLight e ConfiguratoreDataSupergres

  window.ConfiguratoreDataLight = window.ConfiguratoreDataUniversal;

  window.ConfiguratoreDataSupergres = window.ConfiguratoreDataUniversal;



  // Inizializza quando il DOM è pronto - UNIVERSALE (tutti i prodotti)

  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', () => {

      window.ConfiguratoreDataUniversal.init();

    });

  } else {

    // Attendi un attimo per assicurarsi che productData sia disponibile

    setTimeout(() => {

      window.ConfiguratoreDataUniversal.init();

    }, 50);

  }

  // Ricalcola prezzi quando il Worker completa il fetch (in incognito i dati arrivano dopo l'init)
  window.addEventListener('prezzi-m2-updated', () => {
    if (window.ConfiguratoreDataUniversal && window.ConfiguratoreDataUniversal.product) {
      window.ConfiguratoreDataUniversal.applyDisplayPrices();
    }
  });

})();


// === NAVIGAZIONE STEP INDICATOR ===
// Gestisce i click sugli step nella barra di navigazione.
(function() {
  var maxReachedStep = 1;

  // Intercetta i click sui bottoni Next per aggiornare maxReachedStep
  document.addEventListener('click', function(e) {
    var nextBtnIds = ['fxNext2', 'fxNext2Finitura', 'fxNext3Colore', 'fxNext4', 'fxNext5', 'fxNext6'];
    var cfg = window.ceramicaEuroConfig;
    if (cfg && e.target && nextBtnIds.indexOf(e.target.id) >= 0) {
      var ns = cfg.currentStep + 1;
      if (ns > maxReachedStep) maxReachedStep = ns;
    }
  }, true);

  function navigateToStep(targetStep) {
    var cfg = window.ceramicaEuroConfig;
    if (!cfg) return;
    if (typeof cfg.goToStep === 'function') {
      cfg.goToStep(targetStep);
      return;
    }
    if (targetStep === cfg.currentStep) return;
    if (isNaN(targetStep) || targetStep < 1) return;
    if (targetStep > maxReachedStep) return;

    var goingForward = targetStep > cfg.currentStep;
    var oldStep = cfg.currentStep;
    var currentSection = document.getElementById('fxStep' + cfg.currentStep);
    var currentStepEl = document.querySelector('.fx-step[data-step="' + cfg.currentStep + '"]');

    if (currentStepEl) currentStepEl.classList.remove('active');
    if (goingForward && currentStepEl) currentStepEl.classList.add('completed');

    // Torna indietro: rimuovi completed da tutti gli step tra target+1 e oldStep
    if (!goingForward) {
      for (var s = targetStep + 1; s <= maxReachedStep; s++) {
        var el = document.querySelector('.fx-step[data-step="' + s + '"]');
        if (el) { el.classList.remove('completed'); el.classList.remove('active'); }
      }
      maxReachedStep = targetStep;
    }

    if (currentSection) {
      currentSection.classList.remove('active');
      currentSection.classList.add(goingForward ? 'fx-exit-left' : 'fx-exit-right');
      setTimeout(function() {
        currentSection.classList.remove(goingForward ? 'fx-exit-left' : 'fx-exit-right');
      }, 300);
    }

    cfg.currentStep = targetStep;

    setTimeout(function() {
      var newSection = document.getElementById('fxStep' + cfg.currentStep);
      if (newSection) {
        if (!goingForward) newSection.classList.add('fx-enter-reverse');
        newSection.classList.add('active');
      }
      var newStepEl = document.querySelector('.fx-step[data-step="' + cfg.currentStep + '"]');
      if (newStepEl) { newStepEl.classList.remove('completed'); newStepEl.classList.add('active'); }
      if (cfg.updateProgressBar) cfg.updateProgressBar();
      if (cfg.updateStickySummary) cfg.updateStickySummary();
      var mc = document.querySelector('.fx-modal-container');
      if (mc) mc.scrollTop = 0;
      // Su mobile i grid scrollano internamente — reset anche loro
      var activeStepEl = document.getElementById('fxStep' + cfg.currentStep);
      if (activeStepEl) {
        activeStepEl.querySelectorAll('.fx-style-grid, .fx-variants-grid, #fxQuantityContainer').forEach(function(el) {
          el.scrollTop = 0;
        });
        activeStepEl.scrollTop = 0;
      }
    }, 300);

    if (cfg.currentStep === 3 && window.ConfiguratoreDataUniversal && window.ConfiguratoreDataUniversal.populateFiniture) {
      window.ConfiguratoreDataUniversal.populateFiniture();
    }
    if (cfg.currentStep === 4 && window.ConfiguratoreDataUniversal && window.ConfiguratoreDataUniversal.populateColors) {
      window.ConfiguratoreDataUniversal.populateColors();
    }
  }

  document.addEventListener('click', function(e) {
    var stepEl = e.target.closest('.fx-step[data-step]');
    if (!stepEl) return;
    var targetStep = parseInt(stepEl.getAttribute('data-step'), 10);
    if (isNaN(targetStep)) return;
    navigateToStep(targetStep);
  });
})();



// === DEBUG ALTEZZE BOX INFO v2 ===
(function() {
  function debugHeights() {

    // Trova TUTTI i .fx-style-info nel documento
    var allInfos = document.querySelectorAll('.fx-style-info');

    // Controlla step1
    var step1 = document.getElementById('fxStep1');
    if (step1) {
      var s1cards = step1.querySelectorAll('.fx-style-card');
      var s1infos = step1.querySelectorAll('.fx-style-info');
      var s1pc = step1.querySelectorAll('.fx-price-container');
      if (s1infos.length > 0) {
        var first = s1infos[0];
        var s = getComputedStyle(first);
      }
      if (s1pc.length > 0) {
        var firstPc = s1pc[0];
        var sp = getComputedStyle(firstPc);
      }
    } else {
    }

    // Controlla step2
    var step2 = document.getElementById('fxStep2');
    if (step2) {
      var s2pc = step2.querySelectorAll('.fx-price-container');
      if (s2pc.length > 0) {
        var sp2 = getComputedStyle(s2pc[0]);
      }
    }
  }
  setTimeout(debugHeights, 4000);
  document.addEventListener('click', function(e) {
    var btn = e.target && e.target.closest ? e.target.closest('[id^="fxNext"]') : null;
    if (btn) { setTimeout(debugHeights, 800); }
    // anche dopo click CONFIGURA ORA
    var configBtn = e.target && e.target.closest ? e.target.closest('[id*="Configura"], [class*="configura"]') : null;
    if (configBtn) { setTimeout(debugHeights, 1500); }
  });
})();

/* KH-DBG-PREZZI: dump di TUTTI i prezzi del configuratore (auto al load + window.khDumpPrezzi() a mano) */
window.khDumpPrezzi = function(){
  try {
    var prod = window.productData || (window.productConfigurator && window.productConfigurator.product);
    if (!prod || !prod.variants) { console.log('[KH-DBG-PREZZI] prodotto non pronto (riprova tra 1s o chiama khDumpPrezzi())'); return; }
    var rows = prod.variants.map(function(v){
      var box = (parseInt(v.price)||0)/100;
      var u = window.__KH_UNIT__ && window.__KH_UNIT__[v.id];
      var mq = (u && u.p != null) ? u.p : ((typeof window.khMQ==='function') ? window.khMQ(v.id, box) : null);
      return { FORMATO: v.option1, COLORE: v.option2, SPESSORE: v.option3, prezzo_scatola_EUR: box, EUR_mq: mq };
    });
    console.table(rows);
    return rows;
  } catch(e){ console.log('[KH-DBG-PREZZI] err', e); }
};
/* auto-dump disattivato in produzione: chiama khDumpPrezzi() a mano dalla console per verificare i prezzi */
